import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, forwardRef, ViewEncapsulation, ViewChild, NgModule, EventEmitter, Output, HostBinding, ViewChildren, SecurityContext, Pipe, HostListener, Directive } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NgForm, ControlContainer, FormsModule, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import * as i4$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i8 from 'angular2-ladda';
import { LaddaModule } from 'angular2-ladda';
import * as i1$2 from 'ngx-bootstrap/modal';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import * as i1$3 from '@angular/platform-browser';
import { BehaviorSubject, fromEvent, of, zip, combineLatest, Observable, throwError } from 'rxjs';
import { take, filter, map, tap, switchMap, flatMap, catchError, mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { has, first, cloneDeep, filter as filter$1, some, forEach, concat, includes, map as map$1, get, remove, isNil, compact, values, merge, keyBy, isArray, defaultTo, flatten, last, set, replace, join, each, uniq, isEmpty, split, sum, size, find, uniqBy, assign, every, invoke, difference, sortBy, orderBy, isUndefined, lowerCase, isEqual, pickBy, pick, identity, toString, sumBy, keys, bind } from 'lodash';
import * as i1 from '@congacommerce/ecommerce';
import { CartItem, Cart, CartService, StorefrontService, Account, AccountLocation, Contact, Quote, Product, ProductOptionComponent, Order, OrderLineItem, AssetLineItem, QuoteLineItem, Price, LineItemService, PricingModule, User, PriceListItemService, ConstraintActionsIntent, ConstraintActionsType, IncrementLineAction, Favorite, BatchAction, AccessLevel, Category, ProductAttributeValue, LineStatus, AdjustmentItem, TaxBreakup } from '@congacommerce/ecommerce';
import * as i2 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import * as i2$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { plainToClass } from 'class-transformer';
import * as i1$1 from '@congacommerce/core';
import { AObjectService, ApiService, AObject, APageInfo, SalesforceUtils, ApttusModule, ACondition, AFilter, ImagePipe, ASort, Operator, PlatformConstants } from '@congacommerce/core';
import * as moment from 'moment';
import * as i4 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i7 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap/datepicker';
import * as i9 from '@ng-select/ng-option-highlight';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import * as i1$4 from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import * as i3 from 'ngx-bootstrap/alert';
import { AlertModule as AlertModule$1 } from 'ngx-bootstrap/alert';
import * as i4$2 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import * as i3$1 from 'ngx-scrollbar';
import { NgScrollbarModule } from 'ngx-scrollbar';
import * as i1$5 from 'ngx-bootstrap/carousel';
import { CarouselComponent, CarouselModule } from 'ngx-bootstrap/carousel';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i4$3 from '@kolkov/ngx-gallery';
import { NgxGalleryAnimation, NgxGalleryModule } from '@kolkov/ngx-gallery';
import { __decorate, __metadata } from 'tslib';
import { debounce } from 'lodash-decorators';
import * as i2$2 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import * as Chart from 'chart.js';
import * as i2$3 from 'ngx-bootstrap/pagination';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { HttpClientModule } from '@angular/common/http';
import * as i9$1 from 'ngx-bootstrap/typeahead';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

/**
 * The service is used to show the toaster message based on the message type.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ExceptionService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private exceptionService: ExceptionService)
 }
 // or
 export class MyService extends AObjectService {
      private exceptionService: ExceptionService = this.injector.get(ExceptionService);
  }
 ```
 */
class ExceptionService {
    constructor(cartService, constraintRuleService, promotionService, toastr, translateService) {
        this.cartService = cartService;
        this.constraintRuleService = constraintRuleService;
        this.promotionService = promotionService;
        this.toastr = toastr;
        this.translateService = translateService;
        this.cartService.onCartError.subscribe(e => this.showError(e));
    }
    /**
     * Show error message in the toaster.
     * ### Example:
     ```typescript
     
     
     export class MyComponent implements OnInit{
     
         showError(error: CartError | Error | string){
             this.exceptionService.showError(error);
         }
     }
     ```
     * @param error message is of type Error or CartError or string
     */
    showError(error) {
        console.error(error);
        this.translateService.stream([`ERROR.${error}`, 'ERROR.APPLICATION_ERROR_TOASTR_TITLE']).pipe(take(1)).subscribe(val => this.toastr.error(val[`ERROR.${error}`], val['ERROR.APPLICATION_ERROR_TOASTR_TITLE']));
    }
    /**
     * Show success message in the toaster.
     * ### Example:
     ```typescript
     import { ExceptionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         showSuccess(message: string){
             this.exceptionService.showSuccess(message);
         }
     }
     ```
     * @param message success message to be displayed on the toaster.
     * @param title success title on the toaser.
     * @param data is optional; required to return stream of translated values of a
     * key which updates whenever language change.
     */
    showSuccess(message, title = 'SUCCESS.TITLE', data) {
        if (this.timeout)
            clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.translateService.stream([message, title], data).pipe(take(1)).subscribe(val => this.toastr.success(val[message], val[title])), 200);
    }
    /**
     * Show info message in the toaster.
     * ### Example:
     ```typescript
     import { ExceptionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         showInfo(message: string){
             this.exceptionService.showInfo(message);
         }
     }
     ```
     * @param message info message to be displayed on the toaster.
     * @param title info title on the toaser.
     * @param data is optional; required to return stream of translated values of a
     * key which updates whenever language change.
     */
    showInfo(message, title = 'COMMON.INFO_ALERT', data) {
        if (this.timeout)
            clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.translateService.stream([message, title], data).pipe(take(1)).subscribe(val => this.toastr.info(val[message], val[title])), 200);
    }
    /**
     * Show warning message in the toaster.
     * ### Example:
     ```typescript
     import { ExceptionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         showWarning(message: string){
             this.exceptionService.showWarning(message);
         }
     }
     ```
     * @param message warning message to be displayed on the toaster.
     * @param title warning title on the toaser.
     * @param data is optional; required to return stream of translated values of a
     * key which updates whenever language change.
     */
    showWarning(message, title = 'COMMON.INFO_ALERT', data) {
        if (this.timeout)
            clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.translateService.stream([message, title], data).pipe(take(1)).subscribe(val => this.toastr.warning(val[message], val[title])), 200);
    }
}
ExceptionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ExceptionService, deps: [{ token: i1.CartService }, { token: i1.ConstraintRuleService }, { token: i1.PromotionService }, { token: i2.ToastrService }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
ExceptionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ExceptionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ExceptionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.ConstraintRuleService }, { type: i1.PromotionService }, { type: i2.ToastrService }, { type: i2$1.TranslateService }]; } });

/**
 * Product configuration are a complex feature when configuring products with option groups and attribute groups based
 * on business logic.
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductConfigurationService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productConfigurationService: ProductConfigurationService)
 }
 // or
 export class MyService extends AObjectService {
      private productConfigurationService: ProductConfigurationService = this.injector.get(ProductConfigurationService);
  }
 ```
 */
class ProductConfigurationService {
    constructor(metadataService) {
        this.metadataService = metadataService;
        /**
         * Behavior subject emits the configuration state change.
         */
        this.configurationChange = new BehaviorSubject({});
        /**
        * @ignore
        * Emits a boolean when configuration is loaded for the first time in frame.
        */
        this.onLoad = new BehaviorSubject(false);
        /**
        * @ignore
        * Behavior subject emits the bundle information of the product in details page when the configuration
        * is loaded in embedded mode.
        */
        this.bundleState$ = new BehaviorSubject({ isConfig: false });
        /**
         * @ignore
         * CPQ message counter to presume configuration changes in a bundle in CaaS mode.
         */
        this.messageCounter = 0;
        /** stores the quantity of the primary product */
        this.productQuantity = 1;
        fromEvent(window, 'message')
            .pipe(filter((messageEvent) => messageEvent.data && has(messageEvent.data, 'status')), map((messageEvent) => messageEvent.data)).subscribe(message => {
            this.onLoad.next(true);
            this.messageCounter++;
            const ruleActionInfo = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__AppliedRuleActionInfo__c'), message.ruleActionInfos);
            this.onChangeConfiguration({
                hasErrors: message.status.pending,
                netPrice: message.price,
                ruleActions: ruleActionInfo,
                configurationChanged: this.messageCounter > 2
            });
        });
    }
    /**
     * Method responsible to emit the latest configuration State.
     * ### Example:
     ```typescript
     import { ProductConfigurationService } from '@congacommerce/ecommerce';
     import { ConfigurationState } from '../../../shared/interfaces/configuration-state.interface';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private productConfigurationService: ProductConfigurationService){}
     
         onChangeConfiguration(configuration: ConfigurationState){
              this.productConfigurationService.onChangeConfiguration(configuration);
         }
     }
     ```
     * @param configuration accepts the info about the current configuration state in product detail page.
     */
    onChangeConfiguration(configuration) {
        this.onLoad.next(false);
        this.configurationChange.next(configuration);
    }
    /**
     * This method will accepts and stores the quantity of the Primary product in its local state.
     * ### Example:
     ```typescript
     import { ProductConfigurationService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private productConfigurationService: ProductConfigurationService){}
     
         changeProductQuantity(qty: number){
              this.productConfigurationService.changeProductQuantity(qty);
         }
     }
     ```
     * @param qty is of type number.
    */
    changeProductQuantity(qty) {
        this.productQuantity = qty;
    }
    /**
     * Method responsible for fetching the primary lineitem of the product.
     * ### Example:
     ```typescript
     import { ProductConfigurationService, Product, CartItem } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         primaryLineItem: CartItem;
     
         constructor(private productConfigurationService: ProductConfigurationService){}
     
         getProductAttributeGroups(product: Product){
             this.primaryLineItem = this.productConfigurationService.getPrimaryItem(product);
         }
     }
     ```
     * @param product requires instance of product object.
     * @returns an instance of cartItem object.
     */
    getPrimaryItem(product) {
        const primaryItem = plainToClass(CartItem, product.get('item'), { ignoreDecorators: true });
        if (primaryItem && primaryItem.Quantity !== this.productQuantity) {
            primaryItem.Quantity = this.productQuantity;
            return primaryItem;
        }
    }
    /** @ignore */
    getConfigState() {
        return this.bundleState$;
    }
    /** @ignore */
    setConfigState(record) {
        this.bundleState$.next({ isConfig: record.isConfig, relatedTo: record.relatedTo, productId: record.productId });
    }
    /** @ignore */
    postMessageToCpq(dataPayload) {
        this.cassFrame = document.getElementById('embeddedFrame');
        this.targetOrigin = first(this.cassFrame.src.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i));
        this.cassFrame.contentWindow.postMessage(dataPayload, this.targetOrigin);
    }
}
ProductConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationService, deps: [{ token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Injectable });
ProductConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MetadataService }]; } });

/**
 * @ignore
 */
class MiniCartService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.secondaryState = new BehaviorSubject(null);
    }
    publish(cart) {
        this.ngZone.run(() => this.secondaryState.next(cloneDeep(cart)));
    }
    calculateUnsavedChanges(items) {
        let unsavedChanges = [];
        const primaryLineItems = filter$1(items.primary, (p) => p.LineType === 'Product/Service' && p.IsPrimaryLine);
        const secondaryLineItems = filter$1(items.secondary, (p) => p.LineType === 'Product/Service' && p.IsPrimaryLine);
        unsavedChanges = filter$1(secondaryLineItems, item1 => !some(primaryLineItems, item2 => (item2.LineNumber === item1.LineNumber)));
        if (secondaryLineItems.length > 0) {
            const modifiedList = filter$1(primaryLineItems, item1 => !some(secondaryLineItems, item2 => (item2.LineNumber === item1.LineNumber)));
            forEach(modifiedList, (i) => i.set('action', 'exclude'));
            unsavedChanges = unsavedChanges.concat(modifiedList);
        }
        return of(unsavedChanges);
    }
}
MiniCartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartService, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
MiniCartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; } });

/**
 * Revalidate cart modal component is used for showing a modal window with all the cart items which need to be revalidated.
 *
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/cartRevalidation.png" style="max-width: 100%">
 *
 * <h3>Usage</h3>
 *
 ```typescript
import { RevalidateCartModalModule } from '@congacommerce/elements';

@NgModule({
  imports: [RevalidateCartModalModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
<apt-revalidate-cart-modal
* ></apt-revalidate-cart-modal>
```
*/
class RevalidateCartModalComponent {
    constructor(cartService, revalidateCartService, translateService, modalRef) {
        this.cartService = cartService;
        this.revalidateCartService = revalidateCartService;
        this.translateService = translateService;
        this.modalRef = modalRef;
        /** Flag defines whether validation is hard or soft */
        this.isHardRevalidation = false;
        /** Flag to show loader
         * @ignore
         */
        this.loading = false;
        /**
         * Used to hold information for rendering the view.
         * @ignore
         */
        this.view$ = new BehaviorSubject(null);
        /** List of selected cart items */
        this.selectedRecords = [];
        /** Flag to determine cart revalidated or not */
        this.hasError = false;
        /** Flag to disable hard validation cart line items */
        this.isDisabled = false;
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this.subscription = this.revalidateCartService.getRevalidateLines().subscribe((res) => {
            if (res) {
                this.optionalLines = res.optional;
                this.requiredLines = res.required;
                // if any line item need to be revalidate then open revalidate modal popup
                if (this.requiredLines && this.requiredLines.length > 0) {
                    this.isHardRevalidation = true;
                    forEach(this.requiredLines, li => {
                        li.set('state', CheckStatus.CHECKED);
                        li.set('type', 'hard');
                        this.selectedRecords.push(li);
                    });
                }
                const totalLines = concat(this.requiredLines, this.optionalLines);
                this.isDisabled = this.selectedRecords.length === totalLines.length;
                this.view$.next({
                    data: totalLines
                });
                this.updateView();
            }
        });
    }
    /**
     * @ignore
     */
    getProductName(li) {
        return (li.LineType === 'Product/Service') ? li.Product.Name : li.Option.Name;
    }
    /**
     * @ignore
     */
    updateRevalidateitemList(state, record) {
        if (state === CheckStatus.CHECKED && !includes(map$1(this.selectedRecords, 'Id'), get(record, 'Id')))
            this.selectedRecords.push(record);
        else if (state === CheckStatus.UNCHECKED)
            remove(this.selectedRecords, r => get(r, 'Id') === get(record, 'Id'));
    }
    /**
     * @ignore
     */
    updateView() {
        const view = this.view$.value;
        // Add any checked record to the selectedRecords array. This handles programmatically checked records.
        forEach(filter$1(view.data, d => d.get('state') === CheckStatus.CHECKED), checkedRecord => {
            if (!includes(map$1(this.selectedRecords, 'Id'), get(checkedRecord, 'Id')))
                this.selectedRecords.push(checkedRecord);
        });
        // Select records that are in the selected records list
        forEach(view.data, r => {
            if (includes(map$1(this.selectedRecords, 'Id'), get(r, 'Id')))
                r.set('state', CheckStatus.CHECKED);
        });
        // Check the main checkbox based on the state of the selected records.
        if (this.selectedRecords.length === 0)
            view.checkStatus = CheckStatus.UNCHECKED;
        else if (this.selectedRecords.length < get(view.data, 'length'))
            view.checkStatus = CheckStatus.INDETERMINATE;
        else if (this.selectedRecords.length === get(view.data, 'length'))
            view.checkStatus = CheckStatus.CHECKED;
    }
    /**
     * @ignore
     */
    trackById(index, record) {
        return get(record, 'Id');
    }
    /**
       * @ignore
       */
    toggleAllRecords(event) {
        event.target.checked = false;
        const view = this.view$.value;
        let newState;
        // If main checkbox is unchecked or indeterminate with not every record on the current page with actions selected.
        if (view.checkStatus === CheckStatus.UNCHECKED || view.checkStatus === CheckStatus.INDETERMINATE)
            newState = CheckStatus.CHECKED;
        // Else if main checkbox is checked or indeterminated with every record on the current page with actions selected.
        else if (view.checkStatus === CheckStatus.CHECKED)
            newState = CheckStatus.UNCHECKED;
        forEach(get(view, 'data'), d => {
            if (d.get('type') !== 'hard') {
                const state = (get(d, '_metadata.state', '') !== CheckStatus.CHECKED) ? newState : CheckStatus.UNCHECKED;
                d.set('state', state);
                this.updateRevalidateitemList(newState, d);
            }
        });
        // If selected records are less than the total in the table set main checkbox to indeterminate.
        if (this.selectedRecords.length < get(view, 'data', []).length)
            event.target.indeterminate = this.selectedRecords.length === 0 ? false : true;
        // Else if all records in the table are selected set the main checkbox to checked.
        else if (this.selectedRecords.length === get(view, 'data', []).length)
            event.target.checked = true;
        this.updateView();
    }
    /**
     * @ignore
     */
    toggleItem(item) {
        const state = item.get('state') === CheckStatus.CHECKED ? CheckStatus.UNCHECKED : CheckStatus.CHECKED;
        item.set('state', state);
        this.updateRevalidateitemList(state, item);
        this.updateView();
    }
    /**
     * Apply Cart Revalidation.
     */
    applyRevalidation() {
        this.loading = true;
        const cartIds = map$1(this.selectedRecords, 'Id');
        this.revalidateCartService.applyRevalidation(cartIds).pipe(take(1)).subscribe(res => {
            this.loading = false;
            this.revalidateCartService.setRevalidateLines();
            if (res)
                this.modalRef.hide();
            else
                this.hasError = true;
        });
    }
    /**
     * Create Cart or Switch to Previous Cart.
     */
    switchCart() {
        const newCart = new Cart();
        this.cartService.createNewCart(newCart).pipe(take(1), tap(() => this.revalidateCartService.setRevalidateLines())).subscribe(res => {
            this.closeModal();
        }, err => {
            this.translateService.stream('MY_ACCOUNT.CART_LIST.CART_CREATION_FAILED').subscribe((val) => {
                this.message = val;
            });
        });
    }
    /**
     * Close Revalidate cart modal.
     */
    closeModal() {
        this.modalRef.hide();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        if (!isNil(this.subscription))
            this.subscription.unsubscribe();
    }
}
RevalidateCartModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalComponent, deps: [{ token: i1.CartService }, { token: RevalidateCartService }, { token: i2$1.TranslateService }, { token: i1$2.BsModalRef }], target: i0.ɵɵFactoryTarget.Component });
RevalidateCartModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: RevalidateCartModalComponent, selector: "apt-revalidate-cart-modal", ngImport: i0, template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title d-flex align-items-center m-0 text-truncate\">\r\n      {{'REVALIDATE_CART.REVALIDATION_REQUIRED' | translate}}\r\n  </h4>\r\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"closeModal()\" *ngIf=\"!isHardRevalidation\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div\u00A0class=\"modal-body\">\r\n  <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col-sm-12\" *ngIf=\"view$ | async as view\">\r\n          <div class=\"small\">{{ 'REVALIDATE_CART.REVALIDATION_REQUIRED_MSG' | translate }}</div>\r\n          <small class=\"text-danger font-weight-bold\" *ngIf=\"hasError\">{{ 'REVALIDATE_CART.REVALIDATION_ERROR' | translate }}</small>\r\n          <small class=\"text-danger font-weight-bold\" *ngIf=\"message\">{{message}}</small>\r\n          <div class=\"revalidate-block\">\r\n              <table class=\"table table-sm mt-3 mb-0\">\r\n                  <thead class=\"thead-light\">\r\n                  <tr>\r\n                      <th scope=\"col\" width=\"80\" class=\"border-left\">\r\n                          <div class=\"custom-control custom-checkbox\">\r\n                              <input type=\"checkbox\" \r\n                                      class=\"custom-control-input\" \r\n                                      id=\"toggleAll\"\r\n                                      [disabled]=\"isDisabled\"\r\n                                      [indeterminate]=\"view?.checkStatus === 'indeterminate'\"\r\n                                      [checked]=\"view?.checkStatus === 'checked'\"\r\n                                      (click)=\"toggleAllRecords($event)\"\r\n                                      >\r\n                              <label class=\"custom-control-label\" for=\"toggleAll\"></label>\r\n                          </div>\r\n                      </th>\r\n                      <th scope=\"col\" class=\"border-start-0\">{{ 'REVALIDATE_CART.PRODUCTNAME' | translate }}</th>\r\n                      <th scope=\"col\" width=\"220\" class=\"border-left\">{{ 'COMMON.STATUS' | translate }}</th>\r\n                  </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                      <tr>\r\n                          <td colspan=\"3\">\r\n                              <div class=\"inner-body\">\r\n                                  <table>\r\n                                      <ng-container *ngFor=\"let li of view.data; trackBy: trackById\">\r\n                                          <tr [ngClass]=\"{'table-primary' : li.get('type') === 'hard' || li?.get('state') === 'checked'}\">\r\n                                              <td width=\"80\" class=\"border-left border-bottom border-top-0\"> \r\n                                                  <div class=\"custom-control custom-checkbox\">\r\n                                                      <input \r\n                                                          type=\"checkbox\" \r\n                                                          class=\"custom-control-input\" \r\n                                                          [id]=\"'check-' + li?.Id\"\r\n                                                          [disabled]=\"li.get('type') === 'hard'\"\r\n                                                          [checked]=\"li?.get('state') === 'checked'\"\r\n                                                          (click)=\"toggleItem(li)\"\r\n                                                          *ngIf=\"li?.get('state') !== 'readonly'\">\r\n                                                      <label class=\"custom-control-label\" [for]=\"'check-' + li?.Id\"></label>\r\n                                                  </div>\r\n                                              </td>\r\n                                              <td class=\"border-bottom border-top-0\">{{ getProductName(li) }}</td>\r\n                                              <td width=\"220\" class=\"border border-top-0\">{{ 'REVALIDATE_CART.TOBE_REVALIDATE' | translate }} ({{ li.get('type') === 'hard' ? ('REVALIDATE_CART.REQUIRED' | translate) : ('REVALIDATE_CART.OPTIONAL' | translate) }})</td>\r\n                                          </tr>\r\n                                      </ng-container>\r\n                                  </table>\r\n                              </div>\r\n                          </td>\r\n                      </tr>\r\n                  </tbody>\r\n              </table>\r\n          </div>\r\n          <div\u00A0class=\"small mt-3\">\r\n              <span>{{'REVALIDATE_CART.WHATTODO' | translate}}</span>\r\n              <a href=\"javascript:void(0)\" (click)=\"switchCart()\" class=\"ml-1 mr-1\">{{'REVALIDATE_CART.DEACTIVATE_CART' | translate}}</a>\r\n              <span>{{'REVALIDATE_CART.FORNOW' | translate}}</span>\r\n              <small class=\"d-block mt-3 font-italic text-muted\"><i class=\"fas fa-info-circle mr-1\"> </i>{{'REVALIDATE_CART.REVALIDATION_INFO' | translate}}  </small>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary btn-raised\" type=\"button\" [disabled]=\"selectedRecords.length===0\" (click)=\"applyRevalidation()\" [ladda]=\"loading\"\r\n          data-style=\"zoom-in\">{{'REVALIDATE_CART.REVALIDATE' | translate}}</button>\r\n</div>  ", styles: [".revalidate-block .custom-control-label{margin-left:1.5rem}.revalidate-block table tbody>tr>td{padding:0}.revalidate-block table tbody>tr>td .inner-body{padding:0;margin:0;overflow:auto;max-height:10rem}.revalidate-block table tbody>tr>td .inner-body table{width:100%}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-revalidate-cart-modal',
                    templateUrl: './revalidate-cart-modal.component.html',
                    styleUrls: ['./revalidate-cart-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: RevalidateCartService }, { type: i2$1.TranslateService }, { type: i1$2.BsModalRef }]; } });
/** @ignore */
var CheckStatus;
(function (CheckStatus) {
    CheckStatus["CHECKED"] = "checked";
    CheckStatus["INDETERMINATE"] = "indeterminate";
    CheckStatus["UNCHECKED"] = "unchecked";
})(CheckStatus || (CheckStatus = {}));

/**
 * Service that is used by the revalidate cart modal & alert components.
 * @ignore
 */
class RevalidateCartService extends AObjectService {
    constructor() {
        super(...arguments);
        this.apiService = this.injector.get(ApiService);
        this.cartService = this.injector.get(CartService);
        this.modalService = this.injector.get(BsModalService);
        this.storefrontService = this.injector.get(StorefrontService);
        this.state = new BehaviorSubject(null);
    }
    onInit() {
        this.setRevalidateLines();
    }
    /**
     * Used to determine validation of cart line item based on the storefront flag is enable for revalidation
     * and differentiate whether it is optional or required
     */
    setRevalidateLines() {
        const storefront$ = this.storefrontService.getStorefront();
        const validate$ = this.apiService.get(`/carts/${CartService.getCurrentCartId()}/items/validate`);
        storefront$.pipe(switchMap(storefront => (get(storefront, 'EnableCartRevalidation') ? this.cartService.getMyCart() : of(null))), switchMap(res => !isNil(res) ? validate$ : of(null)), take(1)).subscribe(validateRes => {
            if (validateRes) {
                validateRes.optional = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), get(validateRes, 'optional'));
                validateRes.required = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), get(validateRes, 'required'));
            }
            if (validateRes && validateRes.required.length > 0) {
                const modalOptions = {
                    backdrop: 'static',
                    keyboard: false,
                    class: 'modal-lg'
                };
                this.openRevalidateModal(modalOptions);
            }
            this.state.next(validateRes);
        });
    }
    /**
     * get Revalidate lines
     */
    getRevalidateLines() {
        return this.state;
    }
    /**
     * Apply Cart Revalidation
     */
    applyRevalidation(lineItemIds) {
        return zip(this.apiService.post(`/carts/${CartService.getCurrentCartId()}/items/validate`, lineItemIds), this.cartService.getMyCart()).pipe(map(res => {
            if (!get(res[0], 'hasErrors')) {
                const updateLineItems = plainToClass(this.metadataService.getTypeByApiName('Apttus_Config2__LineItem__c'), get(res[0], 'updatedLines'));
                const deletedPrimaryLineNumber = get(res[0], 'deletedLineItems');
                // update cart status
                forEach(deletedPrimaryLineNumber, lineNumber => {
                    remove(res[1].LineItems, { 'PrimaryLineNumber': lineNumber });
                });
                res[1].LineItems = compact(values(merge(keyBy(res[1].LineItems, 'Id'), keyBy(updateLineItems, 'Id'))));
                this.cartService.publish(res[1]);
                // to update status of revalidate lineitems
                const cart = this.state.value;
                forEach(deletedPrimaryLineNumber, lineNumber => {
                    remove(cart.optional, { 'PrimaryLineNumber': lineNumber });
                    remove(cart.required, { 'PrimaryLineNumber': lineNumber });
                });
                forEach(updateLineItems, li => {
                    remove(cart.optional, { 'Id': get(li, 'Id') });
                    remove(cart.required, { 'Id': get(li, 'Id') });
                });
                this.state.next(cart);
                return true;
            }
            else {
                return false;
            }
        }), tap(() => this.cartService.priceCart()));
    }
    /**
     * Open Revalidation Modal popup
     */
    openRevalidateModal(modalOptions) {
        this.modalService.show(RevalidateCartModalComponent, modalOptions);
    }
}
RevalidateCartService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
RevalidateCartService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * An animated spinner built from the bootstrap library to be used to show loading status.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/loadingSpinner.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { IconModule } from '@congacommerce/elements';

@NgModule({
  imports: [IconModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic usage
 ```typescript
* <apt-spinner></apt-spinner>
 ```
*
* // Small spinner
 ```typescript
* <apt-spinner [large]="false"></apt-spinner>
 ```
*
* // Change color of spinner with bootstrap text color class.
 ```typescript
* <apt-spinner color="text-warning"></apt-spinner>
 ```
*/
class SpinnerComponent {
    constructor() {
        /**
         * Flag to set the dots to a larger size.
         */
        this.large = true;
        /**
         * Bootstrap text color class to set the color of the dots.
         */
        this.color = 'text-primary';
    }
}
SpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SpinnerComponent, selector: "apt-spinner", inputs: { large: "large", color: "color" }, ngImport: i0, template: `
    <div
      [class]="'spinner-border ' + color"
      [class.spinner-border-sm]="!large"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-spinner',
                    template: `
    <div
      [class]="'spinner-border ' + color"
      [class.spinner-border-sm]="!large"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  `,
                    styles: [],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], propDecorators: { large: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/**
 * Dependent picklist component displays picklist values with country and state inforamtion of user's address record.
 * @ignore
 *  <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/dependentCountryStatePickList.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { DependentPicklistModule } from '@congacommerce/elements';
@NgModule({
  imports: [DependentPicklistModule, ...]
})
export class AppModule {}
 ```
*
* @example
 ```typescript
* <apt-dependent-picklist
*               [(ngModel)]="myModel"
*               [fieldMethod]="fieldService"
*               [field]="stateCode"
*               [parentField]="countryCode"
*               [inline]="isInline"
*               [size]="inputSize"
* ></apt-dependent-picklist>
 ```
*/
class DependentPicklistComponent {
    constructor(metadataService) {
        this.metadataService = metadataService;
        /**
         * Flag to set this as an inline element.
         */
        this.inline = true;
        /**
         * Size of the input.
         */
        this.size = 'md';
        /**
         * Used to hold information for rendering the view.
         */
        this.view$ = new BehaviorSubject(null);
    }
    /**
    * Stores the picklist values of address fields like country and state which are displayed on initial page load. Picklist values are based on type of address as per user preference. Different address type values can be mailing address, billing address, shipping address etc.
    */
    ngOnChanges() {
        // this.valueSub = Observable.from(this.value);
        this.ngOnDestroy();
        const service = this.metadataService.getAObjectServiceForType(this.entity);
        this.subscription = combineLatest(service.describe(this.entity.getType(), this.parentField), service.describe(this.entity.getType(), this.field))
            .subscribe(r => {
            this.view$.next({
                parentDescribe: _.first(r),
                fieldDescribe: _.last(r)
            });
            this.updateView();
        });
    }
    ngOnDestroy() {
        if (!_.isNil(this.subscription))
            this.subscription.unsubscribe();
    }
    /**
    * @param evt Event associated with the user action.
    * Sets the country and corresponding state inforamtion selected by the user from dropdown.
    */
    parentChange(evt) {
        const state = this.view$.value;
        state.value = '';
        const countryIdx = _.findIndex(state.parentDescribe.picklistValues, (c) => c.value === evt);
        state.childOptions = _.filter(_.get(state, 'fieldDescribe.picklistValues'), s => testBit(b64bin(s.validFor), countryIdx));
        state.parentValue = _.get(_.find(_.get(state, 'parentDescribe.picklistValues'), y => y.value === evt), 'value');
        this.value = [_.find(_.get(state, 'parentDescribe.picklistValues'), y => y.value === state.parentValue), _.find(_.get(state, 'fieldDescribe.picklistValues'), y => y.value === state.value)];
        if (this.onChange)
            this.onChange(this.value);
    }
    /**
    * @param evt Event associated with the user action.
    * Sets the state inforamtion selected by the user from dropdown.
    */
    childChange(evt) {
        const state = this.view$.value;
        state.value = evt;
        this.value = [_.find(_.get(state, 'parentDescribe.picklistValues'), y => y.value === state.parentValue), _.find(_.get(state, 'fieldDescribe.picklistValues'), y => y.value === state.value)];
        if (this.onChange)
            this.onChange(this.value);
    }
    writeValue(value) {
        this.value = value;
        if (value && this.view$.value)
            this.updateView();
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { }
    updateView() {
        if (this.value && this.view$.value) {
            const state = this.view$.value;
            state.parentValue = _.get(_.find(_.get(state, 'parentDescribe.picklistValues'), y => y.label === _.first(this.value)), 'value');
            const countryIdx = _.findIndex(state.parentDescribe.picklistValues, (c) => c.value === state.parentValue);
            state.childOptions = _.filter(_.get(state, 'fieldDescribe.picklistValues'), s => testBit(b64bin(s.validFor), countryIdx));
            state.value = _.get(_.find(_.get(state, 'fieldDescribe.picklistValues'), y => y.label === _.last(this.value)), 'value');
            this.value = [_.find(_.get(state, 'parentDescribe.picklistValues'), y => y.value === state.parentValue), _.find(_.get(state, 'fieldDescribe.picklistValues'), y => y.value === state.value)];
        }
    }
}
DependentPicklistComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistComponent, deps: [{ token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Component });
DependentPicklistComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DependentPicklistComponent, selector: "apt-dependent-picklist", inputs: { entity: "entity", field: "field", parentField: "parentField", inline: "inline", size: "size" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: DependentPicklistComponent,
            multi: true
        }], usesOnChanges: true, ngImport: i0, template: `
    <div [class.d-flex]="inline" *ngIf="view$ | async as view">
      <div *ngIf="view.parentDescribe as parentDescribe" class="form-group" [class.mr-3]="inline">
        <label for="parentField">{{parentDescribe?.label}}</label>
        <select class="custom-select" [class.custom-select-sm]="size === 'sm'" [(ngModel)]="view.parentValue" name="parentValue" (ngModelChange)="parentChange($event)" [class.custom-select-lg]="size === 'lg'" id="parentField" required="" name="parentField" [disabled]="parentDescribe?.updateable === false">
          <option [value]="" *ngIf="parentDescribe?.nillable">{{'DEPENDENT_PICKLIST.CHOOSE' | translate}}...</option>
          <option *ngFor="let picklist of parentDescribe?.picklistValues" [value]="picklist.value" [hidden]="!picklist.active">{{picklist.label}}</option>
        </select>
      </div>
      <div *ngIf="view.fieldDescribe as fieldDescribe" class="form-group">
        <label for="childField">{{fieldDescribe?.label}}</label>
        <select class="custom-select" [class.custom-select-sm]="size === 'sm'" [(ngModel)]="view.value" name="value" (ngModelChange)="childChange($event)" [class.custom-select-lg]="size === 'lg'" id="childField" required="" name="childField" [disabled]="fieldDescribe?.updateable === false || !view?.childOptions">
          <option [value]="" *ngIf="fieldDescribe?.nillable">{{'DEPENDENT_PICKLIST.CHOOSE' | translate}}...</option>
          <option *ngFor="let picklist of view.childOptions" [value]="picklist.value" [hidden]="!picklist.active">{{picklist.label}}</option>
        </select>
      </div>
    </div>
  `, isInline: true, directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-dependent-picklist',
                    template: `
    <div [class.d-flex]="inline" *ngIf="view$ | async as view">
      <div *ngIf="view.parentDescribe as parentDescribe" class="form-group" [class.mr-3]="inline">
        <label for="parentField">{{parentDescribe?.label}}</label>
        <select class="custom-select" [class.custom-select-sm]="size === 'sm'" [(ngModel)]="view.parentValue" name="parentValue" (ngModelChange)="parentChange($event)" [class.custom-select-lg]="size === 'lg'" id="parentField" required="" name="parentField" [disabled]="parentDescribe?.updateable === false">
          <option [value]="" *ngIf="parentDescribe?.nillable">{{'DEPENDENT_PICKLIST.CHOOSE' | translate}}...</option>
          <option *ngFor="let picklist of parentDescribe?.picklistValues" [value]="picklist.value" [hidden]="!picklist.active">{{picklist.label}}</option>
        </select>
      </div>
      <div *ngIf="view.fieldDescribe as fieldDescribe" class="form-group">
        <label for="childField">{{fieldDescribe?.label}}</label>
        <select class="custom-select" [class.custom-select-sm]="size === 'sm'" [(ngModel)]="view.value" name="value" (ngModelChange)="childChange($event)" [class.custom-select-lg]="size === 'lg'" id="childField" required="" name="childField" [disabled]="fieldDescribe?.updateable === false || !view?.childOptions">
          <option [value]="" *ngIf="fieldDescribe?.nillable">{{'DEPENDENT_PICKLIST.CHOOSE' | translate}}...</option>
          <option *ngFor="let picklist of view.childOptions" [value]="picklist.value" [hidden]="!picklist.active">{{picklist.label}}</option>
        </select>
      </div>
    </div>
  `,
                    styles: [],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: DependentPicklistComponent,
                            multi: true
                        }],
                    changeDetection: ChangeDetectionStrategy.Default
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MetadataService }]; }, propDecorators: { entity: [{
                type: Input,
                args: ['entity']
            }], field: [{
                type: Input,
                args: ['field']
            }], parentField: [{
                type: Input,
                args: ['parentField']
            }], inline: [{
                type: Input,
                args: ['inline']
            }], size: [{
                type: Input,
                args: ['size']
            }] } });
/**
 * @ignore
* @param a string value str representing country or state information.
* @returns a result array containing b64 conversion of input string paramater.
*/
function b64bin(str) {
    let chars = str.split('');
    let bits = '';
    for (let n = 0; n < chars.length; n++) {
        let bit = '';
        let num = b64a[chars[n]];
        let bin = num.toString(2);
        for (let i = 6 - bin.length; i > 0; i--) {
            bit += '0';
        }
        bit += bin;
        bits += (bit);
    }
    let result = [];
    while (bits.length) {
        result.push(bits.substr(0, 8));
        bits = bits.substr(8);
    }
    return result;
}
/**
 * @ignore
 */
const b64a = {
    'C': 2, 'B': 1, 'A': 0, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9, 'K': 10, 'L': 11,
    'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 30, 'W': 22, 'X': 23,
    'Y': 24, 'Z': 25, 'a': 26, 'b': 27, 'c': 28, 'd': 29, 'e': 30, 'f': 31, 'g': 32, 'h': 33, 'i': 34, 'j': 35,
    'k': 36, 'l': 37, 'm': 38, 'n': 39, 'o': 40, 'p': 41, 'q': 41, 'r': 43, 's': 44, 't': 45, 'u': 46, 'v': 47,
    'w': 48, 'x': 49, 'y': 50, 'z': 51
};
/**
 *
 *@ignore
 */
function testBit(bytes, pos) {
    let byteToCheck = Math.floor(pos / 8);
    let bit = 7 - (pos % 8);
    return ((Math.pow(2, bit) & bytes[byteToCheck]) >> bit) === 1;
}

/**
 * The Address component allows users to enter address details. The details include street name, city name, country code, state code and zip code.
 * When a user tries to add a new address or update an existing address associated with his account, he can fill in details like street, city name and zip in the respective text boxes provided.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/address.png" style="max-width: 100%">
 *
 * <h3>Usage</h3>
 *
 ```typescript
import { AddressModule } from '@congacommerce/elements';
@NgModule({
  imports: [AddressModule, ...]
})
export class AppModule {}
```
*
* @example
```typescript
* <apt-address
*              [(ngModel)]="contact"
*              [readonly]="readonly"
*              [type]="Shipping"
*              [form]="form"></apt-address>
```
*/
class AddressComponent {
    /**
       * Constructor for Address Component for injecting dependencies.
       *
       * @param accountLocationService Instance of AccountLocationService
       * @param contactService Instance of ContactService
       * @param accountService Instance of AccountService
       */
    constructor(accountLocationService, contactService, accountService, aobjectService) {
        this.accountLocationService = accountLocationService;
        this.contactService = contactService;
        this.accountService = accountService;
        this.aobjectService = aobjectService;
        /**
         * Flag to set this form as read only or as an editable form.
         */
        this.readonly = false;
        /**
         * Set the address as either billing or shipping.
         */
        this.type = 'Billing';
        /**
         * NgForm object to bind data to.
         */
        this.form = new NgForm(null, null);
        /**
         * A new instance of Account
         * @ignore
         */
        this.entity = new Account();
        this.uniqueId = _.uniqueId();
    }
    /**
     * Value to set to the user's address details.
     */
    set value(record) {
        this.record = record;
    }
    /**
      * @returns a string value representing the street details on user's address record.
      * The return value holds the street information of an address type. Different address type values can be mailing address, billing address, shipping address etc.
     * @ignore
    */
    get street() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'Street'))
            return 'Street';
        else if (_.get(this.record, 'street'))
            return 'street';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingStreet'))
            return (this.type === 'Billing') ? 'MailingStreet' : 'OtherStreet';
        else
            return (this.type === 'Billing') ? 'BillingStreet' : 'ShippingStreet';
    }
    /**
      * @returns a string value representing the city details on user's address record.
      * The return value holds the city information of an address type. Different address type values can be mailing address, billing address, shipping address etc.
     * @ignore
    */
    get city() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'City'))
            return 'City';
        else if (_.get(this.record, 'city'))
            return 'city';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingCity'))
            return (this.type === 'Billing') ? 'MailingCity' : 'OtherCity';
        else
            return (this.type === 'Billing') ? 'BillingCity' : 'ShippingCity';
    }
    /**
      * @returns a string value representing the state property on user's address record.
      * The return value defines a picklist with state names for the selected country.
     * @ignore
    */
    get state() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'State'))
            return 'State';
        else if (_.get(this.record, 'state'))
            return 'state';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingState'))
            return (this.type === 'Billing') ? 'MailingState' : 'OtherState';
        else
            return (this.type === 'Billing') ? 'BillingState' : 'ShippingState';
    }
    /**
      * @returns a string value representing the state property on user's address record.
      * The return value defines a picklist with state codes for the selected country code.
     * @ignore
    */
    get stateCode() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'State'))
            return 'State';
        else if (_.get(this.record, 'stateCode'))
            return 'stateCode';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingStateCode'))
            return (this.type === 'Billing') ? 'MailingStateCode' : 'OtherStateCode';
        else
            return (this.type === 'Billing') ? 'BillingStateCode' : 'ShippingStateCode';
    }
    /**
      * @returns a string value representing the postal code property on user's address record.
      * The return value holds the zip code information of an address type. Different address type values can be mailing address, billing address, shipping address etc.
     * @ignore
    */
    get postalCode() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'PostalCode'))
            return 'PostalCode';
        else if (_.get(this.record, 'postalCode'))
            return 'postalCode';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingPostalCode'))
            return (this.type === 'Billing') ? 'MailingPostalCode' : 'OtherPostalCode';
        else
            return (this.type === 'Billing') ? 'BillingPostalCode' : 'ShippingPostalCode';
    }
    /**
      * @returns a string value representing the country property based on the type of user's address record.
      * The return value defines a picklist with country names in address record.
     * @ignore
    */
    get country() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'Country'))
            return 'Country';
        else if (_.get(this.record, 'country'))
            return 'country';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingCountry'))
            return (this.type === 'Billing') ? 'MailingCountry' : 'OtherCountry';
        else
            return (this.type === 'Billing') ? 'BillingCountry' : 'ShippingCountry';
    }
    /**
      * @returns a string value representing the country code property based on the type of user's address record.
      * The return value defines a picklist with country codes in address record.
     * @ignore
    */
    get countryCode() {
        if (this.record instanceof AccountLocation || _.get(this.record, 'Country'))
            return 'Country';
        else if (_.get(this.record, 'countryCode'))
            return 'countryCode';
        else if (this.record instanceof Contact || _.get(this.record, 'MailingCountryCode'))
            return (this.type === 'Billing') ? 'MailingCountryCode' : 'OtherCountryCode';
        else
            return (this.type === 'Billing') ? 'BillingCountryCode' : 'ShippingCountryCode';
    }
    /**
      * @param evt Event associated with the user action.
      * Sets the country and state information selected by the user.
     * @ignore
    */
    countryStateChange([parent, child]) {
        const country = (_.isNil(parent)) ? '' : _.get(parent, 'label');
        const state = (_.isNil(child)) ? '' : _.get(child, 'label');
        if (this.record instanceof Contact) {
            _.set(this.record, `${this.countryCode}`, _.get(parent, 'value'));
            _.set(this.record, `${this.stateCode}`, _.get(child, 'value'));
            _.set(this.record, `${this.country}`, country);
            _.set(this.record, `${this.state}`, state);
        }
        else {
            _.set(this.record, `${this.country}`, country);
            _.set(this.record, `${this.state}`, state);
        }
    }
    ngOnInit() {
        const entity = !(this.record instanceof AObject) ? new Account() : this.record;
        this.cityLabel$ = this.aobjectService.describe(entity.getType(), this.city).pipe(map(res => _.get(res, 'label')));
        this.postalCodeLabel$ = this.aobjectService.describe(entity.getType(), this.postalCode).pipe(map(res => _.get(res, 'label')));
    }
    /**
       * @ignore
       *
    */
    writeValue(value) {
        this.record = value;
        if (this.record instanceof AccountLocation) {
            this.countryState = [this.record.Country, this.record.State];
        }
    }
    /**
     * @ignore
     */
    registerOnChange(fn) { }
    /**
     * @ignore
     */
    registerOnTouched(fn) { }
    /**
       * @returns unique id which is associated to the address fields entered. Address details iclude street name, city name and zip code.
       * @param id Address type for which a unique id has to be generated.
     * @ignore
    */
    getId(id) {
        return this.uniqueId + '_' + id;
    }
}
AddressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressComponent, deps: [{ token: i1.AccountLocationService }, { token: i1.ContactService }, { token: i1.AccountService }, { token: i1$1.AObjectService }], target: i0.ɵɵFactoryTarget.Component });
AddressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AddressComponent, selector: "apt-address", inputs: { readonly: "readonly", type: "type", form: "form", value: "value" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: AddressComponent,
            multi: true
        }], ngImport: i0, template: "\r\n<div *ngIf=\"record\">\r\n  <ng-container *ngIf=\"!readonly; else read\">\r\n    <div class=\"mb-3\">\r\n      <label [for]=\"getId('street')\">{{ 'ADDRESS.ADDRESS_LINE1' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [id]=\"getId('street')\" placeholder=\"{{ 'ADDRESS.PLACEHOLDER_FOR_ADDRESS_LINE1' | translate }}\" required [(ngModel)]=\"record[street]\"\r\n        name=\"street\" #address=\"ngModel\" [ngClass]=\"{ 'is-invalid': address.invalid && (address.touched || address.dirty || form.submitted) }\">\r\n      <div class=\"invalid-feedback\">\r\n        {{ 'ADDRESS.INVALID_SHIPPING' | translate }}\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"mb-3\">\r\n      <label [for]=\"getId('city')\">{{cityLabel$ | async}}</label>\r\n      <input type=\"text\" class=\"form-control\" [id]=\"getId('city')\" placeholder=\"{{ 'ADDRESS.CITY' | translate }}\" required [(ngModel)]=\"record[city]\"\r\n        name=\"city\" #cityTemplate=\"ngModel\" [ngClass]=\"{ 'is-invalid': cityTemplate.invalid && (cityTemplate.touched || cityTemplate.dirty || form.submitted) }\">\r\n      <div class=\"invalid-feedback\">\r\n        {{ 'ADDRESS.INVALID_CITY' | translate }}\r\n      </div>\r\n    </div>\r\n    \r\n    <div class=\"row\">\r\n      <div class=\"col-md-9 mb-3\">\r\n        <apt-dependent-picklist name=\"dependentPicklist\" [entity]=\"entity\" field=\"BillingStateCode\" parentField=\"BillingCountryCode\" [(ngModel)]=\"countryState\" (ngModelChange)=\"countryStateChange($event)\"></apt-dependent-picklist>\r\n      </div>\r\n      <div class=\"col-md-3 mb-3\">\r\n        <label [for]=\"getId('zip')\">{{postalCodeLabel$ | async}}</label>\r\n        <input type=\"text\" class=\"form-control\" [id]=\"getId('zip')\" required [(ngModel)]=\"record[postalCode]\"\r\n          name=\"postal-code\" #zipcode=\"ngModel\" [ngClass]=\"{ 'is-invalid': zipcode.invalid && (zipcode.touched || zipcode.dirty || form.submitted) }\">\r\n        <div class=\"invalid-feedback\">\r\n            {{ 'ADDRESS.INVALID_ZIP' | translate }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #read>\r\n    <address class=\"mb-0\">\r\n      {{record[street]}}\r\n      <br> {{record[city]}}, {{record[state]}} {{record[postalCode]}}\r\n      <br> {{record[country]}}\r\n    </address>\r\n  </ng-template>\r\n</div>", components: [{ type: DependentPicklistComponent, selector: "apt-dependent-picklist", inputs: ["entity", "field", "parentField", "inline", "size"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe }, viewProviders: [{
            provide: ControlContainer,
            useExisting: NgForm
        }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-address',
                    templateUrl: './address.component.html',
                    styles: [],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: AddressComponent,
                            multi: true
                        }],
                    viewProviders: [{
                            provide: ControlContainer,
                            useExisting: NgForm
                        }]
                }]
        }], ctorParameters: function () { return [{ type: i1.AccountLocationService }, { type: i1.ContactService }, { type: i1.AccountService }, { type: i1$1.AObjectService }]; }, propDecorators: { readonly: [{
                type: Input
            }], type: [{
                type: Input
            }], form: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

/** @ignore  */
const _moment$1 = moment;
/**
 * The Input field component displays the field values as a radio button, checkbox, dropdown, a text area or a label value, depending upon the field type.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/input-field.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { InputFieldModule } from '@congacommerce/elements';

@NgModule({
  imports: [InputFieldModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage
 ```typescript
* <apt-input-field
*             [(ngModel)]="myModel"
*             [field]="fieldApiName"
*             [entity]="entityApiName"
* ></apt-input-field>
 ```
*
* // All inputs and outputs
 ```typescript
* <apt-input-field
*             [(ngModel)]="myModel"
*             (ngModelChange)="handleChange($event)"
*             [field]="fieldApiName"
*             [entity]="entityApiName"
*             [label]="label"
*             [readonly]="isReadOnly"
*             [allowEmpty]="allowEmpty"
*             [disabledValues]="disabledValues"
*             [hiddenValues]="hiddenValues"
*             [inline]="isInline"
*             [small]="isSmall"
*             [rows]="2"
*             [placeholder]="myPlaceholder"
*             [required]="true"
*             [errorMsg]="errorMessage"
*             [showLabel]="true"
*             [labelClass]="labelClass"
*             [filterValues]="filterValues"
*             [hideOptions]="true"
*             [hide]="true"
*             [defaultValue]="true"
*             [enableValues]="values"
*             [lookupOptions]="lookupOptions"
* ></apt-input-field>
 ```
*/
class InputFieldComponent {
    constructor(cacheService, translateService, aobjectService, cdr, metadataService) {
        this.cacheService = cacheService;
        this.translateService = translateService;
        this.aobjectService = aobjectService;
        this.cdr = cdr;
        this.metadataService = metadataService;
        /**
         * Label to be shown on this input.
         */
        this.showLabel = true;
        /**
         * Flag to set this input as read only.
         */
        this.readonly = false;
        /**
         * Flag to allow this input to be empty.
         */
        this.allowEmpty = false;
        /**
         * Set of disabled values.
         */
        this.disabledValues = new Set();
        /**
         * Set of hidden values.
         */
        this.hiddenValues = new Set();
        /**
         * Flag to set this input as inline.
         */
        this.inline = false;
        /**
         * Flag to set this element as a small input.
         */
        this.small = false;
        /**
         * rows override for textarea
         */
        this.rows = 3;
        /**
         * Placeholder string for the input.
         */
        this.placeholder = '';
        /**
         * Boolean value to show default picklist values or not.
         */
        this.hideOptions = false;
        /**
         *  Boolean value to show or hide the component.
         */
        this.hide = false;
        /**
         *  set minimum value for the number field of type 'double'.
         */
        this.minVal = 1;
        /**
         * Flag to set the picklist to a multipicklist
         */
        this.multiple = false;
        /**
         * Flag to show the asterisk on a field.
         */
        this.asterisk = true;
        /** @ignore */
        this.disabled = false;
        /** @ignore */
        this.value = null;
        /** @ignore */
        this.view$ = new BehaviorSubject(null);
        /** @ignore */
        this.loading = false;
        /**
         * Current subscriptions in this class.
         * @ignore
         */
        this.subs = [];
        /** @ignore */
        this.onTouched = () => { };
        /**
         * @ignore
         */
        // tslint:disable-next-line:no-shadowed-variable
        this.propagateChange = (_) => { };
    }
    ngOnChanges() {
        if (!this.entity || !this.field)
            throw 'Entity and field name are required for input-field component';
        else {
            this.subs.push(this.aobjectService.describe(this.getEntityType(), this.field)
                .subscribe(metadata => {
                let view = {
                    metadata: null,
                    lookupResults: null
                };
                view.metadata = metadata;
                if (this.fieldType) {
                    view.metadata = {
                        type: this.fieldType
                    };
                }
                this.view$.next(view);
                if (!_.isNil(this.value))
                    this.setLookupFieldData();
            }));
        }
        this.uuid = this.cacheService.guid();
        this.setOptions();
        this.translateService.stream('COMMON.EMPTY').subscribe((value) => {
            this.emptyLabel = value;
        });
        if (this.defaultValue === true)
            this.setInitialValue();
    }
    /** @ignore */
    getEntityType() {
        return (this.entity instanceof AObject) ? this.entity.constructor : this.entity;
    }
    /** @ignore */
    onLookupSearch(data) {
        if (this.timeout)
            clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.setLookupFieldData(_.get(data, 'term'));
        }, 500);
    }
    /** @ignore */
    setLookupFieldData(query = '') {
        this.subs.push(this.view$.pipe(take(1), filter(view => _.get(view, 'metadata.type') === 'reference'), flatMap(view => {
            this.loading = true;
            const objectName = _.get(view, 'metadata.referenceTo[0]');
            const keyType = this.metadataService.getTypeByApiName(objectName);
            const service = this.metadataService.getAObjectServiceForType(keyType);
            this.lookupOptions = _.assign({
                secondaryTextField: '',
                thumbnailField: '',
                primaryTextField: 'Name',
                conditions: null,
                expressionOperator: 'AND',
                filters: null,
                fieldList: ['Name', 'Id'],
                sortOrder: null,
                page: new APageInfo(10)
            }, this.lookupOptions);
            this.lookupOptions.searchString = query;
            const obsv$ = service.query(_.omit(this.lookupOptions, ['primaryTextField', 'secondaryTextField', 'thumbnailField']));
            let recordObsv$ = of(null);
            if (!_.isNil(this.value))
                recordObsv$ = service.fetch(this.value);
            combineLatest(obsv$, recordObsv$).pipe(take(1)).subscribe(([results, record]) => {
                this.loading = false;
                if (!_.isNil(record) && !_.isEmpty(results))
                    results.unshift(record);
                view.lookupResults = results;
                this.cdr.markForCheck();
            });
            return of(view);
        }), catchError(() => {
            this.loading = false;
            return of(null);
        }))
            .subscribe(myView => {
            this.view$.next(myView);
        }));
    }
    /**
      * Adds the field values to be displayed, to an object with key value properties. The field would be a read only if the disabled property is set to true.
      * @returns an array of picklist objects with label, value and disabled properties.
      * @ignore
    */
    setOptions() {
        this.subs.push(this.view$.pipe(map(view => {
            const options = new Array();
            _.get(view, 'metadata.picklistValues', []).forEach(option => {
                if ((!_.get(this.hiddenValues, 'has') || !this.hiddenValues.has(option.value)) && option.active !== false) {
                    // Picklist values to be popoulated in the dropdown.
                    this.placeholder = 'None';
                    if (_.get(this.filterValues, 'length') > 0) {
                        if (this.filterValues.find(r => r === option.value)) {
                            options.push({
                                label: option.label,
                                value: option.value,
                                disabled: (this.disabledValues && this.disabledValues.has) ? this.disabledValues.has(option.value) : false
                            });
                        }
                    }
                    else if (!this.hideOptions) {
                        options.push({
                            label: option.label,
                            value: option.value,
                            disabled: (this.disabledValues && this.disabledValues.has) ? this.disabledValues.has(option.value) : false
                        });
                    }
                }
            });
            if (this.allowEmpty)
                options.unshift({
                    label: this.emptyLabel,
                    value: null,
                    disabled: false
                });
            return options;
        }))
            .subscribe(metadata => {
            this.options = metadata;
            this.cdr.markForCheck();
        }));
    }
    /** @ignore */
    setInitialValue() {
        if (_.isNil(this.value)) {
            this.view$.pipe(take(1))
                .subscribe(view => {
                this.writeValue(SalesforceUtils.getDefaultValue(_.get(view, 'metadata')));
            });
        }
    }
    /**
     * Sets the field value to null or its default.
     * @param field value.
     * @ignore
    */
    writeValue(value = null) {
        if (value !== this.value) {
            this.value = value;
            this.setLookupFieldData();
            this.propagateChange(this.value);
        }
    }
    /** @ignore */
    registerOnChange(fn) { this.propagateChange = fn; }
    /** @ignore */
    registerOnTouched(fn) { this.onTouched = fn; }
    /** @ignore */
    setDisabledState(isDisabled) { this.disabled = isDisabled; }
    /** @ignore */
    onBooleanChange(value) {
        this.propagateChange(value);
    }
    /** @ignore */
    onCurrencyChange(value) {
        this.propagateChange(value);
    }
    /**
     * Sets the field value to the selected checbox value.
     *
     * @param data check box value selected by user.
     * @ignore
     */
    onMultiChange(data) {
        if ((!this.value && data)) {
            this.value = data;
        }
        else if (this.value.indexOf(data) === -1) {
            this.value += `;${data}`;
        }
        else {
            this.value = _.remove(this.value.split(';'), function (n) {
                return n !== data;
            }).join(';');
        }
        if (_.isEmpty(this.value))
            this.value = null;
        this.propagateChange(this.value);
    }
    onPickChange(data) {
        if ((!this.value && data)) {
            this.value = data;
        }
        else if (_.isEmpty(this.value))
            this.value = null;
        this.propagateChange(this.value);
    }
    /*
     * @ignore
     */
    onLookupChange(value, lookupResults) {
        if (_.get(this, 'lookupOptions.onLookupChange')) {
            this.lookupOptions.onLookupChange(_.find(lookupResults, { Id: value }));
        }
        this.propagateChange(value);
    }
    /** @ignore */
    getsetValue(val) {
        if (_.defaultTo(this.value) && this.value.indexOf(val) > -1) {
            return {
                value: true
            };
        }
        else {
            return {
                val: false
            };
        }
    }
    /**
     * Sets the field value to the selected date value.
     * @ignore
     */
    onDateChange(value) {
        this.writeValue(_moment$1(value).format('YYYY-MM-DD'));
    }
    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }
}
InputFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldComponent, deps: [{ token: i1$1.CacheService }, { token: i2$1.TranslateService }, { token: i1$1.AObjectService }, { token: i0.ChangeDetectorRef }, { token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Component });
InputFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InputFieldComponent, selector: "apt-input-field", inputs: { errorMsg: "errorMsg", field: "field", entity: "entity", showLabel: "showLabel", label: "label", readonly: "readonly", allowEmpty: "allowEmpty", disabledValues: "disabledValues", hiddenValues: "hiddenValues", inline: "inline", small: "small", rows: "rows", placeholder: "placeholder", required: "required", labelClass: "labelClass", filterValues: "filterValues", hideOptions: "hideOptions", hide: "hide", minVal: "minVal", defaultValue: "defaultValue", enableValues: "enableValues", lookupOptions: "lookupOptions", multiple: "multiple", asterisk: "asterisk", fieldType: "fieldType", displayFieldType: "displayFieldType" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputFieldComponent),
            multi: true
        }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"view$ | async as view\">\r\n  <div [ngSwitch]=\"view?.metadata?.type\" class=\"form-group align-items-center\" [class.d-flex]=\"inline\"\r\n    [id]=\"uuid + '-container'\">\r\n    <label *ngIf=\"showLabel\" [class.m-0]=\"inline\" [class.mr-2]=\"inline\"\r\n      [ngClass]=\"{'font-weight-bold': !labelClass}\">{{(label) ? label : view?.metadata?.label}}</label>\r\n    <i *ngIf=\"required && asterisk\" class=\"fa fa-asterisk text-danger font-weight-normal custom-asterisk p-1\"></i>\r\n\r\n\r\n    <!--Picklist-->\r\n    <div *ngSwitchCase=\"'picklist'\">\r\n      <ng-select class=\"form-control picklist p-0\" [searchable]=\"false\" [(ngModel)]=\"value\" [required]=\"required\"\r\n        [placeholder]=\"placeholder\" [loading]=\"loading\" [disabled]=\"readonly\" (ngModelChange)=\"onPickChange(value)\"\r\n        #picklist=\"ngModel\" [ngClass]=\"{ 'is-invalid': picklist.invalid && (picklist.touched || picklist.dirty) }\"\r\n        [items]=\"options\" [multiple]=\"multiple\" bindValue=\"value\" bindLabel=\"label\">\r\n        <div class=\"invalid-feedback\">\r\n          {{errorMsg}}\r\n        </div>\r\n      </ng-select>\r\n\r\n      <ng-template #checkboxes>\r\n        <div *ngFor=\"let option of options$ | async\" class=\"custom-control custom-radio\" [class.custom-radio-sm]=\"small\"\r\n          [class.custom-control-inline]=\"inline\">\r\n          <input type=\"radio\" class=\"custom-control-input\" [name]=\"uuid + '_' + view?.metadata.name\"\r\n            [value]=\"option.value\" [id]=\"uuid + '_' + view?.metadata.name + '_' + option.value\" [(ngModel)]=\"value\"\r\n            (ngModelChange)=\"propagateChange(value)\" [disabled]=\"readonly || option.disabled\" [required]=\"required\">\r\n          <label class=\"custom-control-label mr-auto\" [for]=\"uuid + '_' + view?.metadata.name + '_' + option.value\">\r\n            {{option.label}}\r\n          </label>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n\r\n    <ng-container *ngSwitchCase=\"'boolean'\">\r\n      <div *ngIf=\"displayFieldType === 'radio'; else picklists\">\r\n        <div class=\"form-check\">\r\n          <input type=\"radio\" class=\"form-check-input\" [id]=\"uuid + '_' + view?.metadata.name + '_' + value\"\r\n            [name]=\"uuid + '_' + view?.metadata.name\" [checked]=\"value\" (change)=\"onBooleanChange(true)\">\r\n          <label class=\"form-check-label\" [for]=\"uuid + '_' + view?.metadata.name + '_' + value\">{{'COMMON.YES' |\r\n            translate}}</label><br>\r\n        </div>\r\n        <div class=\"form-check\">\r\n          <input type=\"radio\" class=\"form-check-input\" [id]=\"uuid + '_' + view?.metadata.name + '_' + !value\"\r\n            [name]=\"uuid + '_' + view?.metadata.name\" [checked]=\"!value\" (change)=\"onBooleanChange(false)\">\r\n          <label class=\"form-check-label\" [for]=\"uuid + '_' + view?.metadata.name + '_' + !value\">{{'COMMON.NO' |\r\n            translate}}</label><br>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #picklists>\r\n      <select type=\"radio\" class=\"form-control\" [class.form-control-sm]=\"small\" *ngSwitchCase=\"'boolean'\"\r\n        [(ngModel)]=\"value\" [class.custom-control-inline]=\"inline\" (ngModelChange)=\"onBooleanChange(value)\"\r\n        [required]=\"required\" [disabled]=\"readonly\">\r\n        <option [value]=\"true\"> {{'COMMON.YES' | translate}} </option>\r\n        <option [value]=\"false\"> {{'COMMON.NO' | translate}} </option>\r\n      </select>\r\n    </ng-template>\r\n\r\n    <!--Multi select picklist-->\r\n    <ng-container *ngSwitchCase=\"'multipicklist'\">\r\n      <div *ngFor=\"let option of view?.metadata.picklistValues\" class=\"custom-control custom-checkbox\"\r\n        [class.custom-checkbox-sm]=\"small\" [class.custom-control-inline]=\"inline\">\r\n        <input type=\"checkbox\" class=\"custom-control-input\" [checked]=\"value && value?.indexOf(option.value) > -1\"\r\n          [id]=\"uuid + '_' + view?.metadata.name + '_' + option.value\" pattern=\"07[0-9]{9}\"\r\n          [(ngModel)]=\"getsetValue(option.value).value\" (ngModelChange)=\"onMultiChange(option.value)\"\r\n          [disabled]=\"(enableValues?.length > 0 && enableValues?.indexOf(option.value) === -1) || readonly ? true : false\"\r\n          [required]=\"required\">\r\n        <label class=\"custom-control-label\"\r\n          [for]=\"uuid + '_' + view?.metadata.name + '_' + option.value\">{{option.label}}</label>\r\n      </div>\r\n    </ng-container>\r\n\r\n\r\n    <!-- Number -->\r\n\r\n    <ng-container *ngSwitchCase=\"'double'\">\r\n      <input type=\"number\" [min]=\"minVal\" class=\"form-control custom\" [class.form-control-sm]=\"small\" [id]=\"value\"\r\n        [(ngModel)]=\"value\" [disabled]=\"readonly\" (ngModelChange)=\"propagateChange(value)\" [required]=\"required\"\r\n        [placeholder]=\"placeholder\" #num=\"ngModel\"\r\n        [ngClass]=\"{ 'is-invalid': num.invalid && (num.touched || num.dirty) || value === 0}\" />\r\n      <div class=\"invalid-feedback\">\r\n        {{errorMsg | translate}}\r\n      </div>\r\n    </ng-container>\r\n\r\n    <!-- String -->\r\n    <ng-container *ngSwitchCase=\"'string'\">\r\n      <input type=\"text\" class=\"form-control custom\" [class.form-control-sm]=\"small\" [id]=\"value\" [(ngModel)]=\"value\"\r\n        (ngModelChange)=\"propagateChange(value)\" [disabled]=\"readonly\" [required]=\"required\" [placeholder]=\"placeholder\"\r\n        #txt=\"ngModel\" [ngClass]=\"{ 'is-invalid': txt.invalid && (txt.touched || txt.dirty) }\" />\r\n      <div class=\"invalid-feedback\">\r\n        {{errorMsg}}\r\n      </div>\r\n    </ng-container>\r\n\r\n    <!-- Email -->\r\n    <ng-container *ngSwitchCase=\"'email'\">\r\n      <input type=\"text\" class=\"form-control custom\" [class.form-control-sm]=\"small\" [id]=\"value\" [(ngModel)]=\"value\"\r\n        (ngModelChange)=\"propagateChange(value)\" [required]=\"required\" [placeholder]=\"placeholder\" #email=\"ngModel\"\r\n        [ngClass]=\"{ 'is-invalid': email.invalid && (email.touched || email.dirty) }\" />\r\n      <div class=\"invalid-feedback\">\r\n        {{errorMsg}}\r\n      </div>\r\n    </ng-container>\r\n\r\n    <!-- Textarea -->\r\n    <ng-container *ngSwitchCase=\"'textarea'\">\r\n      <textarea [(ngModel)]=\"value\" class=\"form-control custom\" [class.form-control-sm]=\"small\"\r\n        (ngModelChange)=\"propagateChange(value)\" [maxlength]=\"view?.metadata?.length\" [rows]=\"rows\"\r\n        [required]=\"required\" [placeholder]=\"placeholder\"></textarea>\r\n    </ng-container>\r\n\r\n    <!-- Date -->\r\n    <div class=\"date-form\" *ngSwitchCase=\"'date'\">\r\n      <input type=\"text\" [id]=\"uuid\" class=\"form-control custom\" bsDatepicker [class.form-control-sm]=\"small\"\r\n        [value]=\"value\" (bsValueChange)=\"onDateChange($event)\" [required]=\"required\" [placeholder]=\"placeholder\"\r\n        [bsConfig]=\"{ adaptivePosition: true }\">\r\n      <i class=\"fa fa-calendar\"></i>\r\n    </div>\r\n\r\n    <!-- Datetime -->\r\n    <div class=\"date-form\" *ngSwitchCase=\"'datetime'\">\r\n      <input type=\"text\" [id]=\"uuid\" class=\"form-control custom\" bsDatepicker [class.form-control-sm]=\"small\"\r\n        [value]=\"value\" (bsValueChange)=\"writeValue($event)\" [required]=\"required\" [placeholder]=\"placeholder\"\r\n        [bsConfig]=\"{ adaptivePosition: true }\">\r\n      <i class=\"fa fa-calendar\"></i>\r\n    </div>\r\n\r\n    <!-- Percentage -->\r\n    <ng-container *ngSwitchCase=\"'percent'\">\r\n      <input type=\"text\" [id]=\"uuid\" class=\"form-control custom\" [class.form-control-sm]=\"small\"\r\n        [ngModel]=\"value/100 | percent:'1.2'\" (ngModelChange)=\"propagateChange(value)\" [required]=\"required\"\r\n        [placeholder]=\"placeholder\">\r\n    </ng-container>\r\n\r\n    <!-- Currency -->\r\n    <ng-container *ngSwitchCase=\"'currency'\">\r\n      <!-- <input type=\"text\" [id]=\"uuid\" class=\"form-control\" [class.form-control-sm]=\"small\" [(ngModel)]=\"value\"\r\n        (ngModelChange)=\"onCurrencyChange(value)\" [required]=\"required\" [placeholder]=\"placeholder\"> -->\r\n      <input type=\"number\" class=\"form-control custom\" [class.form-control-sm]=\"small\" [id]=\"value\" [(ngModel)]=\"value\"\r\n        [disabled]=\"readonly\" step=\".01\" (ngModelChange)=\"propagateChange(value)\" [required]=\"required\"\r\n        [placeholder]=\"placeholder\" #num=\"ngModel\"\r\n        [ngClass]=\"{ 'is-invalid': num.invalid && (num.touched || num.dirty) }\" />\r\n    </ng-container>\r\n\r\n    <!-- Reference -->\r\n    <ng-container *ngSwitchCase=\"'reference'\">\r\n      <ng-select class=\"form-control aptSingleSelectLookup p-0\" [class.form-control-sm]=\"small\"\r\n        [class.contacts]=\"lookupOptions?.secondaryTextField\" [(ngModel)]=\"value\" [items]=\"view?.lookupResults\"\r\n        (search)=\"onLookupSearch($event)\" [required]=\"required\" [bindLabel]=\"lookupOptions?.primaryTextField\"\r\n        bindValue=\"Id\" [placeholder]=\"placeholder\" [loading]=\"loading\"\r\n        (ngModelChange)=\"onLookupChange($event, view?.lookupResults)\" #select=\"ngModel\"\r\n        [ngClass]=\"{ 'is-invalid': select.invalid && (select.touched || select.dirty) }\" [disabled]=\"readonly\"\r\n        (clear)=\"setLookupFieldData()\" (focus)=\"setLookupFieldData()\">\r\n        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\">\r\n          <span *ngIf=\"!lookupOptions?.secondaryTextField\" class=\"basicOption\" [ngOptionHighlight]=\"search\">\r\n            {{item[lookupOptions?.primaryTextField]}}\r\n          </span>\r\n          <div *ngIf=\"lookupOptions?.secondaryTextField\" class=\"d-flex align-items-center contactOption\">\r\n            <img *ngIf=\"lookupOptions?.thumbnailField\" class=\"rounded-circle mr-4\" width=\"32\" height=\"32\"\r\n              src=\"./assets/images/default.png\" alt=\"Contact Image\">\r\n            <div class=\"d-flex flex-column h-100 justify-content-around\">\r\n              <span [ngOptionHighlight]=\"search\">{{item[lookupOptions?.primaryTextField]}}</span>\r\n              <i class=\"small\" *ngIf=\"lookupOptions?.secondaryTextField\">{{item[lookupOptions?.secondaryTextField]}}</i>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ng-loadingspinner-tmp>\r\n          <apt-spinner></apt-spinner>\r\n        </ng-template>\r\n      </ng-select>\r\n      <div class=\"invalid-feedback\">\r\n        {{errorMsg}}\r\n      </div>\r\n    </ng-container>\r\n\r\n    <!-- Address -->\r\n    <ng-container *ngSwitchCase=\"'address'\">\r\n      <apt-address [(ngModel)]=\"value\"></apt-address>\r\n    </ng-container>\r\n  </div>\r\n</ng-container>", styles: ["apt-input-field{display:block}apt-input-field .custom-asterisk{font-size:8px}apt-input-field select{text-indent:5px}apt-input-field .date-form{position:relative}apt-input-field .date-form input[bsdatepicker]{padding-right:1.6rem}apt-input-field .date-form i{position:absolute;top:25%;right:3%}apt-input-field .ng-select.picklist .ng-select-container{height:100%;min-height:100%}apt-input-field .ng-select.aptSingleSelectLookup{font-size:inherit}apt-input-field .ng-select.aptSingleSelectLookup.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:transparent;box-shadow:none}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container{background-color:transparent;border-radius:0;min-height:34px;height:34px;border-width:0px}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container .ng-arrow-wrapper{display:none}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container apt-spinner svg{width:18px;height:18px}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container .ng-clear-wrapper{width:24px;height:24px}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container .ng-clear-wrapper:hover .ng-clear{opacity:1}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container .ng-clear-wrapper .ng-clear{width:24px;height:24px;color:transparent;content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg fill='%23000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24' class='ng-scope'%3E%3Cpolygon points='20 5.611 18.389 4 12 10.389 5.611 4 4 5.611 10.389 12 4 18.389 5.611 20 12 13.611 18.389 20 20 18.389 13.611 12'%3E%3C/polygon%3E%3C/svg%3E\");opacity:.5}apt-input-field .ng-select.aptSingleSelectLookup .ng-select-container:before{width:24px;height:24px;content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg fill='%23000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24' class='ng-scope'%3E%3Cpath d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'%3E%3C/path%3E%3C/svg%3E\")}apt-input-field .ng-select.aptSingleSelectLookup.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-left:34px;padding-right:36px}apt-input-field .ng-select.aptSingleSelectLookup.ng-select-single .ng-select-container .ng-value-container .ng-input>input{cursor:text}apt-input-field .ng-select.aptSingleSelectLookup.contacts .ng-dropdown-panel{bottom:auto!important}apt-input-field .ng-select.aptSingleSelectLookup .ng-dropdown-panel .ng-dropdown-header{font-size:12px;padding-left:14px;border:none}apt-input-field .ng-select.aptSingleSelectLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{min-height:40px;padding:4px 10px 4px 14px}apt-input-field .ng-select.aptSingleSelectLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .basicOption{line-height:32px}apt-input-field .ng-select.aptSingleSelectLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .contactOption{height:56px}\n"], components: [{ type: i4.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }, { type: AddressComponent, selector: "apt-address", inputs: ["readonly", "type", "form", "value"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.CheckboxRequiredValidator, selector: "input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]" }, { type: i6.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i6.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i4.ɵf, selector: "[ng-option-tmp]" }, { type: i9.NgOptionHighlightDirective, selector: "[ngOptionHighlight]", inputs: ["ngOptionHighlight"] }, { type: i4.ɵp, selector: "[ng-loadingspinner-tmp]" }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "percent": i5.PercentPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-input-field',
                    templateUrl: './input-field.component.html',
                    styleUrls: ['./input-field.component.scss'],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => InputFieldComponent),
                            multi: true
                        }],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1$1.CacheService }, { type: i2$1.TranslateService }, { type: i1$1.AObjectService }, { type: i0.ChangeDetectorRef }, { type: i1$1.MetadataService }]; }, propDecorators: { errorMsg: [{
                type: Input
            }], field: [{
                type: Input
            }], entity: [{
                type: Input
            }], showLabel: [{
                type: Input
            }], label: [{
                type: Input
            }], readonly: [{
                type: Input
            }], allowEmpty: [{
                type: Input
            }], disabledValues: [{
                type: Input
            }], hiddenValues: [{
                type: Input
            }], inline: [{
                type: Input
            }], small: [{
                type: Input
            }], rows: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], required: [{
                type: Input
            }], labelClass: [{
                type: Input
            }], filterValues: [{
                type: Input
            }], hideOptions: [{
                type: Input
            }], hide: [{
                type: Input
            }], minVal: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], enableValues: [{
                type: Input
            }], lookupOptions: [{
                type: Input
            }], multiple: [{
                type: Input
            }], asterisk: [{
                type: Input
            }], fieldType: [{
                type: Input
            }], displayFieldType: [{
                type: Input
            }] } });

/**
 * Wrapper component for displaying the price of a record. Supports cart, product, cart item, product options and orders.
 * Change detection on this component has been tuned, so use this component in favor of using the price pipes directly.
 *  <h3>Preview</h3>
 *  <div>
 *    <h4>Price component used to display prices on mini cart</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/price.PNG" style="max-width: 100%">
 *  </div>
 * <h3>Usage</h3>
 *
 ```typescript
import { PriceModule } from '@congacommerce/elements';

@NgModule({
  imports: [PriceModule, ...]
})
export class AppModule {}
 ```
* @example
* // Basic Usage
```typescript
* <apt-price [record]="product"></apt-price>
```
*
* // All inputs and outputs.
```typescript
* <apt-price
*             [record]="product"
*             [quantity]="1"
*             [attributeValue]="attributeValue"
*             [formatted]="false"
*             [type]="total"
*             [term]="term"
*             [bundle]="true"
* ></apt-price>
```
*/
class PriceComponent {
    constructor(priceService, localCurrencyPipe) {
        this.priceService = priceService;
        this.localCurrencyPipe = localCurrencyPipe;
        /**
         * The quantity of the record (defaults to 1)
         */
        this.quantity = 1;
        /**
         * Flag to set this product type as a bundle
         */
        this.bundle = false;
        /**
         * Optional boolean argument to display the price as a formatted currency or as a raw number (defaults to true)
         */
        this.formatted = true;
        /**
         * The type of the output; net price, base price, discounted price or unit price (defaults to net)
         */
        this.type = 'net';
        /** @ignore */
        this.price$ = new BehaviorSubject(0);
    }
    /**
     * @ignore
     */
    getObservable() {
        if (this.record instanceof Quote)
            return this.priceService.getQuotePrice(this.record);
        else if (this.record instanceof Cart)
            return this.priceService.getCartPrice(this.record);
        else if (this.record instanceof Product)
            return this.priceService.getProductPrice(this.record, this.quantity, this.term, this.attributeValue, this.bundle);
        else if (this.record instanceof ProductOptionComponent)
            return this.priceService.getOptionAdjustmentPrice(this.record, this.quantity);
        else if (this.record instanceof Order)
            return this.priceService.getOrderPrice(this.record);
        else if (this.isItem(this.record))
            return this.priceService.getLineItemPrice(this.record, this.options);
        else
            return of(null);
    }
    /** @ignore */
    isItem(record) {
        const check = (i) => {
            return i instanceof OrderLineItem
                || i instanceof CartItem
                || i instanceof AssetLineItem
                || i instanceof QuoteLineItem;
        };
        return isArray(record) ? some(record, check) : check(record);
    }
    ngOnChanges() {
        this.ngOnDestroy();
        this.subscription = this.getObservable()
            .pipe(map((price) => defaultTo(price, new Price(this.localCurrencyPipe))), switchMap((price) => (this.formatted) ? get(price, `${this.type}Price$`) : of(get(price, `${this.type}Price`))))
            .subscribe((price) => {
            this.price$.next(price);
        });
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
PriceComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceComponent, deps: [{ token: i1.PriceService }, { token: i1.LocalCurrencyPipe }], target: i0.ɵɵFactoryTarget.Component });
PriceComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PriceComponent, selector: "apt-price", inputs: { record: "record", attributeValue: "attributeValue", term: "term", quantity: "quantity", bundle: "bundle", formatted: "formatted", type: "type", options: "options" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-container *ngIf="price$ | async as price; else empty">
      {{price}}
    </ng-container>
    <ng-template #empty>-</ng-template>
  `, isInline: true, styles: ["\n    :host{\n      display: block;\n    }\n  "], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-price',
                    template: `
    <ng-container *ngIf="price$ | async as price; else empty">
      {{price}}
    </ng-container>
    <ng-template #empty>-</ng-template>
  `,
                    styles: [`
    :host{
      display: block;
    }
  `],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.PriceService }, { type: i1.LocalCurrencyPipe }]; }, propDecorators: { record: [{
                type: Input
            }], attributeValue: [{
                type: Input
            }], term: [{
                type: Input
            }], quantity: [{
                type: Input
            }], bundle: [{
                type: Input
            }], formatted: [{
                type: Input
            }], type: [{
                type: Input
            }], options: [{
                type: Input
            }] } });

/**
 *  The Mini Cart component is a cart icon with an associated dropdown menu. The cart icon should be displayed in a fixed header of a page so it is accessible to the user at all times. Once items have been added to the user's current cart a badge will appear next to the Mini Cart icon with the total number of items.
 *  When a user clicks the Mini Cart icon the associated dropdown menu will be displayed. The Mini Cart dropdown menu shows the current line items that have been added to the cart. Line items include information about the product, controls for updating the quantity of items, and a control for removing the item from the cart. A cart total price and checkout button are also shown in the Mini Cart dropdown.
 *  <h3>Preview</h3>
 *  <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/miniCart.png" style="max-width: 100%">
 *  <h3>Usage</h3>
 *
 ```typescript
import { MiniCartModule } from '@congacommerce/elements';

@NgModule({
  imports: [MiniCartModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-mini-cart
*               [productLink]="routeToProduct"
*               [productIdentifier]="productIdentifier"
*               [cartLink]="routeToCart"
*               [manageCartLink]="routeToManageCart"
* ></apt-mini-cart>
```
*/
class MiniCartComponent {
    constructor(cartService, storefrontService, sanitizer, exceptionService, router, productConfigurationService, miniCartService, revalidateCartService) {
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        this.sanitizer = sanitizer;
        this.exceptionService = exceptionService;
        this.router = router;
        this.productConfigurationService = productConfigurationService;
        this.miniCartService = miniCartService;
        this.revalidateCartService = revalidateCartService;
        /** Use to hold routing path to the catalog page */
        this.productLink = '/products';
        /** Use to hold routing path to the details page of product */
        this.productIdentifier = this.cartService.configurationService.get('productIdentifier');
        /** Use to hold routing path to the checkout page */
        this.cartLink = '/checkout';
        /** Use to hold routing path to the cart page */
        this.manageCartLink = '/carts';
        /**
         * The product identifier set in the configuration file.
         * @ignore
         */
        this.identifier = 'Id';
        /** @ignore */
        this.entity = new CartItem();
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /**
         * Flag to show pricing is pending or not for the line items
         * @ignore
         */
        this.lineItemPricePending = false;
        /**
         * Flag to show pricing is completed or not for the line items
         * @ignore
         */
        this.lineItemPriceComplete = false;
    }
    ngOnInit() {
        this.config$ = this.productConfigurationService.getConfigState();
        this.disabled$ = this.productConfigurationService.configurationChange.pipe(map(res => get(res, 'hasErrors')));
        this.identifier = this.cartService.configurationService.get('productIdentifier');
        this.cart$ = this.cartService.getMyCart();
        this.cartItems$ = this.cartService.getMyCart().pipe(map(cart => {
            this.lineItemPriceComplete = filter$1(cart.LineItems, r => r.PricingStatus === 'Complete').length > 0;
            this.lineItemPricePending = filter$1(cart.LineItems, r => r.PricingStatus === 'Pending').length > 0 || ((cart.IsPricePending || cart.get('IsPriced')) && get(cart.LineItems, 'length') > 0);
            const primaryLines = compact(flatten(map$1(LineItemService.groupItems(isArray(cart) ? defaultTo(get(cart, '[0].LineItems'), []) : defaultTo(get(cart, 'LineItems'), [])), 'PrimaryLines')));
            map$1(primaryLines, line => line.set('Quantity', line.Quantity));
            return primaryLines;
        }));
        this.subscription = this.productConfigurationService.onLoad
            .pipe(mergeMap(res => {
            if (res)
                return this.cartService.getChildCart();
            else
                return of(null);
        }))
            .subscribe(r => {
            if (r)
                this.miniCartService.publish(r);
        });
        this.secondaryCart$ = this.miniCartService.secondaryState;
        this.unsavedItems$ = combineLatest([this.secondaryCart$, this.cart$, this.config$])
            .pipe(mergeMap(res => (get(last(res), 'isConfig') && !get(last(res), 'relatedTo')) ? this.miniCartService.calculateUnsavedChanges({ primary: get(res[1], 'LineItems', []), secondary: get(first(res), 'LineItems') }) : of(null)));
    }
    /** @ignore */
    trackById(index, record) {
        return get(record, 'Id');
    }
    /**
     * Removes the provided CartItem from the user's current active cart.
     *
     * @param item CartItem instance to remove from cart.
     * @param evt Event associated with the user action.
     * @fires CartService.removeCartItem()
     * @ignore
     */
    removeCartItem(item, evt) {
        set(item, '_metadata.deleting', true);
        evt.stopPropagation();
        this.cartService.removeCartItem(item).subscribe(() => {
            this.revalidateCartService.setRevalidateLines();
            if (includes(this.router.url, get(item, 'Id')))
                this.router.navigate(['/products', get(item, 'Product.Id')]);
        });
    }
    /**
     * Changes the quantity of the cart item passed to this method.
     *
     * @param cartItem Cart item reference to change quantity.
     * @param event The event object
     * @fires CartService.updateCartItems()
     * @ignore
     */
    changeItemQuantity(cartItem) {
        if (!cartItem.Quantity || cartItem.Quantity <= 0) {
            cartItem.Quantity = cartItem.get('Quantity');
            this.exceptionService.showError('INVALID_QUANTITY');
        }
        else {
            this.cartService.updateCartItems([cartItem]).pipe(take(1)).subscribe(() => cartItem.set('Quantity', cartItem.Quantity));
        }
    }
    /** Function used to route to cart page  */
    navigateToCart() {
        this.router.navigate(['/carts', 'active']);
    }
    /**
     * @ignore
     */
    dropdown(evt) {
        if (this.btnDropdown)
            $(this.btnDropdown.nativeElement).dropdown(evt);
    }
    /**
     * @ignore
     */
    saveChanges(relatedTo, isEmbedded, productId) {
        this.loading = true;
        const obsv$ = relatedTo ? this.cartService.updateItem(null, null, isEmbedded) :
            this.cartService.addItem(null);
        obsv$.subscribe(res => {
            relatedTo = isNil(relatedTo) ?
                res.find(r => r.ProductId === productId && r.LineType === 'Product/Service') :
                relatedTo;
            if (!isNil(relatedTo))
                this.router.navigate(['/products', productId, relatedTo.Id]);
            else
                this.router.navigate(['/products', productId]);
            this.loading = false;
        });
    }
}
MiniCartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartComponent, deps: [{ token: i1.CartService }, { token: i1.StorefrontService }, { token: i1$3.DomSanitizer }, { token: ExceptionService }, { token: i4$1.Router }, { token: ProductConfigurationService }, { token: MiniCartService }, { token: RevalidateCartService }], target: i0.ɵɵFactoryTarget.Component });
MiniCartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: MiniCartComponent, selector: "apt-mini-cart", inputs: { productLink: "productLink", productIdentifier: "productIdentifier", cartLink: "cartLink", manageCartLink: "manageCartLink" }, viewQueries: [{ propertyName: "btnDropdown", first: true, predicate: ["btnDropdown"], descendants: true, static: true }], ngImport: i0, template: "<ng-container *ngIf=\"cartItems$ | async as cartItems\">\r\n    <div class=\"dropdown\">\r\n        <button class=\"btn btn-link dropdown-toggle mr-2\" href=\"#cartMenu\" data-toggle=\"dropdown\" #btnDropdown>\r\n            <i class=\"fa fa-shopping-cart fa-lg\"></i>\r\n        </button>\r\n        <div class=\"dropdown-menu dropdown-menu-right m-0 p-0\" aria-labelledby=\"dropdownMenuButton\" id=\"cartMenu\">\r\n            <ng-container\r\n                *ngTemplateOutlet=\"mainBlock; context: {lineItems:cartItems, config: (config$ | async), unsavedItems: unsavedItems$ | async}\">\r\n            </ng-container>\r\n\r\n            <ng-template #mainBlock let-lineItems=\"lineItems\" let-config=\"config\" let-unsavedItems=\"unsavedItems\">\r\n                <ul class=\"list-group p-0\">\r\n                    <ng-container *ngIf=\"cartItems?.length > 0; else empty\">\r\n                        <ng-container\r\n                            *ngTemplateOutlet=\"listItems; context: {lineItems: cartItems, primary: config?.isConfig, isConfig: config?.isConfig}\">\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"!config?.isConfig\">\r\n                            <ng-container *ngTemplateOutlet=\"footersection; context: {isConfig: false}\">\r\n                            </ng-container>\r\n                        </ng-container>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"config?.isConfig\">\r\n                        <li class=\"seperator\">\r\n                            <span>{{ 'MINI_CART.UNSAVED_CHANGES' | translate}}\r\n                                <span *ngIf=\"!config?.relatedTo\">({{unsavedItems?.length}})</span>\r\n                            </span>\r\n                        </li>\r\n                        <li *ngIf=\"config?.relatedTo\">\r\n                            <p class=\"pl-4 pr-4\"\r\n                                [innerHTML]=\"'MINI_CART.UNSAVED_CHANGES_TEXT' | translate: {value: config?.relatedTo?.Product.Name}\">\r\n                            </p>\r\n                        </li>\r\n                        <ng-container *ngIf=\"!config?.relatedTo\">\r\n                            <ng-container\r\n                                *ngTemplateOutlet=\"listItems; context: {lineItems: unsavedItems, secondary: config?.isConfig, isConfig: config?.isConfig, primaryItems: cartItems}\">\r\n                            </ng-container>\r\n                        </ng-container>\r\n                        <ng-container *ngTemplateOutlet=\"footersection; context: {lineItems: unsavedItems, isConfig: config?.isConfig, \r\n                                relatedTo: config?.relatedTo, productId: config?.productId}\">\r\n                        </ng-container>\r\n                    </ng-container>\r\n                </ul>\r\n            </ng-template>\r\n\r\n            <ng-template #listItems let-lineItems=\"lineItems\" let-primary=\"primary\" let-secondary=\"secondary\"\r\n                let-isConfig=\"isConfig\" let-primaryItems=\"primaryItems\">\r\n                <ng-container *ngFor=\"let item of lineItems; let i = index; trackBy: trackById\">\r\n                    <li class=\"media list-group-item d-flex\"\r\n                        [ngClass]=\"{'last-list-item': (lineItems?.length === (i+1) && primary && isConfig), 'first-list-item': ((i === 0) && secondary && isConfig)}\"\r\n                        *ngIf=\"item?.LineType === 'Product/Service' && item?.Product\">\r\n                        <img class=\"align-self-center\"\r\n                            [src]=\"sanitizer.bypassSecurityTrustUrl(item.Product?.IconId | image)\"\r\n                            alt=\"Generic placeholder image\">\r\n                        <div class=\"media-body ml-3\">\r\n                            <h6 class=\"m-0 d-flex justify-content-between align-items-center\">\r\n                                <div>\r\n                                    <a href=\"javascript:void(0)\"\r\n                                        [routerLink]=\"[productLink, item.Product[identifier], item.Id]\"\r\n                                        *ngIf=\"item?.Product && item?.Id; else read\">\r\n                                        {{item.Product?.Name}}\r\n                                    </a>\r\n                                    <ng-template #read>\r\n                                        {{item.Product?.Name}}\r\n                                    </ng-template>\r\n                                </div>\r\n                                <button *ngIf=\"item?.IsPrimaryLine && !isConfig\" class=\"btn btn-link p-0 m-0\"\r\n                                    (click)=\"removeCartItem(item, $event)\" [ladda]=\"item?._metadata?.deleting\"\r\n                                    data-style=\"zoom-in\" data-spinner-color=\"black\">\r\n                                    <span class=\"fa fa-trash\"></span>\r\n                                </button>\r\n                            </h6>\r\n                            <span class=\"d-block small\">{{item.Product?.ProductCode}}</span>\r\n                            <div class=\"d-flex align-items-center\">\r\n                                <apt-input-field *ngIf=\"!isConfig; else inputField\" inline=\"true\"\r\n                                    [(ngModel)]=\"item.Quantity\" [entity]=\"entity\" field=\"Quantity\"\r\n                                    (change)=\"changeItemQuantity(item)\" [small]=\"true\" [inline]=\"true\"\r\n                                    [readonly]=\"item?.LineStatus?.toLowerCase()==='cancelled'\" class=\"w-50 mt-2\">\r\n                                </apt-input-field>\r\n\r\n                                <ng-template #inputField>\r\n                                    <div class=\"w-50 mt-2\">\r\n                                        <div class=\"form-group align-items-center d-flex\">\r\n                                            <label\r\n                                                class=\"font-weight-bold col-form-label-sm m-0 mr-2\">{{'COMMON.QUANTITY' | translate}}</label>\r\n                                            <span *ngIf=\"secondary else primaryItem\" class=\"font-weight-bold\"\r\n                                                [ngClass]=\"item?._metadata?.action === 'exclude' && secondary ? 'text-danger' : 'text-success'\">\r\n                                                {{(item?._metadata?.action === 'exclude' && secondary) ? - item?.Quantity : '+' + item?.Quantity}}\r\n                                            </span>\r\n                                            <ng-template #primaryItem>\r\n                                                <span class=\"font-weight-bold\">{{item?.Quantity}}</span>\r\n                                            </ng-template>\r\n                                        </div>\r\n                                    </div>\r\n                                </ng-template>\r\n                                <strong class=\"d-flex ml-auto\"\r\n                                    [ngClass]=\"{'text-default': !isConfig,\r\n                                                'text-danger': isConfig && item?._metadata?.action === 'exclude' && secondary,\r\n                                                'text-success': isConfig && item?._metadata?.action !== 'exclude' && secondary}\">\r\n                                    <span *ngIf=\"item?._metadata?.action === 'exclude' && secondary\"> - </span>\r\n\r\n                                    <apt-price *ngIf=\"item?.PricingStatus !== 'Pending'; else pricemask\" [record]=\"item\"\r\n                                        type=\"baseExtended\"></apt-price>\r\n\r\n                                </strong>\r\n                            </div>\r\n                        </div>\r\n                    </li>\r\n                </ng-container>\r\n            </ng-template>\r\n\r\n            <ng-template #footersection let-lineItems=\"lineItems\" let-isConfig=\"isConfig\" let-relatedTo=\"relatedTo\"\r\n                let-productId=\"productId\">\r\n                <li class=\"list-group-item bg-light\">\r\n                    <div class=\"d-flex justify-content-between\">\r\n                        <span>{{ 'MINI_CART.CART_TOTAL' | translate}}</span>\r\n                        <strong *ngIf=\"lineItemPriceComplete; else pricemask\" class=\"d-inline-flex\">\r\n                            <apt-price \r\n                                [record]=\"isConfig? (secondaryCart$ | async) : (cart$ | async)\"></apt-price>\r\n                            <sup class=\"m-1\" *ngIf=\"lineItemPricePending\">\r\n                                <i class=\"fa fa-asterisk fa-xs\" aria-hidden=\"true\"></i>\r\n                            </sup>\r\n                        </strong>\r\n                    </div>\r\n                </li>\r\n                <li class=\"list-group-item bg-light d-block-flex\" *ngIf=\"!isConfig\">\r\n                    <button class=\"btn btn-primary btn-raised btn-block\" (click)=\"navigateToCart()\">\r\n                        {{ 'MINI_CART.VIEW_CART' | translate}}\r\n                    </button>\r\n                    <P class=\"mb-0 mt-1 text-center\" *ngIf=\"lineItemPricePending\">\r\n                        <small>{{ 'MINI_CART.PRICE_NOT_UPDATED_TXT' |translate}}</small>\r\n                    </P>\r\n                </li>\r\n                <li class=\"list-group-item bg-light d-flex justify-content-end\" *ngIf=\"isConfig\">\r\n                    <button class=\"btn btn-link mr-2\"\r\n                        (click)=\"navigateToCart()\">{{ 'MINI_CART.VIEW_CART' | translate}}</button>\r\n                    <button class=\"btn btn-primary\" (click)=\"saveChanges(relatedTo, isConfig, productId)\"\r\n                        [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\"\r\n                        [disabled]=\"disabled$ | async\">{{'MINI_CART.SAVE_CHANGES' | translate}}\r\n                        <span *ngIf=\"!relatedTo\">({{lineItems?.length}})</span>\r\n                    </button>\r\n                </li>\r\n            </ng-template>\r\n\r\n            <ng-template #empty>\r\n                <ul class=\"list-group p-0\">\r\n                    <li class=\"list-group-item bg-light\">\r\n                        {{ 'MINI_CART.YOUR_CART_IS_EMPTY' | translate}}\r\n                    </li>\r\n                </ul>\r\n            </ng-template>\r\n\r\n        </div>\r\n    </div>\r\n    <span class=\"badge badge-primary p-1\" *ngIf=\"cartItems?.length > 0\">{{cartItems?.length}}</span>\r\n</ng-container>\r\n\r\n<ng-template #pricemask>\r\n    <span>\r\n        <i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\"></i>\r\n        <sup class=\"m-1\">\r\n            <i class=\"fa fa-asterisk fa-xs\" aria-hidden=\"true\"></i>\r\n        </sup>\r\n    </span>\r\n</ng-template>", styles: [":host{position:relative;display:block;z-index:10000}:host img{max-width:3rem}:host .dropdown-menu{min-width:25rem}:host span.badge{position:absolute;top:15px;right:5px}:host .dropdown-menu{max-height:80vh;overflow-y:auto}:host button.dropdown-toggle:after{display:none}:host li.last-list-item{border-color:transparent}:host li.first-list-item{border-top-color:transparent}:host li.seperator{width:100%;text-align:center;border-bottom:1px solid #93A1AA;line-height:.1em;margin:10px 0 20px}:host li.seperator span{background:#ffffff;padding:0 10px;color:#323232}\n"], components: [{ type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }, { type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "image": i1$1.ImagePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-mini-cart',
                    templateUrl: './mini-cart.component.html',
                    styleUrls: ['./mini-cart.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.StorefrontService }, { type: i1$3.DomSanitizer }, { type: ExceptionService }, { type: i4$1.Router }, { type: ProductConfigurationService }, { type: MiniCartService }, { type: RevalidateCartService }]; }, propDecorators: { productLink: [{
                type: Input
            }], productIdentifier: [{
                type: Input
            }], cartLink: [{
                type: Input
            }], manageCartLink: [{
                type: Input
            }], btnDropdown: [{
                type: ViewChild,
                args: ['btnDropdown', { static: true }]
            }] } });

/**
 * @ignore
 */
class PriceModule {
}
PriceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PriceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModule, declarations: [PriceComponent], imports: [CommonModule,
        PricingModule], exports: [PriceComponent] });
PriceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModule, imports: [[
            CommonModule,
            PricingModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PricingModule
                    ],
                    declarations: [PriceComponent],
                    exports: [PriceComponent]
                }]
        }] });

/**
 * @ignore
 */
class DependentPicklistModule {
}
DependentPicklistModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DependentPicklistModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistModule, declarations: [DependentPicklistComponent], imports: [CommonModule,
        FormsModule, i2$1.TranslateModule], exports: [DependentPicklistComponent] });
DependentPicklistModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistModule, imports: [[
            CommonModule,
            FormsModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DependentPicklistModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [DependentPicklistComponent],
                    exports: [DependentPicklistComponent]
                }]
        }] });

/**
 * @ignore
 */
class AddressModule {
}
AddressModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AddressModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressModule, declarations: [AddressComponent], imports: [CommonModule,
        DependentPicklistModule,
        FormsModule,
        ApttusModule, i2$1.TranslateModule], exports: [AddressComponent] });
AddressModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressModule, imports: [[
            CommonModule,
            DependentPicklistModule,
            FormsModule,
            ApttusModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddressModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        DependentPicklistModule,
                        FormsModule,
                        ApttusModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [AddressComponent],
                    exports: [AddressComponent]
                }]
        }] });

/**
 * Animated blinking dots built from the bootstrap library to be used to show loading status.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/loadingDots.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { IconModule } from '@congacommerce/elements';

@NgModule({
  imports: [IconModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage
 ```typescript
* <apt-dots></apt-dots>
 ```
*
* // Larger size dots
 ```typescript
* <apt-dots [large]="true"></apt-dots>
 ```
*
* // Change color of dots with bootstrap text color class
 ```typescript
* <apt-dots color="text-warning"></apt-dots>
 ```
*/
class DotsComponent {
    constructor() {
        /**
         * Flag to set the dots to a larger size.
         */
        this.large = false;
        /**
         * Bootstrap text color class to set the color of the dots.
         */
        this.color = 'text-primary';
    }
}
DotsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DotsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DotsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DotsComponent, selector: "apt-dots", inputs: { large: "large", color: "color" }, ngImport: i0, template: "<div [class]=\"'spinner-grow ' + color\" [class.spinner-grow-sm]=\"!large\" role=\"status\">\r\n  <span class=\"sr-only\">Loading...</span>\r\n</div>\r\n<div [class]=\"'spinner-grow ' + color\" [class.spinner-grow-sm]=\"!large\" role=\"status\" style=\"animation-delay: .1s;\">\r\n  <span class=\"sr-only\">Loading...</span>\r\n</div>\r\n<div [class]=\"'spinner-grow ' + color\" [class.spinner-grow-sm]=\"!large\" role=\"status\" style=\"animation-delay: .2s;\">\r\n  <span class=\"sr-only\">Loading...</span>\r\n</div>" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DotsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-dots',
                    templateUrl: './dots.component.html',
                    styles: []
                }]
        }], propDecorators: { large: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class IconModule {
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IconModule, declarations: [SpinnerComponent, DotsComponent], imports: [CommonModule], exports: [SpinnerComponent, DotsComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IconModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [SpinnerComponent, DotsComponent],
                    exports: [SpinnerComponent, DotsComponent]
                }]
        }] });

/**
 * @ignore
 */
class InputFieldModule {
}
InputFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InputFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldModule, declarations: [InputFieldComponent], imports: [CommonModule,
        FormsModule,
        NgSelectModule, i7.BsDatepickerModule, i2$1.TranslateModule, NgOptionHighlightModule,
        AddressModule,
        IconModule], exports: [InputFieldComponent, FormsModule] });
InputFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldModule, imports: [[
            CommonModule,
            FormsModule,
            NgSelectModule,
            BsDatepickerModule.forRoot(),
            TranslateModule.forChild(),
            NgOptionHighlightModule,
            AddressModule,
            IconModule
        ], FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgSelectModule,
                        BsDatepickerModule.forRoot(),
                        TranslateModule.forChild(),
                        NgOptionHighlightModule,
                        AddressModule,
                        IconModule
                    ],
                    declarations: [InputFieldComponent],
                    exports: [InputFieldComponent, FormsModule]
                }]
        }] });

/**
 * @ignore
 */
class MiniCartModule {
}
MiniCartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MiniCartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartModule, declarations: [MiniCartComponent], imports: [CommonModule,
        FormsModule,
        LaddaModule,
        PriceModule,
        ApttusModule,
        RouterModule,
        InputFieldModule, i2$1.TranslateModule, i1$2.ModalModule, i2.ToastrModule], exports: [MiniCartComponent] });
MiniCartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartModule, imports: [[
            CommonModule,
            FormsModule,
            LaddaModule,
            PriceModule,
            ApttusModule,
            RouterModule,
            InputFieldModule,
            TranslateModule.forChild(),
            ModalModule.forRoot(),
            ToastrModule.forRoot({ onActivateTick: true })
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniCartModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        LaddaModule,
                        PriceModule,
                        ApttusModule,
                        RouterModule,
                        InputFieldModule,
                        TranslateModule.forChild(),
                        ModalModule.forRoot(),
                        ToastrModule.forRoot({ onActivateTick: true })
                    ],
                    declarations: [MiniCartComponent],
                    exports: [MiniCartComponent]
                }]
        }] });

/**
 *  Mini profile allows user to login to the website through their existing ID's.
 *  For the new user, there is an option to register to the site .
 *  If the user has forgotten the password there is an option to reset password.
 * <h3>Preview</h3>
 * <div>
 *    <h4>Mini profile from checkout page</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/miniProfile.PNG" style="max-width: 100%">
 * </div>
 * <h3>Usage</h3>
 *
 ```typescript
import { MiniProfileModule } from '@congacommerce/elements';

@NgModule({
  imports: [MiniProfileModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-mini-profile
*              (onRegister)="handleOnRegister($event)"
*              (onLogin)="handleOnLogin($event)"
* ></apt-mini-profile>
```
*/
class MiniProfileComponent {
    constructor(userService, ngZone, modalService, translateService, activatedRoute) {
        this.userService = userService;
        this.ngZone = ngZone;
        this.modalService = modalService;
        this.translateService = translateService;
        this.activatedRoute = activatedRoute;
        /**
         * Event emitter for when user registers.
         */
        this.onRegister = new EventEmitter();
        /**
         * Event emitter for when user logs in.
         */
        this.onLogin = new EventEmitter();
        /**
         * login state of the user
         * @ignore
         */
        this.loginState = 'LOGIN';
        /** @ignore */
        this.user = new User();
        /** @ignore */
        this.loading = false;
    }
    ngOnInit() {
        this.userService.initializeGuestUser().subscribe(res => this.user = res);
        this.me$ = this.userService.me();
    }
    /**
     * Allows user to register to the site using user email.
     * @ignore
     */
    doRegister() {
        this.loading = true;
        this.user.Username = this.user.Email;
        this.userService.register(this.user).subscribe(res => {
            this.onRegister.emit(res);
            this.loading = false;
            this.modalRef.hide();
        }, err => {
            this.loading = false;
            this.translateService.stream('LOGIN').subscribe((val) => {
                this.registerMessage = val['COULD_NOT_REGISTER'];
            });
        });
    }
    /**
     * Allows user to login to the site using user credentials like username and password for the registered user otherwise it shows the error message.
     * @ignore
     */
    doLogin() {
        this.loading = true;
        combineLatest([this.userService.login(this.username, this.password), this.activatedRoute.queryParams])
            .pipe(take(1))
            .subscribe(res => {
            if (get(last(res), 'redirectUrl')) {
                window.location.href = get(last(res), 'redirectUrl');
                if ((!!window.location.hash))
                    window.location.reload(true);
            }
            else
                window.location.reload(true);
        }, err => this.ngZone.run(() => {
            this.loading = false;
            this.translateService.stream('LOGIN').subscribe((val) => {
                this.loginMessage = val['WRONG_CREDENTIALS'];
            });
        }));
    }
    /**
     * Allows user to logout form the site
     * @ignore
    */
    doLogout() {
        this.userService.logout().subscribe(res => window.location.reload(), err => window.location.reload());
    }
    /**
     * Allows user to reset the password for the exisiting user.
     * @ignore
     */
    doResetPassword() {
        this.loading = true;
        this.userService.sendPasswordResetEmail(this.resetUsername)
            .subscribe(res => this.ngZone.run(() => {
            this.loginState = 'RESET-CONFIRM';
            this.loading = false;
        }), err => this.ngZone.run(() => {
            console.log(err);
            this.resetMessage = 'An error occurred resseting your password. Please contact your administrator.';
            this.loading = false;
        }));
    }
    /**
     * opens modal dialog for the tempalate.
     * @ignore
     */
    openModal(strClass = null) {
        this.modalRef = this.modalService.show(this.template, (strClass) ? { 'class': strClass } : null);
    }
}
MiniProfileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileComponent, deps: [{ token: i1.UserService }, { token: i0.NgZone }, { token: i1$2.BsModalService }, { token: i2$1.TranslateService }, { token: i4$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
MiniProfileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: MiniProfileComponent, selector: "apt-mini-profile", outputs: { onRegister: "onRegister", onLogin: "onLogin" }, viewQueries: [{ propertyName: "authModal", first: true, predicate: ["authModal"], descendants: true }, { propertyName: "template", first: true, predicate: ["template"], descendants: true }], ngImport: i0, template: "<!-- Modal -->\r\n<ng-template #template>\r\n    <form *ngIf=\"loginState === 'LOGIN'\" (ngSubmit)=\"doLogin()\">\r\n        <div class=\"modal-header\">\r\n            <h5 class=\"modal-title\" id=\"loginModalLabel\"> {{'MINI_PROFILE.LOGIN' | translate}}</h5>\r\n            <button type=\"button\" class=\"close\" (click)=\"modalRef.hide()\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <div class=\"form-group\">\r\n                <label for=\"email\">{{'COMMON.USERNAME' | translate}}</label>\r\n                <input autofocus type=\"email\" class=\"form-control\" id=\"username\" name=\"username\" placeholder=\"{{'MINI_PROFILE.ENTER_USERNAME' | translate}}\" [(ngModel)]=\"username\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label for=\"password\">{{'MINI_PROFILE.PASSWORD' | translate}}</label>\r\n                <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{'MINI_PROFILE.PASSWORD' | translate}}\" [(ngModel)]=\"password\">\r\n            </div>\r\n            <div class=\"form-group form-check\">\r\n                <input type=\"checkbox\" class=\"form-check-input\" id=\"exampleCheck1\">\r\n                <label class=\"form-check-label\" for=\"exampleCheck1\">{{'MINI_PROFILE.REMEMBER_ME' | translate}}</label>\r\n            </div>\r\n            <small class=\"text-danger \" *ngIf=\"loginMessage\">{{loginMessage}}</small>\r\n        </div>\r\n        <div class=\"modal-footer d-flex justify-content-start\">\r\n            <button class=\"btn btn-link\" type=\"button\" (click)=\"loginState = 'REGISTER'\">{{'COMMON.REGISTER' | translate}}</button>\r\n            |\r\n            <button class=\"btn btn-link\" type=\"button\" (click)=\"loginState = 'RESET-PASSWORD'\">{{'MINI_PROFILE.FORGOT_PASSWORD' | translate}}</button>\r\n            <button type=\"submit\" class=\"btn btn-primary ml-auto\" [ladda]=\"loading\">{{'COMMON.SUBMIT' | translate}}</button>\r\n        </div>\r\n    </form>\r\n\r\n    <form *ngIf=\"loginState === 'REGISTER'\" (ngSubmit)=\"doRegister()\">\r\n        <div class=\"modal-header\">\r\n            <h5 class=\"modal-title\" id=\"loginModalLabel\">{{'COMMON.REGISTER' | translate}}</h5>\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <div class=\"form-group\">\r\n                <label for=\"exampleInputEmail1\">{{'COMMON.EMAIL_ADDRESS' | translate}}</label>\r\n                <input type=\"email\" [(ngModel)]=\"user.Email\" class=\"form-control\" name=\"email\" placeholder=\"{{'MINI_PROFILE.ENTER_EMAIL' | translate}}\">\r\n                <small id=\"emailHelp\" class=\"form-text text-muted\"> {{'MINI_PROFILE.NEVER_SHARE_YOUR_EMAIL' | translate}}</small>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label for=\"firstName\">{{'COMMON.FIRST_NAME' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" id=\"firstName\" [(ngModel)]=\"user.FirstName\" name=\"firstName\" placeholder=\"{{'COMMON.FIRST_NAME' | translate}}\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label for=\"lastName\">{{'COMMON.LAST_NAME' | translate}}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{'COMMON.LAST_NAME' | translate}}\" [(ngModel)]=\"user.LastName\" name=\"lastName\" id=\"lastName\">\r\n            </div>\r\n            <small class=\"text-danger \" *ngIf=\"registerMessage\">{{registerMessage}}</small>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button>\r\n            <button type=\"submit\" class=\"btn btn-primary\" [ladda]=\"loading\">{{'COMMON.SUBMIT' | translate}}</button>\r\n        </div>\r\n    </form>\r\n\r\n    <form *ngIf=\"loginState === 'RESET-PASSWORD'\" (ngSubmit)=\"doResetPassword()\">\r\n        <div class=\"modal-header\">\r\n            <h5 class=\"modal-title\">{{'MINI_PROFILE.RESET_PASSWORD' | translate}}</h5>\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <p>{{'MINI_PROFILE.TROUBLE_LOGGINGIN' | translate}}</p>\r\n            <ul>\r\n                <li>{{'MINI_PROFILE.USERNAME_ARE_IN_EMAIL' | translate}}</li>\r\n                <li>{{'MINI_PROFILE.PASSWORDS_ARE_CASESENSITIVE' | translate}}</li>\r\n            </ul>\r\n            <p>{{'MINI_PROFILE.TO_RESET_PASSWORD_ENTER_USERNAME' | translate}}</p>\r\n            <div class=\"form-group\">\r\n                <label for=\"resetUsername\">{{'COMMON.USERNAME' | translate}}</label>\r\n                <input type=\"email\" [(ngModel)]=\"resetUsername\" class=\"form-control\" name=\"resetUsername\" placeholder=\"{{'COMMON.USERNAME' | translate}}\">\r\n                <small id=\"emailHelp\" class=\"form-text text-muted\">{{'MINI_PROFILE.TO_RESET_PASSWORD_ENTER_USERNAME' | translate}}</small>\r\n            </div>\r\n            <small class=\"text-danger \" *ngIf=\"resetMessage\">{{resetMessage}}</small>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button>\r\n            <button type=\"submit\" class=\"btn btn-primary\" type=\"submit\" [ladda]=\"loading\">{{'COMMON.SUBMIT' | translate}}</button>\r\n        </div>\r\n    </form>\r\n\r\n    <div *ngIf=\"loginState === 'RESET-CONFIRM'\">\r\n        <div class=\"modal-header\">\r\n            <h5 class=\"modal-title\">{{'MINI_PROFILE.PASSWORD_RESET' | translate}}</h5>\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM1' | translate}}</p>\r\n            <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM2' | translate}}</p>\r\n            <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM3' | translate}}</p>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button type=\"button\" class=\"btn btn-secondary\" (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button>\r\n        </div>\r\n    </div>\r\n</ng-template>", styles: [":host{display:flex;align-items:center}.dropdown-menu{z-index:1040}a .oi{margin-right:5px}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileComponent, decorators: [{
            type: Component,
            args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'apt-mini-profile',
                    templateUrl: './mini-profile.component.html',
                    styleUrls: ['./mini-profile.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.UserService }, { type: i0.NgZone }, { type: i1$2.BsModalService }, { type: i2$1.TranslateService }, { type: i4$1.ActivatedRoute }]; }, propDecorators: { authModal: [{
                type: ViewChild,
                args: ['authModal']
            }], template: [{
                type: ViewChild,
                args: ['template']
            }], onRegister: [{
                type: Output
            }], onLogin: [{
                type: Output
            }] } });

/**
 * @ignore
 */
class MiniProfileModule {
}
MiniProfileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MiniProfileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileModule, declarations: [MiniProfileComponent], imports: [CommonModule,
        FormsModule,
        LaddaModule, i1$2.ModalModule, i2$1.TranslateModule], exports: [MiniProfileComponent] });
MiniProfileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileModule, imports: [[
            CommonModule,
            FormsModule,
            LaddaModule,
            ModalModule.forRoot(),
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MiniProfileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        LaddaModule,
                        ModalModule.forRoot(),
                        TranslateModule.forChild()
                    ],
                    declarations: [MiniProfileComponent],
                    exports: [MiniProfileComponent]
                }]
        }] });

/**
 * Service that is used by the constraint rule sidebar and constraint rule alert components.
 * @ignore
 */
class ConstraintRuleMessageService {
    constructor(constraintRuleService, cartService, productService, exceptionService, clientConstraintRuleService, productConfigurationService) {
        this.constraintRuleService = constraintRuleService;
        this.cartService = cartService;
        this.productService = productService;
        this.exceptionService = exceptionService;
        this.clientConstraintRuleService = clientConstraintRuleService;
        this.productConfigurationService = productConfigurationService;
        /**
        * Formats the standard message received from the api response to add links and bold highlighting.
        */
        this.beautifyMessage = (actionMessage, triggeringProducts, suggestedProduct, attachLink = true) => {
            let message = cloneDeep(actionMessage);
            suggestedProduct = compact(suggestedProduct);
            triggeringProducts = compact(triggeringProducts);
            if (message && triggeringProducts && suggestedProduct) {
                message = replace(message, '{0}', join(map$1(triggeringProducts, product => product.Name), ', '));
                message = replace(message, '{1}', join(map$1(suggestedProduct, product => product.Name), ', '));
                if (attachLink) {
                    each(suggestedProduct, product => {
                        message = replace(message, product.Name, `<a href="/products/${product.Id}" target="_blank">${product.Name}</a>`);
                    });
                    each(triggeringProducts, product => {
                        message = replace(message, product.Name, `<strong>${product.Name}</strong>`);
                    });
                }
                return message;
            }
            else
                return message;
        };
        /**
         * Returns an array of ActionItem objects from the given array of products.
         */
        this.getActionItems = (products) => {
            const actionItems = [];
            each(products, (product, index) => {
                actionItems[index] = {
                    product: product,
                    chargeType: get(PriceListItemService.getPriceListItemForProduct(product), 'ChargeType')
                };
            });
            return actionItems;
        };
    }
    /**
     * Refreshes the cart level constraint rules behavior subject.
     */
    refreshCartRules() {
        combineLatest([
            this.productConfigurationService.configurationChange, this.constraintRuleService.getPendingActionsForCart()
        ])
            .pipe(switchMap(([configState, rules]) => {
            if (this.productConfigurationService.getConfigState().value.isConfig) {
                const cartRules = filter$1(get(configState, 'ruleActions', []), action => action.ConstraintRuleAction.MatchInPrimaryLines);
                return this.getConstraintRuleGroups(cartRules);
            }
            else if (rules) {
                return this.getConstraintRuleGroups(rules);
            }
            return of(null);
        })).subscribe(res => {
            this.cartRuleGroups$.next(res);
        });
    }
    /**
     * Refreshes the product configuration level constraint rules behavior subject.
     */
    refreshConfigRules() {
        combineLatest([
            this.productConfigurationService.configurationChange, this.clientConstraintRuleService.ruleMessages$
        ])
            .pipe(switchMap(([configState, response]) => {
            if (this.productConfigurationService.getConfigState().value.isConfig) {
                const configRules = filter$1(get(configState, 'ruleActions', []), action => action.ConstraintRuleAction.MatchInOptions);
                return this.getConstraintRuleGroups(configRules);
            }
            else if (response) {
                return this.getConstraintRuleGroups(response);
            }
            return of(null);
        })).subscribe(res => this.configRuleGroups$.next(res));
    }
    /**
     * Returns an observable of the cart level rule groups.
     */
    getCartRuleGroups() {
        if (!this.cartRuleGroups$) {
            this.cartRuleGroups$ = new BehaviorSubject(null);
            this.refreshCartRules();
        }
        return this.cartRuleGroups$;
    }
    /**
     * Returns an observable of the product configuration level rule groups.
     */
    getConfigurationRuleGroups() {
        if (!this.configRuleGroups$) {
            this.configRuleGroups$ = new BehaviorSubject(null);
            this.refreshConfigRules();
        }
        return this.configRuleGroups$;
    }
    /**
     * @ignore
     * Generates constraint error message
     */
    generateRuleActionMessage(message, actionProducts, triggeringProducts) {
        if (message.indexOf('{') !== -1) {
            const replacedActions = replace(message, '{1}', `<strong>${join(map$1(actionProducts, product => product.Name))}</strong>`);
            return replace(replacedActions, '{0}', `<strong>${join(map$1(triggeringProducts, product => product.Name))}</strong>`);
        }
        else if (message && triggeringProducts && actionProducts) {
            each(uniq(concat(actionProducts, triggeringProducts)), product => {
                message = replace(message, product.Name, `<strong>${product.Name}</strong>`);
            });
            return message;
        }
        return message;
    }
    /**
     * Adds a product to the cart based on the associated constraint rule.
     * @param ruleDetail Constraint rule detail object related to the action product to add to cart.
     * @param product Action product to add for the associated constraint rule.
     * @param quantity Quantity of the given product to add to the cart.
     * @fires cartService.addOptionToBundle()
     * @fires cartService.addProductToCart()
     */
    addProductToCartFromRule(ruleDetail, product, quantity = 1) {
        if (product) {
            if (ruleDetail.isOption) {
                return this.cartService.getMyCart().pipe(take(1), switchMap(cart => {
                    const cartItemId = get(first(filter$1(cart.LineItems, cartItem => get(cartItem, 'PrimaryLineNumber') === get(ruleDetail, 'targetBundleNumber'))), 'Id');
                    if (cartItemId) {
                        // For CaaS mode postMessage to cpq
                        if (this.productConfigurationService.getConfigState().value.isConfig) {
                            const data = { action: "add", targetBundleNumber: `${get(ruleDetail, 'targetBundleNumber')}`, quantity: quantity, productId: get(product, 'Id') };
                            this.productConfigurationService.postMessageToCpq(data);
                            return of(null);
                        }
                        else {
                            return this.cartService.addOptionToBundle(cartItemId, {
                                ProductId: get(product, 'Id'),
                                Quantity: quantity
                            });
                        }
                    }
                    else
                        return of(null);
                }), switchMap(res => {
                    return of(this.exceptionService.showSuccess('SUCCESS.CART.ITEM_ADDED_TOASTR_MESSAGE', 'SUCCESS.CART.ITEM_ADDED_TOASTR_TITLE', { productName: get(product, 'Name') }));
                }), catchError(error => {
                    return of(this.exceptionService.showError(error));
                }));
            }
            else {
                if (this.productConfigurationService.getConfigState().value.isConfig) {
                    const data = { action: "add", targetBundleNumber: `${get(ruleDetail, 'targetBundleNumber')}`, quantity: quantity, productId: get(product, 'Id') };
                    this.productConfigurationService.postMessageToCpq(data);
                    return of(null);
                }
                else {
                    return this.cartService.addProductToCart(product, quantity)
                        .pipe(switchMap(res => {
                        if (!isEmpty(res)) {
                            return of(this.exceptionService.showSuccess('SUCCESS.CART.ITEM_ADDED_TOASTR_MESSAGE', 'SUCCESS.CART.ITEM_ADDED_TOASTR_TITLE', { productName: get(product, 'Name') }));
                        }
                        else {
                            return of(null);
                        }
                    }), catchError(error => {
                        return of(this.exceptionService.showError(error));
                    }));
                }
            }
        }
        return of();
    }
    /**
     * Removes a product from the cart based on the given constraint rule detail object.
     * @param ruleDetail Constraint rule detail object pertaining to the product to remove from the cart.
     */
    deleteProductFromCart(ruleDetail) {
        if (ruleDetail.actionItems) {
            return this.cartService.getMyCart().pipe(switchMap(cart => {
                return of(filter$1(cart.LineItems, cartItem => includes(map$1(ruleDetail.actionItems, item => get(item, 'product.Id')), (ruleDetail.isOption ? get(cartItem, 'OptionId') : cartItem.LineType === 'Product/Service' ? get(cartItem, 'ProductId') : null))
                    && get(cartItem, 'IsPrimaryLine')));
            }), switchMap(cartItems => {
                if (this.productConfigurationService.getConfigState().value.isConfig) {
                    forEach((cartItems), (ci) => {
                        let data;
                        if (isNil(get(ci, 'Option.Id'))) // remove product from a cart
                            data = { action: "remove", targetBundleNumber: `${get(ci, 'PrimaryLineNumber')}` };
                        else // remove product option from a bundle
                            data = { action: "remove", targetBundleNumber: `${get(ci, 'ParentBundleNumber')}`, productId: `${get(ci, 'Option.Id')}` };
                        this.productConfigurationService.postMessageToCpq(data);
                    });
                    return new Observable();
                }
                else {
                    return this.cartService.removeCartItems(cartItems);
                }
            }), catchError(error => {
                return of(this.exceptionService.showError(error));
            }));
        }
        else
            of();
    }
    /**
     * Adds the given option product to the specified bundle product during configuration.
     * @param product Product to add to the configuration.
     * @param quantity Quantity of the given product to add to the configuration.
     * @param bundleProduct Parent product that will be to add the given option product to.
     */
    addProductToConfiguration(product, quantity, targetBundleNumber) {
        // In CaaS mode send message to CPQ to update childcart
        if (product && this.productConfigurationService.getConfigState().value.isConfig) {
            const data = { action: "add", targetBundleNumber: targetBundleNumber, quantity: quantity, productId: get(product, 'Id') };
            this.productConfigurationService.postMessageToCpq(data);
            return of(null);
        }
        else {
            this.clientConstraintRuleService.assignAction({
                prod: product,
                quantity: quantity,
                type: 'Inclusion'
            });
            return of(null);
        }
    }
    /**
     * Removes the given product from the current configuration that hasn't been added to the cart.
     * @param product Product to remove from the current configuration.
     */
    removeOptionFromConfiguration(product, bundleProduct) {
        // In CaaS mode send message to CPQ to update childcart
        if (this.productConfigurationService.getConfigState().value.isConfig) {
            return this.cartService.getChildCart().pipe(switchMap(cart => {
                return of(filter$1(get(cart, 'LineItems'), cartItem => includes(get(product, 'Id'), (get(product, 'ConfigurationType') === 'Option' ? get(cartItem, 'OptionId') : cartItem.LineType === 'Product/Service' ? get(cartItem, 'ProductId') : null))
                    && get(cartItem, 'IsPrimaryLine')));
            }), switchMap(cartItems => {
                forEach((cartItems), (ci) => {
                    let data;
                    if (isNil(get(ci, 'OptionId'))) // remove product from a cart
                        data = { action: "remove", targetBundleNumber: `${get(ci, 'PrimaryLineNumber')}` };
                    else // remove product option from a bundle
                        data = { action: "remove", targetBundleNumber: `${get(ci, 'ParentBundleNumber')}`, productId: `${get(ci, 'OptionId')}` };
                    this.productConfigurationService.postMessageToCpq(data);
                });
                return new Observable();
            }));
        }
        else {
            this.clientConstraintRuleService.assignAction({
                prod: product,
                type: 'Exclusion'
            });
            return of(null);
        }
    }
    /**
     * Returns formatted groups of constraint rules to be presented in the UI.
     * @param actionInfo Array of AppliedRuleActionInfo objects used to create the appropriate constraint rule groups.
     */
    getConstraintRuleGroups(actionInfo) {
        const relatedProductIds = uniq(flatten(concat(map$1(actionInfo, rule => split(get(rule, 'TriggeringProductIds'), ', ')), map$1(actionInfo, rule => split(get(rule, 'ActionProductIds'), ', ')))));
        return combineLatest([
            of(actionInfo),
            this.productService.query({
                conditions: [new ACondition(Product, 'Id', 'In', relatedProductIds)],
                children: [{ field: 'PriceLists' }]
            })
        ])
            .pipe(map(([rules, relatedProducts]) => {
            const success = filter$1(rules, rule => (rule.ConstraintRuleAction.ActionIntent === 'Auto Include' || rule.ConstraintRuleAction.ActionIntent === 'Disable Selection') && rule.Pending);
            const errors = filter$1(rules, rule => rule.MessageType === 'Error' && rule.Pending);
            const warnings = filter$1(rules, rule => rule.MessageType === 'Warning' && rule.Pending);
            const info = filter$1(rules, rule => rule.MessageType === 'Info' && rule.Pending);
            const totalRules = sum([size(errors), size(warnings), size(info)]);
            return {
                errors: map$1(errors, error => {
                    return {
                        triggeringProducts: filter$1(relatedProducts, product => includes(get(error, 'TriggeringProductIds'), get(product, 'Id'))),
                        actionItems: this.getActionItems(filter$1(relatedProducts, product => includes(get(error, 'ActionProductIds'), get(product, 'Id')))),
                        actionType: get(error, 'ConstraintRuleAction.ActionType'),
                        message: get(error, 'Message'),
                        messageHtml: this.beautifyMessage(get(error, 'Message'), filter$1(relatedProducts, product => includes(get(error, 'TriggeringProductIds'), get(product, 'Id'))), filter$1(relatedProducts, product => includes(get(error, 'ActionProductIds'), get(product, 'Id')))),
                        isOption: get(error, 'IsTargetOption'),
                        targetBundleNumber: get(error, 'TargetBundleNumber')
                    };
                }),
                warnings: map$1(warnings, warning => {
                    return {
                        triggeringProducts: filter$1(relatedProducts, product => includes(get(warning, 'TriggeringProductIds'), get(product, 'Id'))),
                        actionItems: this.getActionItems(filter$1(relatedProducts, product => includes(get(warning, 'ActionProductIds'), get(product, 'Id')))),
                        actionType: get(warning, 'ConstraintRuleAction.ActionType'),
                        message: get(warning, 'Message'),
                        messageHtml: this.beautifyMessage(get(warning, 'Message'), filter$1(relatedProducts, product => includes(get(warning, 'TriggeringProductIds'), get(product, 'Id'))), filter$1(relatedProducts, product => includes(get(warning, 'ActionProductIds'), get(product, 'Id')))),
                        isOption: get(warning, 'IsTargetOption'),
                        targetBundleNumber: get(warning, 'TargetBundleNumber')
                    };
                }),
                info: map$1(info, datum => {
                    return {
                        actionType: get(datum, 'ConstraintRuleAction.ActionType'),
                        message: get(datum, 'Message')
                    };
                }),
                success: map$1(success, datum => {
                    return {
                        message: this.generateRuleActionMessage(get(datum, 'Message'), filter$1(relatedProducts, product => includes(get(datum, 'ActionProductIds'), get(product, 'Id'))), filter$1(relatedProducts, product => includes(get(datum, 'TriggeringProductIds'), get(product, 'Id'))))
                    };
                }),
                totalRules: totalRules
            };
        }));
    }
}
ConstraintRuleMessageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleMessageService, deps: [{ token: i1.ConstraintRuleService }, { token: i1.CartService }, { token: i1.ProductService }, { token: ExceptionService }, { token: i1.ClientConstraintRuleService }, { token: ProductConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ConstraintRuleMessageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleMessageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleMessageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ConstraintRuleService }, { type: i1.CartService }, { type: i1.ProductService }, { type: ExceptionService }, { type: i1.ClientConstraintRuleService }, { type: ProductConfigurationService }]; } });

/**
 * Service that is used by the constraint rule popover  component.
 * @ignore
 */
class ConstraintPopoverService {
    constructor(constraintRuleMessageService, clientConstraintRuleService) {
        this.constraintRuleMessageService = constraintRuleMessageService;
        this.clientConstraintRuleService = clientConstraintRuleService;
    }
    renderRuleForOption(rules, parentProduct, product) {
        const ruleList = cloneDeep(rules);
        const promptActionList = {};
        const promptRules = filter$1(filter$1(ruleList, (r) => includes(map$1(get(r, '_metadata.productList', []), 'Id'), product.Id) && first(r.ConstraintRuleActions).ActionIntent === 'Prompt'), (rule) => {
            const conditionRule = filter$1(rule.ConstraintRuleConditions, (condition) => {
                // checks for condition with product scope as Product/ product Family/ product Group and
                // then checks for condition with only matchInOptions/ only matchInPrimaryLines or both are selected.
                let isvalid = false;
                if (condition.MatchInPrimaryLines)
                    isvalid = ((condition.ProductScope === 'Product' && condition.ProductId === parentProduct.Id) ||
                        (condition.ProductScope === 'Product Family' && condition.Product.Family === parentProduct.Family) ||
                        (condition.ProductScope === 'Product Group' && filter$1(get(parentProduct, 'ProductGroups', []), groupMember => groupMember.ProductGroupId === condition.ProductGroupId).length > 0));
                else
                    isvalid = includes(map$1(get(rule, '_metadata.productList', []), 'Id'), product.Id);
                return isvalid;
            }).length === rule.ConstraintRuleConditions.length;
            return conditionRule === true;
        });
        const actionRule = flatten(promptRules.map(r => r.ConstraintRuleActions))
            .filter(action => get(action, 'MatchInOptions') === true && get(action, 'ActionIntent') === ConstraintActionsIntent.PROMPT);
        if (!isNil(actionRule)) {
            const products = compact(flatten(map$1(promptRules, '_metadata.actionProductList')));
            promptActionList.Rule = promptRules;
            promptActionList.Messages = [];
            forEach(actionRule, r => {
                promptActionList.Messages.push(this.constraintRuleMessageService.beautifyMessage(get(r, 'Message', ''), flatten(map$1(promptRules, '_metadata.productList')), flatten(map$1(promptRules, '_metadata.actionProductList')), false));
            });
            promptActionList.ActionItem = [];
            forEach(products, p => {
                const rule = find(promptRules, (r) => includes(map$1(r._metadata.actionProductList, 'Id'), p.Id));
                if (!isNil(rule)) {
                    promptActionList.ActionItem.push({
                        Product: p,
                        ActionType: first(rule.ConstraintRuleActions).ActionType === ConstraintActionsType.INCLUSION ? ConstraintActionsType.INCLUSION : ConstraintActionsType.EXCLUSION
                    });
                }
            });
        }
        return promptActionList;
    }
    handlePopover(ruleList, parentProduct, product, promptActionList) {
        let popoverClose = false;
        // open the popover if the rule condition is satisfied.
        if (get(ruleList, 'length') > 0 && this.clientConstraintRuleService.isProductSelected(product.Id)) {
            const promptRules = filter$1(ruleList, (r) => includes(map$1(get(r, '_metadata.productList', []), 'Id'), product.Id) && first(r.ConstraintRuleActions).ActionIntent === 'Prompt');
            // if not prompt rule then close the popover.
            if (promptRules.length === 0)
                return popoverClose = true;
            const crActionList = [];
            filter$1(promptRules, rule => {
                const applyAction = filter$1(rule.ConstraintRuleConditions, (condition) => 
                // checks for condition with product scope as Product/ product Family/ product Group and
                // then checks for condition with only matchInOptions/ only matchInPrimaryLines or both are selected.
                this.clientConstraintRuleService.validateCRCondition(condition, condition.MatchInPrimaryLines ? parentProduct : product, this.clientConstraintRuleService.getCurrentSelection())).length === rule.ConstraintRuleConditions.length;
                if (applyAction)
                    crActionList.push(rule);
            });
            // if condition is satisfied applyAction flag is true.
            // creating temporary array which has list of rule condition got satisfied for single selected option.
            if (crActionList.length > 0) {
                // checks for the rule action is not satisfied close popover
                if (this.clientConstraintRuleService.validateCRActionForPrompt(promptActionList.Rule, product, true)) {
                    return popoverClose = true;
                }
                else {
                    // checks for the rule action is satisfied close popover
                    return popoverClose = false;
                }
            }
            else {
                return popoverClose = true;
            }
        }
        else {
            return popoverClose = true;
        }
    }
}
ConstraintPopoverService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverService, deps: [{ token: ConstraintRuleMessageService }, { token: i1.ClientConstraintRuleService }], target: i0.ɵɵFactoryTarget.Injectable });
ConstraintPopoverService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConstraintRuleMessageService }, { type: i1.ClientConstraintRuleService }]; } });

/**
 * The constraint rule popover component creates a popover on an element based on the constraint rule list and product passed to it.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/constraintPopover.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ConstraintPopoverModule } from '@congacommerce/elements';

@NgModule({
  imports: [ConstraintPopoverModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* <button
*             [popover]="popTemplate"
*             container="body"
*             [adaptivePosition]="false"
*             [outsideClick]="true"
*             containerClass="CRPopover"
*             triggers="mouseenter:mouseleave focus:blur"
* >
*             Add to Cart
* </button>
*
* <ng-template #popTemplate>
*             <apt-cr-popover
*               [ruleList]="constraintRuleList"
*               [product]="product"
*               [message]="popoverMessage"
*               [optionRules]="hasOptionRules"
*               [triggers]="popoverTriggers"
*               [outsideClick]="closeOnOutsideClick"
*               [containerClass]="popoverWrapperClass"
*             ></apt-cr-popover>
* </ng-template>
 ```
*/
class CRPopoverComponent {
    constructor(productService, elRef, clientConstraintRuleService, constraintPopoverService, cdr) {
        this.productService = productService;
        this.elRef = elRef;
        this.clientConstraintRuleService = clientConstraintRuleService;
        this.constraintPopoverService = constraintPopoverService;
        this.cdr = cdr;
        /**
         * Flag to check if there are option rules.
         */
        this.optionRules = false;
        /**
         * Special string for ngx-bootstrap to configuring events that trigger show/hide of the popover.
         */
        this.triggers = 'mouseenter:mouseleave focus:blur';
        /**
         * Closes the popover if there is mouse click outside the popover.
         */
        this.outsideClick = true;
        /**
         * Class to be applied to the parent of the popover.
         */
        this.containerClass = 'CRPopover';
        /** @ignore */
        this.state = 'LOADING';
        /** @ignore */
        this.rulesToShow = [];
        /** @ignore */
        this.otherRules = new Array();
        /** @ignore */
        this.promptActionList = {};
        /**
         * The product identifier set in the configuration file.
         * @ignore
         */
        this.identifier = 'Id';
        this.productService.configurationService.get('productIdentifier');
        this.popover = this.popTemplate;
    }
    ngOnChanges() {
        const ruleList$ = !isNil(this.ruleList) ? of(this.ruleList) : of([]);
        this.subscription = ruleList$
            .subscribe(ruleList => {
            this.ruleList = cloneDeep(ruleList);
            if (this.ruleList) {
                forEach(this.ruleList, r => {
                    if (get(r.ConstraintRuleActions.filter(action => get(action, 'ActionType') === ConstraintActionsType.INCLUSION || get(action, 'ActionType') === ConstraintActionsType.EXCLUSION), 'length') > 0) {
                        this.rulesToShow.push(r);
                    }
                });
                if (!this.optionRules) {
                    flatten(this.ruleList.map(r => r.ConstraintRuleActions)).forEach(action => {
                        if (!isNil(get(action, 'Message'))) {
                            set(action, 'Message', get(action, 'Message', '').replace('{0}', ''));
                            set(action, 'Message', get(action, 'Message', '').replace('{1}', ''));
                        }
                    });
                    this.productInclusionRules = uniqBy(flatten(this.ruleList.map(r => r.ConstraintRuleActions))
                        .filter(action => get(action, 'ActionType') === ConstraintActionsType.INCLUSION && get(action, 'ProductScope') === 'Product'), 'Id');
                    this.otherRules = uniqBy(flatten(this.ruleList.map(r => r.ConstraintRuleActions))
                        .filter(action => get(action, 'ProductScope') !== 'Product'), 'Id');
                    this.productExclusionRules = uniqBy(flatten(this.ruleList.map(r => r.ConstraintRuleActions))
                        .filter(action => get(action, 'ActionType') === ConstraintActionsType.EXCLUSION && get(action, 'ProductScope') === 'Product'), 'Id');
                }
                else {
                    this.showRuleForOption(ruleList);
                }
            }
            this.cdr.markForCheck();
        });
    }
    /** @ignore */
    showRuleForOption(rules) {
        if (get(rules, 'length') > 0) {
            this.promptActionList = this.constraintPopoverService.renderRuleForOption(rules, this.parentProduct, this.product);
            this.state = 'WRITE';
        }
    }
    /** @ignore */
    selectPromptAction(product, addOption) {
        this.clientConstraintRuleService.assignAction({
            prod: product,
            quantity: get(product, '_metadata.quantity'),
            type: addOption ? ConstraintActionsType.INCLUSION : ConstraintActionsType.EXCLUSION
        });
        if (this.clientConstraintRuleService.validateCRActionForPrompt(this.promptActionList.Rule, product)) {
            this.popoverClose();
        }
    }
    /** @ignore */
    onShown() {
        const top = this.elRef.nativeElement.getBoundingClientRect().top;
        const right = this.elRef.nativeElement.getBoundingClientRect().right;
        const bottom = this.elRef.nativeElement.getBoundingClientRect().bottom;
        const left = this.elRef.nativeElement.getBoundingClientRect().left;
        const middleVert = (top + bottom) / 2;
        const middleHoriz = (left + right) / 2;
        let position = 'top';
        // If there is more space on the top.
        if (middleVert > window.innerHeight / 2)
            position = 'top';
        else
            position = 'bottom';
        // If there is not enough space on the right to show top or bottom.
        if (window.innerWidth - middleHoriz < 200)
            position = 'left';
        // If there is not enough space on the left to show top or bottom.
        else if (middleHoriz < 200)
            position = 'right';
        // If there is not enough space on top or bottom just show where there is most space.
        if (window.innerWidth - middleHoriz < 200 && middleHoriz < 200) {
            // If there is more space on the top.
            if (middleVert > window.innerHeight / 2)
                position = 'top';
            else
                position = 'bottom';
        }
        return position;
    }
    /** @ignore */
    getOptionValue(product) {
        if (!get(product, '_metadata.quantity'))
            set(product, '_metadata.quantity', 1);
        return product || {
            _metadata: {
                quantity: 0
            }
        };
    }
    /** @ignore */
    openPopover(pop) {
        const flag = this.constraintPopoverService.handlePopover(this.ruleList, this.parentProduct, this.product, this.promptActionList);
        if (!flag) {
            this.popover = pop;
            return this.popover.show();
        }
        else {
            return this.popoverClose();
        }
    }
    /** @ignore */
    popoverClose() {
        if (this.pop)
            this.pop.hide();
    }
    /** @ignore */
    isItemSelected(productId) {
        return this.clientConstraintRuleService.isProductSelected(productId);
    }
    ngOnDestroy() {
        if (get(this, 'subscription.unsubscribe'))
            this.subscription.unsubscribe();
    }
}
CRPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CRPopoverComponent, deps: [{ token: i1.ProductService }, { token: i0.ElementRef }, { token: i1.ClientConstraintRuleService }, { token: ConstraintPopoverService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
CRPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: CRPopoverComponent, selector: "apt-cr-popover", inputs: { product: "product", parentProduct: "parentProduct", message: "message", items: "items", options: "options", optionRules: "optionRules", triggers: "triggers", outsideClick: "outsideClick", containerClass: "containerClass", ruleList: "ruleList" }, viewQueries: [{ propertyName: "pop", first: true, predicate: ["pop"], descendants: true }, { propertyName: "popTemplate", first: true, predicate: ["popTemplate"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"h-100\"\r\n  [popover]=\"((ruleList?.length > 0 && rulesToShow?.length > 0 ) || message?.length > 0) ? popTemplate : null\"\r\n  [containerClass]=\"containerClass\" [outsideClick]=\"outsideClick\" [triggers]=\"triggers\" [placement]=\"onShown()\"\r\n  (click)=\"openPopover(pop)\" #pop=\"bs-popover\" [attr.data-popover]=\"(ruleList?.length > 0 || message)\">\r\n  <ng-content></ng-content>\r\n</div>\r\n\r\n\r\n<ng-template #popTemplate>\r\n  <div class=\"p-2\" *ngIf=\"!optionRules; else constraintOptionTemplate\">\r\n    <div class=\"popoverHeader mb-3\">\r\n      <h5>{{'CONSTRAINT_POPOVER.PRODUCTS_INCLUDED_EXCLUDED_HEADING' | translate}}</h5>\r\n    </div>\r\n    <div class=\"popoverBody\">\r\n      <div *ngIf=\"message\">\r\n        <p [innerHTML]=\"message\"></p>\r\n      </div>\r\n\r\n      <div *ngIf=\"productInclusionRules?.length > 0\">\r\n        <p [innerHTML]=\"'CONSTRAINT_POPOVER.PRODUCTS_INCLUSION' | translate: {productName: product?.Name}\"></p>\r\n        <div class=\"border-top pt-3\">\r\n          <div *ngFor=\"let rule of productInclusionRules\" class=\"d-flex justify-content-between\">\r\n            <ng-container *ngIf=\"rule.ProductScope === 'Product'\">\r\n              <a [routerLink]=\"['/products', rule.Product[identifier]]\" *ngIf=\"rule?.Product?.Id\"\r\n                href=\"javascript:void(0)\">{{rule?.Product?.Name}}</a>\r\n              <small>\r\n                <apt-price [record]=\"rule.Product\" quantity=\"1\"></apt-price>\r\n              </small>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"productExclusionRules?.length > 0\">\r\n        <p [ngClass]=\"(productExclusionRules?.length > 0) ? 'border-top pt-3 mt-3' : ''\"\r\n          [innerHTML]=\"'CONSTRAINT_POPOVER.PRODUCTS_EXCLUSION' | translate: {productName: product.Name}\">\r\n        </p>\r\n        <div class=\"border-top pt-3\">\r\n          <div *ngFor=\"let rule of productExclusionRules\" class=\"d-flex justify-content-between\">\r\n            <a [routerLink]=\"['/products', rule.Product[identifier]]\" *ngIf=\"rule?.Product?.Id\"\r\n              href=\"javascript:void(0)\">{{rule?.Product?.Name}}</a>\r\n            <small>\r\n              <apt-price [record]=\"rule.Product\"></apt-price>\r\n            </small>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"otherRules?.length > 0\">\r\n        <div *ngFor=\"let rule of otherRules\">\r\n          <ng-container *ngIf=\"rule.ProductScope === 'Product Group'\">\r\n            <p class=\"pt-3 mt-3\"\r\n              [innerHTML]=\"'COMMON.PRODUCT_GROUP' | translate: {productGroupName: rule?.ProductGroup?.Name}\"></p>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"rule.ProductScope === 'Product Family'\">\r\n            <p class=\"pt-3 mt-3\"\r\n              [innerHTML]=\"'COMMON.PRODUCT_FAMILY' | translate: {productFamily: rule?.ProductFamily}\"></p>\r\n          </ng-container>\r\n          <div class=\"border-top pt-3\">\r\n            <p [innerHTML]=\"rule.Message\"></p>\r\n            <strong> {{product?.Name}}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<!--  Product Details -->\r\n<ng-template #constraintOptionTemplate>\r\n  <div [ngSwitch]=\"state\">\r\n    <div *ngSwitchCase=\"'LOADING'\">\r\n      <div class=\"modal-body d-flex p-5 align-items-center justify-content-center\">\r\n        <apt-spinner class=\"m-5\"></apt-spinner>\r\n      </div>\r\n    </div>\r\n    <div *ngSwitchCase=\"'WRITE'\">\r\n      <div class=\"p-2\">\r\n        <div class=\"d-flex justify-content-between border-bottom mb-3\">\r\n          <h5>\r\n            {{'CONSTRAINT_POPOVER.OPTIONS_HEADING' | translate}}\r\n          </h5>\r\n          <button type=\"button\" class=\"close closeButton\" aria-label=\"Close\" (click)=\"popoverClose()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </div>\r\n        <div class=\"popoverBody\">\r\n          <div *ngIf=\"message\">\r\n            <p [innerHTML]=\"message\"></p>\r\n          </div>\r\n\r\n          <div>\r\n            <ng-container *ngFor=\"let msg of promptActionList.Messages\">\r\n              <p [innerHTML]=\"msg\"></p>\r\n            </ng-container>\r\n\r\n            <div class=\"border-top pt-3\">\r\n              <div *ngFor=\"let item of promptActionList.ActionItem\" class=\"d-flex mt-3\">\r\n                <ng-container>\r\n                  <div class=\"d-flex justify-content-between flex-grow-1\">\r\n                    <div class=\"d-flex flex-grow-1 option-details pr-5 w-75\">\r\n                      <div>\r\n                        <p class=\"mt-0 mb-1\">{{item.Product.Name}}</p>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                    <div class=\"border-left  d-flex align-items-center justify-content-end\">\r\n                      <div class=\"pl-3\">\r\n                        <label>{{'COMMON.PRICE' | translate}}</label>\r\n                        <apt-price [record]=\"item.Product\" quantity=\"1\"></apt-price>\r\n                      </div>\r\n\r\n                      <div class=\"pl-3\">\r\n                        <label for=\"item.Product.Id\" class=\"mr-2 mb-0\">{{'COMMON.QTY2' | translate}}</label>\r\n                        <input type=\"number\" class=\"form-control form-control-sm text-center w-50\" id=\"item.Product.Id\"\r\n                          placeholder=\"1\" name=\"quantity\"\r\n                          [(ngModel)]=\"getOptionValue(item.Product)._metadata.quantity\" />\r\n                      </div>\r\n                      <div class=\"input-group-append\">\r\n                        <button class=\"btn btn-outline-primary\" *ngIf=\"item.ActionType === 'Inclusion'\"\r\n                          [disabled]=\"isItemSelected(item.Product?.Id)\"\r\n                          (click)=\"selectPromptAction(item.Product, true)\">{{'COMMON.ADD' | translate}}</button>\r\n                        <button class=\"btn btn-outline-danger\" *ngIf=\"item.ActionType === 'Exclusion'\"\r\n                          [disabled]=\"!isItemSelected(item.Product?.Id)\"\r\n                          (click)=\"selectPromptAction(item.Product, false)\">{{'COMMON.REMOVE' | translate}}</button>\r\n                      </div>\r\n                    </div>\r\n                </ng-container>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</ng-template>", styles: [":host{display:block}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CRPopoverComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-cr-popover',
                    templateUrl: './constraint-popover.component.html',
                    styleUrls: ['./constraint-popover.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.ProductService }, { type: i0.ElementRef }, { type: i1.ClientConstraintRuleService }, { type: ConstraintPopoverService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { product: [{
                type: Input
            }], parentProduct: [{
                type: Input
            }], message: [{
                type: Input
            }], items: [{
                type: Input
            }], options: [{
                type: Input
            }], optionRules: [{
                type: Input
            }], triggers: [{
                type: Input
            }], outsideClick: [{
                type: Input
            }], containerClass: [{
                type: Input
            }], ruleList: [{
                type: Input
            }], pop: [{
                type: ViewChild,
                args: ['pop']
            }], popTemplate: [{
                type: ViewChild,
                args: ['popTemplate']
            }] } });

/**
 * @ignore
 */
class ConstraintPopoverModule {
}
ConstraintPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ConstraintPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverModule, declarations: [CRPopoverComponent], imports: [CommonModule,
        PriceModule,
        IconModule,
        RouterModule,
        FormsModule, i1$4.PopoverModule, i2$1.TranslateModule], exports: [CRPopoverComponent] });
ConstraintPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverModule, providers: [ConstraintPopoverService], imports: [[
            CommonModule,
            PriceModule,
            IconModule,
            RouterModule,
            FormsModule,
            PopoverModule.forRoot(),
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PriceModule,
                        IconModule,
                        RouterModule,
                        FormsModule,
                        PopoverModule.forRoot(),
                        TranslateModule.forChild()
                    ],
                    providers: [ConstraintPopoverService],
                    declarations: [CRPopoverComponent],
                    exports: [CRPopoverComponent]
                }]
        }] });

/**
 * Constraint rule sidebar is used to show a list of all the constraint rule messages that have been applied to the current cart.
 * <h3>Preview</h3>
 * <strong>Constraint rule validation panel with error and warning message</strong>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/constraintRuleValidationPanel.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ConstraintRuleModule } from '@congacommerce/elements';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  imports: [ConstraintRuleModule, ModalModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* import { ConstraintRuleSidebarComponent } from '@congacommerce/elements';
* import { BsModalService } from 'ngx-bootstrap/modal';
*
* constructor(private bsModalService: BsModalService) {}
*
* showSidebar() {
*       this.bsModalService.show(ConstraintRuleSidebarComponent, {
*              backdrop: false,
*              class: 'constraintRuleSidebar'
*       });
* }
 ```
*/
class ConstraintRuleSidebarComponent {
    constructor(bsModalRef, constraintRuleMessageService, clientConstraintRuleService, productConfigurationService) {
        this.bsModalRef = bsModalRef;
        this.constraintRuleMessageService = constraintRuleMessageService;
        this.clientConstraintRuleService = clientConstraintRuleService;
        this.productConfigurationService = productConfigurationService;
        /** @ignore */
        this.loading = {};
        /** @ignore */
        this.quantityControlValues = {};
        /**
         * Flag used to specify if this component is showing product level constraint rules.
         * If false this component will show cart level configuration rules.
         */
        this.showProductConfig = false;
    }
    /** @ignore */
    ngOnInit() {
        this.ruleDetailGroups$ = this.showProductConfig ? this.constraintRuleMessageService.getConfigurationRuleGroups() : this.constraintRuleMessageService.getCartRuleGroups();
        this.sub = this.ruleDetailGroups$.subscribe(groups => {
            if (get(groups, 'totalRules') === 0)
                this.bsModalRef.hide();
        });
    }
    /** @ignore */
    handleAddToCart(ruleDetail, product, quantity = 1, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.addProductToCartFromRule(ruleDetail, product, quantity)
            .pipe(take(1)).subscribe(() => {
            if (this.productConfigurationService.getConfigState().value.isConfig)
                this.bsModalRef.hide();
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleAddToConfiguration(product, quantity = 1, loadingKey, targetBundleNumber) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.addProductToConfiguration(product, quantity, targetBundleNumber)
            .pipe(take(1)).subscribe(() => {
            if (this.productConfigurationService.getConfigState().value.isConfig)
                this.bsModalRef.hide();
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleDeleteFromCart(ruleDetail, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.deleteProductFromCart(ruleDetail)
            .pipe(take(1)).subscribe(() => {
            if (this.productConfigurationService.getConfigState().value.isConfig)
                this.bsModalRef.hide();
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleRemoveFromBundle(product, bundleProduct, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.removeOptionFromConfiguration(product, bundleProduct)
            .pipe(take(1)).subscribe(() => {
            if (this.productConfigurationService.getConfigState().value.isConfig)
                this.bsModalRef.hide();
            this.loading[loadingKey] = false;
        });
    }
    /**
    * Method responsible to disable/enable the products in the sidebar to add/remove
    * based on the rule configured and product selection.
    * @param product instance of Product object.
    * @param action optional parameter accepts 'add' or 'remove' to perform add /remove action.
    * @returns boolean value is returned.
    */
    isItemSelected(product, action) {
        const disabled = (action === 'remove') ? true : false;
        return this.productConfigurationService.getConfigState().value.isConfig ? disabled : this.clientConstraintRuleService.isProductSelected(product.Id);
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
ConstraintRuleSidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleSidebarComponent, deps: [{ token: i1$2.BsModalRef }, { token: ConstraintRuleMessageService }, { token: i1.ClientConstraintRuleService }, { token: ProductConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
ConstraintRuleSidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ConstraintRuleSidebarComponent, selector: "apt-constraint-rule-sidebar", ngImport: i0, template: "<ng-container *ngIf=\"ruleDetailGroups$ | async as ruleDetailGroups\">\r\n  <div class=\"modal-header py-2 border-0\">\r\n    <h5 class=\"modal-title pull-left\">{{ \"CONSTRAINT_SIDE_MENU.VALIDATION_MESSAGES\" | translate }}</h5>\r\n    <button type=\"button\" class=\"close pull-left\" aria-label=\"Close\">\r\n      <span aria-hidden=\"true\" (click)=\"bsModalRef.hide()\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body p-0\">\r\n    <!-- Errors -->\r\n    <div *ngIf=\"ruleDetailGroups.errors.length > 0\" class=\"card border-0\">\r\n      <div class=\"card-header border-bottom-0 border-top\">\r\n        <i class=\"fas fa-exclamation-circle text-danger\"></i> <span>\r\n          {{ (ruleDetailGroups.errors.length > 1 ? \"CONSTRAINT_SIDE_MENU.NUM_OF_ERRORS.PLURAL\" : \"CONSTRAINT_SIDE_MENU.NUM_OF_ERRORS.ONE\") | translate: {amount: ruleDetailGroups.errors.length} }}\r\n        </span>\r\n      </div>\r\n      <ng-container *ngFor=\"let error of ruleDetailGroups.errors; let i = index\">\r\n        <ng-container [ngSwitch]=\"error.actionType\">\r\n          <!-- Inclusions -->\r\n          <ng-container *ngSwitchCase=\"'Inclusion'\">\r\n            <div class=\"card-body bg-white py-2 flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"error.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"error.messageHtml\"></div>\r\n              </ng-container>\r\n              <ng-container *ngFor=\"let item of error.actionItems\">\r\n                <div class=\"py-3\">\r\n                  <a class=\"pt-2\" href=\"javascript:void(0)\"\r\n                    [routerLink]=\"['/products/', item.product.Id]\">{{item.product.Name}}</a>\r\n                  <div class=\"d-flex py-2 align-items-center justify-content-between\">\r\n                    <small class=\"font-weight-bold\">{{item.chargeType}}</small>\r\n                    <small class=\"font-weight-bold\">\r\n                      <apt-price [record]=\"item.product\"></apt-price>\r\n                    </small>\r\n                  </div>\r\n                  <div class=\"d-flex align-items-center justify-content-end\">\r\n                    <label [for]=\"item.product.Name + i\" class=\"mr-2 mb-0\">{{ \"COMMON.QTY\" | translate }}</label>\r\n                    <input class=\"form-control mr-2 w-25\" [id]=\"item.product.Name + i\" type=\"number\" min=\"1\"\r\n                      [(ngModel)]=\"quantityControlValues[item.product.Name + i]\" placeholder=\"1\">\r\n                    <div class=\"input-group-append\">\r\n                      <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-primary\"\r\n                        (click)=\"handleAddToCart(error, item.product, quantityControlValues[item.product.Name + i], item.product.Name + i)\"\r\n                        [ladda]=\"loading[item.product.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.ADD_TO_CART\" | translate }}</button>\r\n                      <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-primary\"\r\n                        [disabled]=\"isItemSelected(item.product)\"\r\n                        (click)=\"handleAddToConfiguration(item.product, quantityControlValues[item.product.Name + i], item.product.Name + i, error.targetBundleNumber)\"\r\n                        [ladda]=\"loading[item.product.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.ADD\" | translate }}</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"card-footer bg-white border-0 py-2\">\r\n            </div>\r\n          </ng-container>\r\n          <!-- Exclusions -->\r\n          <ng-container *ngSwitchCase=\"'Exclusion'\">\r\n            <div class=\"card-body bg-white py-2 flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"error.messageHtml !== null;\">\r\n                <span [innerHtml]=\"error.messageHtml\"></span>\r\n              </ng-container>\r\n              <ng-container *ngFor=\"let item of error.actionItems\">\r\n                <div class=\"py-3\">\r\n                  <a class=\"pt-2\" href=\"javascript:void(0)\"\r\n                    [routerLink]=\"['/products/', item.product.Id]\">{{item.product.Name}}</a>\r\n                  <div class=\"d-flex py-2 align-items-center justify-content-between\">\r\n                    <small class=\"font-weight-bold\">{{item.chargeType}}</small>\r\n                    <small class=\"font-weight-bold\">\r\n                      <apt-price [record]=\"item.product\"></apt-price>\r\n                    </small>\r\n                  </div>\r\n                  <div class=\"d-flex align-items-center justify-content-end\">\r\n                    <label [for]=\"item.product.Name + i\" class=\"mr-2 mb-0\">{{ \"COMMON.QTY\" | translate }}</label>\r\n                    <input class=\"form-control mr-2 w-25\" [id]=\"item.product.Name + i\" type=\"number\" min=\"1\"\r\n                      [(ngModel)]=\"quantityControlValues[item.product.Name + i]\" placeholder=\"1\">\r\n                    <div class=\"input-group-append\">\r\n                      <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-danger\"\r\n                        (click)=\"handleDeleteFromCart(error, item.product?.Name + i)\"\r\n                        [ladda]=\"loading[item.product?.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</button>\r\n                      <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-danger\"\r\n                        [disabled]=\"!isItemSelected(item.product, 'remove')\"\r\n                        (click)=\"handleRemoveFromBundle(item.product, error.triggeringProducts[0], item.product?.Name + i)\"\r\n                        [ladda]=\"loading[item.product?.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.REMOVE\" | translate }}</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <!-- <div class=\"card-footer bg-white border-0 py-2 d-flex justify-content-end\">\r\n              <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-danger\" (click)=\"handleDeleteFromCart(error, error.actionItems[0].product?.Name + i)\" [ladda]=\"loading[error.actionItems[0].product?.Name + i]\" data-style=\"zoom-in\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</button>\r\n              <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-danger\" [disabled]=\"isItemSelected(error.actionItems[0].product)\" (click)=\"handleRemoveFromBundle(error.actionItems[0].product, error.triggeringProducts[0], error.actionItems[0].product?.Name + i)\" [ladda]=\"loading[error.actionItems[0].product?.Name + i]\" data-style=\"zoom-in\">{{ \"COMMON.REMOVE\" | translate }}</button>\r\n            </div> -->\r\n            <div class=\"card-footer bg-white border-0 py-2\">\r\n            </div>\r\n          </ng-container>\r\n          <!-- Validation -->\r\n          <ng-container *ngSwitchCase=\"'Validation'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"error.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"error.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- Recommendation -->\r\n          <ng-container *ngSwitchCase=\"'Recommendation'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"error.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"error.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- Replacement -->\r\n          <ng-container *ngSwitchCase=\"'Replacement'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"error.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"error.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n    <!-- Warnings -->\r\n    <div *ngIf=\"ruleDetailGroups.warnings.length > 0\" class=\"card border-0\">\r\n      <div class=\"card-header border-bottom-0 border-top\">\r\n        <i class=\"fas fa-exclamation-triangle text-warning\"></i> <span>\r\n          {{ (ruleDetailGroups.warnings.length > 1 ? \"CONSTRAINT_SIDE_MENU.NUM_OF_WARNINGS.PLURAL\" : \"CONSTRAINT_SIDE_MENU.NUM_OF_WARNINGS.ONE\") | translate: {amount: ruleDetailGroups.warnings.length} }}</span>\r\n      </div>\r\n      <ng-container *ngFor=\"let warning of ruleDetailGroups.warnings; let i = index\">\r\n        <ng-container [ngSwitch]=\"warning.actionType\">\r\n          <!-- Inclusion -->\r\n          <ng-container *ngSwitchCase=\"'Inclusion'\">\r\n            <div class=\"card-body bg-white py-2 flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"warning.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"warning.messageHtml\"></div>\r\n              </ng-container>\r\n              <ng-container *ngFor=\"let item of warning.actionItems\">\r\n                <div class=\"py-3\">\r\n                  <a class=\"pt-2\" href=\"javascript:void(0)\"\r\n                    [routerLink]=\"['/products/', item.product.Id]\">{{item.product.Name}}</a>\r\n                  <div class=\"d-flex py-2 align-items-center justify-content-between\">\r\n                    <small class=\"font-weight-bold\">{{item.chargeType}}</small>\r\n                    <small class=\"font-weight-bold\">\r\n                      <apt-price [record]=\"item.product\"></apt-price>\r\n                    </small>\r\n                  </div>\r\n                  <div class=\"d-flex align-items-center justify-content-end\">\r\n                    <label [for]=\"item.product.Name + i\" class=\"mr-2 mb-0\">{{ \"COMMON.QTY\" | translate }}</label>\r\n                    <input class=\"form-control mr-2 w-25\" [id]=\"item.product.Name + i\" type=\"number\" min=\"1\"\r\n                      [(ngModel)]=\"quantityControlValues[item.product.Name + i]\" placeholder=\"1\">\r\n                    <div class=\"input-group-append\">\r\n                      <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-primary\"\r\n                        (click)=\"handleAddToCart(warning, item.product, quantityControlValues[item.product.Name + i], item.product.Name + i)\"\r\n                        [ladda]=\"loading[item.product.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.ADD_TO_CART\" | translate }}</button>\r\n                      <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-primary\"\r\n                        [disabled]=\"isItemSelected(item.product)\"\r\n                        (click)=\"handleAddToConfiguration(item.product, quantityControlValues[item.product.Name + i], item.product.Name + i, warning.targetBundleNumber)\"\r\n                        [ladda]=\"loading[item.product.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.ADD\" | translate }}</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"card-footer bg-white border-0 py-2\">\r\n            </div>\r\n          </ng-container>\r\n          <!-- Exclusion -->\r\n          <ng-container *ngSwitchCase=\"'Exclusion'\">\r\n            <div class=\"card-body bg-white py-2 flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"warning.messageHtml !== null;\">\r\n                <span [innerHtml]=\"warning.messageHtml\"></span>\r\n              </ng-container>\r\n              <ng-container *ngFor=\"let item of warning.actionItems\">\r\n                <div class=\"py-3\">\r\n                  <a class=\"pt-2\" href=\"javascript:void(0)\"\r\n                    [routerLink]=\"['/products/', item.product.Id]\">{{item.product.Name}}</a>\r\n                  <div class=\"d-flex py-2 align-items-center justify-content-between\">\r\n                    <small class=\"font-weight-bold\">{{item.chargeType}}</small>\r\n                    <small class=\"font-weight-bold\">\r\n                      <apt-price [record]=\"item.product\"></apt-price>\r\n                    </small>\r\n                  </div>\r\n                  <div class=\"d-flex align-items-center justify-content-end\">\r\n                    <label [for]=\"item.product.Name + i\" class=\"mr-2 mb-0\">{{ \"COMMON.QTY\" | translate }}</label>\r\n                    <input class=\"form-control mr-2 w-25\" [id]=\"item.product.Name + i\" type=\"number\" min=\"1\"\r\n                      [(ngModel)]=\"quantityControlValues[item.product.Name + i]\" placeholder=\"1\">\r\n                    <div class=\"input-group-append\">\r\n                      <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-danger\"\r\n                        (click)=\"handleDeleteFromCart(warning, item.product?.Name + i)\"\r\n                        [ladda]=\"loading[item.product?.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</button>\r\n                      <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-danger\"\r\n                        [disabled]=\"!isItemSelected(item.product, 'remove')\"\r\n                        (click)=\"handleRemoveFromBundle(item.product, warning.triggeringProducts[0], item.product?.Name + i)\"\r\n                        [ladda]=\"loading[item.product?.Name + i]\"\r\n                        data-style=\"zoom-in\">{{ \"COMMON.REMOVE\" | translate }}</button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"card-footer bg-white border-0 py-2\">\r\n            </div>\r\n            <!-- <div class=\"card-footer bg-white border-0 py-2 d-flex justify-content-end\">\r\n              <button *ngIf=\"!showProductConfig\" class=\"btn btn-outline-danger\"\r\n                (click)=\"handleDeleteFromCart(warning, warning.actionItems[0].product?.Name + i)\"\r\n                [ladda]=\"loading[warning.actionItems[0].product?.Name + i]\"\r\n                data-style=\"zoom-in\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</button>\r\n              <button *ngIf=\"showProductConfig\" class=\"btn btn-outline-danger\"\r\n                [disabled]=\"isItemSelected(warning.actionItems[0].product)\"\r\n                (click)=\"handleRemoveFromBundle(warning.actionItems[0].product, warning.triggeringProducts[0], warning.actionItems[0].product?.Name + i)\"\r\n                [ladda]=\"loading[warning.actionItems[0].product?.Name + i]\"\r\n                data-style=\"zoom-in\">{{ \"COMMON.REMOVE\" | translate }}</button>\r\n            </div> -->\r\n          </ng-container>\r\n          <!-- Validation -->\r\n          <ng-container *ngSwitchCase=\"'Validation'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"warning.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"warning.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- Recommendation -->\r\n          <ng-container *ngSwitchCase=\"'Recommendation'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"warning.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"warning.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <!-- Replacement -->\r\n          <ng-container *ngSwitchCase=\"'Replacement'\">\r\n            <div class=\"card-body bg-white py-2 d-flex-column\" [class.border-top]=\"i > 0\">\r\n              <ng-container *ngIf=\"warning.messageHtml !== null;\">\r\n                <div class=\"mb-2\" [innerHtml]=\"warning.messageHtml\"></div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n    <!-- Info Messages -->\r\n    <!-- <div *ngIf=\"ruleDetailGroups.info.length > 0\" class=\"card border-0\">\r\n      <div class=\"card-header border-bottom-0 border-top\">\r\n        <i class=\"fas fa-info-circle\"></i> <span> {{ruleDetailGroups.info.length}}</span> {{ruleDetailGroups.info.length > 1 ? 'Information Messages' : 'Information Message'}}\r\n      </div>\r\n      <ng-container *ngFor=\"let info of data.infoMessages; let i = index\">\r\n        <div class=\"card-body bg-white py-2\" [class.border-top]=\"i > 0\">\r\n          <strong>{{info.includedProduct.name}}</strong> is included with product <a href=\"javascript:void(0)\">{{info.product.name}}</a>.\r\n        </div>\r\n        <div class=\"card-footer bg-white border-0 py-2\">\r\n          <div class=\"d-flex justify-content-end\">\r\n            <button class=\"btn btn-outline-danger\">Delete All</button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div> -->\r\n    <!-- Success Messages -->\r\n    <div *ngIf=\"ruleDetailGroups.success.length > 0\" class=\"card border-0\">\r\n      <div class=\"card-header border-bottom-0 border-top\">\r\n        <i class=\"fas fa-info-circle\"></i> <span>\r\n          {{ (ruleDetailGroups.success.length > 1 ? \"CONSTRAINT_SIDE_MENU.NUM_OF_INFO_MESSAGES.PLURAL\" : \"CONSTRAINT_SIDE_MENU.NUM_OF_INFO_MESSAGES.ONE\") | translate: {amount: ruleDetailGroups.success.length} }}</span>\r\n      </div>\r\n      <ng-container *ngFor=\"let success of ruleDetailGroups.success; let i = index\">\r\n        <div class=\"card-body bg-white py-2\" [class.border-top]=\"i > 0\">\r\n          <ng-container *ngIf=\"success.message !== null;\">\r\n            <span [innerHtml]=\"success.message\"></span>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</ng-container>", styles: [".modal.show div.constraintRuleSidebar.modal-dialog{right:-1px}.modal div.constraintRuleSidebar.modal-dialog{position:absolute;transition:right .3s;margin:-1px 0 0;right:-20rem;width:20rem}.modal div.constraintRuleSidebar.modal-dialog .modal-content{height:100vh;overflow-y:auto}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleSidebarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-constraint-rule-sidebar',
                    templateUrl: './constraint-rule-sidebar.component.html',
                    styleUrls: ['./constraint-rule-sidebar.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: ConstraintRuleMessageService }, { type: i1.ClientConstraintRuleService }, { type: ProductConfigurationService }]; } });

/**
 * Constraint rule alert component is used to show a bootstrap style alert banner for the active constraint rules based on the user's cart.
 * <h3>Preview</h3>
 * <strong>Constraint rule error Alert</strong>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/constraintRuleErrorAlert.png" style="max-width: 100%">
 *  <strong>Constraint rule warning Alert</strong>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/constraintRuleWarningAlert.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ConstraintRuleModule } from '@congacommerce/elements';

@NgModule({
  imports: [ConstraintRuleModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* <apt-constraint-rule-alert></apt-constraint-rule-alert>
 ```
*/
class ConstraintRuleAlertComponent {
    constructor(modalService, constraintRuleMessageService) {
        this.modalService = modalService;
        this.constraintRuleMessageService = constraintRuleMessageService;
        /** @ignore */
        this.loading = {
            error: false,
            warning: false
        };
    }
    /** @ignore */
    ngOnInit() {
        this.ruleGroups$ = this.showProductConfig ? this.constraintRuleMessageService.getConfigurationRuleGroups() : this.constraintRuleMessageService.getCartRuleGroups();
    }
    /** @ignore */
    handleViewDetails() {
        this.modalService.show(ConstraintRuleSidebarComponent, {
            backdrop: false,
            class: 'constraintRuleSidebar',
            initialState: {
                showProductConfig: this.showProductConfig
            }
        });
    }
    /** @ignore */
    handleAddToCart(ruleDetail, product, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.addProductToCartFromRule(ruleDetail, product, 1)
            .pipe(take(1)).subscribe(() => {
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleAddToConfiguration(product, loadingKey, targetBundleNumber) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.addProductToConfiguration(product, 1, targetBundleNumber)
            .pipe(take(1)).subscribe(() => {
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleDeleteFromCart(ruleDetail, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.deleteProductFromCart(ruleDetail)
            .pipe(take(1)).subscribe(() => {
            this.loading[loadingKey] = false;
        });
    }
    /** @ignore */
    handleRemoveFromBundle(product, bundleProduct, loadingKey) {
        this.loading[loadingKey] = true;
        this.constraintRuleMessageService.removeOptionFromConfiguration(product, bundleProduct)
            .pipe(take(1)).subscribe(() => {
            this.loading[loadingKey] = false;
        });
    }
}
ConstraintRuleAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleAlertComponent, deps: [{ token: i1$2.BsModalService }, { token: ConstraintRuleMessageService }], target: i0.ɵɵFactoryTarget.Component });
ConstraintRuleAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ConstraintRuleAlertComponent, selector: "apt-constraint-rule-alert", inputs: { showProductConfig: "showProductConfig" }, ngImport: i0, template: "<ng-container *ngIf=\"ruleGroups$ | async as ruleGroups\">\r\n  <alert *ngIf=\"ruleGroups.errors?.length\" class=\"constraintRuleAlert\" type=\"danger\">\r\n    <i class=\"fas fa-exclamation-circle text-danger mr-2\"></i>\r\n    <!-- Errors -->\r\n    <ng-container *ngIf=\"ruleGroups.errors.length === 1; else multipleErrors\">\r\n      <ng-container [ngSwitch]=\"ruleGroups.errors[0]?.actionType\">\r\n        <!-- Inclusion -->\r\n        <ng-container *ngSwitchCase=\"'Inclusion'\">\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.errors[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.error; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToCart(ruleGroups.errors[0], ruleGroups.errors[0].actionItems[0].product, 'error')\">{{ \"COMMON.ADD_TO_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToConfiguration(ruleGroups.errors[0].actionItems[0].product, 'error', ruleGroups.errors[0].targetBundleNumber)\">{{ \"COMMON.ADD\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Exclusion -->\r\n        <ng-container *ngSwitchCase=\"'Exclusion'\">\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.errors[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.error; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleDeleteFromCart(ruleGroups.errors[0], 'error')\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleRemoveFromBundle(ruleGroups.errors[0].actionItems[0].product, ruleGroups.errors[0].triggeringProducts[0], 'error')\">{{ \"COMMON.REMOVE\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Validation -->\r\n        <ng-container *ngSwitchCase=\"'Validation'\">\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.errors[0].messageHtml\"></span>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Recommendation -->\r\n        <ng-container *ngSwitchCase=\"'Recommendation'\">\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.errors[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.error; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToCart(ruleGroups.errors[0], ruleGroups.errors[0].actionItems[0].product, 'error')\">{{ \"COMMON.ADD_TO_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToConfiguration(ruleGroups.errors[0].actionItems[0].product, 'error', ruleGroups.errors[0].targetBundleNumber)\">{{ \"COMMON.ADD\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Replacement -->\r\n        <ng-container *ngSwitchCase=\"'Replacement'\">\r\n          <ng-container *ngIf=\"ruleGroups.errors[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.errors[0].messageHtml\"></span>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-template #multipleErrors>\r\n      <span>{{ \"CONSTRAINT_ALERT.NUM_OF_ERRORS\" | translate: {amount: ruleGroups.errors.length} }} <a\r\n          href=\"javascript:void(0)\"\r\n          (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a></span>\r\n    </ng-template>\r\n  </alert>\r\n  <!-- Warnings -->\r\n  <alert *ngIf=\"ruleGroups.warnings?.length\" type=\"warning\" [dismissible]=\"true\">\r\n    <i class=\"fas fa-exclamation-triangle text-warning mr-2\"></i>\r\n    <ng-container *ngIf=\"ruleGroups.warnings.length === 1; else multipleWarnings\">\r\n      <ng-container [ngSwitch]=\"ruleGroups.warnings[0]?.actionType\">\r\n        <!-- Inclusion -->\r\n        <ng-container *ngSwitchCase=\"'Inclusion'\">\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.warnings[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.warning; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToCart(ruleGroups.warnings[0], ruleGroups.warnings[0].actionItems[0].product, 'warning')\">{{ \"COMMON.ADD_TO_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToConfiguration(ruleGroups.warnings[0].actionItems[0].product, 'warning', ruleGroups.warnings[0].targetBundleNumber)\">{{ \"COMMON.ADD\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Exclusion -->\r\n        <ng-container *ngSwitchCase=\"'Exclusion'\">\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.warnings[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.warning; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleDeleteFromCart(ruleGroups.warnings[0], 'warning')\">{{ \"CONSTRAINT_SIDE_MENU.REMOVE_FROM_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleRemoveFromBundle(ruleGroups.warnings[0].actionItems[0].product, ruleGroups.warnings[0].triggeringProducts[0], 'warning')\">{{ \"COMMON.REMOVE\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Validation -->\r\n        <ng-container *ngSwitchCase=\"'Validation'\">\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.warnings[0].messageHtml\"></span>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Recommendation -->\r\n        <ng-container *ngSwitchCase=\"'Recommendation'\">\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.warnings[0].messageHtml\"></span>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length === 1\">\r\n            <ng-container *ngIf=\"!loading.warning; else spinner\">\r\n              <a *ngIf=\"!showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToCart(ruleGroups.warnings[0], ruleGroups.warnings[0].actionItems[0].product, 'warning')\">{{ \"COMMON.ADD_TO_CART\" | translate }}</a>\r\n              <a *ngIf=\"showProductConfig\" class=\"ml-1\" href=\"javascript:void(0)\"\r\n                (click)=\"handleAddToConfiguration(ruleGroups.warnings[0].actionItems[0].product, 'warning', ruleGroups.warnings[0].targetBundleNumber)\">{{ \"COMMON.ADD\" | translate }}</a>\r\n            </ng-container>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].actionItems.length > 1\">\r\n            <a class=\"ml-1\" href=\"javascript:void(0)\"\r\n              (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <!-- Replacement -->\r\n        <ng-container *ngSwitchCase=\"'Replacement'\">\r\n          <ng-container *ngIf=\"ruleGroups.warnings[0].messageHtml !== null\">\r\n            <span class=\"d-lg-inline-block d-inline py-1\" [innerHtml]=\"ruleGroups.warnings[0].messageHtml\"></span>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-template #multipleWarnings>\r\n      <span>{{ \"CONSTRAINT_ALERT.NUM_OF_ERRORS\" | translate: {amount: ruleGroups.warnings.length} }} <a\r\n          href=\"javascript:void(0)\"\r\n          (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a></span>\r\n    </ng-template>\r\n  </alert>\r\n  <!-- Info Messages -->\r\n  <!-- <alert *ngIf=\"ruleGroups.info?.length\" type=\"info\" [dismissible]=\"true\">\r\n    <i class=\"fas fa-info-circle mr-2\"></i>\r\n    <ng-container *ngIf=\"ruleGroups.info.length === 1; else multipleMessages\">\r\n      <a href=\"javascript:void(0)\">{{ data.infoMessages[0].product.name }}</a> product must include <strong>{{data.infoMessages[0].includedProduct.name }}</strong> product. <a href=\"javascript:void(0)\">Add to Cart</a>\r\n    </ng-container>\r\n    <ng-template #multipleMessages>\r\n      <span>{{ ruleGroups.info.length }} information messages found. <a href=\"javascript:void(0)\" (click)=\"handleViewDetails()\">View details</a></span>\r\n    </ng-template>\r\n  </alert> -->\r\n  <!-- Success Messages -->\r\n  <alert *ngIf=\"ruleGroups.success?.length\" type=\"success\" [dismissible]=\"true\">\r\n    <i class=\"fas fa-info-circle mr-2\"></i>\r\n    <ng-container *ngIf=\"ruleGroups.success.length === 1; else multipleMessages\">\r\n      <span *ngIf=\"ruleGroups.success[0].message !== null\" [innerHtml]=\"ruleGroups.success[0].message\"></span>\r\n    </ng-container>\r\n    <ng-template #multipleMessages>\r\n      <span>{{ \"CONSTRAINT_ALERT.NUM_OF_INFO_MESSAGES\" | translate: {amount: ruleGroups.success.length} }} <a\r\n          href=\"javascript:void(0)\"\r\n          (click)=\"handleViewDetails()\">{{ \"CONSTRAINT_ALERT.VIEW_DETAILS\" | translate }}</a></span>\r\n    </ng-template>\r\n  </alert>\r\n</ng-container>\r\n\r\n<ng-template #spinner>\r\n  <apt-spinner class=\"ml-4\" [large]=\"false\"></apt-spinner>\r\n</ng-template>", styles: ["apt-constraint-rule-alert alert>div.alert:first-child{margin-bottom:0;height:auto;line-height:30px;padding-top:0;padding-bottom:0}apt-constraint-rule-alert alert>div.alert:first-child button.close{padding:0 16px 0 0;line-height:40px}\n"], components: [{ type: i3.AlertComponent, selector: "alert,bs-alert", inputs: ["type", "dismissible", "isOpen", "dismissOnTimeout"], outputs: ["onClose", "onClosed"] }, { type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleAlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-constraint-rule-alert',
                    templateUrl: './constraint-rule-alert.component.html',
                    styleUrls: ['./constraint-rule-alert.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalService }, { type: ConstraintRuleMessageService }]; }, propDecorators: { showProductConfig: [{
                type: Input
            }] } });

/**
 * The icon to display when there is an alert related to constraint rules.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/constraintIcon.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ConstraintIconModule } from '@congacommerce/elements';

@NgModule({
  imports: [ConstraintIconModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* <apt-cr-constraint-icon></apt-cr-constraint-icon>
 ```
*/
class CRIconComponent {
    constructor(crService, bsModalService, prodConfigService) {
        this.crService = crService;
        this.bsModalService = bsModalService;
        this.prodConfigService = prodConfigService;
        /** @ignore */
        this.isHidden = true;
    }
    ngOnInit() {
        this.view$ = this.prodConfigService.getConfigState()
            .pipe(switchMap(res => res.isConfig ? this.getPendingActionsForSecondaryCart() : this.getPendingActionsForCart()), tap(pendingActions => {
            this.isHidden = get(pendingActions, 'length', 0) === 0;
        }), map(pendingActions => ({ pendingActions })));
    }
    /**
     * @ignore
     */
    getPendingActionsForCart() {
        return this.crService.getPendingActionsForCart();
    }
    /**
     * @ignore
     */
    getPendingActionsForSecondaryCart() {
        return this.prodConfigService.configurationChange.pipe(map(configState => {
            const pendingCartActions = filter$1(get(configState, 'ruleActions'), action => action.ConstraintRuleAction.MatchInPrimaryLines && action.Pending === true && !isEmpty(concat(get(action, 'ActionProductIds'))));
            return pendingCartActions;
        }));
    }
    /**
     * Opens the side menu when icon is clicked on.
     * @ignore
     */
    openSideMenu() {
        this.modalRef = this.bsModalService.show(ConstraintRuleSidebarComponent, {
            backdrop: false,
            class: 'constraintRuleSidebar'
        });
    }
}
CRIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CRIconComponent, deps: [{ token: i1.ConstraintRuleService }, { token: i1$2.BsModalService }, { token: ProductConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
CRIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: CRIconComponent, selector: "apt-cr-constraint-icon", host: { properties: { "hidden": "this.isHidden" } }, ngImport: i0, template: `
    <ng-container *ngIf="view$ | async as view">
      <ng-container *ngIf="view.pendingActions?.length > 0">
        <button class="btn btn-link nav-link" (click)="openSideMenu()">
          <i class="fas fa-exclamation-triangle fa-lg"></i>
        </button>
        <span class="badge badge-primary p-1">{{view.pendingActions?.length}}</span>
      </ng-container>
    </ng-container>
  `, isInline: true, styles: [":host{display:block;position:relative}:host span.badge{position:absolute;top:15px;right:5px}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CRIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-cr-constraint-icon',
                    template: `
    <ng-container *ngIf="view$ | async as view">
      <ng-container *ngIf="view.pendingActions?.length > 0">
        <button class="btn btn-link nav-link" (click)="openSideMenu()">
          <i class="fas fa-exclamation-triangle fa-lg"></i>
        </button>
        <span class="badge badge-primary p-1">{{view.pendingActions?.length}}</span>
      </ng-container>
    </ng-container>
  `,
                    styleUrls: ['./constraint-icon.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.ConstraintRuleService }, { type: i1$2.BsModalService }, { type: ProductConfigurationService }]; }, propDecorators: { isHidden: [{
                type: HostBinding,
                args: ['hidden']
            }] } });

/**
 * Output field component is used to create a label value paired output that can be displayed as an editable field with an optional popover that shows related information about the field.
 * <h3>Preview</h3>
 *  <div>
 *    <h4>1. Output field</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/outputField.PNG" style="max-width: 100%">
 *  </div>
 * <br>
 * <div>
 *    <h4>2. Output field displayed as an editable field with popover</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/outputFieldWithEditableField.PNG" style="max-width: 100%">
 * </div>
 * <h3>Usage</h3>
 *
 ```typescript
import { OutputFieldModule } from '@congacommerce/elements';

@ngModule({
  imports: [OutputFieldModule, ...]
})
 ```
 * @example
 ```typescript
 * <apt-output-field
 *              [record]="quote"
 *              [field]="CreatedDate"
 *              layout="inline"
 *              [editable]="false"
 * ></apt-output-field>
 ```
 */
class OutputFieldComponent {
    constructor(aobjectService, elRef, metadataService) {
        this.aobjectService = aobjectService;
        this.elRef = elRef;
        this.metadataService = metadataService;
        /**
         * The layout for the displayed label and value
         */
        this.layout = 'stacked';
        /**
         * Use default value of value is undefined
         */
        this.default = false;
        /**
         * Flag to display only field label
         */
        this.labelOnly = false;
        /**
         * Flag to set this field as editable.
         */
        this.editable = true;
        /**
         * Flag to show the quick view lookup popover for this field.
         */
        this.showQuickView = false;
        this.valueOnly = false;
        this.onChange = new EventEmitter();
        /**
         * Flag to set the popover to its expanded state.
         * @ignore
         */
        this.expanded = false;
        /**
         * Flag to check if mouse is hovering over lookup popover expand button.
         * @ignore
         */
        this.hovering = false;
        /**
         * Flag to check if the update is loading for the update button in the edit field popover.
         * @ignore
         */
        this.loading = false;
        /**
         * Used to hold information for rendering the view.
         * @ignore
         */
        this.view$ = new BehaviorSubject(null);
        /** @ignore */
        this.supportedObjectRoutes = ['orders', 'proposals', 'products', 'carts', 'assets'];
    }
    ngOnChanges() {
        this.ngOnDestroy();
        if (this.required && _.isNil(_.get(this.record, this.field))) {
            this.record.setError('DETAILS.MISSING_REQ_FIELDS');
        }
        if (!_.isNil(this.record) && this.record instanceof AObject) {
            let referenceInstance = this.record.instanceOf(this.field);
            let recordInstance = this.record.instanceOf(this.field);
            let labelInstance = this.record.instanceOf(this.label);
            let referenceField = _.last(_.split(this.field, '.'));
            let referenceLabel = _.isNil(this.label) ? referenceField : _.last(_.split(this.label, '.'));
            if (!_.isNil(_.get(referenceInstance, 'getType'))) {
                this.subscription = this.aobjectService.describe(referenceInstance.getType())
                    .pipe(switchMap(fieldObjectMetadata => {
                    const fieldMetadata = _.find(_.get(fieldObjectMetadata, 'fields'), fieldData => _.get(fieldData, 'name') === referenceInstance.getApiName(referenceField));
                    const labelDescribe$ = (this.valueOnly) ? of(null) : this.aobjectService.describe(labelInstance.getType());
                    let recordObsv$ = of(null);
                    const objectName = _.first(_.get(fieldMetadata, 'referenceTo'));
                    const keyType = this.metadataService.getTypeByApiName(objectName);
                    const service = this.metadataService.getAObjectServiceForType(keyType);
                    if (!_.isNil(_.get(fieldMetadata, 'relationshipName'))) {
                        const data$ = (service && _.get(this.record, this.field)) ? service.fetch(_.get(this.record, this.field)) : of(null);
                        recordObsv$ = this.displayValue ? data$ : of(null);
                        this.displayValue = _.defaultTo(this.displayValue, 'Name');
                        referenceField = this.displayValue;
                        referenceInstance = referenceInstance.instanceOf(referenceInstance.getKey(_.get(fieldMetadata, 'relationshipName')));
                        return combineLatest(this.aobjectService.describe(referenceInstance.getType()), labelDescribe$, of(fieldObjectMetadata), recordObsv$);
                    }
                    else {
                        return combineLatest(of(fieldObjectMetadata), labelDescribe$, of(fieldObjectMetadata), recordObsv$);
                    }
                }), map(([fieldObjectMetadata, labelObjectMetadata, recordObjectMetadata, resultdata]) => {
                    const labelMetadata = _.find(_.get(labelObjectMetadata, 'fields'), fieldData => _.get(fieldData, 'name') === labelInstance.getApiName(referenceLabel));
                    const fieldMetadata = _.find(_.get(fieldObjectMetadata, 'fields'), fieldData => _.get(fieldData, 'name') === referenceInstance.getApiName(referenceField));
                    const recordMetadata = _.find(_.get(recordObjectMetadata, 'fields'), fieldData => _.get(fieldData, 'name') === recordInstance.getApiName(_.last(_.split(this.field, '.'))));
                    const r = {
                        metadata: fieldMetadata,
                        recordMetadata: recordMetadata,
                        value: resultdata ? _.get(resultdata, 'Name') : this.getValue(referenceInstance, referenceField, fieldMetadata),
                        label: _.defaultTo(_.get(labelMetadata, 'label'), this.label),
                        field: _.last(_.split(this.field, '.')),
                        referenceFieldInstance: referenceInstance,
                        recordInstance: recordInstance,
                        labelPlural: _.lowerCase(_.get(fieldObjectMetadata, 'labelPlural')),
                        popoverFields: this.getPopoverFields(referenceInstance),
                        titleIsLink: _.includes(this.supportedObjectRoutes, _.lowerCase(_.get(fieldObjectMetadata, 'labelPlural')))
                    };
                    if (_.isNil(r.value) && _.get(recordMetadata, 'type') === "currency") {
                        r.value = '0';
                    }
                    if (this.field === 'Primary_Contact')
                        console.log(fieldObjectMetadata, recordObjectMetadata, referenceInstance, referenceField);
                    return r;
                }))
                    .subscribe(r => {
                    if (this.maxCharacterLength && _.get(r.value, 'length') > this.maxCharacterLength) {
                        r.nonTruncatedValue = r.value;
                        r.value = r.value.substring(0, this.maxCharacterLength - 3);
                        r.value += '...';
                    }
                    this.view$.next(r);
                });
            }
        }
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    /**
     * Returns the proper constructor for the record at the given path.
     * @param fieldPath The path to the field for this record.
     * @ignore
     */
    getFieldType(fieldPath) {
        if (!_.isNil(this.record)) {
            let recordConstructor = this.record.constructor;
            if (fieldPath.indexOf('.') >= 0) {
                const objectInstance = _.get(new recordConstructor(), fieldPath.substring(0, fieldPath.lastIndexOf('.')));
                if (!_.isNil(objectInstance))
                    recordConstructor = objectInstance.constructor;
                else
                    recordConstructor = this.record.getType();
            }
            return recordConstructor;
        }
    }
    /**
     * Returns the date format based on the metadata of the field on this record.
     * @param metadata The metadata for the field on this record.
     * @ignore
     */
    getDateFormat(metadata) {
        if (this.dateFormat)
            return this.dateFormat;
        else if (metadata.type === 'datetime')
            return 'short';
        else if (metadata.type === 'date')
            return 'shortDate';
    }
    /**
     * Returns the value of the field on this record.
     * @ignore
     */
    getValue(instance, field, metadata) {
        return _.defaultTo(_.get(instance, 
        // If display value input is populated, use the records display value field
        _.get(this, 'displayValue', field)), 
        // If default is set to true, default the output to salesforce's default value if no value is found
        (this.default === true) ? SalesforceUtils.getDefaultValue(metadata) : undefined);
    }
    getPopoverFields(instance) {
        const compactFields = instance.getFieldMetadata(y => _.includes(y.view, 'Compact'));
        return _.map(compactFields, (value, key) => {
            if (!_.isNil(_.get(value, 'compactLabel')))
                return { field: key, label: _.get(value, 'compactLabel') };
            return { field: key, label: key };
        });
    }
    /**
     * Event handler for when the update button is pressed on the edit field popover.
     * @ignore
     */
    update(view) {
        if (this.onChange.observers.length >= 1) {
            this.onChange.emit(_.get(view, `recordInstance.${view.field}`));
            this.pop.hide();
        }
        else {
            this.loading = true;
            const service = this.metadataService.getAObjectServiceForType(view.recordInstance);
            service.update([view.recordInstance]).subscribe(r => {
                this.loading = false;
                this.pop.hide();
            }, e => this.loading = false);
        }
    }
    /**
     * Event handler for when the cancel button is pressed on the edit field popover.
     * @ignore
     */
    handleHidePop(view) {
        view && _.set(view, `recordInstance.${view.field}`, _.get(view, `recordInstance.${_.split(view.field, 'Id')[0]}.Id`));
        this.pop.hide();
    }
    /**
     * Event handler for when the target of the quickview lookup popover is clicked.
     * @ignore
     */
    handleLookupPopClick() {
        if (this.showQuickView) {
            if (this.lookupPop.isOpen) {
                this.hidePopover();
            }
            else
                this.lookupPop.show();
        }
    }
    /**
     * Sets the position of the quickview popover based on where the target is on the screen.
     * @ignore
     */
    onShown() {
        if (this.showQuickView) {
            let top, right, bottom, left, middleVert;
            if (_.get(this.elRef, 'nativeElement')) {
                top = this.elRef.nativeElement.getBoundingClientRect().top;
                right = this.elRef.nativeElement.getBoundingClientRect().right;
                bottom = this.elRef.nativeElement.getBoundingClientRect().bottom;
                left = this.elRef.nativeElement.getBoundingClientRect().left;
                middleVert = (top + bottom) / 2;
            }
            let position;
            // If too close to the top or bottom of page show vertically
            if (middleVert < 250 || window.innerHeight - middleVert < 250) {
                if (middleVert < 250)
                    position = 'bottom';
                else
                    position = 'top';
            }
            else {
                // Pick left or right which ever has more space
                if (window.innerWidth - right > left)
                    position = 'right';
                else
                    position = 'left';
                // If there is not enough space on either side pick top or bottom
                if (window.innerWidth - right < 320 && left < 320) {
                    // If there is more space on the top.
                    if (middleVert > window.innerHeight / 2)
                        position = 'top';
                    else
                        position = 'bottom';
                }
            }
            return position;
        }
    }
    /**
     * Hides the quickview popover.
     * @ignore
     */
    hidePopover() {
        if (this.lookupPop) {
            this.lookupPop.hide();
        }
        this.expanded = false;
    }
}
OutputFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldComponent, deps: [{ token: i1$1.AObjectService }, { token: i0.ElementRef }, { token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Component });
OutputFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: OutputFieldComponent, selector: "apt-output-field", inputs: { field: "field", record: "record", layout: "layout", dateFormat: "dateFormat", displayValue: "displayValue", label: "label", default: "default", labelOnly: "labelOnly", labelClass: "labelClass", valueClass: "valueClass", editable: "editable", showQuickView: "showQuickView", valueOnly: "valueOnly", lookupOptions: "lookupOptions", required: "required", maxCharacterLength: "maxCharacterLength" }, outputs: { onChange: "onChange" }, viewQueries: [{ propertyName: "pop", first: true, predicate: ["pop"], descendants: true }, { propertyName: "lookupPop", first: true, predicate: ["lookupPop"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<span [class.align-items-baseline]=\"layout === 'inline'\" [class.inline]=\"layout === 'inline'\" [class.d-flex]=\"layout === 'inline'\" [class.label-only]=\"labelOnly\" *ngIf=\"view$ | async as view\">\r\n  \r\n  \r\n    <dt [ngClass]=\"labelClass\" *ngIf=\"!valueOnly\">\r\n      {{view?.label}}\r\n    </dt>\r\n    <dd *ngIf=\"!labelOnly\" class=\"m-0 py-2 position-relative\"  [class.px-1]=\"layout === 'inline'\" [class.py-1]=\"layout === 'stacked'\" [class.empty]=\"!view.value\" [ngClass]=\"valueClass\" [ngSwitch]=\"true\">\r\n      <ng-container *ngSwitchCase=\"view.recordMetadata?.type === 'date' || view.recordMetadata?.type === 'datetime'\">{{view.value | date:getDateFormat(view.metadata)}}</ng-container>\r\n  \r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'currency'\">{{view?.value | localCurrency | async}}</ng-container>\r\n  \r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'address'\">\r\n        <apt-address [value]=\"view?.value\" [readonly]=\"true\"></apt-address>\r\n      </ng-container>\r\n  \r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'double'\">\r\n        {{view?.value | number:'1.0-' + view.metadata.scale}}\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'boolean'\">\r\n        <span [innerHTML]=\"view?.value ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate)\"></span>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'reference' || view?.recordMetadata?.type === 'string'\">\r\n        <ng-container *ngIf=\"view?.recordMetadata?.type === 'string' && !showQuickView;\">\r\n          <ng-container [ngTemplateOutlet]=\"view?.nonTruncatedValue ? popOverTemplate : simple\" \r\n          [ngTemplateOutletContext]=\"{view:view}\" >\r\n          </ng-container>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"view?.recordMetadata?.type === 'reference' && !showQuickView\">\r\n          <a href=\"javascript:void(0)\" *ngIf=\"view?.referenceFieldInstance?.Id && view?.titleIsLink; else noLinkReference\" [routerLink]=\"['/' + view?.labelPlural, view?.referenceFieldInstance?.Id]\" [innerHTML]=\"view?.value\" target=\"_blank\"></a>\r\n        </ng-container>\r\n        <ng-template #noLinkReference>\r\n          <span [innerHTML]=\"view?.value\"></span>\r\n        </ng-template>\r\n\r\n        <ng-container *ngIf=\"showQuickView\">\r\n          <span\r\n            [ngClass]=\"showQuickView ? 'btn-link popoverLink' : ''\"\r\n            #lookupPop=\"bs-popover\"\r\n            [popover]=\"lookupPopTemplate\"\r\n            (click)=\"handleLookupPopClick()\"\r\n            triggers=\"\"\r\n            container=\"body\"\r\n            containerClass=\"lookupPopover\"\r\n            [outsideClick]=\"true\"\r\n            [placement]=\"onShown()\"\r\n            [innerHTML]=\"view?.value\"></span>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"view?.recordMetadata?.type === 'textarea'\">\r\n        <ng-container [ngTemplateOutlet]=\"view?.nonTruncatedValue ? popOverTemplate : simple\">\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchDefault>\r\n        <ng-container [ngTemplateOutlet]=\"simple\">\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <i\r\n        *ngIf=\"editable\"\r\n        #pop=\"bs-popover\"\r\n        class=\"fa fa-pencil edit-icon ml-3\"\r\n        [popover]=\"editable ? popTemplate : null\"\r\n        container=\"body\"\r\n        containerClass=\"editPopover\"\r\n        [outsideClick]=\"false\"\r\n        (onShown)=\"hidePopover()\"\r\n      ></i>\r\n    </dd>\r\n\r\n\r\n\r\n\r\n\r\n    <ng-template #lookupPopTemplate>\r\n      <div class=\"popHeader p-3 mb-1\" [ngClass]=\"expanded ? 'bg-dark text-white' : 'bg-white text-dark'\">\r\n        <div class=\"titleSection pb-2 border-bottom d-flex justify-content-between align-items-baseline\">\r\n          <ng-container>\r\n            <a class=\"h5 btn-link\" href=\"javascript:void(0)\" *ngIf=\"view?.referenceFieldInstance?.Id && view?.titleIsLink; else noLinkPopoverTitle\" [routerLink]=\"['/' + view?.labelPlural, view?.referenceFieldInstance?.Id]\" [innerHTML]=\"view?.value\" target=\"_blank\"></a>\r\n          </ng-container>\r\n          <ng-template #noLinkPopoverTitle>\r\n            <h5 [innerHTML]=\"view?.value\"></h5>\r\n          </ng-template>\r\n          <button aria-label=\"Close\" [ngClass]=\"{'text-white': expanded}\" class=\"close\" type=\"button\" (click)=\"hidePopover()\">\u00D7</button>\r\n        </div>\r\n        <div class=\"fieldSection container-fluid py-2\">\r\n          <div class=\"row\">\r\n            <div *ngFor=\"let field of view?.popoverFields | slice:0:6\" class=\"col-6 pl-0 d-flex flex-column\">\r\n              <apt-output-field\r\n                [record]=\"view?.referenceFieldInstance\"\r\n                [field]=\"field.field\"\r\n                [label]=\"field.label\"\r\n                layout=\"stacked\"\r\n                [editable]=\"false\"\r\n                [showQuickView]=\"false\"\r\n              ></apt-output-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"!expanded\" class=\"bottomBar bg-dark\"></div>\r\n        <div\r\n          *ngIf=\"view?.popoverFields?.length > 6\"\r\n          class=\"toggleButton justify-content-center align-items-center border d-flex\"\r\n          [ngClass]=\"hovering ? 'bg-primary' : 'bg-white'\"\r\n          (mouseover)=\"hovering = true\"\r\n          (mouseout)=\"hovering = false\"\r\n          (click)=\"expanded = !expanded\"\r\n        >\r\n          <i class=\"fa\" [ngClass]=\"{'fa-chevron-up': expanded, 'fa-chevron-down': !expanded, 'text-white': hovering, 'text-primary': !hovering}\" aria-hidden=\"true\"></i>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"expanded\" class=\"expandSection p-3\">\r\n        <div class=\"container-fluid\">\r\n          <div class=\"row\">\r\n            <div *ngFor=\"let field of view?.popoverFields | slice:6\" class=\"col-6 pl-0 d-flex flex-column\">\r\n              <apt-output-field\r\n                [record]=\"view?.referenceFieldInstance\"\r\n                [field]=\"field.field\"\r\n                [label]=\"field.label\"\r\n                layout=\"stacked\"\r\n                [editable]=\"false\"\r\n                [showQuickView]=\"false\"\r\n              ></apt-output-field>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n\r\n  <ng-template #popTemplate>\r\n    <form class=\"p-3\" (ngSubmit)=\"update(view)\">\r\n      <apt-input-field [(ngModel)]=\"view.recordInstance[view.field]\" [field]=\"view.field\" [entity]=\"view.recordInstance\" [name]=\"view.field\" [lookupOptions]=\"lookupOptions\"></apt-input-field>\r\n      <div class=\"d-flex justify-content-end\">\r\n        <button class=\"btn-link btn\" (click)=\"handleHidePop(view)\">{{'COMMON.CANCEL' | translate}}</button>\r\n        <button class=\"btn btn-primary btn-raised\" type=\"submit\" [ladda]=\"loading\">{{'COMMON.UPDATE' | translate}}</button>\r\n      </div>\r\n    </form>\r\n  </ng-template>\r\n\r\n  <ng-template #popOverTemplate>\r\n    <span\r\n    [innerHTML]=\"view?.value\"\r\n    [popover]=\"view?.nonTruncatedValue\"\r\n    triggers=\"mouseenter:mouseleave\"\r\n    container=\"body\"\r\n  ></span>\r\n  </ng-template>\r\n\r\n  <ng-template #simple>\r\n    <span [innerHTML]=\"!!view?.value ? view?.value : ('COMMON.NO_DATA' | translate)\"></span>\r\n  </ng-template>\r\n\r\n  <ng-content></ng-content>\r\n</span>\r\n", styles: ["@charset \"UTF-8\";apt-output-field .edit-icon{display:inline-block;cursor:pointer;opacity:.5}apt-output-field .edit-icon:hover{opacity:1}apt-output-field .popoverLink{cursor:pointer;text-decoration:underline}apt-output-field .hover:hover{background-color:#d3d3d3;cursor:pointer;position:relative}apt-output-field .hover:hover i.edit-icon{display:block;position:absolute;right:2%;top:22%}apt-output-field apt-input-field{min-width:300px}apt-output-field popover-container.popover{max-width:inherit}apt-output-field .inline:not(.label-only) dt{white-space:nowrap}apt-output-field .inline:not(.label-only) dt:after{content:\":\";margin:0 2px 0 -2px}apt-output-field dd.empty:after{content:\"\\200b\"}apt-output-field dd{width:initial}.lookupPopover{max-width:unset;width:322px;border-radius:4px}.lookupPopover .popover-body{padding:0}.lookupPopover .popHeader{position:relative;border-top-left-radius:4px;border-top-right-radius:4px}.lookupPopover .bottomBar{position:absolute;left:0px;right:0px;bottom:-4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;height:10px}.lookupPopover .toggleButton{position:absolute;right:20px;bottom:-17px;width:34px;height:34px;border-radius:50%;cursor:pointer;z-index:5}.lookupPopover .toggleButton i{font-size:18px}.lookupPopover .expandSection{border-bottom-left-radius:4px;border-bottom-right-radius:4px;max-height:300px;overflow-y:auto}.editPopover{min-width:322px}\n"], components: [{ type: AddressComponent, selector: "apt-address", inputs: ["readonly", "type", "form", "value"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i5.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "async": i5.AsyncPipe, "date": i5.DatePipe, "localCurrency": i1.LocalCurrencyPipe, "number": i5.DecimalPipe, "translate": i2$1.TranslatePipe, "slice": i5.SlicePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-output-field',
                    templateUrl: './output-field.component.html',
                    styleUrls: ['./output-field.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1$1.AObjectService }, { type: i0.ElementRef }, { type: i1$1.MetadataService }]; }, propDecorators: { field: [{
                type: Input
            }], record: [{
                type: Input
            }], layout: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], displayValue: [{
                type: Input
            }], label: [{
                type: Input
            }], default: [{
                type: Input
            }], labelOnly: [{
                type: Input
            }], labelClass: [{
                type: Input
            }], valueClass: [{
                type: Input
            }], editable: [{
                type: Input
            }], showQuickView: [{
                type: Input
            }], valueOnly: [{
                type: Input
            }], lookupOptions: [{
                type: Input
            }], required: [{
                type: Input
            }], maxCharacterLength: [{
                type: Input
            }], pop: [{
                type: ViewChild,
                args: ['pop']
            }], lookupPop: [{
                type: ViewChild,
                args: ['lookupPop']
            }], onChange: [{
                type: Output
            }] } });

/**
 * The buy more modal is used to create a modal for buying more of one or many assets.
 * To open a buy more modal the AssetModalService must be used.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/buyMoreModal.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetModalService } from '@congacommerce/elements';

@Component({
  ...
})
export class AppComponent {

  private lineItems: Array<AssetLineItem>;

  constructor(private assetModalService: AssetModalService) {}

  openBuyMoreModal() {
    this.assetModalService.openBuyMoreModal(lineItems[0], lineItems);
  }
}
 ```
 */
class BuyMoreModalComponent {
    constructor(bsModalRef, assetService, exceptionService, cartItemService) {
        this.bsModalRef = bsModalRef;
        this.assetService = assetService;
        this.exceptionService = exceptionService;
        this.cartItemService = cartItemService;
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        this.moment = moment;
        /**
       * start date and end date is set to default to current date.
       */
        this.minimumStartDate = new Date();
        this.minimumEndDate = new Date();
    }
    ngOnInit() {
        this.minimumStartDate = new Date();
        this.minimumEndDate = this.getMinimumEndDate();
        this.buyMoreForm = {
            quantity: 1,
            startDate: this.minimumStartDate,
            endDate: this.minimumEndDate
        };
    }
    /**
    * This method calculates the end date based on the term and sets the minimum end date.
    * @param startDate a date value representing the asset line item start date
    * @returns a date value representing the asset line item end date.
    */
    getMinimumEndDate(startDate = new Date()) {
        const endDate = this.cartItemService.getEndDate(startDate, _.get(this, 'assetList[0].SellingTerm'), _.get(this, 'assetList[0].SellingFrequency'));
        if (!_.isNil(endDate) && endDate > new Date())
            return endDate;
        else
            return this.moment(startDate).add(1, 'y').toDate();
    }
    /**
     * Method calculates the minimum enddate based on start date selected.
     * @param event selected start date
     */
    startDateChange(event) {
        this.minimumEndDate = this.getMinimumEndDate(event);
        this.buyMoreForm.endDate = this.minimumEndDate;
    }
    /**
     * This method buy more assets for a given account.
     * @fires AssetService.incrementAssets().
     */
    buyMore() {
        if (this.buyMoreForm.quantity <= 0) {
            this.exceptionService.showError('INVALID_QUANTITY');
            this.buyMoreForm.quantity = 1;
            return;
        }
        this.loading = true;
        const incrementAssetDoObj = {
            AssetId: this._assetItem.Id,
            NewStartDate: this._assetItem.PriceType !== 'One Time' ? this.moment(this.buyMoreForm.startDate).format('YYYY-MM-DD') : null,
            NewEndDate: this._assetItem.PriceType !== 'One Time' ? this.moment(this.buyMoreForm.endDate).format('YYYY-MM-DD') : null,
            Quantity: (this._assetItem.Quantity + this.buyMoreForm.quantity),
            LineAction: IncrementLineAction.INCREMENT
        };
        this.assetService.incrementAssets([incrementAssetDoObj])
            .subscribe(res => {
            this.loading = false;
            this.bsModalRef.hide();
            this.exceptionService.showSuccess('ASSETS.BUYMORE_SUCCESS');
        }, err => {
            this.loading = false;
            this.bsModalRef.hide();
            this.exceptionService.showError(err);
        });
    }
}
BuyMoreModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BuyMoreModalComponent, deps: [{ token: i1$2.BsModalRef }, { token: i1.AssetService }, { token: ExceptionService }, { token: i1.CartItemService }], target: i0.ɵɵFactoryTarget.Component });
BuyMoreModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: BuyMoreModalComponent, selector: "apt-buy-more-modal", ngImport: i0, template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title d-flex align-items-center m-0 text-truncate\">\r\n    {{'COMMON.BUY_MORE' | translate}} \r\n    <apt-output-field [record]=\"_assetItem\" field=\"Product.Name\" layout=\"inline\" [editable]=\"false\" [valueOnly]=\"true\">\r\n    </apt-output-field>\r\n  </h4>\r\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"bsModalRef.hide()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div\u00A0class=\"modal-body\" \u00A0*ngIf=\"_assetItem\">\r\n  <div\u00A0class=\"row\">\r\n    <div\u00A0class=\"col-md-5\">\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"NetUnitPrice\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n      </div>\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"SellingTerm\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n    </div>\r\n    <div\u00A0class=\"col-md-7\">\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"ChargeType\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"SellingFrequency\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n      <div>\r\n        <apt-output-field [record]=\"_assetItem\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\">\r\n        </apt-output-field>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <hr class=\"my-4\">\r\n\r\n\r\n  <form class=\"pb-0\" (ngSubmit)=\"buyMore()\">\r\n    <div class=\"row\" *ngIf=\"_assetItem?.PriceType === 'Recurring' || _assetItem?.PriceType === 'Usage'\">\r\n\r\n      <div class=\"form-group col-6\">\r\n        <label for=\"buyMoreStartDate\" class=\"font-weight-bold\">{{'MODAL.NEW_START_DATE' | translate}} </label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" id=\"buyMoreStartDate\" name=\"startDate\" class=\"form-control\" placeholder=\"MM/DD/YYYY\"\r\n            [minDate]=\"minimumStartDate\" [(ngModel)]=\"buyMoreForm.startDate\" bsDatepicker\r\n            [bsConfig]=\"{ showWeekNumbers: false }\" (ngModelChange)=\"startDateChange(buyMoreForm.startDate)\">\r\n          <div class=\"input-group-append\">\r\n            <span class=\"input-group-text\">\r\n              <i class=\"fas fa-calendar-alt\"></i>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group col-6\">\r\n        <label for=\"buyMoreEndDate\" class=\"font-weight-bold\">{{'MODAL.NEW_END_DATE' | translate}} </label>\r\n        <div class=\"input-group\">\r\n          <input type=\"text\" id=\"buyMoreEndDate\" name=\"endDate\" class=\"form-control\" placeholder=\"MM/DD/YYYY\"\r\n            [minDate]=\"minimumEndDate\" [(ngModel)]=\"buyMoreForm.endDate\" bsDatepicker\r\n            [bsConfig]=\"{ showWeekNumbers: false }\">\r\n          <div class=\"input-group-append\">\r\n            <span class=\"input-group-text\">\r\n              <i class=\"fas fa-calendar-alt\"></i>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-6 form-group\">\r\n        <label for=\"buyMoreQty\" class=\"font-weight-bold\">{{'BUYMORE.ADDITIONAL_QUANTITY' | translate}} </label>\r\n        <input type=\"number\" min=\"1\" class=\"\" [(ngModel)]=\"buyMoreForm.quantity\" name=\"quantity\" class=\"form-control\"\r\n          id=\"buyMoreQty\" />\r\n      </div>\r\n      <div class=\"col-6 form-group\">\r\n        <label for=\"staticQuantity\" class=\"font-weight-bold\">\r\n          {{'BUYMORE.UPDATED_QUANTITY' | translate}}\r\n        </label>\r\n        <input type=\"number\" *ngIf=\"_assetItem && buyMoreForm\" readonly class=\"form-control-plaintext\" id=\"staticQuantity\" [value]=\"_assetItem.Quantity + buyMoreForm.quantity\"/>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn\" (click)=\"bsModalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n  <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"buyMore()\" [ladda]=\"loading\"\r\n    data-style=\"zoom-in\">{{'COMMON.BUY_MORE' | translate}}</button>\r\n</div>", styles: ["apt-buy-more-modal{font-size:small;line-height:1.5rem}apt-buy-more-modal .row div[class^=col-md-] dt{width:55%}apt-buy-more-modal .row div[class^=col-md-] dd{width:45%}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BuyMoreModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-buy-more-modal',
                    templateUrl: './buy-more-modal.component.html',
                    styleUrls: ['./buy-more-modal.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: i1.AssetService }, { type: ExceptionService }, { type: i1.CartItemService }]; } });

/**
 * The change configuration modal is used to create a modal for terminating one or many assets.
 * To open a terminate modal the AssetModalService must be used.
 * @ignore
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetModalService } from '@congacommerce/elements';

@Component({
  ...
})
export class AppComponent {

  private lineItems: Array<AssetLineItem>;

  constructor(private assetModalService: AssetModalService) {}

  openChangeConfigModal() {
    this.assetModalService.openChangeConfigurationModal(lineItems[0], lineItems);
  }
}
 ```
 */
class ChangeConfigurationModalComponent {
    /**@ignore */
    constructor(bsModalRef, assetService, exceptionService, cartItemService, configurationService, router, cartService) {
        this.bsModalRef = bsModalRef;
        this.assetService = assetService;
        this.exceptionService = exceptionService;
        this.cartItemService = cartItemService;
        this.configurationService = configurationService;
        this.router = router;
        this.cartService = cartService;
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /** @ignore  */
        this.moment = moment;
        /**
       * start date and end date is set to default to current date.
       */
        this.minimumStartDate = new Date();
        this.minimumEndDate = new Date();
    }
    /**@ignore */
    ngOnInit() {
        this.minimumStartDate = new Date();
        this.minimumEndDate = this.getMinimumEndDate();
        this.changeConfigurationform = {
            startDate: this.minimumStartDate,
            endDate: this.minimumEndDate
        };
    }
    /**
    * This method calculates the end date based on the term and sets the minimum end date.
    *  @param startDate a date value representing the asset line item start date
    *  @returns a date value representing the asset line item end date.
    */
    getMinimumEndDate(startDate = new Date()) {
        if (this.assetList) {
            let latestDate = this.moment(_.get(this.assetList[0], 'EndDate', this.cartItemService.getEndDate(startDate, this.assetList[0].Term, _.get(this.assetList[0], 'PriceListItem.Frequency')))).toDate();
            return latestDate;
        }
        else {
            return new Date();
        }
    }
    /**
     * Method calculates the minimum enddate based on start date selected.
     * @param event selected start date
     */
    startDateChange(event) {
        this.minimumEndDate = this.getMinimumEndDate(event);
        this.changeConfigurationform.endDate = this.minimumEndDate;
    }
    /**
     * This method amend current configuration of given assets for a given account.
     * @fires AssetService.amendAssets(listOfAssetsIDToAmend).
     */
    changeConfiguration() {
        this.loading = true;
        this.assetService.amendAssets([this._assetItem.Id])
            .subscribe(res => {
            this.cartService.getMyCart().pipe(filter(cart => _.some(cart.LineItems, (item => _.get(item, 'LineStatus') === 'Amended' && item.AssetLineItemId === this._assetItem.Id))), take(1))
                .subscribe(cart => {
                this.loading = false;
                this.bsModalRef.hide();
                this.exceptionService.showSuccess('ASSETS.CHANGECONFIGURATION_SUCCESS');
                const amendItem = _.find(cart.LineItems, (item => _.get(item, 'LineStatus') === 'Amended' && item.AssetLineItemId === this._assetItem.Id));
                this.router.navigate(['/products', _.get(this, '_assetItem.ProductId'), amendItem.Id]);
            });
        }, err => {
            this.loading = false;
            this.bsModalRef.hide();
            this.exceptionService.showError(err);
        });
    }
}
ChangeConfigurationModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChangeConfigurationModalComponent, deps: [{ token: i1$2.BsModalRef }, { token: i1.AssetService }, { token: ExceptionService }, { token: i1.CartItemService }, { token: i1$1.ConfigurationService }, { token: i4$1.Router }, { token: i1.CartService }], target: i0.ɵɵFactoryTarget.Component });
ChangeConfigurationModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ChangeConfigurationModalComponent, selector: "apt-change-configuration-modal", ngImport: i0, template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title pull-left\">{{'COMMON.CHANGE_CONFIGURATION' | translate}}</h4>\r\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"bsModalRef.hide()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div\u00A0class=\"modal-body\" \u00A0*ngIf=\"_assetItem\">\r\n  <div\u00A0class=\"container-fluid\">\r\n    <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col ml-1\">\r\n        <apt-output-field [record]=\"_assetItem\" field=\"Name\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n      </div>\r\n    </div>\r\n    <div\u00A0class=\" row\">\r\n      <div\u00A0class=\"col col-md-7\">\r\n        <div\u00A0class=\"container-fluid\">\r\n          <div\u00A0class=\"row p-1\">\r\n            <apt-output-field [record]=\"_assetItem\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row p-1\">\r\n            <apt-output-field [record]=\"_assetItem\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\u00A0class=\"col col-md-5 pl-0\">\r\n        <div\u00A0class=\"container-fluid\">\r\n          <div\u00A0class=\"row p-1\">\r\n            <apt-output-field [record]=\"_assetItem\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row p-1\">\r\n              <apt-output-field [record]=\"_assetItem\" field=\"NetPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n            </div>\r\n        </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  <hr class=\"m-0\">\r\n  <form class=\"pt-1 pb-3\" (ngSubmit)=\"changeConfiguration()\">\r\n    <div\u00A0class=\"container-fluid \">\r\n        <div\u00A0class=\" row\">\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div class=\"pr-3 mt-2\" *ngIf=\"_assetItem?.PriceType === 'Recurring' || _assetItem?.PriceType === 'Usage'\">\r\n          <label for=\"changeConfigurationStartDate\" class=\"font-weight-bold ml-1\">{{'ASSETS.CHANGECONFIGURATION_START_DATE' | translate}}\r\n          </label>\r\n          <div class=\"input-group ml-1\">\r\n            <input type=\"text\" id=\"changeConfigurationStartDate\" name=\"startDate\" class=\"form-control\"\r\n              placeholder=\"MM/DD/YYYY\" [minDate]=\"minimumStartDate\" [(ngModel)]=\"changeConfigurationform.startDate\"\r\n              bsDatepicker [bsConfig]=\"{ showWeekNumbers: false }\"\r\n              (ngModelChange)=\"startDateChange(changeConfigurationform.startDate)\">\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\">\r\n                <i class=\"fas fa-calendar-alt\"></i>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div class=\"pl-4 mt-2\" *ngIf=\"_assetItem?.PriceType === 'Recurring' || _assetItem?.PriceType === 'Usage'\">\r\n          <label for=\"changeConfigurationEndDate\"\r\n            class=\"font-weight-bold ml-1\">{{'ASSETS.CHANGECONFIGURATION_END_DATE' | translate}}</label>\r\n          <div class=\"input-group ml-1\">\r\n            <input type=\"text\" id=\"changeConfigurationEndDate\" name=\"endDate\" class=\"form-control\"\r\n              placeholder=\"MM/DD/YYYY\" [minDate]=\"minimumEndDate\" [(ngModel)]=\"changeConfigurationform.endDate\"\r\n              bsDatepicker [bsConfig]=\"{ showWeekNumbers: false }\">\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\">\r\n                <i class=\"fas fa-calendar-alt\"></i>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>\r\n</form>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-link\" (click)=\"bsModalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n  <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"changeConfiguration()\" [ladda]=\"loading\"\r\n    data-style=\"zoom-in\">{{'COMMON.CHANGE_CONFIGURATION' | translate}}</button>\r\n</div>", styles: [""], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChangeConfigurationModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-change-configuration-modal',
                    templateUrl: './change-configuration-modal.component.html',
                    styleUrls: ['./change-configuration-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: i1.AssetService }, { type: ExceptionService }, { type: i1.CartItemService }, { type: i1$1.ConfigurationService }, { type: i4$1.Router }, { type: i1.CartService }]; } });

/**
 * The terminate modal is used to create a modal for terminating one or many assets.
 * To open a terminate modal the AssetModalService must be used.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/terminateModal.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetModalService } from '@congacommerce/elements';

@Component({
  ...
})
export class AppComponent {

  private lineItems: Array<AssetLineItem>;

  constructor(private assetModalService: AssetModalService) {}

  openRenewModal() {
    this.assetModalService.openTerminateModal(lineItems[0], lineItems);
  }
}
 ```
 */
class TerminateModalComponent {
    constructor(bsModalRef, assetService, exceptionService) {
        this.bsModalRef = bsModalRef;
        this.assetService = assetService;
        this.exceptionService = exceptionService;
        /**
         * Hold end date for an asset intially set current date as end date of an asset.
         */
        this.endDate = new Date();
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /**
         * Falg to determine selected terminate date is valid or not
         */
        this.dateIsValid = false;
        /** @ignore */
        this.moment = moment;
    }
    ngOnInit() {
        if (this.moment(this._assetItem.StartDate).isBefore(this.moment())) {
            if (this.moment(this._assetItem.EndDate).isBefore(this.moment())) {
                this.minimumDate = this.endDate;
                this.maximumDate = this.endDate;
            }
            else {
                this.minimumDate = this.endDate;
                this.maximumDate = new Date(this.moment(this._assetItem.EndDate).format());
            }
        }
        else {
            this.endDate = new Date(this.moment(this._assetItem.StartDate).format());
            this.minimumDate = new Date(this.moment(this._assetItem.StartDate).format());
            this.maximumDate = new Date(this.moment(this._assetItem.StartDate).format());
        }
        console.log(this.endDate);
        console.log("MAX:", this.maximumDate, "min::", this.minimumDate);
    }
    /**
     * Fetches the earliest date that can be selected for canceling the group of selected assets.
     * @returns A date value representing the asset line item minimum termination date.
     */
    getMinimumDate() {
        if (this.assetList) {
            let latestDate = new Date(this.moment(this.assetList[0].StartDate).format());
            _.each(this.assetList, asset => {
                if (new Date(this.moment(asset.StartDate).format()) > latestDate)
                    latestDate = new Date(this.moment(asset.StartDate).format());
            });
            return this.moment(latestDate).toDate();
        }
        else
            return new Date();
    }
    /**
     * This method fetches the oldest end date from among the existing assets for a given account.
     * @returns a date value representing the asset line item maximum termination date.
     */
    getMaximumDate() {
        if (this.assetList) {
            let earliestDate = new Date(this.moment(this.assetList[0].EndDate).format());
            _.each(this.assetList, asset => {
                if (new Date(this.moment(asset.EndDate).format()) < earliestDate)
                    earliestDate = new Date(this.moment(asset.EndDate).format());
            });
            return this.moment(earliestDate).subtract(1, 'day').toDate();
        }
        else
            return new Date();
    }
    /**
     * This method terminates the existing assets for a given account.
     * @fires AssetService.cancelAssets().
     */
    terminate() {
        this.loading = true;
        this.assetService.cancelAssets(_.map(this.assetList, a => a.Id), this.endDate)
            .subscribe(res => {
            this.loading = false;
            this.bsModalRef.hide();
            this.exceptionService.showSuccess('ASSETS.TERMINATE_SUCCESS');
        }, err => {
            this.loading = false;
            this.bsModalRef.hide();
            this.exceptionService.showError(err);
        });
    }
    /**
     * Event handler for when the datepicker input changes.
     * @param event The event that was fired.
     * @ignore
     */
    handleDateChange(event) {
        this.dateIsValid = this.moment(event).isBetween(this.moment(this.minimumDate).subtract(1, 'day').toDate(), this.moment(this.maximumDate).add(1, 'day').toDate());
    }
}
TerminateModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TerminateModalComponent, deps: [{ token: i1$2.BsModalRef }, { token: i1.AssetService }, { token: ExceptionService }], target: i0.ɵɵFactoryTarget.Component });
TerminateModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TerminateModalComponent, selector: "apt-terminate-modal", ngImport: i0, template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title pull-left\"> {{'COMMON.TERMINATE_ASSETS' | translate}}</h4>\r\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"bsModalRef.hide()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div\u00A0class=\"modal-body renew-detail\"\u00A0*ngIf=\"assetList?.length==1\">\r\n  <div\u00A0class=\"container-fluid\">\r\n    <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col\">\r\n        <apt-output-field [record]=\"this._assetItem\" field=\"Product.Name\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n      </div>\r\n    </div>\r\n    <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div\u00A0class=\"container-fluid\">\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"SellingFrequency\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"ChargeType\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div\u00A0class=\"row\">\r\n          <apt-output-field [record]=\"this._assetItem\" field=\"NetUnitPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </div>\r\n        <div\u00A0class=\"row\">\r\n          <apt-output-field [record]=\"this._assetItem\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </div>\r\n        <div\u00A0class=\"row\">\r\n          <apt-output-field [record]=\"this._assetItem\" field=\"NetPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </div>\r\n        <div class=\"row\">\r\n          <apt-output-field [record]=\"this._assetItem\" field=\"SellingTerm\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<hr class=\"m-0\">\r\n<form class=\"d-flex justify-content-between modal-body row\" (ngSubmit)=\"terminate()\">\r\n  <div class=\"col-6 form-group\">\r\n    <div class=\"mb-2\">\r\n      <label for=\"terminateModalEndDate\" class=\"ml-3\">\r\n        <b>{{'MODAL.TERMINATION_DATE' | translate}}</b>\r\n      </label>\r\n    </div>\r\n    <div class=\"input-group ml-3\">\r\n      <input\r\n        type=\"text\"\r\n        id=\"renewalDate\"\r\n        name=\"endDate\"\r\n        class=\"form-control\"\r\n        placeholder=\"MM/DD/YYYY\"\r\n        [minDate]=\"minimumDate\"\r\n        [maxDate]=\"maximumDate\"\r\n        [(ngModel)]=\"endDate\"\r\n        bsDatepicker\r\n        [bsConfig]=\"{ showWeekNumbers: false }\"\r\n        (bsValueChange)=\"handleDateChange(endDate)\"\r\n      >\r\n      <div class=\"input-group-append\">\r\n        <span class=\"input-group-text\">\r\n          <i class=\"fas fa-calendar-alt\"></i>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-link\" (click)=\"bsModalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n  <ng-container>\r\n    <button\r\n      class=\"btn btn-primary btn-raised\"\r\n      type=\"button\"\r\n      (click)=\"terminate()\"\r\n      [ladda]=\"loading\"\r\n      data-style=\"zoom-in\"\r\n    >{{'COMMON.TERMINATE' | translate}}</button>\r\n  </ng-container>\r\n  <ng-template #disabledButton>\r\n    <div\r\n      [tooltip]=\"'MODAL.INVALID_TERMINATION_DATE' | translate\"\r\n      container=\"body\"\r\n    >\r\n      <button\r\n        class=\"btn btn-primary btn-raised\"\r\n        type=\"button\"\r\n        (click)=\"terminate()\"\r\n        [ladda]=\"loading\"\r\n        data-style=\"zoom-in\"\r\n        disabled=\"true\"\r\n      >{{'COMMON.TERMINATE' | translate}}</button>\r\n    </div>\r\n  </ng-template>\r\n</div>", styles: [""], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TerminateModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-terminate-modal',
                    templateUrl: './terminate-modal.component.html',
                    styleUrls: ['./terminate-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: i1.AssetService }, { type: ExceptionService }]; } });

/**
 * The renew modal is used to create a modal for renewing one or many assets.
 * To open a renew modal the AssetModalService must be used.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/renewModal.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetModalService } from '@congacommerce/elements';

@Component({
  ...
})
export class AppComponent {

  private lineItems: Array<AssetLineItem>;

  constructor(private assetModalService: AssetModalService) {}

  openRenewModal() {
    this.assetModalService.openRenewModal(lineItems[0], lineItems);
  }
}
 ```
 */
class RenewModalComponent {
    constructor(bsModalRef, cartItemService, assetService, exceptionService) {
        this.bsModalRef = bsModalRef;
        this.cartItemService = cartItemService;
        this.assetService = assetService;
        this.exceptionService = exceptionService;
        /**
         * Latest end date value from among the existing assets for an account.
         */
        this.minimumDate = new Date();
        /**
         * An arry of term option values.
         */
        this.termOptions = new Array();
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /**  @ignore */
        this.moment = moment;
        /** To set renewal type
         * state = term will disable datepicker
         */
        this.state = 'renewal';
    }
    ngOnInit() {
        this.minimumDate = this.getMinimumEndDate();
        this.termOptions = this.getTermOptions();
        this.renewForm = {
            endDate: this.minimumDate,
            term: this.termOptions[0]
        };
    }
    ngOnChanges() {
        this.minimumDate = this.getMinimumEndDate();
        this.termOptions = this.getTermOptions();
        this.renewForm = {
            endDate: this.minimumDate,
            term: this.termOptions[0]
        };
    }
    /**
     * This method fetches the most recent end date from among the existing assets for a given account.
     * @returns a date value representing the asset line item end date.
     */
    getMinimumEndDate() {
        if (this.assetList) {
            let latestDate = new Date(this.moment(this.assetList[0].EndDate).format()), latestAsset = Object.assign({}, this.assetList[0]), latestAssetTerm, latestAssetFrequency;
            this.assetList.forEach(asset => {
                if (new Date(this.moment(asset.EndDate).format()) > latestDate) {
                    latestDate = new Date(this.moment(asset.EndDate).format());
                    latestAsset = Object.assign({}, asset);
                }
                latestAssetTerm = (latestAsset) ? latestAsset.SellingTerm : asset.SellingTerm;
                latestAssetFrequency = (latestAsset) ? latestAsset.Frequency : asset.Frequency;
            });
            latestDate.setDate(latestDate.getDate() + 1);
            latestDate = this.cartItemService.getEndDate(latestDate, latestAssetTerm, latestAssetFrequency);
            return latestDate;
        }
        else
            return new Date();
    }
    /**
     * This method returns a list of unique term options for existing assets of a given account.
     * Each term option item contains the selling term of the asset line item and the term calculated based on its selling term and selling frequency.
     * @fires CartItemService.getReadableTerm()
     */
    getTermOptions() {
        const options = _.uniq(this.assetList.map(asset => {
            return {
                label: this.cartItemService.getReadableTerm(asset.SellingTerm, asset.SellingFrequency),
                value: asset.SellingTerm
            };
        })).filter(y => y != null);
        if (_.get(options, 'length', 0) === 0)
            options.push(1);
        return options;
    }
    /**
     * This method renews the existing assets for a given account.
     * @fires AssetService.renewAssets().
     */
    renew() {
        this.loading = true;
        let obsv$;
        if (this.state === 'renewal') {
            obsv$ = this.assetService.renewAssets(this.assetList.map(asset => asset.Id), new Date(this.renewForm.endDate), null, false);
            obsv$.pipe(take(1))
                .subscribe(res => {
                this.successCallback();
            }, err => {
                this.errorCallback(err);
            });
        }
        else if (this.state === 'term') {
            this.assetService.renewAssets(_.map(this.assetList, a => a.Id), null, null, false)
                .pipe(take(1))
                .subscribe(res => this.successCallback(), err => this.errorCallback(err));
        }
    }
    /**
      * This method returns success as a response upon successful renew of the existing assets for a given account.
      * @fires  ExceptionService.showSuccess().
      */
    successCallback() {
        this.loading = false;
        this.bsModalRef.hide();
        this.exceptionService.showSuccess('ASSETS.RENEW_SUCCESS');
    }
    /**
    * This method returns error as a response when renewing the existing assets for a given account fails.
    * @fires  ExceptionService.showError().
    */
    errorCallback(objErr) {
        this.loading = false;
        this.bsModalRef.hide();
        this.exceptionService.showError(objErr);
    }
}
RenewModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RenewModalComponent, deps: [{ token: i1$2.BsModalRef }, { token: i1.CartItemService }, { token: i1.AssetService }, { token: ExceptionService }], target: i0.ɵɵFactoryTarget.Component });
RenewModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: RenewModalComponent, selector: "apt-renew-modal", usesOnChanges: true, ngImport: i0, template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title pull-left\">{{'COMMON.RENEW' | translate}}</h4>\r\n  <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"bsModalRef.hide()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div\u00A0class=\"modal-body renew-detail\"\u00A0*ngIf=\"assetList?.length==1\">\r\n  <div\u00A0class=\"container-fluid\">\r\n    <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col\">\r\n        <apt-output-field [record]=\"this._assetItem\" field=\"Product.Name\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n      </div>\r\n    </div>\r\n    <div\u00A0class=\"row\">\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div\u00A0class=\"container-fluid\">\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"ChargeType\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"SellingFrequency\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n              <apt-output-field [record]=\"this._assetItem\" field=\"NetPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\u00A0class=\"col col-md-6\">\r\n        <div\u00A0class=\"container-fluid\">\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"NetUnitPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div\u00A0class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n          <div class=\"row\">\r\n            <apt-output-field [record]=\"this._assetItem\" field=\"SellingTerm\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<hr class=\"m-0\">\r\n<form class=\"d-flex justify-content-between modal-body row\" (ngSubmit)=\"renew()\">\r\n  <div class=\"col-6 form-group\">\r\n    <div class=\"custom-control custom-radio mb-2 ml-3\">\r\n      <input type=\"radio\" class=\"custom-control-input\" id=\"renewModalEndDate\" name=\"state\" value=\"renewal\" \r\n        [(ngModel)]=\"state\">\r\n      <label class=\"custom-control-label\" for=\"renewModalEndDate\">\r\n        {{'MODAL.RENEWAL_END_DATE' | translate}}\r\n      </label>\r\n    </div>\r\n    <div class=\"input-group ml-3\">\r\n      <input\r\n        type=\"text\"\r\n        id=\"renewalDate\"\r\n        name=\"endDate\"\r\n        class=\"form-control\"\r\n        placeholder=\"MM/DD/YYYY\"\r\n        [minDate]=\"minimumDate\"\r\n        [(ngModel)]=\"renewForm.endDate\"\r\n        bsDatepicker\r\n        [bsConfig]=\"{ showWeekNumbers: false }\"\r\n        [disabled]=\"state !== 'renewal'\"\r\n      >\r\n      <div class=\"input-group-append\">\r\n        <span class=\"input-group-text\">\r\n          <i class=\"fas fa-calendar-alt\"></i>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-6 form-group\">\r\n    <div class=\"custom-control custom-radio mb-2\">\r\n      <input type=\"radio\" class=\"custom-control-input\" id=\"renewModalTerm\" name=\"state\" value=\"term\" [(ngModel)]=\"state\">\r\n      <label class=\"custom-control-label\" for=\"renewModalTerm\">\r\n        {{'MODAL.USE_EXISTING_TERM' | translate}}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</form>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn\" (click)=\"bsModalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n  <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"renew()\" [ladda]=\"loading\" data-style=\"zoom-in\">{{'COMMON.RENEW' | translate}}</button>\r\n</div>", styles: [""], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RenewModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-renew-modal',
                    templateUrl: './renew-modal.component.html',
                    styleUrls: ['./renew-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: i1.CartItemService }, { type: i1.AssetService }, { type: ExceptionService }]; } });

/**
 * Asset modal service is used to open asset modals.
 * @ignore
 */
class AssetModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    /**
     * Opens the renew asset modal.
     * @param assetItem The first asset in the list
     * @param assetList The list of asset items.
     */
    openRenewModal(assetItem, assetList) {
        this.modalService.show(RenewModalComponent, { initialState: { _assetItem: assetItem, assetList: assetList } });
    }
    /**
     * Opens the terminate asset modal.
     * @param assetItem The first asset in the list.
     * @param assetList The list of asset items.
     */
    openTerminateModal(assetItem, assetList) {
        this.modalService.show(TerminateModalComponent, { initialState: { _assetItem: assetItem, assetList: assetList } });
    }
    /**
     * Opens the Buy more asset modal.
     * @param assetItem The first asset in the list.
     * @param assetList The list of asset items.
     */
    openBuyMoreModal(assetItem, assetList) {
        this.modalService.show(BuyMoreModalComponent, { initialState: { _assetItem: assetItem, assetList: assetList } });
    }
    /**
     * Opens the Change Configuration asset modal.
     * @param assetItem The first asset in the list.
     * @param assetList The list of asset items.
     */
    openChangeConfigurationModal(assetItem, assetList) {
        this.modalService.show(ChangeConfigurationModalComponent, { initialState: { _assetItem: assetItem, assetList: assetList } });
    }
}
AssetModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetModalService, deps: [{ token: i1$2.BsModalService }], target: i0.ɵɵFactoryTarget.Injectable });
AssetModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalService }]; } });

/**
 * @ignore
 */
class OutputFieldModule {
}
OutputFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OutputFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldModule, declarations: [OutputFieldComponent], imports: [CommonModule,
        AddressModule, i1$4.PopoverModule, i2$1.TranslateModule, InputFieldModule,
        RouterModule,
        LaddaModule,
        PricingModule], exports: [OutputFieldComponent] });
OutputFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldModule, imports: [[
            CommonModule,
            AddressModule,
            PopoverModule.forRoot(),
            TranslateModule.forChild(),
            InputFieldModule,
            RouterModule,
            LaddaModule,
            PricingModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: OutputFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AddressModule,
                        PopoverModule.forRoot(),
                        TranslateModule.forChild(),
                        InputFieldModule,
                        RouterModule,
                        LaddaModule,
                        PricingModule
                    ],
                    declarations: [OutputFieldComponent],
                    exports: [OutputFieldComponent]
                }]
        }] });

/**
 * Asset selection service keeps track of which assets in the application have been selected for batch actions.
 * <h3>Usage</h3>
 *
  ```typescript
 import { AssetSelectionService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private assetSelectionService: AssetSelectionService)
 }
 // or
 export class MyService extends AObjectService {
      private assetSelectionService: AssetSelectionService = this.injector.get(AssetSelectionService);
  }
 ```
 */
class AssetSelectionService {
    constructor() {
        /**
         * List of currently selected assets.
         */
        this.assets = [];
        /**
         * List of assets to be subscribed to.
         */
        this._assets = new BehaviorSubject([]);
    }
    /**
     * Adds a new asset to the list of selected assets.
     * ### Example:
     ```typescript
     import { AssetSelectionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private assetSelectionService: AssetSelectionService){}
     
         addAssetToSelection(asset: AssetLineItemExtended){
             this.assetSelectionService.addAssetToSelection(asset)
         }
     }
     ```
     * @param asset Asset to be added to the selection.
     */
    addAssetToSelection(asset) {
        if (!this.assets.includes(asset)) {
            this.assets.unshift(asset);
            this._assets.next(this.assets);
        }
    }
    /**
     * Removes assets from the list of selected assets.
     * ### Example:
     ```typescript
     import { AssetSelectionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private assetSelectionService: AssetSelectionService){}
     
         removeAssetFromSelection(asset: AssetLineItemExtended){
             this.assetSelectionService.removeAssetFromSelection(asset)
         }
     }
     ```
     * @param asset Asset to be removed from the selection.
     */
    removeAssetFromSelection(asset) {
        _.remove(this.assets, a => a.Id === asset.Id);
        this._assets.next(this.assets);
    }
    /**
     * Sets the currently selected assets to the given array of assets.
     * ### Example:
     ```typescript
     import { AssetSelectionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private assetSelectionService: AssetSelectionService){}
     
         setSelectedAssets(assets: Array<AssetLineItemExtended>){
             this.assetSelectionService.setSelectedAssets(assets)
         }
     }
     ```
     * @param assets Array of assets to set as the current selection.
     */
    setSelectedAssets(assets) {
        this.assets = assets;
        this._assets.next(this.assets);
    }
    /**
     * Gets the list of currently selected assets.
     * ### Example:
     ```typescript
     import { AssetSelectionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         assets: Array<AssetLineItemExtended>
         assets$: Observable<Array<AssetLineItemExtended>>
         constructor(private assetSelectionService: AssetSelectionService){}
     
         getSelectedAssets(){
             this.assetSelectionService.getSelectedAssets().subscribe(a => this.assets = a);
               // or
             assets$ = this.assetSelectionService.getSelectedAssets();
         }
     }
     ```
     */
    getSelectedAssets() {
        return this._assets;
    }
    /**
     * Checks if the given asset is part of the selected asset list.
     * ### Example:
     ```typescript
     import { AssetSelectionService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         isSelected : boolean;
         constructor(private assetSelectionService: AssetSelectionService){}
     
         isAssetSelected(asset: AssetLineItemExtended){
             this.isSelected = this.assetSelectionService.isAssetSelected(asset);
         }
     }
     ```
     * @param asset Asset to check against the list of selected assets.
     */
    isAssetSelected(asset) {
        return !!_.find(this.assets, { Id: asset.Id });
    }
    /**
     * Clears the array of currently selected assets and notifies all observers.
     */
    clearSelection() {
        this.assets = [];
        this._assets.next(this.assets);
    }
}
AssetSelectionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetSelectionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AssetSelectionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetSelectionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetSelectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Btach selecion service provides methods to perform operation on selected product in the drawer.
 * <h3>Usage</h3>
 *
 ```typescript
 import { BatchSelectionService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private batchSelectionService: BatchSelectionService)
 }
 // or
 export class MyService extends AObjectService {
      private batchSelectionService: BatchSelectionService = this.injector.get(BatchSelectionService);
  }
 ```
 */
/**
 * Batch selection service keeps track of which products & cartItems in the application have been selected for batch actions.
 */
class BatchSelectionService {
    constructor(cartService, plService) {
        this.cartService = cartService;
        this.plService = plService;
        /**
         * List of currently selected products.
         */
        this.products = [];
        /**
         * List of products to be subscribed to.
         */
        this._products = new BehaviorSubject([]);
        /**
         * List of currently selected lineItems.
         */
        this.lineItems = [];
        /**
         * List of lineItems to be subscribed to.
         */
        this._lineItems = new BehaviorSubject([]);
        this.cartSubscription = null;
        this.cartSubscription = this.cartService.getMyCart().subscribe(cart => {
            this.updateLineItemSelections(cart.LineItems);
            this.updateProductSelections(cart);
        });
    }
    /**
     * Adds a new product to the list of selected products.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private batchSelectionService: BatchSelectionService){}
     
         addProductToSelection(product: Product){
              this.batchSelectionService.addProductToSelection(product);
         }
     }
     ```
     * @param product Product to be added to the selection.
     */
    addProductToSelection(product) {
        this.products.unshift(product);
        this._products.next([...this.products]);
    }
    /**
     * Adds all products to the list of selected products.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private batchSelectionService: BatchSelectionService){}
     
         addAllProductstoSelection(products: Array<Product>){
              this.batchSelectionService.addAllProductstoSelection(products);
         }
     }
     ```
     * @param products Products to be added to the selection.
     */
    addAllProductstoSelection(products) {
        forEach(products, (p) => {
            if (filter$1(this.products, ['Id', p.Id]).length <= 0) {
                this.products.unshift(p);
            }
        });
        this._products.next([...this.products]);
    }
    /**
     * Removes products from the list of selected products.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private batchSelectionService: BatchSelectionService){}
     
         removeProductFromSelection(product:Product){
              this.batchSelectionService.removeProductFromSelection(product);
         }
     }
     ```
     * @param product Product to be removed from the selection.
     */
    removeProductFromSelection(product) {
        remove(this.products, { 'Id': product.Id });
        this._products.next([...this.products]);
    }
    /**
     * Removes all products from the list of selected products.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private batchSelectionService: BatchSelectionService){}
     
         removeAllProductsFromSelection(products: Array<Product>){
              this.batchSelectionService.removeAllProductsFromSelection(products);
         }
     }
     ```
     * @param products Products to be removed from the selection.
     */
    removeAllProductsFromSelection(products) {
        forEach(products, (p) => {
            if (filter$1(this.products, ['Id', p.Id]).length >= 0) {
                remove(this.products, { 'Id': p.Id });
            }
        });
        this._products.next([...this.products]);
    }
    /**
     * @ignore
     */
    removeAllProducts() {
        this.products = [];
        this._products.next([]);
    }
    /**
     * Adds a list of products to drawer selection.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
     
         constructor(private batchSelectionService: BatchSelectionService){}
     
         setSelectedProducts(products: Array<Product>){
              this.batchSelectionService.setSelectedProducts(products);
         }
     }
     ```
     * @param products List of products to be added to drawer selection
     */
    setSelectedProducts(products) {
        this.products = products;
        this._products.next([...this.products]);
    }
    /**
     * Gets the list of currently selected products.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         products:Product=[];
         constructor(private batchSelectionService: BatchSelectionService){}
     
         getSelectedProducts(){
              this.batchSelectionService.getSelectedProducts().subscribe((res)=> this.products = res);
         }
     }
     ```
     * @returns Observable<Array<Product>> return an array list of products.
     */
    getSelectedProducts() {
        return this._products;
    }
    /**
     * Checks if the given product is part of the selected product list.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         isSelected:boolean;
         constructor(private batchSelectionService: BatchSelectionService){}
     
         isProductSelected(product: Product){
              this.batchSelectionService.isProductSelected().subscribe((res)=> this.isSelected = res);
         }
     }
     ```
     * @param product Product to check against the list of selected products.
     * @returns an observable of type boolean.
     */
    isProductSelected(product) {
        return of(!!find(this.products, { Id: product.Id }));
    }
    /**
     * update product list in drawer if pricelist is changed when switching cart
     * @param cart Cart to check pricelist of the cart
     */
    updateProductSelections(cart) {
        const nonExistingSelections = this.plService.isValidPriceList(get(cart, 'PriceList')) ? filter$1(this._products.value, p => !includes(map$1(get(p, 'PriceLists'), item => item.PriceListId), cart.PriceListId)) : this._products.value;
        map$1(nonExistingSelections, selection => this.removeProductFromSelection(selection));
    }
    /**
     * Adds a new lineitem to the list of selected lineItems.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private batchSelectionService: BatchSelectionService){}
     
         addLineItemToSelection(lineItem: CartItem){
              this.batchSelectionService.addLineItemToSelection(lineItem);
         }
     }
     ```
     * @param lineItem LineItem to be added to the selection.
     */
    addLineItemToSelection(lineItem) {
        this.lineItems.unshift(lineItem);
        this._lineItems.next([...this.lineItems]);
    }
    /**
     * Adds all lineitems to the list of selected LineItems.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private batchSelectionService: BatchSelectionService){}
     
         addAllLineItemstoSelection(lineItems: Array<CartItem>){
              this.batchSelectionService.addAllLineItemstoSelection(lineItems);
         }
     }
     ```
     * @param lineItems LineItems to be added to the selection.
     */
    addAllLineItemstoSelection(lineItems) {
        forEach(lineItems, (l) => {
            if (filter$1(this.lineItems, ['Id', l.Id]).length <= 0) {
                this.lineItems.unshift(l);
            }
        });
        this._lineItems.next([...this.lineItems]);
    }
    /**
     * Removes LineItems from the list of selected LineItems.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private batchSelectionService: BatchSelectionService){}
     
         removeLineItemFromSelection(lineItem: CartItem){
              this.batchSelectionService.removeLineItemFromSelection(lineItem);
         }
     }
     ```
     * @param lineItem CartItem to be removed from the selection.
     */
    removeLineItemFromSelection(lineItem) {
        remove(this.lineItems, { 'Id': lineItem.Id });
        this._lineItems.next([...this.lineItems]);
    }
    /**
     * Removes all lineItems from the list of selected lineItem.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private batchSelectionService: BatchSelectionService){}
     
         removeAllLineItemsFromSelection(lineItems: Array<CartItem>){
              this.batchSelectionService.removeAllLineItemsFromSelection(lineItems);
         }
     }
     ```
     * @param lineItems LineItems to be removed from the selection.
     */
    removeAllLineItemsFromSelection(lineItems) {
        forEach(lineItems, (l) => {
            if (filter$1(this.lineItems, ['Id', l.Id]).length >= 0) {
                remove(this.lineItems, { 'Id': l.Id });
            }
        });
        this._lineItems.next([...this.lineItems]);
    }
    /**
     * @ignore
     */
    removeAllLineitems() {
        this.lineItems = [];
        this._lineItems.next([]);
    }
    /**
     * Adds a list of cart items to drawer selection.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private batchSelectionService: BatchSelectionService){}
     
         setSelectedLineItems(lineItems: Array<CartItem>){
              this.batchSelectionService.setSelectedLineItems(lineItems);
         }
     }
     ```
     * @param lineItems List of cart items to be added to drawer selection.
     */
    setSelectedLineItems(lineItems) {
        this.lineItems = lineItems;
        this._lineItems.next([...this.lineItems]);
    }
    /**
     * Gets the list of currently selected lineItem.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         lineItems: CartItem;
         lineItems$: Observable<Array<CartItem>>;
         constructor(private batchSelectionService: BatchSelectionService){}
     
         getSelectedLineItems(){
              this.batchSelectionService.getSelectedLineItems().subscribe((res)=> this.lineItems = res);
               // or
              this.lineItems$ = this.batchSelectionService.getSelectedLineItems();
         }
     }
     ```
     * @returns Observable<Array<CartItem>> return an array list of cart items.
     */
    getSelectedLineItems() {
        return this._lineItems;
    }
    /**
     * Checks if the given lineItem is part of the selected lineItem list.
     * ### Example:
     ```typescript
     import { BatchSelectionService, Product } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
      isLineItemSelected:boolean;
         constructor(private batchSelectionService: BatchSelectionService){}
     
         isLineItemSelected(lineItems: Array<CartItem>){
              this.batchSelectionService.isLineItemSelected(lineItems).subscribe((res)=> this.isLineItemSelected=res);
         }
     }
     ```
     * @param lineItem lineItem to check against the list of selected lineItems.
     * @returns an observable of type boolean.
     */
    isLineItemSelected(lineItem) {
        return of(!!find(this.lineItems, { Id: lineItem.Id }));
    }
    /**
     * @ignore
     */
    updateLineItemSelections(items) {
        const nonExistingSelections = filter$1(this._lineItems.value, li => !includes(map$1(items, item => item.Id), li.Id));
        map$1(nonExistingSelections, selection => this.removeLineItemFromSelection(selection));
    }
    ngOnDestroy() {
        if (this.cartSubscription)
            this.cartSubscription.unsubscribe();
    }
}
BatchSelectionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchSelectionService, deps: [{ token: i1.CartService }, { token: i1.PriceListService }], target: i0.ɵɵFactoryTarget.Injectable });
BatchSelectionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchSelectionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchSelectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.PriceListService }]; } });

/**
 * Favorite modal lets you add products/cart line items from the drawer to the Favorite Configuration.
 * The modal provides option to choose from existing favorites or allow
 * users to create new favorite and add/update items to the favorite configuartion.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/favorite%20modal.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 * ```typescript
import { FavoriteModalModule } from '@congacommerce/elements';
@NgModule({
  imports: [FavoriteModalModule, ...]
})
export class AppModule {}
 ```
*
* @example
 ```typescript
* <apt-favorite-modal></apt-favorite-modal>
 ```
*/
class FavoriteModalComponent {
    constructor(modalRef, plService, userService, exceptionService, favService) {
        this.modalRef = modalRef;
        this.plService = plService;
        this.userService = userService;
        this.exceptionService = exceptionService;
        this.favService = favService;
        /**
        * @ignore
        * */
        this.favorite = new Favorite();
        this.lookupResults = [];
        this.view$ = new BehaviorSubject(null);
        this.layout = 'AddExistingFav';
        this.loading = false;
        this.lookUpLoading = false;
        this.lookupOptions = {
            primaryTextField: 'Name',
            fieldList: ['Id', 'Name'],
        };
    }
    ngOnInit() {
        this.setFavLookupFieldData();
        if (this.view$) {
            this.sub = this.view$.subscribe((r) => {
                if (r && r.length === 0)
                    this.layout = 'AddNewFav';
            });
        }
    }
    /**
     * @ignore
     * */
    onLookupSearch(data) {
        this.favoriteName = get(data, 'term');
        this.setFavLookupFieldData(get(data, 'term'));
    }
    /**
     * @ignore
     * */
    setFavLookupFieldData(searchString = '') {
        this.searchTerm =
            searchString.trim().length > 0
                ? `'${searchString.trim()}'`
                : searchString.trim();
        this.lookUpLoading = true;
        let options = {
            conditions: null,
            expressionOperator: 'AND',
            filters: null,
            sortOrder: null,
            fieldList: ['Name', 'Id']
        };
        if (searchString)
            options['searchString'] = searchString;
        let recordObsv$ = of(null);
        if (!isNil(this.value))
            recordObsv$ = this.favService.fetch(this.value);
        combineLatest([this.userService.getCurrentUser(), this.plService.getPriceListId()])
            .pipe(switchMap(([user, plId]) => {
            let filters = [];
            filters.push(new AFilter(this.favService.type, [
                new ACondition(this.favService.type, 'Scope', 'Equal', 'Private'),
                new ACondition(this.favService.type, 'CreatedById', 'Equal', get(user, 'Id')),
                new ACondition(this.favService.type, 'OwnerId', 'Equal', get(user, 'Id'))
            ], null, 'AND'));
            filters.push(new AFilter(this.favService.type, [
                new ACondition(this.favService.type, 'Scope', 'Equal', 'Public')
            ], null, 'AND'));
            options.filters = [new AFilter(this.favService.type, null, filters, 'OR')];
            const obsv$ = !this.lookupResults || this.lookupResults.length === 0
                ? this.favService.query(assign(options))
                : of(this.lookupResults);
            return combineLatest([obsv$, recordObsv$]);
        }), take(1))
            .subscribe(([results, record]) => {
            this.lookUpLoading = false;
            if (!isNil(record) && !isEmpty(results))
                results.unshift(record);
            this.lookupResults = results;
            this.view$.next(this.lookupResults);
        }, (err) => {
            this.lookUpLoading = false;
            this.view$.next(null);
        });
    }
    /**
     * Method Addfavorite is responsible for adding the products or lineitems
     * to the already existing Favorite configuration from the drawer.
     * @fires this.favService.addFavorite.
    * */
    addFavorite() {
        this.loading = true;
        const payload = this.generatePayload();
        this.favService
            .addFavorite(this.value, payload)
            .pipe(take(1))
            .subscribe((succ) => {
            this.loading = false;
            this.modalRef.hide();
            const result = this.lookupResults.find(r => r.Id === this.value);
            this.exceptionService.showSuccess('SUCCESS.FAVORITE.UPDATE_FAVORITE', 'SUCCESS.TITLE', { name: result.Name });
        }, (err) => {
            this.loading = false;
            this.modalRef.hide();
            console.log(err);
        });
    }
    /**
     * Method createFavorite is responsible for creating new favorite and
     * adding the products or lineitems to the newly created favorite configuration.
     * @fires this.favService.createFavorite
     * @fires this.favService.addFavorite
    * */
    createFavorite() {
        this.loading = true;
        this.plService
            .getPriceListId()
            .pipe(switchMap((pId) => {
            if (!this.favorite.Scope)
                this.favorite.Scope = 'Private';
            this.favorite.PriceListId = pId;
            this.favorite.Name = this.favoriteName;
            return this.favService.createFavorite([this.favorite]);
        }), switchMap((fav) => {
            this.favorite = fav;
            const payload = this.generatePayload();
            return this.favService.addFavorite(fav.Id, payload);
        }), take(1))
            .subscribe((succ) => {
            this.loading = false;
            this.modalRef.hide();
            this.exceptionService.showSuccess('SUCCESS.FAVORITE.ADD_FAVORITE', 'SUCCESS.TITLE', { name: this.favorite.Name });
        }, (err) => {
            this.loading = false;
            this.modalRef.hide();
            console.log(err);
        });
    }
    /**
     * @ignore
     */
    generatePayload() {
        let payload = [];
        if (this._items[0] instanceof CartItem)
            payload = map$1(this._items, 'LineNumber');
        if (this._items[0] instanceof Product) {
            payload = map$1(this._items, (item) => ({
                ProductId: item.Id,
                Quantity: item.Quantity ? item.Quantity : 1,
            }));
        }
        return payload;
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
FavoriteModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalComponent, deps: [{ token: i1$2.BsModalRef }, { token: i1.PriceListService }, { token: i1.UserService }, { token: ExceptionService }, { token: i1.FavoriteService }], target: i0.ɵɵFactoryTarget.Component });
FavoriteModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: FavoriteModalComponent, selector: "apt-favorite-modal", ngImport: i0, template: "<div>\r\n    <div class=\"modal-header\">\r\n        <h4 class=\"modal-title d-flex align-items-center m-0 text-truncate\">\r\n            {{ \"FAVORITE.FAVORITE_MODAL.ADD_FAVORITE\" | translate }}\r\n        </h4>\r\n        <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <ng-container [ngSwitch]=\"layout\">\r\n        <ng-container *ngSwitchCase=\"'AddExistingFav'\">\r\n            <ng-container *ngTemplateOutlet=\"AddExistingFav;\"></ng-container>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'AddNewFav'\">\r\n            <ng-container *ngTemplateOutlet=\"AddNewFav;\"></ng-container>\r\n        </ng-container>\r\n    </ng-container>\r\n</div>\r\n\r\n<ng-template #AddExistingFav>\r\n    <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n            <div class=\"col-12 col-md-12\">\r\n                <div class=\"form-group\">\r\n                    <label [class.col-form-label-sm]=\"small\"\r\n                        class=\"font-weight-bold\">{{'FAVORITE.FAVORITE_MODAL.SEARCH_OR_ADD_FAV' | translate}}</label>\r\n                    <ng-select class=\"form-control aptFavLookup p-0\" [class.form-control-sm]=\"small\" [(ngModel)]=\"value\"\r\n                        [items]=\"lookupResults\" bindLabel=\"Name\" (search)=\"onLookupSearch($event)\" bindValue=\"Id\"\r\n                        bindLabel=\"Name\" placeholder=\"{{'FAVORITE.FAVORITE_MODAL.ENTER_FAVORITE_NAME' | translate}}\"\r\n                        [loading]=\"lookUpLoading\"\r\n                        [ngClass]=\"{ 'is-invalid': select.invalid && (select.touched || select.dirty) }\"\r\n                        (clear)=\"setFavLookupFieldData()\" (focus)=\"setFavLookupFieldData()\" #select=\"ngModel\">\r\n                        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"search\">\r\n                            <div class=\"d-flex align-items-center\">\r\n                                <div class=\"d-flex flex-column h-100 justify-content-around\">\r\n                                    <span [ngOptionHighlight]=\"search\">{{item['Name']}}</span>\r\n                                    <i class=\"small\" *ngIf=\"lookupOptions?.secondaryTextField\">{{item['Name']}}</i>\r\n                                </div>\r\n                            </div>\r\n                        </ng-template>\r\n                        <ng-template ng-footer-tmp let-search=\"search\">\r\n                            <button type=\"button\" class=\"btn btn-link\" (click)=\"layout = 'AddNewFav'\">\r\n                                <small class=\"d-block\">\r\n                                    <i class=\"fa fa-plus mr-2\" aria-hidden=\"true\"></i>\r\n                                    <small\r\n                                        [innerHTML]=\"'FAVORITE.FAVORITE_MODAL.ADD_NEW_FAVORITE' | translate: {search: searchTerm}\"></small>\r\n                                </small>\r\n                            </button>\r\n                        </ng-template>\r\n                        <ng-template ng-loadingspinner-tmp>\r\n                            <apt-spinner></apt-spinner>\r\n                        </ng-template>\r\n                    </ng-select>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <div class=\"form-group d-flex justify-content-end\">\r\n            <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"addFavorite()\" [disabled]=\"!value\"\r\n                [ladda]=\"loading\" data-style=\"zoom-in\">{{ \"COMMON.UPDATE\" | translate }}</button>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n<ng-template #AddNewFav>\r\n    <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n            <div class=\"col-12 col-md-12\">\r\n                <div class=\"form-group\">\r\n                    <apt-input-field [entity]=\"favorite\" [field]=\"'Name'\" [(ngModel)]=\"favoriteName\" [label]=\"'Name'\">\r\n                    </apt-input-field>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <apt-input-field [entity]=\"favorite\" [field]=\"'Description'\" [(ngModel)]=\"favorite.Description\">\r\n                    </apt-input-field>\r\n                </div>\r\n                <div class=\"form-group custom-control custom-checkbox pl-3\">\r\n                    <input type=\"checkbox\" [checked]=\"fav_checked\" id=\"favScope\" class=\"custom-control-input\"\r\n                        [(ngModel)]=\"fav_checked\"\r\n                        (ngModelChange)=\"fav_checked ? favorite.Scope = 'Public': favorite.Scope = 'Private'\">\r\n                    <label class=\"ml-2 custom-control-label\"\r\n                        for=\"favScope\">{{'FAVORITE.FAVORITE_MODAL.MAKE_PUBLICLY_VISIBILE' | translate}}</label>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <div class=\"form-group d-flex justify-content-end\">\r\n            <button *ngIf=\"lookupResults.length > 0\" class=\"btn btn-link btn-raised\" type=\"button\"\r\n                (click)=\"layout = 'AddExistingFav'\" data-style=\"zoom-in\">\r\n                {{ 'FAVORITE.FAVORITE_MODAL.ADD_TO_EXISTING' | translate }}\r\n            </button>\r\n            <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"createFavorite()\" [ladda]=\"loading\"\r\n                data-style=\"zoom-in\">\r\n                {{ 'FAVORITE.FAVORITE_MODAL.ADD_FAVORITE' | translate }}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</ng-template>", styles: [".ng-select.aptFavLookup{font-size:14px}.ng-select.aptFavLookup.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:transparent;box-shadow:none}.ng-select.aptFavLookup .ng-select-container{background-color:transparent;border-radius:0;min-height:34px;height:34px;border-width:0px}.ng-select.aptFavLookup .ng-select-container .ng-arrow-wrapper{display:none}.ng-select.aptFavLookup .ng-select-container apt-spinner svg{width:18px;height:18px}.ng-select.aptFavLookup .ng-select-container .ng-clear-wrapper{width:24px;height:24px}.ng-select.aptFavLookup .ng-select-container .ng-clear-wrapper:hover .ng-clear{opacity:1}.ng-select.aptFavLookup .ng-select-container .ng-clear-wrapper .ng-clear{width:24px;height:24px;color:transparent;content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg fill='%23000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24' class='ng-scope'%3E%3Cpolygon points='20 5.611 18.389 4 12 10.389 5.611 4 4 5.611 10.389 12 4 18.389 5.611 20 12 13.611 18.389 20 20 18.389 13.611 12'%3E%3C/polygon%3E%3C/svg%3E\");opacity:.5}.ng-select.aptFavLookup .ng-select-container:before{width:24px;height:24px;content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg fill='%23000' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24' class='ng-scope'%3E%3Cpath d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'%3E%3C/path%3E%3C/svg%3E\")}.ng-select.aptFavLookup.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-left:34px;padding-right:36px}.ng-select.aptFavLookup.ng-select-single .ng-select-container .ng-value-container .ng-input>input{cursor:text}.ng-select.aptFavLookup.contacts .ng-dropdown-panel{bottom:auto!important}.ng-select.aptFavLookup .ng-dropdown-panel .ng-dropdown-header{font-size:12px;padding-left:14px;border:none}.ng-select.aptFavLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{min-height:40px;padding:4px 10px 4px 14px}.ng-select.aptFavLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .basicOption{line-height:32px}.ng-select.aptFavLookup .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .contactOption{height:56px}\n"], components: [{ type: i4.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }, { type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }], directives: [{ type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.ɵf, selector: "[ng-option-tmp]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.ɵk, selector: "[ng-footer-tmp]" }, { type: i4.ɵp, selector: "[ng-loadingspinner-tmp]" }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }], pipes: { "translate": i2$1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-favorite-modal',
                    templateUrl: './favorite-modal.component.html',
                    styleUrls: ['./favorite-modal.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalRef }, { type: i1.PriceListService }, { type: i1.UserService }, { type: ExceptionService }, { type: i1.FavoriteService }]; } });

/**
 * Favorite modal service is used to open favorite modals.
 * @ignore
 */
class FavoriteModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    /**
     * Opens the Add Existing /Add New Favorite in the modal.
     * @param items accepts list of Product or cartItems.
     */
    openExistingFavModal(items) {
        this.modalService.show(FavoriteModalComponent, { initialState: { _items: items }, class: 'modal-md' });
    }
}
FavoriteModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalService, deps: [{ token: i1$2.BsModalService }], target: i0.ɵɵFactoryTarget.Injectable });
FavoriteModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalService }]; } });

/**
 * @ignore
 */
/**
 * Batch Action service is used to create and filter batch actions.
 */
class BatchActionService {
    constructor(config, BatchSelectionService, router, cartService, storefrontService, translateService, userService, favModalService) {
        this.config = config;
        this.BatchSelectionService = BatchSelectionService;
        this.router = router;
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        this.translateService = translateService;
        this.userService = userService;
        this.favModalService = favModalService;
        /**
         * Array of batch actions to subscribe to.
         */
        this._batchActions = new BehaviorSubject([]);
        /**
         * Array of asset batch actions to subscribe to.
         */
        this._assetBatchActions = new BehaviorSubject([]);
        /**
         * Current subscriptions in this class.
         * @ignore
         */
        this.subs = [];
        /**
         * Flag for if ABO is enabled on the storefront.
         */
        this.AboEnabled = false;
        /**
         * Flag for if Show Favorites to enable or not.
         * */
        this.showFavorites = false;
        /**
         * The product identifier set in the configuration file.
         */
        /**@ignore */
        this.isGuest = false;
        this.identifier = 'Id';
        /**
         * flag to set preloader on action in process
         */
        this.loading$ = new BehaviorSubject(false);
        /**
         * Constant values for batch actions
         */
        this._renew = 'Renew';
        this._terminate = 'Terminate';
        this._buyMore = 'Buy More';
        this._changeConfiguration = 'Change Configuration';
        this._compare = 'Compare';
        this._saveFavorite = 'Save Favorite';
        this._clone = 'Clone';
        /**
         * Array of batch action keys that are enabled.
         */
        this.enabledActions = [];
        /**
         * Actions that are mapped to string representations of each batch action.
         */
        this.actionMap = {
            [this._buyMore]: new BatchAction(this._buyMore, null, null),
            [this._changeConfiguration]: new BatchAction(this._changeConfiguration, null, null),
            [this._renew]: new BatchAction(this._renew, 'loop-circular', this.renew.bind(this, [this.router])),
            [this._terminate]: new BatchAction(this._terminate, 'circle-x', this.terminate.bind(this, [this.router])),
            [this._buyMore]: new BatchAction(this._buyMore, 'circle-x', this.buyMore.bind(this, [this.router])),
            [this._changeConfiguration]: new BatchAction(this._changeConfiguration, 'circle-x', this.changeConfiguration.bind(this, [this.router])),
            [this._compare]: new BatchAction(this._compare, 'transfer', this.compare.bind(this, [this.router])),
            [this._saveFavorite]: new BatchAction(this._saveFavorite, 'circle-x', this.saveFavorite.bind(this, [this.router])),
            [this._clone]: new BatchAction(this._clone, 'circle-x', this.clone.bind(this, [this.router]))
        };
        this.identifier = this.config.get('productIdentifier');
        this.subs.push(combineLatest([this.storefrontService.getStorefront(), this.storefrontService.isFavoriteDisabled(), this.userService.isGuest()])
            .subscribe(([storefront, isFavoriteDisabled, isGuest]) => {
            this.AboEnabled = get(storefront, 'EnableABO', false);
            this.enabledActions = (this.AboEnabled && get(storefront, 'AssetActions')) ? get(storefront, 'AssetActions', '').split(';') : [];
            this.showFavorites = isFavoriteDisabled;
            this.isGuest = isGuest;
        }));
        this.activateProductActions();
        this.activateCartitemActions();
    }
    /**
     * @ignore
     */
    isLoading() {
        return this.loading$;
    }
    /**
     * Refresh Product actions when activating product pill
     * @ignore
     */
    activateProductActions() {
        if (this.productSubscription)
            this.productSubscription.unsubscribe();
        this.productSubscription = this.BatchSelectionService.getSelectedProducts().subscribe(products => {
            this.filterBatchActions(products);
            this.products = products;
        });
    }
    /**
     * Refresh cart item actions when activating cart item pill
     * @ignore
     */
    activateCartitemActions() {
        if (this.cartItemSubscription)
            this.cartItemSubscription.unsubscribe();
        this.cartItemSubscription = this.BatchSelectionService.getSelectedLineItems().subscribe(cartItems => {
            this.filterBatchActions(cartItems);
            this.cartItems = cartItems;
        });
    }
    /**
     * Filters the batch actions based on the currently selected products.
     * @param products The array of selected products used to filter batch actions.
     * @ignore
     */
    filterBatchActions(items) {
        Object.keys(this.actionMap).forEach(key => this.actionMap[key].setDisabled(true));
        Object.keys(this.actionMap).forEach(key => this.actionMap[key].setVisible(false));
        const currentActions = [];
        if (items[0] instanceof Product) {
            if (items.length > 1) {
                if (items.length < 6) {
                    let productMissingFeatures = false;
                    items.forEach(product => {
                        if (get(product, 'ProductFeatureValues')) {
                            if (get(product, 'ProductFeatureValues').length < 1)
                                productMissingFeatures = true;
                        }
                        else
                            productMissingFeatures = true;
                    });
                    if (productMissingFeatures)
                        this.actionMap[this._compare].setDisabled(true);
                    else
                        this.actionMap[this._compare].setDisabled(false);
                }
                else {
                    this.actionMap[this._compare].setDisabled(true);
                }
            }
            else {
                this.actionMap[this._compare].setDisabled(true);
            }
            this.actionMap[this._compare].setVisible(true);
            currentActions.push(this.actionMap[this._compare]);
            currentActions.push(this.filterRenewAction(items));
            currentActions.push(this.filterTerminateAction(items));
        }
        else if (items[0] instanceof CartItem) {
            if (items.length > 0) {
                this.actionMap[this._clone].setDisabled(false);
                this.actionMap[this._clone].setVisible(true);
                currentActions.push(this.actionMap[this._clone]);
            }
        }
        this.actionMap[this._saveFavorite].setVisible(true);
        if (!this.isGuest) {
            if (this.showFavorites) {
                this.actionMap[this._saveFavorite].setDisabled(true);
            }
            else {
                this.actionMap[this._saveFavorite].setDisabled(false);
            }
        }
        currentActions.push(this.actionMap[this._saveFavorite]);
        this._batchActions.next(currentActions);
    }
    /**
     * Filters the renew actions based on the currently selected products.
     * @param products Products to be filtered.
     * @ignore
     */
    filterRenewAction(products) {
        if (this.enabledActions.includes(this._renew)) {
            this.actionMap[this._renew].setVisible(true);
            if (products.length > 1) {
                if (products.length < 6) {
                    this.actionMap[this._renew].setDisabled(!this.isSubscriptionProduct(products));
                    if (this.actionMap[this._renew].isDisabled()) {
                        this.translateService.stream('SERVICES.ONE_OR_MORE_ITEMS_CANNOT_RENEW').subscribe((translatedValue) => {
                            this.actionMap[this._renew].setTooltipText(translatedValue);
                        });
                    }
                }
                else {
                    this.actionMap[this._renew].setDisabled(true);
                    this.translateService.stream('SERVICES.TOO_MANY_PRODUCTS_SELECTED_TO_RENEW_TOOLTIP').subscribe((val) => {
                        this.actionMap[this._renew].setTooltipText(val);
                    });
                }
            }
            else {
                this.actionMap[this._renew].setDisabled(true);
                this.translateService.stream('SERVICES.SELECT_MORE_PRODUCTS_TO_RENEW_TOOLTIP').subscribe((val) => {
                    this.actionMap[this._renew].setTooltipText(val);
                });
            }
        }
        return this.actionMap[this._renew];
    }
    /**
    * Filters the terminate actions based on the currently selected products.
    * @param products Products to be filtered.
    * @returns List of Terminate Actions
    * @ignore
    */
    filterTerminateAction(products) {
        if (this.enabledActions.some(terminateAction => terminateAction === this._terminate)) {
            this.actionMap[this._terminate].setVisible(true);
            if (products.length > 1) {
                if (products.length < 6) {
                    this.actionMap[this._terminate].setDisabled(!this.isSubscriptionProduct(products));
                    this.translateService.stream('SERVICES.UNABLE_TO_TERMINATE_TOOLTIP').subscribe((val) => {
                        this.actionMap[this._terminate].setTooltipText(val);
                    });
                }
                else {
                    this.actionMap[this._terminate].setDisabled(true);
                    this.translateService.stream('SERVICES.TOO_MANY_PRODUCTS_SELECTED_TO_TERMINATE_TOOLTIP').subscribe((val) => {
                        this.actionMap[this._terminate].setTooltipText(val);
                    });
                }
            }
            else {
                this.actionMap[this._terminate].setDisabled(true);
                this.translateService.stream('SERVICES.SELECT_MORE_PRODUCTS_TO_TERMINATE_TOOLTIP').subscribe((val) => {
                    this.actionMap[this._terminate].setTooltipText(val);
                });
            }
        }
        return this.actionMap[this._terminate];
    }
    /**
     * Checks if the given products are able to be renewed or terminated.
     * @param products Array of products to check.
     * @returns boolean
     * @ignore
     */
    isSubscriptionProduct(products) {
        return every(products, product => 
        // The product has asset line items
        !isEmpty(get(product, 'AssetLineItems'))
            // and some asset line items can be renewed or terminated
            && some(get(product, 'AssetLineItems', []), (asset) => {
                return invoke(asset, 'canRenew') || invoke(asset, 'canTerminate');
            }));
    }
    /**
     * Gets the current batch actions observable.
     * @returns Observable array of batch action objects.
     */
    getBatchActions() {
        return this._batchActions;
    }
    /**
    * Renew selected products.
    * @param router Instance of the router
    * @param products Array of selected products
    * @ignore
    */
    renew(router, products) {
        const productIdentifier = products.map(product => product[this.identifier]);
        this.router.navigate(['/assets'], { queryParams: { action: 'Renew', productIds: encodeURIComponent(productIdentifier.join(',')) } });
    }
    /**
     * Terminate selected products.
     * @param router Instance of the router
     * @param products Array of selected products
     * @ignore
     */
    terminate(router, products) {
        const productIdentifier = products.map(product => product[this.identifier]);
        this.router.navigate(['/assets'], { queryParams: { action: 'Terminate', productIds: encodeURIComponent(productIdentifier.join(',')) } });
    }
    /**
     * Buy more products.
     * @param router Instance of the router
     * @param products Array of selected product
     * @ignore
     */
    buyMore(router, products) {
        const productIdentifier = products.map(product => product[this.identifier]);
        this.router.navigate(['/assets'], { queryParams: { action: encodeURIComponent('Buy More'), productIds: encodeURIComponent(productIdentifier.join(',')) } });
    }
    /**
     * Change configuration of products.
     * @param router Instance of the router
     * @param products Array of selected product, usually this in single product
     * @ignore
     */
    changeConfiguration(router, products) {
        // change configuration does not have a mass action at this time.
    }
    /**
     * @ignore
     */
    addToCart(products) {
        console.log('Adding products to cart', products);
    }
    /**
     * Compares selected products.
     * @param router Instance of the router
     * @param products Array of selected products
     * @ignore
     */
    compare(router, products) {
        const productIdentifier = products.map(product => product[this.identifier]);
        this.router.navigateByUrl(`/products/compare?products=${productIdentifier.join(',')}`);
    }
    /**
     * Save Favorite products or cartItems.
     * @param router Instance of the router
     * @param items Array of selected items(Products/CartItems)
     * @ignore
     */
    saveFavorite(router, items) {
        this.favModalService.openExistingFavModal(items);
    }
    /**
     * Clone primary line Items.
     * @param router Instance of the router
     * @param items Array of selected CartItems
     * @ignore
     */
    clone(router, items) {
        this.loading$.next(true);
        this.subs.push(this.cartService.clonePrimaryLines(items).subscribe(res => {
            this.loading$.next(false);
        }));
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
        this.productSubscription.unsubscribe();
        this.cartItemSubscription.unsubscribe();
    }
}
BatchActionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchActionService, deps: [{ token: i1$1.ConfigurationService }, { token: BatchSelectionService }, { token: i4$1.Router }, { token: i1.CartService }, { token: i1.StorefrontService }, { token: i2$1.TranslateService }, { token: i1.UserService }, { token: FavoriteModalService }], target: i0.ɵɵFactoryTarget.Injectable });
BatchActionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchActionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchActionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ConfigurationService }, { type: BatchSelectionService }, { type: i4$1.Router }, { type: i1.CartService }, { type: i1.StorefrontService }, { type: i2$1.TranslateService }, { type: i1.UserService }, { type: FavoriteModalService }]; } });

/**
 * Product configuration summary component is used to show the hierarchical view of the selected configurations for a given cart/order line item in a modal window.
 * The view is a tree like structure containing selected attributes and values within attribute groups, selected options/attributes within option groups, nested at different levels in the hierarchy.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productConfigSummary.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductConfigurationSummaryModule } from '@congacommerce/elements';
 @NgModule({
  imports: [ProductConfigurationSummaryModule, ...]
})
 export class AppModule {}
 ```
 *
 * @example
 * // Basic Usage
 ```typescript
 * <apt-product-configuration-summary [product]="product"></apt-product-configuration-summary>
 ```
 *
 * // All inputs and outputs.
 ```typescript
 * <apt-product-configuration-summary
 *             [product]="product"
 *             [relatedTo]="lineItem"
 *             [changes]="lineItems"
 *             [preload]="true"
 *             [position]="'top'"
 *             (onProductAdd)="closeModal()"
 *             (onNavigate)="closeModal()">
 * </apt-product-configuration-summary>
 ```
 */
class ProductConfigurationSummaryComponent {
    constructor(productOptionService, cartService, router, cacheService, ngZone, exceptionService) {
        this.productOptionService = productOptionService;
        this.cartService = cartService;
        this.router = router;
        this.cacheService = cacheService;
        this.ngZone = ngZone;
        this.exceptionService = exceptionService;
        /**
         * Will preload the data for the configuration component before showing to speed up initial render
         */
        this.preload = false;
        /**
         * Sets the position.
         */
        this.position = 'middle';
        /**
         * Quantity selected of this product used for adding to cart.
         */
        this.quantity = 1;
        /**
         * Boolean to show action buttons on configuration component.
         */
        this.showActionButtons = true;
        /**
         * Event emitter for when a product is added to cart.
         */
        this.onProductAdd = new EventEmitter();
        /**
         * Event emitter for when user navigates from summary.
         */
        this.onNavigate = new EventEmitter();
        /** @ignore */
        this.addLoading = false;
        /** @ignore */
        this.product$ = new BehaviorSubject(null);
        /** @ignore */
        this.filter = 'items';
        /** @ignore */
        this.isOrderLineItem = false;
        /** @ignore */
        this.isQuoteLineItem = false;
    }
    /** @ignore */
    get uuid() {
        if (!this._uuid)
            _.set(this, '_uuid', 'a' + this.cacheService.guid());
        return _.get(this, '_uuid');
    }
    ngOnChanges() {
        if (this.showActionButtons) {
            if (this.relatedTo instanceof CartItem && !_.includes(['Renewed', 'Cancelled', 'Incremented'], this.relatedTo.LineStatus)) {
                this.actionButton = {
                    label: 'PRODUCT_CARD.CHANGE_CONFIGURATION',
                    action: _.bind(this.changeConfiguration, this),
                    style: 'btn-outline-primary'
                };
            }
            else if (_.isNil(this.relatedTo)) {
                this.actionButton = {
                    label: 'COMMON.ADD_TO_CART',
                    action: _.bind(this.addToCart, this, _.get(this, 'quantity', 1)),
                    style: 'btn-primary'
                };
                this.secondaryButton = {
                    label: 'PRODUCT_CARD.CHANGE_CONFIGURATION',
                    action: _.bind(this.changeConfiguration, this),
                    style: 'btn-link'
                };
            }
        }
        if (!_.isNil(this.product$.value) || this.preload === true)
            this.setProduct();
        this.isOrderLineItem = this.relatedTo && this.relatedTo instanceof OrderLineItem;
        this.isQuoteLineItem = this.relatedTo && this.relatedTo instanceof QuoteLineItem;
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    /** @ignore */
    setProduct() {
        this.product$.next(null);
        this.ngOnDestroy();
        this.subscription = this.productOptionService.getProductOptionTree(_.get(this, 'product.Id', this.product), this.relatedTo, this.filter, this.changes)
            .subscribe(product => {
            this.product$.next(product);
        });
        this.cartItems = _.filter(_.get(this, 'changes', []), c => c instanceof CartItem);
        this.optionItems = _.filter(_.get(this, 'changes', []), c => c instanceof CartItem && _.get(c, 'LineType') === 'Option');
        this.cartItem = _.find(_.get(this, 'changes', []), c => _.get(c, 'LineType') === 'Product/Service');
    }
    /**
     * @ignore
     */
    isLineItem() {
        return this.relatedTo instanceof CartItem;
    }
    /**
     * @ignore
     */
    hasChangeConfiguration() {
        return !(this.relatedTo instanceof OrderLineItem || this.relatedTo instanceof QuoteLineItem);
    }
    /**
     * Method to add the bundled product or standalone product with attributes to the cart.
     * This method will add default configurations of the product.
     * @ignore
     */
    addToCart(quantity, product) {
        this.addLoading = true;
        this.cartService.addProductToCart(product, quantity)
            .subscribe(res => {
            this.hide();
            this.addLoading = false;
            if (!_.isEmpty(res)) {
                this.exceptionService.showSuccess('SUCCESS.CART.ITEM_ADDED_TOASTR_MESSAGE', 'SUCCESS.CART.ITEM_ADDED_TOASTR_TITLE', { productName: product.Name });
                this.onProductAdd.emit();
            }
        }, err => this.addLoading = false);
    }
    /** @ignore */
    changeConfiguration(product) {
        if (!_.isNil(_.get(this, 'relatedTo')))
            this.router.navigate(['/products', _.get(product, 'Id'), _.get(this, 'relatedTo.Id')], { state: this.product });
        else
            this.router.navigate(['/products', _.get(product, 'Id')], { state: this.product });
    }
    /** @ignore */
    show(quantity) {
        if (_.isNil(this.product$.value))
            this.setProduct();
        this.quantity = quantity;
        this.summaryModal.show();
    }
    /** @ignore */
    trackById(index, record) {
        return _.get(record, 'Id');
    }
    /** @ignore */
    hide() {
        this.summaryModal.hide();
    }
}
ProductConfigurationSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationSummaryComponent, deps: [{ token: i1.ProductOptionService }, { token: i1.CartService }, { token: i4$1.Router }, { token: i1$1.CacheService }, { token: i0.NgZone }, { token: ExceptionService }], target: i0.ɵɵFactoryTarget.Component });
ProductConfigurationSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductConfigurationSummaryComponent, selector: "apt-product-configuration-summary", inputs: { product: "product", relatedTo: "relatedTo", changes: "changes", preload: "preload", position: "position", quantity: "quantity", showActionButtons: "showActionButtons" }, outputs: { onProductAdd: "onProductAdd", onNavigate: "onNavigate" }, viewQueries: [{ propertyName: "summaryModal", first: true, predicate: ["summaryModal"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div bsModal #summaryModal=\"bs-modal\" class=\"modal fade\" [ngClass]=\"position\" tabindex=\"-1\" role=\"dialog\"\r\n  aria-labelledby=\"dialog-sizes-name1\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content overflow-auto\" *ngIf=\"product$ | async as product; else loading\">\r\n\r\n\r\n      <!-- -->\r\n      <div class=\"p-0 mx-4 mt-3\" *ngIf=\"position === 'middle'\">\r\n        <div class=\"align-items-center border-bottom border-secondary d-flex justify-content-between pb-3\">\r\n          <h5 class=\"modal-title font-weight-normal\">\r\n            {{'COMMON.PRODUCT_CONFIGURATION' | translate}}\r\n          </h5>\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </div>\r\n\r\n\r\n        <div class=\"bg-light d-flex justify-content-between p-3\">\r\n          <div class=\"flex-grow-1\">\r\n            <h4>{{product?.Name}}</h4>\r\n            <div class=\"text-muted\" [translate]=\"'PRODUCT_CONFIGURATION_SUMMARY.PRODUCT_ID'\"\r\n              [translateParams]=\"{productCode: product?.ProductCode}\" *ngIf=\"product.ProductCode\"></div>\r\n          </div>\r\n\r\n          <div class=\"border-left border-secondary d-flex align-items-center\">\r\n            <div class=\"px-4\">\r\n              <div class=\"text-muted mb-2\">\r\n                {{'COMMON.NET_PRICE' | translate}}\r\n              </div>\r\n              <h5 class=\"m-0\">\r\n                <apt-price *ngIf=\"changes?.length > 0; else relatedOrProductPrice\"\r\n                           [record]=\"changes\"\r\n                           [bundle]=\"true\"\r\n                           [quantity]=\"quantity\"\r\n                           type=\"net\"></apt-price>\r\n                <ng-template #relatedOrProductPrice>\r\n                  <apt-price *ngIf=\"relatedTo; else productPrice\"\r\n                             [record]=\"relatedTo\"\r\n                             [quantity]=\"quantity\"\r\n                             [bundle]=\"true\"\r\n                             type=\"net\"></apt-price>\r\n\r\n                  <ng-template #productPrice>\r\n                    <apt-price [record]=\"product\"\r\n                               [quantity]=\"quantity\"\r\n                               [bundle]=\"true\"\r\n                               type=\"net\"></apt-price>\r\n                  </ng-template>\r\n                </ng-template>\r\n              </h5>\r\n            </div>\r\n            <div class=\"d-flex align-items-center\">\r\n              <div *ngIf=\"secondaryButton\">\r\n                <button class=\"btn\" [ngClass]=\"secondaryButton?.style\"\r\n                  (click)=\"secondaryButton.action(product)\">{{secondaryButton.label | translate}}</button>\r\n              </div>\r\n              <div *ngIf=\"actionButton\">\r\n                <button class=\"btn ml-2 btn-raised\" [ngClass]=\"actionButton?.style\"\r\n                  (click)=\"actionButton.action(product)\" [ladda]=\"addLoading\"\r\n                  data-style=\"zoom-in\">{{actionButton.label | translate}}</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"p-0 mx-4 mt-3\" *ngIf=\"position === 'right'\">\r\n        <div class=\"align-items-center border-bottom border-secondary d-flex pb-3\">\r\n          <h5 class=\"modal-title font-weight-normal\">\r\n            <div>{{'COMMON.PRODUCT_CONFIGURATION' | translate}}</div>\r\n          </h5>\r\n          <div *ngIf=\"relatedTo\">\r\n            <select class=\"form-control ml-3 form-control-sm\" id=\"summary-filter\" name=\"summaryFilter\"\r\n              [(ngModel)]=\"filter\" (ngModelChange)=\"setProduct()\">\r\n              <option [value]=\"'items'\">{{'COMMON.ALL' | translate}}</option>\r\n              <option [value]=\"'changes'\">{{'COMMON.CHANGES_ONLY' | translate}}</option>\r\n            </select>\r\n          </div>\r\n          <button type=\"button\" class=\"close ml-auto\" aria-label=\"Close\" (click)=\"hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </div>\r\n\r\n        <div>\r\n          <div class=\"bg-light p-3 line-height-large\">\r\n            <div class=\"row\">\r\n              <strong class=\"col-7\">{{product?.Name}}</strong>\r\n              <div class=\"col-2\">{{'COMMON.QTY' | translate}}: 1</div>\r\n              <apt-price class=\"col-3 text-right\" [record]=\"product?._metadata?.item\" [type]=\"'net'\"></apt-price>\r\n            </div>\r\n            <div class=\"d-flex justify-content-between\">\r\n              <span>{{'COMMON.OPTION_TOTAL' | translate}}</span>\r\n              <apt-price [record]=\"optionItems\" [type]=\"'net'\"></apt-price>\r\n            </div>\r\n            <div class=\"d-flex border-top border-gray justify-content-between pt-3\">\r\n              <strong>{{'COMMON.NET_PRICE' | translate}}</strong>\r\n              <apt-price [record]=\"cartItems\" [type]=\"'net'\"></apt-price>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <h5 class=\"font-weight-normal mt-4\">\r\n          {{'COMMON.ITEMIZED_OPTIONS' | translate}}\r\n        </h5>\r\n      </div>\r\n\r\n\r\n      <div class=\"modal-body px-0 pt-0 mx-4\">\r\n        <ng-container *ngIf=\"product?.OptionGroups?.length > 0 || product?.AttributeGroups?.length > 0; else empty\">\r\n          <div class=\"h-100\">\r\n            <!-- Header -->\r\n\r\n\r\n            <!-- Main Accordion -->\r\n\r\n            <div class=\"accordion mt-3\" [id]=\"uuid + product?.Id\"\r\n              *ngIf=\"product?.AttributeGroups?.length > 0 || product?.OptionGroups?.length > 0\">\r\n\r\n              <!-- Top Level Attributes -->\r\n              <ng-container\r\n                *ngFor=\"let attributeGroupMember of product?.AttributeGroups; let x = index; let xf = first; trackBy: trackById\">\r\n                <ng-container *ngIf=\"attributeGroupMember?.AttributeGroup?.ProductAttributes?.length > 0\">\r\n                  <div class=\"bg-light border-top border-secondary\">\r\n                    <button class=\"btn btn-link chevron\" type=\"button\" data-toggle=\"collapse\"\r\n                      [attr.data-target]=\"'#' + uuid + attributeGroupMember.Id\" [attr.aria-expanded]=\"xf\">\r\n                      <strong class=\"ml-2\">{{attributeGroupMember?.AttributeGroup?.Name}}</strong>\r\n                    </button>\r\n\r\n                  </div>\r\n\r\n                  <div [id]=\"uuid + attributeGroupMember.Id\" class=\"collapse\" [class.show]=\"xf\"\r\n                    [attr.data-parent]=\"'#' + uuid + product?.Id\">\r\n                    <ng-container\r\n                      *ngFor=\"let attribute of attributeGroupMember?.AttributeGroup?.ProductAttributes; let l = last\">\r\n                      <div class=\"pt-2 px-3\" [class.border-bottom]=\"!l\" [class.border-gray]=\"!l\" *ngIf=\"product.get('item')?.AttributeValue[attribute.Field]\">\r\n                        <apt-output-field [record]=\"product?._metadata?.item?.AttributeValue\" [field]=\"attribute.Field\" [displayValue]=\"attribute.Field\"\r\n                          [editable]=\"false\" labelClass=\"font-italic font-weight-normal\" valueClass=\"font-weight-bold\">\r\n                        </apt-output-field>\r\n                      </div>\r\n                    </ng-container>\r\n                  </div>\r\n                </ng-container>\r\n              </ng-container>\r\n\r\n              <!-- Top Level Options-->\r\n              <div\r\n                *ngFor=\"let optionGroupMember of product.OptionGroups; let f = first; let i = index; trackBy: trackById\">\r\n                <ng-container *ngIf=\"!optionGroupMember?.IsHidden\">\r\n                  <div class=\"bg-light border-top border-secondary\">\r\n                    <button class=\"btn btn-link chevron\" type=\"button\" data-toggle=\"collapse\"\r\n                      [attr.data-target]=\"'#' + uuid + optionGroupMember.Id\"\r\n                      [attr.aria-expanded]=\"i + product?.AttributeGroups?.length === 0\">\r\n                      <strong class=\"ml-2\">{{optionGroupMember?.OptionGroup?.Label}}</strong>\r\n                    </button>\r\n                  </div>\r\n                  <div class=\"collapse\" [id]=\"uuid + optionGroupMember.Id\" [attr.data-parent]=\"'#' + uuid + product?.Id\"\r\n                    [class.show]=\"i + product?.AttributeGroups?.length === 0\">\r\n                    <div class=\"card-body\">\r\n                      <div class=\"accordion\" [id]=\"'child' + uuid + optionGroupMember.Id\">\r\n                        <div\r\n                          *ngFor=\"let productOptionGroup of optionGroupMember?.ChildOptionGroups; trackBy: trackById\"\r\n                          class=\"mb-3\">\r\n                          <ng-template *ngIf=\"!productOptionGroup?.IsHidden\" [ngTemplateOutlet]=\"productOptionGroupTemplate\"\r\n                            [ngTemplateOutletContext]=\"{productOptionGroup: productOptionGroup, parent: 'child' + uuid + optionGroupMember.Id}\">\r\n                          </ng-template>\r\n                        </div>\r\n\r\n                        <div *ngFor=\"let option of optionGroupMember?.Options; let f = first; trackBy: trackById\"\r\n                          class=\"mb-3\">\r\n                          <ng-template [ngTemplateOutlet]=\"optionTemplate\" [ngTemplateOutletContext]=\"{option: option\r\n                                  ,parent: 'child' + uuid + optionGroupMember.Id\r\n                                  ,expanded: f\r\n                                  , cartItem: option?.ComponentProduct?._metadata?.item}\">\r\n                          </ng-template>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n\r\n              <ng-template #productOptionGroupTemplate let-productOptionGroup=\"productOptionGroup\" let-parent=\"parent\">\r\n                <button class=\"btn btn-link p-0 minus text-capitalize text-dark\" data-toggle=\"collapse\"\r\n                  [attr.data-target]=\"'#' + parent + productOptionGroup.Id\" [attr.aria-expanded]=\"true\">\r\n                  <i>{{productOptionGroup?.OptionGroup?.Label}}</i>\r\n                </button>\r\n\r\n                <div [id]=\"parent + productOptionGroup.Id\" class=\"collapse\" [class.show]=\"true\"\r\n                  [attr.data-parent]=\"'#' + parent\">\r\n                  <div class=\"my-2 ml-3\"\r\n                    *ngFor=\"let component of productOptionGroup?.Options; let f = first; trackBy: trackById\">\r\n                    <ng-template [ngTemplateOutlet]=\"optionTemplate\"\r\n                      [ngTemplateOutletContext]=\"{option: component, parent: parent + productOptionGroup.Id, expanded: f, cartItem: component?.ComponentProduct?._metadata?.item}\">\r\n                    </ng-template>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n\r\n              <!-- Nested option template -->\r\n              <ng-template #optionTemplate let-option=\"option\" let-parent=\"parent\" let-expanded=\"expanded\"\r\n                let-cartItem=\"cartItem\">\r\n                <div class=\"d-flex justify-content-between border-bottom border-gray\" *ngIf=\"cartItem?.AssetStatus !== 'Cancelled'\">\r\n                  <div class=\"d-flex align-items-center text-truncate mb-1\">\r\n                    <button class=\"btn btn-link p-0 minus text-capitalize text-dark text-truncate btn-sm\"\r\n                      data-toggle=\"collapse\" [attr.data-target]=\"'#' + parent + option?.Id\"\r\n                      [attr.aria-expanded]=\"expanded\"\r\n                      *ngIf=\"option?.ComponentProduct?.OptionGroups?.length > 0 || option?.ComponentProduct?.AttributeGroups?.length > 0; else read\">\r\n                      {{option?.ComponentProduct?.Name}}\r\n                    </button>\r\n                    <ng-template #read>\r\n                      <div class=\"text-dark text-truncate\">\r\n                        {{option?.ComponentProduct?.Name}}\r\n                      </div>\r\n                    </ng-template>\r\n                    <ng-template [ngTemplateOutlet]=\"statusBadge\" [ngTemplateOutletContext]=\"{cartItem: cartItem}\"\r\n                      *ngIf=\"relatedTo?.AssetLineItemId || isOrderLineItem || isQuoteLineItem\"></ng-template>\r\n                  </div>\r\n                  <div class=\"d-flex flex-nowrap justify-content-between width-fixed mx-2\">\r\n                    <ng-container *ngIf=\"cartItem; else productPrice\">\r\n                      <div>\r\n                        {{'COMMON.QTY' | translate}}: {{cartItem?.Quantity}}\r\n                      </div>\r\n                      <div class=\"ml-auto\">\r\n                        <apt-price [record]=\"cartItem\" [quantity]=\"cartItem?.Quantity\"></apt-price>\r\n                      </div>\r\n                    </ng-container>\r\n                    <ng-template #productPrice>\r\n                      <div>\r\n                        {{'COMMON.QTY' | translate}}: {{(option?.DefaultQuantity) ? (option?.DefaultQuantity) : 1}}\r\n                      </div>\r\n                      <div class=\"ml-auto\">\r\n                        <apt-price [record]=\"option?.ComponentProduct\"\r\n                          [quantity]=\"(option?.DefaultQuantity) ? (option?.DefaultQuantity) : 1\"></apt-price>\r\n                      </div>\r\n                    </ng-template>\r\n                  </div>\r\n                </div>\r\n\r\n                <!-- Option Accordion -->\r\n                <div [id]=\"parent + option?.Id\" [attr.data-parent]=\"'#' + parent\"\r\n                  class=\"collapse pl-4 configuration accordion\" [class.show]=\"expanded\">\r\n                  <div\r\n                    *ngFor=\"let attributeGroupMember of option?.ComponentProduct?.AttributeGroups; let aIndex = index; let aFirst = first; trackBy: trackById\"\r\n                    class=\"mt-2\">\r\n                    <button class=\"btn btn-link p-0 minus text-capitalize text-dark\" data-toggle=\"collapse\"\r\n                      [attr.data-target]=\"'#' + option?.Id + attributeGroupMember.Id\" [attr.aria-expanded]=\"true\">\r\n                      <i>{{attributeGroupMember?.AttributeGroup?.Name}}</i>\r\n                    </button>\r\n\r\n                    <div [id]=\"option?.Id + attributeGroupMember.Id\" class=\"collapse\" [class.show]=\"true\"\r\n                      [attr.data-parent]=\"'#' + parent + option?.Id\">\r\n                      <div\r\n                        *ngFor=\"let attribute of attributeGroupMember?.AttributeGroup?.ProductAttributes; let l = last\">\r\n                        <div class=\"pt-2 px-3 border-bottom border-gray\" *ngIf=\"cartItem?.AttributeValue && cartItem?.AttributeValue[attribute.Field]\">\r\n                          <apt-output-field [record]=\"cartItem?.AttributeValue\" [field]=\"attribute.Field\" [displayValue]=\"attribute.Field\"\r\n                            [editable]=\"false\" labelClass=\"font-italic font-weight-normal\"\r\n                            valueClass=\"font-weight-bold\"></apt-output-field>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div\r\n                    *ngFor=\"let productOptionGroup of option.ComponentProduct?.OptionGroups; let oFirst = first; trackBy: trackById\"\r\n                    class=\"mt-3\">\r\n                    <ng-template *ngIf=\"!productOptionGroup?.IsHidden\" [ngTemplateOutlet]=\"productOptionGroupTemplate\"\r\n                      [ngTemplateOutletContext]=\"{productOptionGroup: productOptionGroup, parent: parent + option.Id}\">\r\n                    </ng-template>\r\n                  </div>\r\n                </div>\r\n\r\n              </ng-template>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #empty>\r\n          <div class=\"d-flex justify-content-center flex-column align-items-center py-5 my-5\">\r\n            <i class=\"fa fa-cog fa-5x text-primary xl text-faded\"></i>\r\n            <div class=\"mt-4\">{{'CONFIGURATION.EMPTY' | translate}}</div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n\r\n    <ng-template #loading>\r\n      <div class=\"modal-content\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"d-flex justify-content-center py-5\">\r\n            <apt-dots></apt-dots>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n\r\n  </div>\r\n</div>\r\n\r\n<ng-template #statusBadge let-cartItem=\"cartItem\">\r\n  <ng-container [ngSwitch]=\"cartItem?.LineStatus\">\r\n    <span class=\"badge ml-2 badge-danger py-1\" *ngSwitchCase=\"'Cancelled'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-info py-1\" *ngSwitchCase=\"'Upgraded'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning py-1\" *ngSwitchCase=\"'Amended'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-success py-1\" *ngSwitchCase=\"'New'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning py-1\" *ngSwitchCase=\"'Renewed'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-light py-1\" *ngSwitchCase=\"'Existing'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n  </ng-container>\r\n</ng-template>", styles: [":host{font-size:small}.configuration{font-size:small}.line-height-large{line-height:1.8rem}.modal.right .modal-content{height:100vh}.modal.right.show .modal-dialog{right:-1px}.modal.right .modal-dialog{position:absolute;transition:right .3s;margin:-1px 0 0;right:-20rem;width:40rem;max-width:100vw}.modal.right .modal-dialog .modal-content{height:100vh}.width-fixed{min-width:8rem;max-width:8rem}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: DotsComponent, selector: "apt-dots", inputs: ["large", "color"] }], directives: [{ type: i1$2.ModalDirective, selector: "[bsModal]", inputs: ["config"], outputs: ["onShow", "onShown", "onHide", "onHidden"], exportAs: ["bs-modal"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-configuration-summary',
                    templateUrl: './product-configuration-summary.component.html',
                    styleUrls: ['./product-configuration-summary.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.ProductOptionService }, { type: i1.CartService }, { type: i4$1.Router }, { type: i1$1.CacheService }, { type: i0.NgZone }, { type: ExceptionService }]; }, propDecorators: { product: [{
                type: Input
            }], relatedTo: [{
                type: Input
            }], changes: [{
                type: Input
            }], preload: [{
                type: Input
            }], position: [{
                type: Input
            }], quantity: [{
                type: Input
            }], showActionButtons: [{
                type: Input
            }], onProductAdd: [{
                type: Output
            }], onNavigate: [{
                type: Output
            }], summaryModal: [{
                type: ViewChild,
                args: ['summaryModal']
            }] } });

/** @ignore  */
class ConfigurationSummaryModule {
}
ConfigurationSummaryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationSummaryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ConfigurationSummaryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationSummaryModule, declarations: [ProductConfigurationSummaryComponent], imports: [CommonModule,
        PriceModule,
        PricingModule,
        IconModule,
        RouterModule,
        LaddaModule,
        OutputFieldModule,
        ModalModule,
        NgScrollbarModule,
        FormsModule, i2$1.TranslateModule], exports: [ProductConfigurationSummaryComponent] });
ConfigurationSummaryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationSummaryModule, imports: [[
            CommonModule,
            PriceModule,
            PricingModule,
            IconModule,
            RouterModule,
            LaddaModule,
            OutputFieldModule,
            ModalModule,
            NgScrollbarModule,
            FormsModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationSummaryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PriceModule,
                        PricingModule,
                        IconModule,
                        RouterModule,
                        LaddaModule,
                        OutputFieldModule,
                        ModalModule,
                        NgScrollbarModule,
                        FormsModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [
                        ProductConfigurationSummaryComponent
                    ],
                    exports: [
                        ProductConfigurationSummaryComponent
                    ]
                }]
        }] });

/**
 * The Add to cart component is a button associated with controls for updating the quantity of cart line items before they are added to user"s active cart.
 *
 * When a user clicks on Add to Cart component, a modal window opens up to the user. The modal window displays the selected line item details. These details include item name, product code, quantity, price. A cart total price and checkout button are also shown in the modal window.
 *
 * The add to cart component also shows a dropdown with further actions that can be taken on the product if it is also an asset.
 * <h3>Preview</h3>
 * <div>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/addToCart.png" style="max-width: 100%">
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/addToCartDropdown.png" style="max-width: 100%">
 * </div>
 * <h3>Usage</h3>
 *
```typescript
import { ButtonModule } from "@congacommerce/elements";
@NgModule({
  imports: [ButtonModule, ...]
})
export class AppModule {}
```
* @example
* // Basic Usage
```typescript
* <apt-add-to-cart [product]="product"></apt-add-to-cart>
```
*
* // All input and output options.
```typescript
* <apt-add-to-cart
*             [product]="product"
*             [showQuantityControls]="quantityControlsShowing"
*             [disabled]="isDisabled"
*             [quantity]="quantity"
*             [configurationEnabled]="isConfigEnabled"
*             [configurationRoute]="route/to/configure/page"
*             [trigger]="willTrigger"
*             [btnClass]="classOfButton"
*             [size]="lg"
*             (onAddToCart)="handleAddToCart($event)"></apt-add-to-cart>
```
*/
class AddToCartComponent {
    /**
     * Constructor for Add to Cart Component for injecting dependencies.
     *
     * @param cartService Instance of CartService
     * @param storefrontService Instance of StorefrontService
     * @param assetModalService Instance of AssetModalService
     * @param crService Instance of ConstraintRuleService
     * @param exceptionService Instance of ExceptionService
     * @param router Instance of Angular Router
     * @param productOptionService Instance of ProductOptionService
     * @param userService Instance of UserService
    */
    constructor(cartService, storefrontService, assetModalService, crService, exceptionService, router, productOptionService, userService) {
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        this.assetModalService = assetModalService;
        this.crService = crService;
        this.exceptionService = exceptionService;
        this.router = router;
        this.productOptionService = productOptionService;
        this.userService = userService;
        /**
         * Label to use for this control.
         */
        this.label = 'COMMON.ADD_TO_CART';
        /**
         * Flag to show number input beside the add to cart button.
         */
        this.showQuantityControls = true;
        /**
         * Initial quantity to set for the component. Defaults to 1.
         */
        this.quantity = 1;
        /**
         * Flag to enable configuration for this component.
         */
        this.configurationEnabled = true;
        /**
         * Flag to disable the button if not valid.
         */
        this.disabled = false;
        /**
         * Flag for if ABO is enabled.
         */
        this.aboEnabled = true;
        /**
         * Bootstrap class to set on this button.
         */
        this.btnClass = 'btn-outline-primary';
        /**
         * Define the size of the add to cart input
         */
        this.size = 'md';
        /**
         * Rules to be skipped or not.
         */
        this.skipRules = false;
        /**
         * Event emitter called when something is added to the cart.
         */
        this.onAddToCart = new EventEmitter();
        /** @ignore */
        this.view$ = new BehaviorSubject({
            actions: new Array(),
            rules: new Array(),
            cart: null,
            disabled: false
        });
        /** @ignore */
        this.viewSubscriptions = [];
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /** Flag to show configuration popup while adding product to cart
         * @ignore
         */
        this.renderConfiguration = false;
        /** Flag to check user is loggedin or not */
        this.isLoggedIn = false;
        this.isLoggedIn$ = this.userService.isLoggedIn();
        this.isLoggedIn$.subscribe(s => this.isLoggedIn = s);
    }
    /** @ignore */
    get buttonClass() {
        return `${this.btnClass} btn-${this.size}`;
    }
    /** @ignore */
    get inputClass() {
        return `d-flex flex-column align-items-stretch input-group-${this.size}`;
    }
    ngOnInit() {
        const exclusionAction$ = this.skipRules ? of(null) : this.crService.getExclusionProductActionsForCart();
        this.viewSubscriptions.push(combineLatest([this.storefrontService.getStorefront(), exclusionAction$, this.cartService.getMyCart()])
            .pipe(map(([storefront, exclusionActions, cart]) => {
            this.storefront = storefront;
            const excludedProducts = uniq(flatten(map$1(exclusionActions, a => split(get(a, 'SuggestedProductIds'), ', '))));
            const configLoading = (this.product.HasAttributes || this.product.HasOptions) && isEmpty(this.cartItems) && this.configurationEnabled === false;
            return {
                actions: filter$1(this.getAssetActions(storefront, this.product, cart), { enabled: true }),
                disabled: storefront.ConfigurationLayout !== 'Embedded' ? (this.product.hasErrors || includes(excludedProducts, this.product.Id) || configLoading) : (includes(excludedProducts, this.product.Id) || this.disabled),
                cart: cart
            };
        }))
            .subscribe(r => this.view$.next(r)));
        this.productRules$ = this.skipRules ? of(null) : this.crService.getRuleByProductId(this.product.Id);
    }
    ngOnChanges() {
        const viewState = this.view$.value;
        if (get(viewState, 'cart')) {
            const temp = cloneDeep(viewState.cart);
            temp.LineItems = concat(temp.LineItems, this.cartItems);
            // Get the list of Product Option Components for the bundle.
            let productOptionComponents = this.productOptionService.getProductOptions(this.product);
            // Get required Option Components based on the current selection in the configuration.
            let requiredOptionComponents = this.productOptionService.getRequiredOptions(productOptionComponents, this.cartItems);
            let requiredProducts = map$1(requiredOptionComponents, action => get(action, 'ComponentProductId'));
            let selectedProducts = compact(map$1(this.cartItems, item => item.ProductOption && item.ProductOption.ComponentProductId));
            let hasDifference = (difference(requiredProducts, selectedProducts).length > 0);
            viewState.disabled = this.storefront.ConfigurationLayout !== 'Embedded' ? (this.product.hasErrors || hasDifference) : this.disabled;
            this.view$.next(viewState);
        }
    }
    /**
     * The method is fired when user clicks on Add to Cart button.
     * Runs a constraint rule engine to look for any product recommendations for the selected cart line item.
     * Fetches the price of the selected line item, opens up a modal window to display the price, quantity and name of the selected line item.
     * The selected item is also added to user's current active cart.
     *
     * @fires ConstraintRuleService.getConstraintRules()
     * @fires CartService.getMyCart()
     * @fires CartService.addProductToCart()
     * @fires PriceService.getProductPrice()
     *
    */
    addToCart() {
        if (this.quantity <= 0) {
            this.exceptionService.showError('INVALID_QUANTITY');
            this.quantity = 1;
            this.onAddToCart.emit(null); // To revert back the quantity to 1 in product details page
        }
        else if ((this.product.HasAttributes || this.product.HasOptions) && this.configurationEnabled) {
            this.showProductConfiguration();
        }
        else {
            this.loading = true;
            // Set the quantity to all the cart items.
            if (this.cartItems)
                forEach(this.cartItems, (cartItem) => {
                    if (get(cartItem, 'LineType') === 'Product/Service')
                        set(cartItem, 'Quantity', this.quantity);
                });
            const isEmbedded = this.storefront.ConfigurationLayout === 'Embedded';
            let obs$ = this.cartService.addProductToCart(this.product, this.quantity, this.cartItems, isEmbedded);
            obs$.subscribe(cartItemList => {
                this.loading = false;
                // Updating a cart item
                if (!isEmpty(cartItemList)) {
                    if (some(this.cartItems, (item) => !isNil(get(item, 'Id')))) {
                        this.exceptionService.showSuccess('SUCCESS.CART.CONFIGURATION_UPDATED', 'SUCCESS.TITLE', { productName: this.product.Name });
                        // Adding a new cart item
                    }
                    else {
                        this.exceptionService.showSuccess('SUCCESS.CART.ITEM_ADDED_TOASTR_MESSAGE', 'SUCCESS.CART.ITEM_ADDED_TOASTR_TITLE', { productName: this.product.Name });
                    }
                    this.onAddToCart.emit(cartItemList);
                }
            }, err => {
                this.loading = false;
                this.exceptionService.showError(err);
            });
        }
    }
    ngOnDestroy() {
        this.viewSubscriptions.forEach(subscription => subscription.unsubscribe());
    }
    /** @ignore */
    showProductConfiguration() {
        this.renderConfiguration = true;
        setTimeout(() => this.productConfiguration.show(this.quantity));
    }
    getAssetActions(storefront, product, cart) {
        const actionList = split(get(storefront, 'AssetActions'), ';');
        const assetList = filter$1(get(product, 'AssetLineItems'), {
            IsPrimaryLine: true,
            LineType: 'Product/Service'
        });
        const asset = last(sortBy(assetList, 'CreatedDate'));
        const assetsInCart = filter$1(assetList, (list) => filter$1(cart.LineItems, (item) => get(item, 'AssetLineItemId') === list.Id).length > 0);
        const inCart = assetList.length === assetsInCart.length;
        const aboEnabled = !isNil(asset) && storefront.EnableABO && this.aboEnabled && !inCart;
        const canBuyMore = aboEnabled && asset.canBuyMore() && includes(actionList, 'Buy More') && this.isLoggedIn;
        const primaryAction = {
            label: this.label,
            enabled: !canBuyMore,
            onClick: () => this.addToCart()
        };
        const assetActions = map$1(actionList, action => {
            switch (action) {
                case AssetAction.BUY_MORE: {
                    return {
                        label: AssetAction.BUY_MORE,
                        enabled: canBuyMore,
                        onClick: () => {
                            if (assetList.length > 1)
                                this.router.navigate(['/assets'], { queryParams: { action: AssetAction.BUY_MORE, productIds: this.product.Id } });
                            else
                                this.assetModalService.openBuyMoreModal(asset, this.product.AssetLineItems);
                        }
                    };
                }
                case AssetAction.RENEW: {
                    return {
                        label: AssetAction.RENEW,
                        enabled: aboEnabled && asset.canRenew() && includes(actionList, 'Renew'),
                        onClick: () => {
                            if (assetList.length > 1)
                                this.router.navigate(['/assets'], { queryParams: { action: AssetAction.RENEW, productIds: this.product.Id } });
                            else
                                this.assetModalService.openRenewModal(asset, assetList);
                        }
                    };
                }
                case AssetAction.TERMINATE: {
                    return {
                        label: AssetAction.TERMINATE,
                        enabled: aboEnabled && asset.canTerminate() && includes(actionList, 'Terminate'),
                        onClick: () => {
                            if (assetList.length > 1)
                                this.router.navigate(['/assets'], { queryParams: { action: AssetAction.TERMINATE, productIds: this.product.Id } });
                            else
                                this.assetModalService.openTerminateModal(asset, assetList);
                        }
                    };
                }
                case AssetAction.CHANGE_CONFIGURATION: {
                    return {
                        label: AssetAction.CHANGE_CONFIGURATION,
                        enabled: aboEnabled && asset.canChangeConfiguration() && includes(actionList, 'Change Configuration'),
                        onClick: () => {
                            if (assetList.length > 1)
                                this.router.navigate(['/assets'], { queryParams: { action: AssetAction.CHANGE_CONFIGURATION, productIds: this.product.Id } });
                            else
                                this.assetModalService.openChangeConfigurationModal(asset, this.product.AssetLineItems);
                        }
                    };
                }
            }
        });
        return concat(primaryAction, assetActions);
    }
}
AddToCartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddToCartComponent, deps: [{ token: i1.CartService }, { token: i1.StorefrontService }, { token: AssetModalService }, { token: i1.ConstraintRuleService }, { token: ExceptionService }, { token: i4$1.Router }, { token: i1.ProductOptionService }, { token: i1.UserService }], target: i0.ɵɵFactoryTarget.Component });
AddToCartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AddToCartComponent, selector: "apt-add-to-cart", inputs: { product: "product", cartItems: "cartItems", label: "label", showQuantityControls: "showQuantityControls", quantity: "quantity", configurationEnabled: "configurationEnabled", disabled: "disabled", aboEnabled: "aboEnabled", btnClass: "btnClass", size: "size", trigger: "trigger", skipRules: "skipRules" }, outputs: { onAddToCart: "onAddToCart" }, viewQueries: [{ propertyName: "productConfiguration", first: true, predicate: ["productConfiguration"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container>\r\n  <form [ngClass]=\"inputClass\">\r\n    <div class=\"align-items-center d-flex justify-content-center input-group-sm\" *ngIf=\"showQuantityControls\">\r\n      <label [for]=\"'quantity' + product.Id\" class=\"mr-3\">{{'COMMON.QUANTITY' | translate}}</label>\r\n      <input type=\"number\" min=\"1\" class=\"form-control mb-2 w-25\" [(ngModel)]=\"quantity\" min=\"1\" name=\"quantity\"\r\n        [id]=\"'quantity' + product.Id\" />\r\n    </div>\r\n    <div class=\"d-flex\" *ngIf=\"view$ | async as view\">\r\n      <ng-container *ngIf=\"view?.actions?.length > 0; else disabled\">\r\n        <apt-cr-popover class=\"d-block flex-grow-1\" [product]=\"product\" [ruleList]=\"productRules$ | async\">\r\n          <button class=\"btn btn-block\" [disabled]=\"view?.disabled || view.actions[0]?.enabled === false\"\r\n            [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\" [ngClass]=\"buttonClass\" (click)=\"view.actions[0]?.onClick()\"\r\n            type=\"button\">\r\n            {{view.actions[0]?.label | translate}}\r\n          </button>\r\n        </apt-cr-popover>\r\n\r\n        <button type=\"button\" class=\"btn dropdown-toggle dropdown-toggle-split\"\r\n          *ngIf=\"(isLoggedIn$ | async) === true && view.actions.length > 1\" [ngClass]=\"buttonClass\"\r\n          data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n          <i class=\"fa fa-caret-down\"></i>\r\n        </button>\r\n        <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"dropdownMenuButton\">\r\n          <ng-container *ngFor=\"let action of view.actions; let idx = index\">\r\n            <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"action.onClick()\"\r\n              *ngIf=\"idx > 0 && action?.enabled\">{{action.label}}</a>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-template #disabled>\r\n        <button class=\"btn btn-block\" [disabled]=\"true\" [ngClass]=\"buttonClass\" type=\"button\">\r\n          {{label | translate}}\r\n        </button>\r\n      </ng-template>\r\n    </div>\r\n\r\n  </form>\r\n</ng-container>\r\n\r\n<apt-product-configuration-summary\r\n  *ngIf=\"renderConfiguration && configurationEnabled && (product?.HasOptions || product?.HasAttributes)\"\r\n  [product]=\"product\" [quantity]=\"quantity\" #productConfiguration></apt-product-configuration-summary>", styles: [".dropdownButton{margin-left:-1px}\n"], components: [{ type: CRPopoverComponent, selector: "apt-cr-popover", inputs: ["product", "parentProduct", "message", "items", "options", "optionRules", "triggers", "outsideClick", "containerClass", "ruleList"] }, { type: ProductConfigurationSummaryComponent, selector: "apt-product-configuration-summary", inputs: ["product", "relatedTo", "changes", "preload", "position", "quantity", "showActionButtons"], outputs: ["onProductAdd", "onNavigate"] }], directives: [{ type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AddToCartComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-add-to-cart',
                    templateUrl: './add-to-cart.component.html',
                    styleUrls: ['./add-to-cart.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.StorefrontService }, { type: AssetModalService }, { type: i1.ConstraintRuleService }, { type: ExceptionService }, { type: i4$1.Router }, { type: i1.ProductOptionService }, { type: i1.UserService }]; }, propDecorators: { product: [{
                type: Input
            }], cartItems: [{
                type: Input
            }], label: [{
                type: Input
            }], showQuantityControls: [{
                type: Input
            }], quantity: [{
                type: Input
            }], configurationEnabled: [{
                type: Input
            }], disabled: [{
                type: Input
            }], aboEnabled: [{
                type: Input
            }], btnClass: [{
                type: Input
            }], size: [{
                type: Input
            }], trigger: [{
                type: Input
            }], skipRules: [{
                type: Input
            }], onAddToCart: [{
                type: Output
            }], productConfiguration: [{
                type: ViewChild,
                args: ['productConfiguration', { static: false }]
            }] } });
/**@ignore */
var PriceType;
(function (PriceType) {
    PriceType["RECURRING"] = "Recurring";
    PriceType["USAGE"] = "Usage";
    PriceType["ONE_TIME"] = "One Time";
})(PriceType || (PriceType = {}));
/**@ignore */
var AssetAction;
(function (AssetAction) {
    AssetAction["RENEW"] = "Renew";
    AssetAction["TERMINATE"] = "Terminate";
    AssetAction["BUY_MORE"] = "Buy More";
    AssetAction["CHANGE_CONFIGURATION"] = "Change Configuration";
})(AssetAction || (AssetAction = {}));

/**
 * Installed products component is a button that links users to the installed products page.
 * The button is disabled for users who are not logged in.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/installedProductsButton.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { ButtonModule } from '@congacommerce/elements';

@NgModule({
  imports: [ButtonModule, ...]
})
export class AppModule {}
```
* @example
* <apt-installed-products></apt-installed-products>
*/
class InstalledProductsComponent {
    constructor(storefrontService, userService) {
        this.storefrontService = storefrontService;
        this.userService = userService;
    }
    ngOnInit() {
        this.storefront$ = this.storefrontService.getStorefront();
        this.isLoggedIn$ = this.userService.isLoggedIn();
    }
}
InstalledProductsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InstalledProductsComponent, deps: [{ token: i1.StorefrontService }, { token: i1.UserService }], target: i0.ɵɵFactoryTarget.Component });
InstalledProductsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InstalledProductsComponent, selector: "apt-installed-products", ngImport: i0, template: "<ng-container *ngIf=\"(storefront$ | async)?.EnableABO\">\r\n  <ng-container *ngIf=\"(isLoggedIn$ | async) === true; else guest\">\r\n    <button class=\"btn btn-outline-primary\" [routerLink]=\"['/assets']\">\r\n      {{'BUTTON.INSTALLED_PRODUCTS' | translate}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-template #guest>\r\n    <div tooltip=\"{{'BUTTON.LOGIN_REQUIRED_TOOLTIP' | translate}}\" placement=\"left\">\r\n      <button class=\"btn btn-link border\" disabled=\"true\">\r\n        {{'BUTTON.INSTALLED_PRODUCTS' | translate}}\r\n      </button>\r\n    </div>\r\n  </ng-template>\r\n</ng-container>\r\n\r\n\r\n\r\n\r\n", directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InstalledProductsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-installed-products',
                    templateUrl: './installed-products.component.html',
                    styles: [],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.StorefrontService }, { type: i1.UserService }]; } });

/**
 * The asset dropdown button is used to create a split dropdown button with all of the enabled ABO actions on the storefront record.
 * By default the first action in the list of enabled actions is set as the primary action on the button, however, users can set the desired primary action with the 'primaryAction' input.
 * An onClick event is emitted when a user clicks on the main button or one in the dropdown.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/assetDropdownButton.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { ButtonModule } from '@congacommerce/elements';

@NgModule({
  imports: [ButtonModule, ...]
})
export class AppModule {}
```
* @example
```typescript
* <apt-asset-dropdown-button
*              [buttonType]="'btn-outline-primary'"
*              [setDisabled]="isDisabled"
*              [setTooltipText]="'Asset selection disabled.'"
*              (onClick)="handleAssetDropdownClick($event)"
* ></apt-asset-dropdown-button>
```
*/
class AssetDropdownButtonComponent {
    constructor(userService, storefrontService, translateService) {
        this.userService = userService;
        this.storefrontService = storefrontService;
        this.translateService = translateService;
        /**
         * Flag to check if this button should be set to disabled.
         */
        this.setDisabled = false;
        /**
         * Bootstrap class name for the button type.
         */
        this.buttonType = 'btn-primary';
        /**
         * Event emitter for when an action is clicked.
         */
        this.onClick = new EventEmitter();
    }
    ngOnInit() {
        this.view$ = combineLatest(this.userService.isLoggedIn(), this.storefrontService.getStorefront(), this.translateService.stream('BUTTON.LOGIN_MUST_TOOLTIP'))
            .pipe(map(([isLoggedIn, storefront, buttonTooltip]) => {
            let enabledActions;
            // Check if pricetype is available before populating value for dropdown.
            if (this.priceType)
                enabledActions = (_.get(storefront, 'AssetActions')) ? _.get(storefront, 'AssetActions').split(';') : [];
            // Check if configurationType is Bundle and dropdown has 'Buy More' then remove buymore action from dropdown
            if (this.configurationType === 'Bundle' && !this.operation && enabledActions.filter(action => action === 'Buy More').length > 0)
                enabledActions = enabledActions.filter(action => action !== 'Buy More');
            // check if operation is 'Buy More' or dropdown has 'Buy More' and price type as one time, then enable only 'Buy More' action.
            if ((this.operation === 'Buy More') || (enabledActions.filter(action => action === 'Buy More').length > 0 && this.priceType === 'One Time'))
                enabledActions = enabledActions.filter(action => action === 'Buy More');
            // check if operation is 'Change Configuration' or dropdown has 'Change Configuration' and price type as one time, then enable only 'Change Configuration' action.
            if ((this.operation === 'Change Configuration') || (enabledActions.filter(action => action === 'Change Configuration').length > 0 && this.priceType === 'One Time'))
                enabledActions = enabledActions.filter(action => action === 'Change Configuration');
            // Do not show Change Configuration action for standalone product which does not have any attributes
            if (this.configurationType === 'Standalone' && !this.hasAttributes && !this.operation && enabledActions.filter(action => action === 'Change Configuration').length > 0)
                enabledActions = enabledActions.filter(action => action !== 'Change Configuration');
            if (this.primaryAction && enabledActions.includes(this.primaryAction)) {
                let action = enabledActions.splice(enabledActions.indexOf(this.primaryAction), 1);
                enabledActions.unshift(action[0]);
            }
            return {
                isLoggedIn: isLoggedIn,
                enabledActions: enabledActions,
                buttonTooltip: buttonTooltip
            };
        }));
    }
}
AssetDropdownButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetDropdownButtonComponent, deps: [{ token: i1.UserService }, { token: i1.StorefrontService }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
AssetDropdownButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetDropdownButtonComponent, selector: "apt-asset-dropdown-button", inputs: { operation: "operation", priceType: "priceType", configurationType: "configurationType", primaryAction: "primaryAction", setDisabled: "setDisabled", setTooltipText: "setTooltipText", buttonType: "buttonType", hasAttributes: "hasAttributes" }, outputs: { onClick: "onClick" }, ngImport: i0, template: "<ng-container *ngIf=\"view$ | async as view\">\r\n  <div\r\n    *ngIf=\"!view.isLoggedIn || setDisabled\"\r\n    [tooltip]=\"setTooltipText ? setTooltipText : view.buttonTooltip\"\r\n    container=\"body\"\r\n  >\r\n    <button\r\n      *ngIf = \"view.enabledActions.length > 0\"\r\n      class=\"btn btn-block btn-link px-4 btn-sm\"\r\n      [ngClass]=\"buttonType\"\r\n      disabled=\"true\"\r\n    >\r\n      {{ ('BUTTON.' + view.enabledActions[0]) | translate }}\r\n    </button>\r\n  </div>\r\n  <div\r\n    *ngIf=\"view.isLoggedIn && !setDisabled\"\r\n    class=\"btn-group btn-block\"\r\n  >\r\n    <button *ngIf=\"view.enabledActions.length >= 1\"\r\n      class=\"btn btn-block px-4 btn-sm w-100 mainButton\"\r\n      [ngClass]=\"buttonType\"\r\n      (click)=\"onClick.emit(view.enabledActions[0])\"\r\n    >\r\n      {{ ('BUTTON.' + view.enabledActions[0]) | translate }}\r\n    </button>\r\n    <button\r\n      *ngIf=\"view.enabledActions.length > 1\"\r\n      class=\"btn btn-sm px-2 dropdown-toggle-split\"\r\n      [ngClass]=\"buttonType\"\r\n      data-toggle=\"dropdown\"\r\n      data-reference=\"parent\"\r\n      aria-haspopup=\"true\"\r\n      aria-expanded=\"false\"\r\n    >\r\n      <small class=\"downArrow\"><i class=\"fa fa-caret-down\"></i></small>\r\n    </button>\r\n    <div class=\"dropdown-menu\" aria-labelledby=\"dropdownMenuButton\">\r\n      <button\r\n        *ngFor=\"let action of view.enabledActions | slice:1\"\r\n        class=\"dropdown-item\"\r\n        [class.text-danger]=\"action === 'Terminate'\"\r\n        (click)=\"onClick.emit(action)\"\r\n      >\r\n        {{ ('BUTTON.' + action) | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</ng-container>", styles: [".mainButton{margin-right:2px}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "slice": i5.SlicePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetDropdownButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-dropdown-button',
                    templateUrl: './asset-dropdown-button.component.html',
                    styleUrls: ['./asset-dropdown-button.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.UserService }, { type: i1.StorefrontService }, { type: i2$1.TranslateService }]; }, propDecorators: { operation: [{
                type: Input
            }], priceType: [{
                type: Input
            }], configurationType: [{
                type: Input
            }], primaryAction: [{
                type: Input
            }], setDisabled: [{
                type: Input
            }], setTooltipText: [{
                type: Input
            }], buttonType: [{
                type: Input
            }], onClick: [{
                type: Output
            }], hasAttributes: [{
                type: Input
            }] } });

/**
 * The Generate-document component is used to generate the document for a custom Order.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/generateDocumentButton.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 *```typescript
import { ButtonModule } from '@congacommerce/elements';

@NgModule({
  imports: [ButtonModule, ...]
})
export class AppModule {}
```
*
* @example
* // Basic Usage
```typescript
* <apt-generate-document
*              [record]="order"
* ></apt-generate-document>
```
*/
class GenerateDocumentComponent {
    constructor(quoteService, modalService, templateService, exceptionService, platformService, orderService, emailService) {
        this.quoteService = quoteService;
        this.modalService = modalService;
        this.templateService = templateService;
        this.exceptionService = exceptionService;
        this.platformService = platformService;
        this.orderService = orderService;
        this.emailService = emailService;
        /**
         * Event emitter for update of generated document.
         */
        this.onStatusUpdate = new EventEmitter();
        /** two-way data binding object. */
        this.generateDocObj = {
            templateId: null,
            format: null
        };
        /** picklist values for templates */
        this.templateList = [];
        /** picklist values for formats */
        this.formatList = ['PDF', 'DOC', 'RTF'];
        /** @igore */
        this.disableGenFormBtn = false;
        this.disableGenModalBtn = true;
    }
    ngOnInit() {
        if (this.record) {
            this.type = (this.record instanceof Order) ? 'Order' : 'Quote';
            this.templateService.getActiveTemplates(this.record.getApiName()).subscribe((temp) => {
                forEach(temp, item => {
                    this.templateList.push({
                        name: item.Name,
                        id: item.Id
                    });
                });
            });
        }
    }
    /**
     * @ignore
     */
    onChange() {
        this.disableGenModalBtn = true;
        if (defaultTo(this.generateDocObj.templateId) && defaultTo(this.generateDocObj.format)) {
            this.disableGenModalBtn = false;
        }
    }
    /**
    * To open the modal dialog
    *
    */
    openModal() {
        this.modalRef = this.modalService.show(this.docGenTemplate);
    }
    /**
     * Method gets invoked on click of Generate button
     * which calls generateDocument method to create custom document for order/quote
     */
    generateDocument() {
        this.disableGenFormBtn = true;
        const req = {
            templateId: get(this.generateDocObj, 'templateId.id'),
            recordId: this.record.Id,
            sObjectType: this.record.getApiName(),
            format: this.generateDocObj.format,
            accessLevel: AccessLevel.FULL_ACCESS,
            sessionId: get(this.platformService, 'connection.accessToken'),
            isDraft: false
        };
        this.modalRef.hide();
        this.exceptionService.showInfo('INFO.GENERATE_INFO', 'COMMON.INFO_ALERT', { type: this.type === 'Order' ? 'order' : 'quote' });
        this.quoteService.generateDocument(req)
            .pipe(switchMap(() => {
            const orderRecord = cloneDeep(this.record);
            this.record instanceof Order ? set(orderRecord, 'Status', 'Generated') : set(orderRecord, 'Approval_Stage', 'Generated');
            if (this.record instanceof Order) {
                return this.orderService.update([orderRecord]);
            }
            else {
                return this.quoteService.update([orderRecord]);
            }
        }), take(1)).subscribe(() => {
            this.exceptionService.showSuccess('SUCCESS.GENERATED', 'SUCCESS.DOCUMENT_GENERATED_TITLE', { type: this.type === 'Order' ? 'order' : 'quote' });
            this.disableGenFormBtn = false;
            const primaryContactId = this.record instanceof Order ? get(this.record, 'PrimaryContactId') : get(this.record, 'Primary_ContactId');
            this.record instanceof Order ? this.emailService.statusChangeNotification('CustomerOrderEmailNotificationsTemplate', this.record.Id, primaryContactId).pipe(take(1)).subscribe() : this.emailService.statusChangeNotification('CustomerQuoteEmailNotificationsTemplate', this.record.Id, primaryContactId).pipe(take(1)).subscribe();
            ;
            this.onStatusUpdate.emit();
        });
    }
}
GenerateDocumentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GenerateDocumentComponent, deps: [{ token: i1.QuoteService }, { token: i1$2.BsModalService }, { token: i1.TemplateService }, { token: ExceptionService }, { token: i1$1.PlatformService }, { token: i1.OrderService }, { token: i1.EmailService }], target: i0.ɵɵFactoryTarget.Component });
GenerateDocumentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: GenerateDocumentComponent, selector: "apt-generate-document", inputs: { record: "record" }, outputs: { onStatusUpdate: "onStatusUpdate" }, viewQueries: [{ propertyName: "docGenTemplate", first: true, predicate: ["docGenTemplate"], descendants: true }], ngImport: i0, template: "<button class=\"btn btn-primary btn-outline-primary btn-raised\" (click)=\"openModal()\" *ngIf=\"type==='Order'; else generateQuote\"\r\n  [disabled]=\"disableGenFormBtn || record.hasErrors\">{{'DETAILS.GENERATE_ORDER' | translate}}</button>\r\n\r\n<ng-template #generateQuote>\r\n  <button [ngClass]=\"record.Approval_Stage === 'Approved'  ? 'btn btn-primary btn-raised px-4 py-2' : 'btn btn-outline-primary btn-link text-primary text-primary px-4 ml-auto'\" (click)=\"openModal()\" \r\n  [disabled]=\"disableGenFormBtn || record.hasErrors\">{{'DETAILS.GENERATE_QUOTE' | translate}}</button>\r\n</ng-template>\r\n\r\n<ng-template #docGenTemplate>\r\n  <div class=\"modal-header align-items-center p-0 mx-4 mt-3 border-bottom border-secondary\">\r\n    <h6 *ngIf=\"type==='Order'; else Quote\" class=\"modal-title pull-left font-weight-bold\">\r\n      {{'DETAILS.GENERATE_ORDER' | translate}}\r\n    </h6>\r\n    <ng-template #Quote>\r\n      <h6 class=\"modal-title pull-left font-weight-bold\">\r\n        {{'DETAILS.GENERATE_QUOTE' | translate}}\r\n      </h6>\r\n    </ng-template>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body d-flex flex-column justify-content-center\">\r\n    <label>{{'DETAILS.TEMPLATE' | translate}} *</label>\r\n    <ng-select [items]=\"templateList\" bindLabel=\"name\" [(ngModel)]=\"generateDocObj.templateId\" (change)=\"onChange()\">\r\n    </ng-select>\r\n    <label class=\"mt-4\">{{'DETAILS.FILE_FORMAT' | translate}} *</label>\r\n    <ng-select [items]=\"formatList\" [(ngModel)]=\"generateDocObj.format\" (change)=\"onChange()\"></ng-select>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-link text-uppercase\" (click)=\"modalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n    <button class=\"btn btn-primary btn-raised text-uppercase\" type=\"button\" (click)=\"generateDocument()\"\r\n      [disabled]=\"disableGenModalBtn\">{{'DETAILS.GENERATE' | translate}}</button>\r\n  </div>\r\n</ng-template>", components: [{ type: i4.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GenerateDocumentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-generate-document',
                    templateUrl: './generate-document.component.html',
                    styles: []
                }]
        }], ctorParameters: function () { return [{ type: i1.QuoteService }, { type: i1$2.BsModalService }, { type: i1.TemplateService }, { type: ExceptionService }, { type: i1$1.PlatformService }, { type: i1.OrderService }, { type: i1.EmailService }]; }, propDecorators: { docGenTemplate: [{
                type: ViewChild,
                args: ['docGenTemplate']
            }], record: [{
                type: Input
            }], onStatusUpdate: [{
                type: Output
            }] } });

/**
 * The Present-document component is used to send out an email notification of the Orders to the customers.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/presentOrderButton.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ButtonModule } from '@congacommerce/elements';

@NgModule({
  imports: [ButtonModule, ...]
})
export class AppModule {}
```
*
* @example
* // Basic Usage
```typescript
* <apt-present-document
*              [record]="order"
* ></apt-present-document>
```
*/
class PresentDocumentComponent {
    constructor(quoteService, modalService, exceptionService, orderService, emailService) {
        this.quoteService = quoteService;
        this.modalService = modalService;
        this.exceptionService = exceptionService;
        this.orderService = orderService;
        this.emailService = emailService;
        /** flag to disable button */
        this.disablePresentAction = false;
        /** @ignore */
        this.disablePresentBtn = false;
        /** CC email for email notification */
        this.ccEmail = null;
        this.isTypeOfOrder = false;
    }
    /** @ignore */
    ngOnInit() {
        this.isTypeOfOrder = this.record instanceof Order;
        this.disablePresentBtn = this.record instanceof Order ? isNil(get(this, 'record.PrimaryContactId')) : isNil(get(this, 'record.Primary_ContactId'));
    }
    /** @ignore */
    onChange() {
        this.disablePresentBtn = this.record instanceof Order ? isNil(get(this, 'record.PrimaryContactId')) : isNil(get(this, 'record.Primary_ContactId'));
    }
    /**
    * To open the modal dialog
    */
    openModal() {
        this.modalRef = this.modalService.show(this.presentDocTemplate);
    }
    /**
     * Present document to primary contact of the record and email notification sent out.
     * Sets status of record to Presented.
     */
    presentDocument() {
        this.disablePresentAction = true;
        this.record instanceof Order ? set(this.record, 'Status', 'Presented') : set(this.record, 'Approval_Stage', 'Presented');
        const primaryContactId = this.record instanceof Order ? get(this.record, 'PrimaryContactId') : get(this.record, 'Primary_ContactId');
        if (this.record instanceof Order) {
            this.orderService.update([this.record]).pipe(take(1)).subscribe((order) => {
                const attachmentId = get(first(orderBy(this.record.Attachments, ['LastModifiedDate'], ['desc'])), 'Id');
                this.exceptionService.showSuccess('SUCCESS.PRESENTED', 'SUCCESS.DOCUMENT_PRESENTED_TITLE', { primary_contact: get(order[0], 'PrimaryContact.Name'), type: 'order' });
                this.emailService.statusChangeNotification('CustomerOrderEmailNotificationsTemplate', this.record.Id, primaryContactId, null, [get(this, 'ccEmail')], (attachmentId ? [attachmentId] : null)).pipe(take(1)).subscribe();
            });
        }
        else {
            this.quoteService.update([this.record]).pipe(take(1)).subscribe((quote) => {
                const attachmentId = get(first(orderBy(this.record.Attachments, ['LastModifiedDate'], ['desc'])), 'Id');
                this.exceptionService.showSuccess('SUCCESS.PRESENTED', 'SUCCESS.DOCUMENT_PRESENTED_TITLE', { primary_contact: get(quote[0], 'Primary_Contact.Name'), type: 'quote' });
                this.emailService.statusChangeNotification('CustomerQuoteEmailNotificationsTemplate', this.record.Id, primaryContactId, null, [get(this, 'ccEmail')], (attachmentId ? [attachmentId] : null)).pipe(take(1)).subscribe();
            });
        }
        this.modalRef.hide();
    }
}
PresentDocumentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PresentDocumentComponent, deps: [{ token: i1.QuoteService }, { token: i1$2.BsModalService }, { token: ExceptionService }, { token: i1.OrderService }, { token: i1.EmailService }], target: i0.ɵɵFactoryTarget.Component });
PresentDocumentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PresentDocumentComponent, selector: "apt-present-document", inputs: { record: "record" }, viewQueries: [{ propertyName: "presentDocTemplate", first: true, predicate: ["presentDocTemplate"], descendants: true }], ngImport: i0, template: "<button class=\"btn btn-primary btn-outline-primary btn-raised\" (click)=\"openModal()\"\r\n    [disabled]=\"disablePresentAction || record.hasErrors\">{{(isTypeOfOrder ? 'DETAILS.PRESENT_ORDER' : 'DETAILS.PRESENT_QUOTE') | translate}}</button>\r\n\r\n<ng-template #presentDocTemplate>\r\n    <div class=\"modal-header align-items-center p-0 mx-4 mt-3 border-bottom border-secondary\">\r\n        <h6 class=\"modal-title pull-left font-weight-bold\">\r\n            {{(isTypeOfOrder ? 'DETAILS.PRESENT_ORDER' : 'DETAILS.PRESENT_QUOTE') | translate}}\r\n        </h6>\r\n        <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n    </div>\r\n    <form name=\"frmPresentDoc\" (ngSubmit)=\"f.form.valid && presentDocument()\" #f=\"ngForm\" novalidate>\r\n        <div class=\"modal-body d-flex flex-column justify-content-center\">\r\n            <label class=\"font-weight-bold\">{{(isTypeOfOrder ? 'DETAILS.SEND_TO' : 'DETAILS.SEND_QUOTE_TO') | translate}} </label>\r\n            <apt-output-field [record]=\"record\" class=\"form-control\" [field]=\"isTypeOfOrder ? 'PrimaryContact.Name' : 'Primary_Contact.Name'\" layout=\"inline\" valueOnly=\"true\"\r\n                [editable]=\"false\" [showQuickView]=\"false\">\r\n            <apt-output-field [record]=\"record\" [field]=\"isTypeOfOrder ? 'PrimaryContact.Email' : 'Primary_Contact.Email'\" layout=\"inline\" [editable]=\"false\"\r\n                [showQuickView]=\"false\"></apt-output-field>\r\n            </apt-output-field>\r\n            <label class=\"font-weight-bold mt-4\">{{'COMMON.CC' | translate}} </label>\r\n\r\n            <div class=\"form-group\">\r\n                <input type=\"email\" [(ngModel)]=\"ccEmail\" class=\"form-control\" name=\"email\" placeholder=\"{{'COMMON.VALID_EMAIL' | translate}}\"\r\n                    pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$\" #email=\"ngModel\" [ngClass]=\"{ 'is-invalid': email.invalid && (email.touched || email.dirty) }\" email>\r\n                <div *ngIf=\"email.invalid && (email.touched || email.dirty)\" class=\"invalid-feedback\">\r\n                    {{'COMMON.INVALID_EMAIL_ERROR' | translate}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-link text-uppercase\" type=\"button\" (click)=\"modalRef.hide()\"> {{'COMMON.CANCEL' | translate}} </button>\r\n            <button class=\"btn btn-primary btn-raised\" type=\"submit\"\r\n                [disabled]=\"disablePresentBtn || f.form.invalid\"> {{'DETAILS.PRESENT' | translate}} </button>\r\n        </div>\r\n    </form>\r\n</ng-template>", styles: [".form-control.is-invalid:focus{box-shadow:none}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { type: i6.EmailValidator, selector: "[email][formControlName],[email][formControl],[email][ngModel]", inputs: ["email"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PresentDocumentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-present-document',
                    templateUrl: './present-document.component.html',
                    styleUrls: ['./present-document.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.QuoteService }, { type: i1$2.BsModalService }, { type: ExceptionService }, { type: i1.OrderService }, { type: i1.EmailService }]; }, propDecorators: { presentDocTemplate: [{
                type: ViewChild,
                args: ['presentDocTemplate']
            }], record: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class ButtonModule {
}
ButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ButtonModule, declarations: [AddToCartComponent, AssetDropdownButtonComponent, InstalledProductsComponent, GenerateDocumentComponent, PresentDocumentComponent], imports: [CommonModule,
        FormsModule,
        RouterModule,
        LaddaModule,
        PricingModule,
        ConfigurationSummaryModule,
        ConstraintPopoverModule, i4$2.TooltipModule, i7.BsDatepickerModule, i1$2.ModalModule, i2$1.TranslateModule, NgSelectModule,
        OutputFieldModule], exports: [AddToCartComponent, AssetDropdownButtonComponent, InstalledProductsComponent, GenerateDocumentComponent, PresentDocumentComponent] });
ButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ButtonModule, imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            LaddaModule,
            PricingModule,
            ConfigurationSummaryModule,
            ConstraintPopoverModule,
            TooltipModule.forRoot(),
            BsDatepickerModule.forRoot(),
            ModalModule.forRoot(),
            TranslateModule.forChild(),
            NgSelectModule,
            OutputFieldModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        RouterModule,
                        LaddaModule,
                        PricingModule,
                        ConfigurationSummaryModule,
                        ConstraintPopoverModule,
                        TooltipModule.forRoot(),
                        BsDatepickerModule.forRoot(),
                        ModalModule.forRoot(),
                        TranslateModule.forChild(),
                        NgSelectModule,
                        OutputFieldModule
                    ],
                    declarations: [AddToCartComponent, AssetDropdownButtonComponent, InstalledProductsComponent, GenerateDocumentComponent, PresentDocumentComponent],
                    exports: [AddToCartComponent, AssetDropdownButtonComponent, InstalledProductsComponent, GenerateDocumentComponent, PresentDocumentComponent]
                }]
        }] });

/**
 * @ignore
 */
class ConstraintRuleModule {
}
ConstraintRuleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ConstraintRuleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleModule, declarations: [ConstraintRuleSidebarComponent, ConstraintRuleAlertComponent, CRIconComponent], imports: [CommonModule,
        RouterModule,
        IconModule,
        FormsModule, i1$2.ModalModule, i3.AlertModule, i2$1.TranslateModule, i1$4.PopoverModule, LaddaModule,
        PriceModule,
        ButtonModule], exports: [ConstraintRuleSidebarComponent, ConstraintRuleAlertComponent, ModalModule, AlertModule$1, CRIconComponent] });
ConstraintRuleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleModule, imports: [[
            CommonModule,
            RouterModule,
            IconModule,
            FormsModule,
            ModalModule.forRoot(),
            AlertModule$1.forRoot(),
            TranslateModule.forChild(),
            PopoverModule.forRoot(),
            LaddaModule,
            PriceModule,
            ButtonModule
        ], ModalModule, AlertModule$1] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConstraintRuleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        IconModule,
                        FormsModule,
                        ModalModule.forRoot(),
                        AlertModule$1.forRoot(),
                        TranslateModule.forChild(),
                        PopoverModule.forRoot(),
                        LaddaModule,
                        PriceModule,
                        ButtonModule
                    ],
                    declarations: [ConstraintRuleSidebarComponent, ConstraintRuleAlertComponent, CRIconComponent],
                    exports: [ConstraintRuleSidebarComponent, ConstraintRuleAlertComponent, ModalModule, AlertModule$1, CRIconComponent],
                    entryComponents: [ConstraintRuleSidebarComponent]
                }]
        }] });

/**
 * Product Drawer service is used to check Drawer status(open/close).
 * <h3>Usage</h3>
 *
  ```typescript
 import { ProductDrawerService, AObjectService} from '@congacommerce/ecommerce';
 
 export class MyComponent implements OnInit{
 constructor( private productDrawerService: ProductDrawerService)
 }
 // or
 export class MyService extends AObjectService {
      private productDrawerService: ProductDrawerService = this.injector.get(ProductDrawerService);
  }
 ```
 */
class ProductDrawerService {
    constructor() {
        this._drawerShowing = new BehaviorSubject(false);
    }
    /**
     * check drawer is open or close
     * ### Example:
     ```typescript
     
     
         isDrawerOpen(){
            this.productDrawerService.isDrawerOpen().subscribe(a => this.isOpen = a);
             // or
             this.isOpen$ = this.productDrawerService.isDrawerOpen();
         }
     }
     ```
     * @returns Observable<boolean> true if drawer is open and false if it is close
     */
    isDrawerOpen() {
        return this._drawerShowing;
    }
    /**
     * toggle the drawer action. close if it is open or vice versa
     * ### Example:
     ```typescript
     import { ProductDrawerService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private productDrawerService: ProductDrawerService){}
     
         toggleDrawer(){
              this.productDrawerService.toggleDrawer();
         }
     }
     ```
     */
    toggleDrawer() {
        this._drawerShowing.pipe(take(1)).subscribe(drawerShowing => {
            if (drawerShowing)
                this.closeDrawer();
            else
                this.openDrawer();
        });
    }
    /**
     * TO open the drawer
     * ### Example:
     ```typescript
     import { ProductDrawerService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private productDrawerService: ProductDrawerService){}
     
         openDrawer(){
              this.productDrawerService.openDrawer();
         }
     }
     ```
     */
    openDrawer() {
        this._drawerShowing.next(true);
    }
    /**
     * To close the drawer
     * ### Example:
     ```typescript
     import { ProductDrawerService } from '@congacommerce/ecommerce';
     import { Observable } from 'rxjs/Observable';
     
     export class MyComponent implements OnInit{
         constructor(private productDrawerService: ProductDrawerService){}
     
         closeDrawer(){
              this.productDrawerService.closeDrawer();
         }
     }
     ```
     */
    closeDrawer() {
        this._drawerShowing.next(false);
    }
}
ProductDrawerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ProductDrawerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * A super awesome animated chevron used in the product drawer component.
 * @ignore
 */
class SuperChevronComponent {
}
SuperChevronComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuperChevronComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SuperChevronComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SuperChevronComponent, selector: "apt-super-chevron", inputs: { direction: "direction" }, ngImport: i0, template: "<svg id=\"superChevron\" class=\"superChevron\" [class.up]=\"direction === 'up'\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"24\" viewBox=\"0 0 24 24\">\r\n  <rect class=\"leftArm\" x=\"11.2\" y=\"11\" width=\"10\" height=\"2\" rx=\"1\" ry=\"1\" />\r\n  <rect class=\"rightArm\" x=\"11.2\" y=\"11\" width=\"10\" height=\"2\" rx=\"1\" ry=\"1\" />\r\n</svg>", styles: [".superChevron .leftArm{transform-origin:50% 50%;width:14.14213562px;transform:translateY(5px) rotate(225deg);transition:all .4s ease-in-out}.superChevron .rightArm{transform-origin:50% 50%;width:14.14213562px;transform:translateY(5px) rotate(-45deg);transition:all .4s ease-in-out}.superChevron.up .leftArm{width:14.14213562px;transform:translateY(-5px) rotate(135deg)}.superChevron.up .rightArm{width:14.14213562px;transform:translateY(-5px) rotate(45deg)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuperChevronComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-super-chevron',
                    templateUrl: './super-chevron.component.html',
                    styleUrls: ['./super-chevron.component.scss']
                }]
        }], propDecorators: { direction: [{
                type: Input
            }] } });

/** @ignore  */
const fade = // the fade-in/fade-out animation.
 trigger('simpleFadeAnimation', [
    // the "in" style determines the "resting" state of the element when it is visible.
    state('in', style({ opacity: 1 })),
    // fade in when created. this could also be written as transition('void => *')
    transition(':enter', [
        style({ opacity: 0 }),
        animate(600)
    ]),
    // fade out when destroyed. this could also be written as transition('void => *')
    transition(':leave', animate(600, style({ opacity: 0 })))
]);

/**
 * The Product Card component generates a card template which displays the product information.
 * A product description is displayed if type input is set to 'media'.
 * <h3>Preview</h3>
 * <div>
 *    <h4>1. Card</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productCard.png" style="max-width: 100%">
 *    <h4>2. Media</h4>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productCardMedia.png" style="max-width: 100%">
 * </div>
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductCardModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductCardModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage
```typescript
* <apt-product-card [product]="product"></apt-product-card>
```
*
```typescript
* // All inputs and outputs
* <apt-product-card
*              [product]="product"
*              [thumbnail]="showThumbnail"
*              [type]="card"
*              [showCategory]="showingCategory"
*              [showCode]="showingCode"
*              [showPrice]="showingPrice"
*              [canAddToCart]="canAddToCart"
* ></apt-product-card>
```
*/
class ProductCardComponent {
    constructor(config, BatchSelectionService, productService, activatedRoute, router, storefrontService, userService, productConfigurationService) {
        this.config = config;
        this.BatchSelectionService = BatchSelectionService;
        this.productService = productService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.storefrontService = storefrontService;
        this.userService = userService;
        this.productConfigurationService = productConfigurationService;
        /**
         * Flag to show the thumbnail image on the product card.
         */
        this.thumbnail = true;
        /**
         * Display type of the product card.
         */
        this.type = 'card';
        /**
         * Flag to show the category of the product.
         */
        this.showCategory = true;
        /**
         * Flag to show the code of the product.
         */
        this.showCode = true;
        /**
         * Flag to show the price of the product.
         */
        this.showPrice = true;
        /**
         * Flag to show the add to cart button on the card.
         */
        this.canAddToCart = true;
        /**
         * Rules to be skipped or not.
         */
        this.skipRules = false;
        /** @ignore */
        this.subs = [];
        /** @ignore */
        this.identifier = 'Id';
        /**
         * Array of batch action keys that are enabled.
         * @ignore
         */
        this.enabledActions = [];
        this.selected$ = of(false);
        this.identifier = this.config.get('productIdentifier');
    }
    ngOnInit() {
        this.isLoggedIn$ = this.userService.isLoggedIn();
        this.config$ = this.productConfigurationService.getConfigState().pipe(map(res => res.isConfig));
        this.storefrontService.getStorefront().pipe(take(1)).subscribe(storefront => {
            this.aboEnabled = get(storefront, 'EnableABO', false);
            this.enabledActions = split(get(storefront, 'AssetActions', ''), ';');
        });
        if (typeof this.product === 'string') {
            this.productService
                .get([this.product]).pipe(map(res => res[0]))
                .subscribe(p => {
                this._product = p;
                this.onProduct();
            });
        }
        else if (this.product instanceof Product) {
            this._product = this.product;
            this.onProduct();
        }
        else {
            throw 'apt-product-card product input must be a product or product id';
        }
    }
    /** @ignore */
    onProduct() {
        this.subs.push(this.BatchSelectionService.getSelectedProducts().subscribe(products => {
            this.selected$ = this.BatchSelectionService.isProductSelected(this._product);
        }));
    }
    /**
     * @ignore
     */
    ngOnChanges() { }
    /** @ignore */
    handleCheckbox(e) {
        if (e.target.checked)
            this.BatchSelectionService.addProductToSelection(this._product);
        else
            this.BatchSelectionService.removeProductFromSelection(this._product);
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        if (this.subs.length > 0) {
            this.subs.forEach(sub => sub.unsubscribe());
        }
    }
    /**
      * Remove product from Drawer
      * @ignore
     */
    removeProduct() {
        this.BatchSelectionService.removeProductFromSelection(this.product);
    }
}
ProductCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardComponent, deps: [{ token: i1$1.ConfigurationService }, { token: BatchSelectionService }, { token: i1.ProductService }, { token: i4$1.ActivatedRoute }, { token: i4$1.Router }, { token: i1.StorefrontService }, { token: i1.UserService }, { token: ProductConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
ProductCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductCardComponent, selector: "apt-product-card", inputs: { product: "product", thumbnail: "thumbnail", type: "type", showCategory: "showCategory", showCode: "showCode", showPrice: "showPrice", canAddToCart: "canAddToCart", skipRules: "skipRules" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"_product && _product[identifier]\">\r\n  <div class=\"card\" *ngIf=\"type == 'card'\">\r\n    <div class=\"card-body\">\r\n      <div class=\"custom-control custom-checkbox custom-checkbox-lg card-title\">\r\n        <input [id]=\"_product.Id\" type=\"checkbox\" class=\"custom-control-input\" (change)=\"handleCheckbox($event)\"\r\n          [checked]=\"selected$ | async\" />\r\n        <label class=\"custom-control-label d-flex justify-content-between\" [for]=\"_product.Id\"></label>\r\n        <div class=\"d-flex justify-content-between\">\r\n          <p class=\"m-0 font-weight-bold d-flex text-break\" tooltip=\"{{_product?.Name}}\" container=\"body\" placement=\"top\">{{ _product?.Name | truncate:30 }}</p>\r\n          <span class=\"pt-1 text-muted icons d-flex\">\r\n            <i\r\n              class=\"fa fa-shopping-bag\"\r\n              tooltip=\"{{'PRODUCT_CARD.INSTALLED_PRODUCT' | translate}}\"\r\n              container=\"body\"\r\n              [adaptivePosition]=\"false\"\r\n               *ngIf=\"aboEnabled && _product?.AssetLineItems?.length > 0 && isLoggedIn$ | async\"\r\n            >\r\n            </i>\r\n            <i class=\"fa fa-wrench\" tooltip=\"{{'PRODUCT_CARD.COMPLEX_PRODUCT' | translate}}\" container=\"body\" [adaptivePosition]=\"false\" *ngIf=\"_product.HasAttributes || _product.HasOptions\"></i>\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <a href=\"javascript:void(0)\" [routerLink]=\"['/products', _product[identifier]]\" [state]=\"_product\">\r\n        <div class=\"img-container\">\r\n          <img class=\"card-img-top w-100 m-auto d-flex align-self-center\" [src]=\"_product.IconId | image\"\r\n            [alt]=\"_product.Name\" *ngIf=\"thumbnail\">\r\n        </div>\r\n    \r\n        <div class=\"d-flex my-1 align-items-center split-items\">\r\n          <span class=\"text-muted product-code pr-1 text-truncate\" *ngIf=\"showCode\">{{_product.ProductCode}}</span>\r\n          <span class=\"text-muted product-category pl-1 pr-1 border-left text-truncate\"\r\n            *ngIf=\"showCategory && _product.Categories?.length > 0\">{{_product.Categories[0]?.Classification?.Name}}</span>\r\n        </div>\r\n        <span class=\"card-text font-weight-bold d-flex flex-column justify-content-between\" *ngIf=\"showPrice\">\r\n          <span class=\"text-truncate\">{{'PRODUCT_CARD.STANDARD_PRICE' | translate}}</span>\r\n          <apt-price [record]=\"_product\"></apt-price>\r\n        </span>\r\n      </a>\r\n    </div>\r\n    <div class=\"card-footer px-2\" *ngIf=\"canAddToCart\">\r\n      <apt-add-to-cart [skipRules]=\"skipRules\" size=\"sm\" [product]=\"_product\"></apt-add-to-cart>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"type == 'media'\" class=\"media\">\r\n    <div class=\"custom-control custom-checkbox custom-checkbox-lg\">\r\n      <input [id]=\"_product.Id\" type=\"checkbox\" class=\"custom-control-input\" (change)=\"handleCheckbox($event)\"\r\n        [checked]=\"selected$ | async\" />\r\n      <label class=\"custom-control-label mt-2 ml-2\" [for]=\"_product.Id\">&nbsp;</label>\r\n    </div>\r\n    <a href=\"javascript:void(0)\" [routerLink]=\"['/products', _product[identifier]]\"\r\n      class=\"d-flex justify-content-center w-25\" [state]=\"_product\">\r\n      <img class=\"mr-3\" [src]=\"_product.IconId | image\" [alt]=\"_product.Name\">\r\n    </a>\r\n    <div class=\"media-body px-3\">\r\n      <h5 class=\"m-0\">\r\n        <a href=\"javascript:void(0)\" [routerLink]=\"['/products', _product[identifier]]\" [state]=\"_product\">\r\n          {{_product.Name}}\r\n        </a>\r\n        <span class=\"ml-auto mr-3 purchased list-purchasedbucket\">\r\n          <i\r\n            *ngIf=\"aboEnabled && _product?.AssetLineItems?.length>0 && isLoggedIn$ | async\"\r\n            class=\"fa fa-shopping-bag\"\r\n            tooltip=\"{{'PRODUCT_CARD.INSTALLED_PRODUCT' | translate}}\"\r\n            container=\"body\"\r\n            [adaptivePosition]=\"false\"\r\n            aria-hidden=\"true\"\r\n          ></i>\r\n          <i class=\"fa fa-wrench\" tooltip=\"{{'PRODUCT_CARD.COMPLEX_PRODUCT' | translate}}\" container=\"body\" [adaptivePosition]=\"false\" *ngIf=\"_product.HasAttributes || _product.HasOptions\"></i>\r\n        </span>\r\n      </h5>\r\n      <div class=\"d-flex mb-3 align-items-center split-items\">\r\n        <div class=\"text-muted\" *ngIf=\"showCode\">{{_product.ProductCode}}</div>\r\n        <div class=\"text-muted\" *ngIf=\"showCategory && _product.Categories?.length > 0\">\r\n          {{_product.Categories[0]?.Classification?.Name}}</div>\r\n      </div>\r\n      <div class=\"productDescription\">\r\n        {{_product.Description}}\r\n      </div>\r\n    </div>\r\n    <div class=\"pl-4 align-self-stretch d-flex align-items-start flex-column\">\r\n      <strong class=\"mb-auto align-self-end\" *ngIf=\"showPrice\">\r\n        <apt-price [record]=\"_product\"></apt-price>\r\n      </strong>\r\n      <div *ngIf=\"canAddToCart\">\r\n        <apt-add-to-cart [skipRules]=\"skipRules\" size=\"sm\" [product]=\"_product\"></apt-add-to-cart>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"card\" *ngIf=\"type === 'readonly'\">\r\n    <div class=\"card-body readonly p-3\">\r\n      <div class=\"card-title d-flex justify-content-between align-items-start\">\r\n          <p class=\"m-0 card-title font-weight-bold text-break\" tooltip=\"{{_product?.Name}}\" container=\"body\" placement=\"top\">{{_product?.Name | truncate:30}}</p>\r\n          <button type=\"button\" class=\"btn btn-link p-0 close\" aria-label=\"Close\" (click)=\"removeProduct()\" *ngIf=\"selected$ | async\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n      </div>\r\n      <a href=\"javascript:void(0)\" [routerLink]=\"['/products', _product[identifier]]\" [state]=\"_product\">\r\n        <div class=\"img-container\">\r\n          <img class=\"card-img-top w-100 m-auto d-flex align-self-center\" [src]=\"_product.IconId | image\"\r\n            [alt]=\"_product.Name\" *ngIf=\"thumbnail\">\r\n        </div>\r\n    \r\n        <div class=\"d-flex mt-3 align-items-center split-items\" *ngIf=\"showCategory || showCode\">\r\n          <span class=\"text-muted product-code\" *ngIf=\"showCode\">{{_product.ProductCode}}</span>\r\n          <span class=\"text-muted product-category\"\r\n            *ngIf=\"showCategory && _product.Categories?.length > 0\">{{_product.Categories[0].Classification.Name}}</span>&nbsp;\r\n        </div>\r\n        <span class=\"card-text font-weight-bold d-flex flex-column justify-content-between mt-2\" *ngIf=\"showPrice\">\r\n          <span>{{'PRODUCT_CARD.STANDARD_PRICE' | translate}}</span>\r\n          <apt-price [record]=\"_product\"></apt-price>\r\n        </span>\r\n      </a>\r\n    </div>\r\n  </div>\r\n</ng-container>", styles: ["apt-product-card :host{display:block;width:100%}apt-product-card a{text-decoration:none;color:inherit}apt-product-card .card .card-body .card-title p{height:3rem}apt-product-card .card .card-body img{max-height:8rem;max-width:100%}apt-product-card .card .card-body .img-container{height:8rem}apt-product-card .card .card-body .card-text>span{font-size:x-small}apt-product-card .card .card-body .card-text apt-price{font-size:large}apt-product-card .card .card-body.readonly img{max-height:6rem;max-width:75%}apt-product-card .card .card-body.readonly .img-container{height:6rem}apt-product-card .split-items{height:2rem}apt-product-card .split-items>*{border-radius:0;line-height:15px}apt-product-card .product-code{max-width:50%}apt-product-card .product-category{max-width:50%}apt-product-card .purchased{float:right;padding-top:6px}apt-product-card button.btn.close{margin-top:-5px;line-height:.9;font-size:2rem}apt-product-card .btn.btn-primary.dropdown-toggle.dropdown-toggle-split{height:31px;padding-top:3px}apt-product-card .icons{white-space:nowrap}apt-product-card .icons i{font-size:smaller;margin-left:5px}apt-product-card .list-purchasedbucket{font-size:1rem;font-weight:400;position:absolute;padding-top:3px}apt-product-card .list-purchasedbucket .fa{padding-left:5px}apt-product-card label:before,apt-product-card label:after{top:.15rem}apt-product-card .media img{max-height:8rem;max-width:100%}apt-product-card .media apt-add-to-cart form.d-flex div:first-child{justify-content:flex-end!important}apt-product-card .media apt-add-to-cart form.d-flex div:last-child{justify-content:flex-end}apt-product-card .media apt-add-to-cart form.d-flex div:last-child>apt-cr-popover{flex-grow:unset!important;margin-right:0!important}apt-product-card .media apt-add-to-cart form.d-flex div:last-child>apt-cr-popover>div{margin-right:0!important}apt-product-card .productDescription{max-height:100px;overflow:auto}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: AddToCartComponent, selector: "apt-add-to-cart", inputs: ["product", "cartItems", "label", "showQuantityControls", "quantity", "configurationEnabled", "disabled", "aboEnabled", "btnClass", "size", "trigger", "skipRules"], outputs: ["onAddToCart"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "async": i5.AsyncPipe, "truncate": i1$1.TruncatePipe, "translate": i2$1.TranslatePipe, "image": i1$1.ImagePipe }, animations: [fade], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-card',
                    templateUrl: './product-card.component.html',
                    styleUrls: ['./product-card.component.scss'],
                    animations: [fade],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ConfigurationService }, { type: BatchSelectionService }, { type: i1.ProductService }, { type: i4$1.ActivatedRoute }, { type: i4$1.Router }, { type: i1.StorefrontService }, { type: i1.UserService }, { type: ProductConfigurationService }]; }, propDecorators: { product: [{
                type: Input
            }], thumbnail: [{
                type: Input
            }], type: [{
                type: Input
            }], showCategory: [{
                type: Input
            }], showCode: [{
                type: Input
            }], showPrice: [{
                type: Input
            }], canAddToCart: [{
                type: Input
            }], skipRules: [{
                type: Input
            }] } });

/**
  * The LineItem Card component generates a card template which displays the LineItem information.
  * <h3>Preview</h3>
  * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/line_item_card.png" style="max-width: 100%">
  * <h3>Usage</h3>
 *
 ```typescript
 import { LineItemCardModule } from '@congacommerce/elements';

 @NgModule({
  imports: [LineItemCardModule, ...]
})
 export class AppModule {}
 ```
  * @example
  * // Basic Usage
  ```typescript
  * <apt-lineitem-card [lineItem]="lineItem"></apt-lineitem-card>
  ```
  *
  * // All inputs and outputs
  ```typescript
  * <apt-lineitem-card
  *              [lineItem]="lineItem"
  *              [thumbnail]="showThumbnail"
  *              [showPrice]="showingPrice"
  * ></apt-lineitem-card>
  ```
  */
class LineitemCardComponent {
    constructor(config, BatchSelectionService) {
        this.config = config;
        this.BatchSelectionService = BatchSelectionService;
        /**
         * Flag to show the thumbnail image on the product card.
         */
        this.thumbnail = true;
        /**
         * Flag to show the price of the product.
         */
        this.showPrice = true;
        /** @ignore */
        this.subs = [];
        /** @ignore */
        this.identifier = 'Id';
        this.selected$ = of(false);
        this.identifier = this.config.get('productIdentifier');
    }
    ngOnInit() {
        if (this.lineItem instanceof CartItem) {
            this._lineItem = this.lineItem;
            this._product = get(this.lineItem, 'Product');
            this.subs.push(this.BatchSelectionService.getSelectedLineItems().subscribe(cartItems => {
                this.selected$ = this.BatchSelectionService.isLineItemSelected(this._lineItem);
            }));
        }
        else {
            throw 'apt-lineitem-card lineitem input must be a lineitem or lineitem id';
        }
    }
    /**
      * Remove cart item from Drawer
      * @ignore
     */
    removeCartItem() {
        this.BatchSelectionService.removeLineItemFromSelection(this.lineItem);
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        if (this.subs.length > 0) {
            this.subs.forEach(sub => sub.unsubscribe());
        }
    }
}
LineitemCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardComponent, deps: [{ token: i1$1.ConfigurationService }, { token: BatchSelectionService }], target: i0.ɵɵFactoryTarget.Component });
LineitemCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LineitemCardComponent, selector: "apt-lineitem-card", inputs: { lineItem: "lineItem", thumbnail: "thumbnail", showPrice: "showPrice" }, ngImport: i0, template: "<ng-container *ngIf=\"_lineItem && _lineItem[identifier]\">\r\n  <div class=\"card\">\r\n    <div class=\"card-body readonly p-3\">\r\n      <div class=\"card-title d-flex justify-content-between align-items-start\">\r\n        <p class=\"m-0 card-title font-weight-bold text-break\" tooltip=\"{{_product?.Name}}\" container=\"body\"\r\n          placement=\"top\">{{_product?.Name | truncate:30}}</p>\r\n        <button type=\"button\" class=\"btn btn-link p-0 close\" aria-label=\"Close\" (click)=\"removeCartItem()\"\r\n          *ngIf=\"selected$ | async\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n      </div>\r\n      <a href=\"javascript:void(0)\" [routerLink]=\"['/products', _product[identifier], _lineItem[identifier]]\"\r\n        [state]=\"_product\">\r\n        <div class=\"img-container\">\r\n          <img class=\"card-img-top w-100 m-auto d-flex align-self-center\" [src]=\"_product.IconId | image\"\r\n            [alt]=\"_product.Name\" *ngIf=\"thumbnail\">\r\n        </div>\r\n\r\n        <span class=\"card-text font-weight-bold d-flex flex-column justify-content-between mt-2\" *ngIf=\"showPrice\">\r\n          <span>{{'COMMON.NET_PRICE' | translate}}</span>\r\n          <apt-price [record]=\"_lineItem\" type=\"net\"></apt-price>\r\n        </span>\r\n      </a>\r\n    </div>\r\n  </div>\r\n</ng-container>", styles: ["apt-lineitem-card :host{display:block;width:100%}apt-lineitem-card a{text-decoration:none;color:inherit}apt-lineitem-card .card .card-body .card-title p{height:3rem}apt-lineitem-card .card .card-body img{max-height:8rem;max-width:100%}apt-lineitem-card .card .card-body .img-container{height:8rem}apt-lineitem-card .card .card-body.readonly img{max-height:6rem;max-width:75%}apt-lineitem-card .card .card-body.readonly .img-container{height:6rem}apt-lineitem-card .card .card-body.readonly .card-text>span{font-size:.65rem}apt-lineitem-card .card .card-body.readonly .card-text apt-price{font-size:1.1rem}apt-lineitem-card .split-items>*{border-radius:0;border-right:1px solid #000;padding-right:7px;margin-right:7px;padding-bottom:0;line-height:15px}apt-lineitem-card .split-items>*:last-child{border-right:none}apt-lineitem-card button.btn.close{margin-top:-5px;line-height:.9;font-size:2rem}apt-lineitem-card .btn.btn-primary.dropdown-toggle.dropdown-toggle-split{height:31px;padding-top:3px}apt-lineitem-card .list-purchasedbucket{font-size:1rem;font-weight:400;position:absolute;padding-top:3px}apt-lineitem-card .list-purchasedbucket .fa{padding-left:5px}apt-lineitem-card label:before,apt-lineitem-card label:after{top:.15rem}apt-lineitem-card label .icons{white-space:nowrap}apt-lineitem-card label .icons i{font-size:smaller;margin-left:5px}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "truncate": i1$1.TruncatePipe, "async": i5.AsyncPipe, "image": i1$1.ImagePipe, "translate": i2$1.TranslatePipe }, animations: [fade], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-lineitem-card',
                    templateUrl: './lineitem-card.component.html',
                    styleUrls: ['./lineitem-card.component.scss'],
                    animations: [fade],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ConfigurationService }, { type: BatchSelectionService }]; }, propDecorators: { lineItem: [{
                type: Input
            }], thumbnail: [{
                type: Input
            }], showPrice: [{
                type: Input
            }] } });

/**
 * The Product carousel component is a carousel to display the list of products based on the categories which is populated from the  selected price list.
 * The user can slide and view the products listed in the carousel. When user clicks on any product it launches product detail page of the product selelcted.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productCarousel.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductCarouselModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductCarouselModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage
```typescript
* <apt-product-carousel [productList]="products"></apt-product-carousel>
```
*
* // All inputs and outputs.
```typescript
* <apt-product-carousel
*             [productList]="products"
*             [dots]="showingDots"
*             [slides]="numberOfSlides"
*             [draggable]="isDraggable"
*             [leftAlign]="isLeftAlign"
*             [title]="title"
*             [subtitle]="subtitle"
* ></apt-product-carousel>
```
*/
class ProductCarouselComponent {
    constructor() {
        /**
         * Show the dots in carousel
         */
        this.dots = true;
        /**
         * Set the slide count in carousel
         */
        this.slides = 5;
        /**
        *  Allow drags in carousel
        */
        this.draggable = true;
        /**
        * Set carousel alignment to left.
        */
        this.leftAlign = true;
        /**
         * Flag to set product card type as read only or not.
         */
        this.readonly = false;
        /**
         * Flag to show category name on the product card.
         */
        this.showCategory = true;
        /**
         * Flag to show product code on the product card.
         */
        this.showCode = true;
        /** @ignore */
        this.cardType = 'card';
    }
    ngOnChanges() {
        this.cardType = (this.readonly) ? 'readonly' : 'card';
        if (!isNil(this.carouselList)) {
            this.carouselList.forEach(i => i.ngAfterViewInit());
        }
        this.adjustCarouselSlide();
    }
    /** @ignore  */
    trackById(index, record) {
        return get(record, 'Id');
    }
    /** The function used to set number of slides for the carousel based on screen width */
    adjustCarouselSlide() {
        if (window.innerWidth < 576)
            this.slides = 1;
        else if (window.innerWidth < 768)
            this.slides = 2;
        else if (window.innerWidth < 992)
            this.slides = 3;
        else
            this.slides = 4;
    }
}
ProductCarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ProductCarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductCarouselComponent, selector: "apt-product-carousel", inputs: { productList: "productList", cartItemList: "cartItemList", dots: "dots", slides: "slides", draggable: "draggable", leftAlign: "leftAlign", title: "title", subtitle: "subtitle", readonly: "readonly", showCategory: "showCategory", showCode: "showCode" }, viewQueries: [{ propertyName: "carouselList", predicate: CarouselComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"productList?.length > 0\">\r\n    <h3 class=\"mt-5\" [innerHTML]=\"title\" *ngIf=\"title\"></h3>\r\n    <p [innerHTML]=\"subtitle\" *ngIf=\"subtitle\"></p>\r\n    <carousel [itemsPerSlide]=\"slides\" [interval]=\"0\" [indicatorsByChunk]=\"true\" [showIndicators]=\"false\" class=\"d-lg-block\">\r\n        <slide *ngFor=\"let product of productList; trackBy: trackById\">\r\n            <apt-product-card [product]=\"product\" class=\"d-block mr-2 ml-2\" *ngIf=\"product?.Id\" [type]=\"cardType\" [showCategory]=\"showCategory\" [showCode]=\"showCode\"></apt-product-card>\r\n        </slide>\r\n    </carousel>\r\n</div>\r\n\r\n<div *ngIf=\"cartItemList?.length > 0\">\r\n    <h3 class=\"mt-5\" [innerHTML]=\"title\" *ngIf=\"title\"></h3>\r\n    <p [innerHTML]=\"subtitle\" *ngIf=\"subtitle\"></p>\r\n    <carousel [itemsPerSlide]=\"slides\" [interval]=\"0\" [indicatorsByChunk]=\"true\" [showIndicators]=\"false\" class=\"d-lg-block\">\r\n        <slide *ngFor=\"let cartItem of cartItemList; trackBy: trackById\" >\r\n            <apt-lineitem-card [lineItem]=\"cartItem\" class=\"d-block mr-2 ml-2\" *ngIf=\"cartItem?.Id\"></apt-lineitem-card>\r\n        </slide>\r\n    </carousel>\r\n\r\n</div>", styles: ["apt-product-carousel .carousel.slide{padding:0 1.5rem}apt-product-carousel .carousel.slide:focus{outline:none}apt-product-carousel .carousel.slide .carousel-inner{overflow:initial;display:block}apt-product-carousel .carousel.slide .carousel-indicators li{box-shadow:inset 1px 1px 1px 1px #00000080;background-color:#46464640;width:10px;height:10px;border-radius:100%}apt-product-carousel .carousel.slide .carousel-indicators li.active{background-color:#000}apt-product-carousel .carousel.slide slide.item.carousel-item{perspective:inherit;-webkit-perspective:inherit;animation-duration:1s;animation-fill-mode:both;margin-right:inherit;padding:0 .25rem}apt-product-carousel .carousel.slide .carousel-control{display:block;background:rgba(0,0,0,.4);top:46%;width:1.5rem;height:1.5rem;border-radius:50%;line-height:1.5rem}apt-product-carousel .carousel.slide .carousel-control-prev{left:0}apt-product-carousel .carousel.slide .carousel-control-next{right:0}apt-product-carousel .carousel.slide .carousel-control-prev-icon,apt-product-carousel .carousel.slide .carousel-control-next-icon{height:10px;width:10px}\n"], components: [{ type: i1$5.CarouselComponent, selector: "carousel", inputs: ["indicatorsByChunk", "itemsPerSlide", "singleSlideOffset", "isAnimated", "startFromIndex", "activeSlide", "interval", "noWrap", "noPause", "showIndicators", "pauseOnFocus"], outputs: ["activeSlideChange", "slideRangeChange"] }, { type: i1$5.SlideComponent, selector: "slide", inputs: ["active"] }, { type: ProductCardComponent, selector: "apt-product-card", inputs: ["product", "thumbnail", "type", "showCategory", "showCode", "showPrice", "canAddToCart", "skipRules"] }, { type: LineitemCardComponent, selector: "apt-lineitem-card", inputs: ["lineItem", "thumbnail", "showPrice"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselComponent, decorators: [{
            type: Component,
            args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'apt-product-carousel',
                    templateUrl: `./product-carousel.component.html`,
                    styleUrls: ['./product-carousel.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { productList: [{
                type: Input
            }], cartItemList: [{
                type: Input
            }], dots: [{
                type: Input
            }], slides: [{
                type: Input
            }], draggable: [{
                type: Input
            }], leftAlign: [{
                type: Input
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], readonly: [{
                type: Input
            }], showCategory: [{
                type: Input
            }], showCode: [{
                type: Input
            }], carouselList: [{
                type: ViewChildren,
                args: [CarouselComponent]
            }] } });

/**
 * Batch action component is used to display the list of currently active batch actions as buttons on the UI of the product drawer component.
 * @ignore
*/
class BatchActionComponent {
    constructor(batchSelectionService, batchActionService) {
        this.batchSelectionService = batchSelectionService;
        this.batchActionService = batchActionService;
        /**
         * Output that is called when a batch action button is clicked.
         */
        this.actionFired = new EventEmitter();
        /**
        * Input for active pill
        */
        this.activePill = null;
        /**
         * Current subscriptions in this class.
         * @ignore
         */
        this.subs = [];
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this.subs.push(this.batchSelectionService.getSelectedProducts().subscribe(res => this.products = res));
        this.subs.push(this.batchSelectionService.getSelectedLineItems().subscribe(res => this.cartItems = res));
        this.subs.push(this.batchActionService.getBatchActions().pipe(map(actions => filter$1(actions, action => !action.disabled))).subscribe(res => {
            this.actionList = res;
            this.actionBatch = res[0];
        }));
        this.subs.push(this.batchActionService.isLoading().subscribe(res => {
            this.loading = res;
        }));
    }
    /**
     * Calls the given batch action's action method and calls the actionFired output.
     * @param action Batch action that was triggered.
     */
    handleClick() {
        const items = (this.activePill === 'Product') ? this.products : this.cartItems;
        this.actionBatch.getActionMethod()(items);
        this.actionFired.emit(true);
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }
}
BatchActionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchActionComponent, deps: [{ token: BatchSelectionService }, { token: BatchActionService }], target: i0.ɵɵFactoryTarget.Component });
BatchActionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: BatchActionComponent, selector: "apt-batch-action", inputs: { activePill: "activePill" }, outputs: { actionFired: "actionFired" }, ngImport: i0, template: "<div class=\"d-flex flex-md-column align-items-center\" *ngIf=\"actionList.length > 0\">\r\n    <label class=\"w-100 font-weight-bold\">{{ 'COMMON.SELECT_ACTION' | translate }}</label>\r\n    <select class=\"form-control sm\" [(ngModel)]=\"actionBatch\">\r\n        <ng-container *ngFor=\"let action of actionList\">\r\n            <option [ngValue]=\"action\" *ngIf=\"!action.isDisabled()\">{{action.getTranslationKey() | translate}}</option> \r\n        </ng-container>\r\n    </select>\r\n    <button class=\"btn btn-raised btn-primary my-md-3\" (click)=\"handleClick()\" [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\" type=\"button\" [disabled]=\"(actionList.length === 0)\">\r\n        {{ 'COMMON.CONFIRM' | translate }}\r\n    </button> \r\n  </div>", styles: ["button{width:100%;justify-content:center}button:hover{text-decoration:none}button:focus{text-decoration:none}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BatchActionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-batch-action',
                    templateUrl: './batch-action.component.html',
                    styleUrls: ['./batch-action.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: BatchSelectionService }, { type: BatchActionService }]; }, propDecorators: { actionFired: [{
                type: Output
            }], activePill: [{
                type: Input
            }] } });

/**
 * Product drawer component is used to create a toggleable drawer on the bottom of the screen that displays currently selected products and their associated batch actions.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productDrawer.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductDrawerModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductDrawerModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
<apt-product-drawer [products]="products"></apt-product-drawer>
```
*/
class ProductDrawerComponent {
    constructor(batchSelectionService, productDrawerService, batchActionService) {
        this.batchSelectionService = batchSelectionService;
        this.productDrawerService = productDrawerService;
        this.batchActionService = batchActionService;
        /**
         * Flag used to show/hide the drawer.
         * @ignore
         */
        this.hidden = false;
        /**
         * Current subscriptions in this class.
         * @ignore
         */
        this.subs = [];
        /**
         * Use to hold currect active tab for drawer.
         */
        this.activePill = '';
    }
    ngOnInit() {
        this.drawerIsOpen$ = this.productDrawerService.isDrawerOpen();
        this.products$ = this.batchSelectionService.getSelectedProducts();
        this.subs.push(this.batchSelectionService.getSelectedProducts().subscribe((product) => {
            this.activePill = (product && product.length > 0) ? 'Product' : 'CartItem';
            this.productDrawerService.openDrawer();
        }));
        this.cartItems$ = this.batchSelectionService.getSelectedLineItems();
        this.subs.push(this.batchSelectionService.getSelectedLineItems().subscribe((cartItem) => {
            this.activePill = (cartItem && cartItem.length > 0) ? 'CartItem' : 'Product';
            this.productDrawerService.openDrawer();
        }));
    }
    /**
     * Event method that is called when a batch action is clicked.
     * @param event Event from batch action being clicked.
     * @ignore
     */
    onAction(event) {
        if (event)
            this.productDrawerService.closeDrawer();
    }
    /**
     * Toggles the drawer between hidden and visible.
     * @ignore
     */
    toggleDrawer() {
        this.productDrawerService.toggleDrawer();
    }
    /**
     * Sets the drawer to visibile.
     * @ignore
     */
    openDrawer() {
        this.hidden = false;
    }
    /**
     * Sets the drawer to hidden.
     * @ignore
     */
    closeDrawer() {
        this.hidden = true;
    }
    /**
     * Activate Product/CartItem Pill in the drawer.
     * @ignore
     */
    setActivePill(pill) {
        this.activePill = pill;
        if (pill === 'Product')
            this.batchActionService.activateProductActions();
        else if (pill === 'CartItem')
            this.batchActionService.activateCartitemActions();
    }
    /**
     * Remove all products from drawer
     * @ignore
     */
    removeAllProducts(event) {
        event.stopPropagation();
        if (confirm('Do you want to remove all selected products?')) {
            this.batchSelectionService.removeAllProducts();
            return true;
        }
        else
            return false;
    }
    /**
     * Remove all cart items from drawer
     * @ignore
     */
    removeAllCartItems(event) {
        event.stopPropagation();
        if (confirm('Do you want to remove all selected cart items?')) {
            this.batchSelectionService.removeAllLineitems();
            return true;
        }
        else
            return false;
    }
    ngOnDestroy() {
        if (this.subs && this.subs.length > 0) {
            this.subs.forEach(sub => sub.unsubscribe());
        }
    }
}
ProductDrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerComponent, deps: [{ token: BatchSelectionService }, { token: ProductDrawerService }, { token: BatchActionService }], target: i0.ɵɵFactoryTarget.Component });
ProductDrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductDrawerComponent, selector: "apt-product-drawer", inputs: { products: "products" }, ngImport: i0, template: "<div class=\"bannerWrapper\" [class.hiddenBelow]='!(drawerIsOpen$ | async)'>\r\n  <div class=\"body container-fluid bg-white\" *ngIf=\"{ products: products$ | async, cartItems: cartItems$ | async } as data\">\r\n    <div class=\"tab px-3 bg-white\" (click)=\"toggleDrawer()\">\r\n      <span class=\"d-md-inline\"> {{'COMMON.SELECTIONS' | translate}} </span>\r\n      <apt-super-chevron direction=\"{{!(drawerIsOpen$ | async) ? 'up' : 'down'}}\"></apt-super-chevron>\r\n    </div>\r\n    <div class=\"drawer-selection\">\r\n        <button class=\"btn btn-sm btn-pill btn-raised shadow-none m-2 p-0 pl-2\"\r\n                *ngIf=\"data.products && data.products.length > 0\"\r\n                [ngClass]=\"activePill==='Product' ? 'btn-primary' : 'btn-outline-primary'\"\r\n                (click)=\"setActivePill('Product')\">\r\n                {{ 'COMMON.PRODUCTS' | translate }} ({{ data.products.length }}) \r\n                <button class=\"btn btn-link text-white p-0\" (click)=\"removeAllProducts($event)\">\r\n                  <i class=\"fas fa-times\"></i>\r\n                </button>\r\n        </button>\r\n        <button class=\"btn btn-sm btn-pill btn-raised shadow-none m-2 p-0 pl-2\"\r\n                *ngIf=\"data.cartItems && data.cartItems.length > 0\"\r\n                [ngClass]=\"activePill==='CartItem' ? 'btn-primary' : 'btn-outline-primary'\"\r\n                (click)=\"setActivePill('CartItem')\" >\r\n                {{ 'COMMON.CARTITEMS' | translate }} ({{data.cartItems.length}}) \r\n                <button class=\"btn btn-link text-white p-0\" (click)=\"removeAllCartItems($event)\">\r\n                  <i class=\"fas fa-times\"></i>\r\n                </button>\r\n        </button>\r\n    </div>\r\n    <div class=\"row h-100\">\r\n      <div class=\"col-lg-10 col-md-9 col-12\">\r\n        <div class=\"justify-content-center flex-column\" *ngIf=\"data.products && data.products?.length > 0\" [ngClass]=\"activePill === 'Product' ? 'd-flex': 'd-none'\">\r\n            <apt-product-carousel [productList]=\"data.products\" [readonly]=\"true\" [showCategory]=\"false\" [showCode]=\"false\"></apt-product-carousel>\r\n        </div>\r\n        <div class=\"justify-content-center flex-column\" *ngIf=\"data.cartItems && data.cartItems?.length > 0\" [ngClass]=\"activePill === 'CartItem' ? 'd-flex': 'd-none'\">\r\n            <apt-product-carousel [cartItemList]=\"data.cartItems\" [readonly]=\"true\" [showCategory]=\"false\" [showCode]=\"false\"></apt-product-carousel>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-2 col-md-3 col-12 my-md-2 pb-md-3\">\r\n        <apt-batch-action (actionFired)=\"onAction($event)\" [activePill]=\"activePill\"></apt-batch-action>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".bannerWrapper{position:fixed;width:100%;height:18.5rem;bottom:0px;pointer-events:none;transition:bottom .4s ease-in-out;z-index:1000}.bannerWrapper.hiddenBelow{bottom:-18.5rem}.bannerWrapper .batchActionWrapper{overflow-y:auto}.bannerWrapper .body{position:relative;pointer-events:fill;height:100%;margin:0 auto;border:1px solid #aaa}.bannerWrapper .body .tab{position:absolute;display:flex;justify-content:space-between;left:-1px;top:-40px;height:40px;width:120px;line-height:40px;border:1px solid #aaa;border-top-left-radius:8px;border-top-right-radius:8px;border-bottom:none;cursor:pointer}.bannerWrapper .drawer-selection .btn:focus{box-shadow:none}.bannerWrapper .drawer-selection .btn-pill{height:1.6rem;font-size:.65rem}.bannerWrapper .drawer-selection .btn-link{height:1.4rem;margin:2px 8px}.bannerWrapper .drawer-selection .btn-outline-primary .btn-link{color:#0079cc!important}.bannerWrapper .drawer-selection .btn-outline-primary:hover .btn-link{color:#fff!important}@media (min-width: 768px){.bannerWrapper .body{width:80%}.bannerWrapper .body .tab{width:300px}}@media (max-width: 767.98px){.bannerWrapper{height:23rem}.bannerWrapper.hiddenBelow{bottom:-23rem}.carousel{height:95%;overflow:hidden}.batchActionWrapper{position:absolute;top:-40px;left:118px;width:calc(100% - 117px);height:40px;border-top:1px solid #aaa;border-right:1px solid #aaa;background-color:#fff}}\n"], components: [{ type: SuperChevronComponent, selector: "apt-super-chevron", inputs: ["direction"] }, { type: ProductCarouselComponent, selector: "apt-product-carousel", inputs: ["productList", "cartItemList", "dots", "slides", "draggable", "leftAlign", "title", "subtitle", "readonly", "showCategory", "showCode"] }, { type: BatchActionComponent, selector: "apt-batch-action", inputs: ["activePill"], outputs: ["actionFired"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-drawer',
                    templateUrl: './product-drawer.component.html',
                    styleUrls: ['./product-drawer.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: BatchSelectionService }, { type: ProductDrawerService }, { type: BatchActionService }]; }, propDecorators: { products: [{
                type: Input
            }] } });

/**
 * Compare product card is used as the header in the compare table.
 * Compare cards show product details including images, price, short description, and add to cart button.
 * @ignore
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/compareProductCard.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductCardModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductCardModule, ...]
})
export class AppModule {}
 ```
* @example
* <apt-compare-product-card [product]="product"></apt-compare-product-card>
*/
class CompareProductCardComponent extends ProductCardComponent {
    constructor() {
        super(...arguments);
        /**
         * The product identifier set in the configuration file.
         * @ignore
         */
        this.identifier = 'Id';
    }
    /**
     * Removes the product associated with this card from the product compare table.
     * @ignore
     */
    removeProduct() {
        this.activatedRoute.queryParams.pipe(take(1)).subscribe(params => {
            let array = params.products.split(',');
            let filtered = array.filter(value => {
                return value !== this._product[this.identifier];
            });
            this.router.navigateByUrl(`/products/compare?products=${filtered.join(',')}`);
        });
    }
}
CompareProductCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CompareProductCardComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
CompareProductCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: CompareProductCardComponent, selector: "apt-compare-product-card", usesInheritance: true, ngImport: i0, template: "<div class=\"card compareProductCard\">\r\n  <button type=\"button\" class=\"close remove-button\" aria-label=\"Close\" (click)=\"removeProduct()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n  <a href=\"javascript.void(0)\" [routerLink]=\"['/products', _product[identifier]]\" class=\"pt-3\">\r\n    <div class=\"img-container\">\r\n      <img class=\"card-img-top w-50 m-auto d-flex align-self-center\" [src]=\"_product.IconId | image\" [alt]=\"_product.Name\">\r\n    </div>\r\n    <div class=\"card-body\">\r\n      <h5 class=\"card-title mb-0\">{{_product.Name}}</h5>\r\n      <div class=\"d-flex mb-3 align-items-center split-items\">\r\n        <small class=\"text-muted product-code\" *ngIf=\"showCode\">{{_product.ProductCode}}</small>\r\n        <small class=\"text-muted product-category\" *ngIf=\"showCategory && _product.Categories?.length > 0\">{{_product.Categories[0]?.Classification?.Name}}</small>\r\n      </div>\r\n      <p class=\"card-text font-weight-bold\">\r\n        <apt-price [record]=\"_product\"></apt-price>\r\n      </p>\r\n    </div>\r\n  </a>\r\n  <div class=\"card-footer\" *ngIf=\"canAddToCart\">\r\n    <apt-add-to-cart [product]=\"_product\"></apt-add-to-cart>\r\n  </div>\r\n</div>\r\n", styles: [".compareProductCard{max-width:350px}.card-title{height:52px;overflow-y:hidden}img{max-height:8rem;max-width:100%}.img-container{height:8rem}.remove-button{position:absolute;right:7px;top:0px}.split-items>*{border-radius:0;border-right:1px solid #000;padding-right:7px;margin-right:7px;padding-bottom:0;line-height:15px}.split-items>*:last-child{border-right:none}.product-code{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:50%}.product-category{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:50%}\n"], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: AddToCartComponent, selector: "apt-add-to-cart", inputs: ["product", "cartItems", "label", "showQuantityControls", "quantity", "configurationEnabled", "disabled", "aboEnabled", "btnClass", "size", "trigger", "skipRules"], outputs: ["onAddToCart"] }], directives: [{ type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "image": i1$1.ImagePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CompareProductCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-compare-product-card',
                    templateUrl: './compare-product-card.component.html',
                    styleUrls: ['./compare-product-card.component.scss']
                }]
        }] });

/**
 * @ignore
 */
class ProductCardModule {
}
ProductCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardModule, declarations: [ProductCardComponent, CompareProductCardComponent], imports: [CommonModule,
        ButtonModule,
        PriceModule,
        TooltipModule,
        RouterModule,
        ApttusModule, i2$1.TranslateModule], exports: [ProductCardComponent, CompareProductCardComponent] });
ProductCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardModule, imports: [[
            CommonModule,
            ButtonModule,
            PriceModule,
            TooltipModule,
            RouterModule,
            ApttusModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        PriceModule,
                        TooltipModule,
                        RouterModule,
                        ApttusModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [ProductCardComponent, CompareProductCardComponent],
                    exports: [ProductCardComponent, CompareProductCardComponent]
                }]
        }] });

/**
 * @ignore
 */
class LineitemCardModule {
}
LineitemCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LineitemCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardModule, declarations: [LineitemCardComponent], imports: [CommonModule,
        ButtonModule,
        PriceModule,
        TooltipModule,
        RouterModule,
        ApttusModule, i2$1.TranslateModule], exports: [LineitemCardComponent] });
LineitemCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardModule, imports: [[
            CommonModule,
            ButtonModule,
            PriceModule,
            TooltipModule,
            RouterModule,
            ApttusModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineitemCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        PriceModule,
                        TooltipModule,
                        RouterModule,
                        ApttusModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [LineitemCardComponent],
                    exports: [LineitemCardComponent]
                }]
        }] });

/**
 * @ignore
 */
class ProductCarouselModule {
}
ProductCarouselModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductCarouselModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselModule, declarations: [ProductCarouselComponent], imports: [CommonModule,
        ProductCardModule,
        LineitemCardModule, i1$5.CarouselModule], exports: [ProductCarouselComponent] });
ProductCarouselModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselModule, imports: [[
            CommonModule,
            ProductCardModule,
            LineitemCardModule,
            CarouselModule.forRoot()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ProductCardModule,
                        LineitemCardModule,
                        CarouselModule.forRoot()
                    ],
                    declarations: [ProductCarouselComponent],
                    exports: [ProductCarouselComponent]
                }]
        }] });

/**
 * @ignore
 */
class ProductDrawerModule {
}
ProductDrawerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductDrawerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerModule, declarations: [ProductDrawerComponent, SuperChevronComponent, BatchActionComponent], imports: [CommonModule,
        FormsModule,
        LaddaModule,
        ProductCarouselModule,
        ProductCardModule,
        LineitemCardModule, i4$2.TooltipModule, i2$1.TranslateModule], exports: [ProductDrawerComponent] });
ProductDrawerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerModule, imports: [[
            CommonModule,
            FormsModule,
            LaddaModule,
            ProductCarouselModule,
            ProductCardModule,
            LineitemCardModule,
            TooltipModule.forRoot(),
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        LaddaModule,
                        ProductCarouselModule,
                        ProductCardModule,
                        LineitemCardModule,
                        TooltipModule.forRoot(),
                        TranslateModule.forChild()
                    ],
                    declarations: [ProductDrawerComponent, SuperChevronComponent, BatchActionComponent],
                    exports: [ProductDrawerComponent]
                }]
        }] });

/**
 * The Product Images component displays the image of the products.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productImages.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductImagesModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductImagesModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-product-images [product]="product"></apt-product-images>
```
*/
class ProductImagesComponent {
    constructor(dss, config, productInformationService) {
        this.dss = dss;
        this.config = config;
        this.productInformationService = productInformationService;
        /**
         * Flag to show the thumbnails.
         */
        this.thumbnails = true;
        /** @ignore */
        this.showBlank = false;
    }
    ngOnChanges() {
        if (this.product) {
            this.productInformationService.getProductInformation(this.product.Id).subscribe(result => {
                const Attachments = result.map(res => res.Attachments);
                if (Attachments) {
                    this.galleryOptions = [
                        {
                            width: '100%',
                            thumbnailsColumns: 4,
                            imageAnimation: NgxGalleryAnimation.Slide,
                            imageSize: 'contain',
                            arrowPrevIcon: 'fa fa-arrow-circle-left text-dark',
                            arrowNextIcon: 'fa fa-arrow-circle-right text-dark',
                            thumbnailsArrows: false,
                            imageInfinityMove: true,
                            closeIcon: 'fa fa-times-circle-o text-dark',
                            thumbnails: this.thumbnails && Attachments.length > 1,
                            previewCloseOnClick: true,
                            previewCloseOnEsc: true,
                        },
                        // max-width 400
                        {
                            breakpoint: 767,
                            preview: false,
                            width: '100%',
                            imagePercent: 80,
                            thumbnails: this.thumbnails && Attachments.length > 1,
                            thumbnailsPercent: 20,
                            thumbnailsMargin: 20,
                            thumbnailMargin: 20
                        }
                    ];
                    this.galleryImages = [];
                    if (Attachments.length > 0) {
                        result.forEach(productinfo => {
                            if (_.get(productinfo, 'Attachments')) {
                                productinfo.Attachments.forEach(attachment => {
                                    this.galleryImages.push({
                                        small: new ImagePipe(this.config, this.dss).transform(attachment.Id, true, false, productinfo.ProductId),
                                        medium: new ImagePipe(this.config, this.dss).transform(attachment.Id, true, false, productinfo.ProductId),
                                        big: new ImagePipe(this.config, this.dss).transform(attachment.Id, true, false, productinfo.ProductId)
                                    });
                                });
                            }
                        });
                    }
                    if (_.get(this.product, 'IconId')) {
                        this.galleryImages.push({
                            small: new ImagePipe(this.config, this.dss).transform(this.product.IconId, true, false, this.product.Id),
                            medium: new ImagePipe(this.config, this.dss).transform(this.product.IconId, true, false, this.product.Id),
                            big: new ImagePipe(this.config, this.dss).transform(this.product.IconId, true, false, this.product.Id)
                        });
                    }
                    if (!this.galleryImages || this.galleryImages.length === 0)
                        this.showBlank = true;
                }
            });
        }
    }
}
ProductImagesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesComponent, deps: [{ token: i1$3.DomSanitizer }, { token: i1$1.ConfigurationService }, { token: i1.ProductInformationService }], target: i0.ɵɵFactoryTarget.Component });
ProductImagesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductImagesComponent, selector: "apt-product-images", inputs: { product: "product", thumbnails: "thumbnails" }, usesOnChanges: true, ngImport: i0, template: `
      <ngx-gallery [options]="galleryOptions" [images]="galleryImages" *ngIf="!showBlank && galleryImages && galleryImages.length > 0"></ngx-gallery>
      <img [src]="null | image" *ngIf="showBlank" class="w-100 img-fluid"/>
    `, isInline: true, styles: ["\n      :host{\n        height: 28rem;\n        display: block;\n      }\n    "], components: [{ type: i4$3.NgxGalleryComponent, selector: "ngx-gallery", inputs: ["options", "images"], outputs: ["imagesReady", "change", "previewOpen", "previewClose", "previewChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "image": i1$1.ImagePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-images',
                    template: `
      <ngx-gallery [options]="galleryOptions" [images]="galleryImages" *ngIf="!showBlank && galleryImages && galleryImages.length > 0"></ngx-gallery>
      <img [src]="null | image" *ngIf="showBlank" class="w-100 img-fluid"/>
    `,
                    styles: [`
      :host{
        height: 28rem;
        display: block;
      }
    `]
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }, { type: i1$1.ConfigurationService }, { type: i1.ProductInformationService }]; }, propDecorators: { product: [{
                type: Input
            }], thumbnails: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class ProductImagesModule {
}
ProductImagesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductImagesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesModule, declarations: [ProductImagesComponent], imports: [CommonModule,
        NgxGalleryModule,
        ApttusModule], exports: [ProductImagesComponent] });
ProductImagesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesModule, imports: [[
            CommonModule,
            NgxGalleryModule,
            ApttusModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductImagesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgxGalleryModule,
                        ApttusModule
                    ],
                    declarations: [ProductImagesComponent],
                    exports: [ProductImagesComponent]
                }]
        }] });

/**
 * Jumbotron component is used to showcase key marketing messages on the site.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/jumbotron.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { JumbotronModule } from '@congacommerce/elements';

@NgModule({
  imports: [JumbotronModule, ...]
})
export class AppModule {}
 ```
* @example
* // Basic Usage.
 ```typescript
* <apt-jumbotron
*               [storefront]="storefront"
* ><apt-jumbotron>
 ```
*
* // Implementation with custom options.
 ```typescript
* <apt-jumbotron
*               [storefront]="storefront"
*               [height]="height"
*               [imagePosition]="center"
*               [brightness]="brightness"
* ></apt-jumbotron>
 ```
*/
class JumbotronComponent {
    constructor(sanitizer, storefrontService) {
        this.sanitizer = sanitizer;
        this.storefrontService = storefrontService;
        /**
         * height for jumbotron it's type is string.
         */
        this.height = '20rem';
        /**
         *  brightness it's type is number to set the brightness of jumbotron.
         */
        this.brightness = 40;
    }
    /**
     * set the height for the jumbotron using height property.
     * @ignore
     */
    get heightStyle() {
        return this.sanitizer.bypassSecurityTrustStyle('height: ' + this.height);
    }
    /**
     * set the visual efffects  for the jumbotron using filter property.
     * @ignore
     */
    get filterStyle() {
        return this.sanitizer.bypassSecurityTrustStyle('filter: brightness(' + this.brightness + '%)');
    }
    ngOnInit() {
        this.storefront$ = isUndefined(this.storefront) ? this.storefrontService.getStorefront() : of(this.storefront);
    }
}
JumbotronComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronComponent, deps: [{ token: i1$3.DomSanitizer }, { token: i1.StorefrontService }], target: i0.ɵɵFactoryTarget.Component });
JumbotronComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: JumbotronComponent, selector: "apt-jumbotron", inputs: { storefront: "storefront", height: "height", imagePosition: "imagePosition", brightness: "brightness" }, host: { properties: { "style": "this.storefront$" } }, ngImport: i0, template: "<ng-container *ngIf=\"storefront$ | async as storefront\">\r\n    <div id=\"promotionCarousel\" class=\"carousel slide \" data-ride=\"carousel\" *ngIf=\"storefront?.StoreBanners?.length > 0\">\r\n        <ol class=\"carousel-indicators\">\r\n            <li data-target=\"#promotionCarousel\" [attr.data-slide-to]=\"i\" [class.active]=\"i === 0\" *ngFor=\"let banner of storefront?.StoreBanners; let i = index\"></li>\r\n        </ol>\r\n        <div class=\"carousel-inner\">\r\n                <div [class]=\"'carousel-item text-' + imagePosition\" [class.active]=\"i === 0\" [style]=\"heightStyle\" *ngFor=\"let banner of storefront?.StoreBanners; let i = index\">\r\n                <img [src]=\"banner?.Image | image\" [style]=\"filterStyle\">\r\n                <div class=\"carousel-caption text-right\">\r\n                    <h1>{{banner?.Title}}</h1>\r\n                    <p [innerHTML]=\"banner?.Subtitle\"></p>\r\n                    <p>\r\n                        <a class=\"btn btn-light btn-lg\" [href]=\"banner?.Link\"> {{ 'JUMBORTON.MORE_INFO' | translate }} </a>\r\n                    </p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <a class=\"carousel-control-prev\" href=\"#promotionCarousel\" role=\"button\" data-slide=\"prev\">\r\n            <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\"> {{ 'JUMBORTON.PREVIOUS' | translate }} </span>\r\n        </a>\r\n        <a class=\"carousel-control-next\" href=\"#promotionCarousel\" role=\"button\" data-slide=\"next\">\r\n            <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\"> {{ 'JUMBORTON.NEXT' | translate }} </span>\r\n        </a>\r\n    </div>\r\n</ng-container>\r\n\r\n", styles: ["\n        :host {\n            display: block;\n        }\n        .carousel {\n            margin-bottom: 4rem;\n            min-height: 320px;\n        }\n        /* Since positioning the image, we need to help out the caption */\n        .carousel-caption {\n            bottom: 3rem;\n            z-index: 10;\n            max-width: 35%;\n            left: inherit;\n        }\n        /* Declare heights because of positioning of img element */\n        .carousel-item {\n            overflow-x: hidden;\n        }\n        .carousel-item > img {\n            height: 100%;\n            overflow-y: hidden;\n            width: 100%;\n        }\n    "], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe, "image": i1$1.ImagePipe, "translate": i2$1.TranslatePipe }, animations: [fade] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-jumbotron',
                    templateUrl: './jumbotron.component.html',
                    styles: [`
        :host {
            display: block;
        }
        .carousel {
            margin-bottom: 4rem;
            min-height: 320px;
        }
        /* Since positioning the image, we need to help out the caption */
        .carousel-caption {
            bottom: 3rem;
            z-index: 10;
            max-width: 35%;
            left: inherit;
        }
        /* Declare heights because of positioning of img element */
        .carousel-item {
            overflow-x: hidden;
        }
        .carousel-item > img {
            height: 100%;
            overflow-y: hidden;
            width: 100%;
        }
    `],
                    animations: [fade]
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }, { type: i1.StorefrontService }]; }, propDecorators: { storefront: [{
                type: Input
            }], height: [{
                type: Input
            }], imagePosition: [{
                type: Input
            }], brightness: [{
                type: Input
            }], storefront$: [{
                type: HostBinding,
                args: ['style']
            }] } });

/**
 * @ignore
 */
class JumbotronModule {
}
JumbotronModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
JumbotronModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronModule, declarations: [JumbotronComponent], imports: [CommonModule,
        ApttusModule], exports: [JumbotronComponent] });
JumbotronModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronModule, imports: [[
            CommonModule,
            ApttusModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: JumbotronModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule
                    ],
                    declarations: [JumbotronComponent],
                    exports: [JumbotronComponent]
                }]
        }] });

/**
 * The Breadcrumb component generates links which allow users to navigate to different pages.
 * <h3>Preview</h3>
 * <img  src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/breadcrumb.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { BreadcrumbModule } from '@congacommerce/elements';

@NgModule({
  imports: [BreadcrumbModule, ...]
})
export class AppModule {}
```
* @example
* // Generate breadcrumb from AObject record
```typescript
* <apt-breadcrumb [sobject]="product"></apt-breadcrumb>
```
*
* // Pass in a defined array of breadcrumbs.
```typescript
* <apt-breadcrumb
*              [label]="myLabel"
*              [breadcrumbs]="myBreadcrumbs"
*              [autoGenerated]="false"
* ></apt-breadcrumb>
```
*/
class BreadcrumbComponent {
    constructor(categoryService, aobjectService, translateService) {
        this.categoryService = categoryService;
        this.aobjectService = aobjectService;
        this.translateService = translateService;
        /**
         * Flag to generate the breadcrumbs based on the given AObject record.
         */
        this.autoGenerated = true;
        /** @ignore */
        this.subscriptions = [];
        this.subscriptions.push(this.translateService.stream(['HEADER', 'AOBJECTS']).subscribe((val) => {
            this.productCatalogLabel = val['HEADER']['PRODUCT_CATALOG'];
            this.aobjectLabels = val['AOBJECTS'];
        }));
    }
    ngOnChanges() {
        if (_.get(this.breadcrumbs, 'length', 0) > 0)
            this.breadcrumbs$ = of(this.breadcrumbs);
        else if (this.sobject instanceof Product)
            this.breadcrumbs$ = this.categoryService.getCategoryBranchForProduct(this.sobject).pipe(map(cList => this.mapCategories(cList)));
        else if (this.sobject instanceof Category)
            this.breadcrumbs$ = this.categoryService.getCategoryBranch(_.get(this.sobject, 'Id')).pipe(map(cList => this.mapCategories(cList)));
        else if (this.sobject instanceof AObject && this.autoGenerated === true)
            this.breadcrumbs$ = this.getAObjectBreadcrumbs();
        else
            this.breadcrumbs$ = of(null);
    }
    /** @ignore */
    mapCategories(categoryList) {
        if (!categoryList)
            categoryList = [];
        return [{
                label: this.productCatalogLabel, route: ['/products']
            }]
            .concat(categoryList
            .filter(category => category.Label !== this.label)
            .map(category => {
            return {
                label: category.Label, route: ['/products/category', _.get(category, 'Id')]
            };
        }));
    }
    /** @ignore */
    getAObjectBreadcrumbs() {
        let translatedLables = this.aobjectLabels;
        return this.aobjectService.describe(this.sobject.constructor, null, null).pipe(map(metadata => {
            const routeLabel = this.route ? this.route : metadata.labelPlural;
            return [
                {
                    route: [`/${encodeURIComponent(routeLabel.toLowerCase())}`],
                    label: _.defaultTo(translatedLables[_.upperCase(routeLabel)], routeLabel)
                },
                {
                    route: [`/${encodeURIComponent(routeLabel.toLowerCase())}/${_.get(this.sobject, 'Id')}`],
                    label: _.get(this.sobject, 'Name'),
                    active: !_.get(this, 'label')
                }
            ];
        }));
    }
    /** @ignore */
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
BreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1.CategoryService }, { token: i1$1.AObjectService }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: BreadcrumbComponent, selector: "apt-breadcrumb", inputs: { sobject: "sobject", label: "label", route: "route", breadcrumbs: "breadcrumbs", autoGenerated: "autoGenerated" }, usesOnChanges: true, ngImport: i0, template: `
    <nav aria-label="breadcrumb" class="container-fluid">
      <div class="d-flex justify-content-between align-items-center">
        <ol class="breadcrumb p-0">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" [routerLink]="['/']">{{'BREADCRUMB.HOME' | translate}}</a>
          </li>
          <li class="breadcrumb-item" [class.active]="breadcrumb.active" *ngFor="let breadcrumb of breadcrumbs$ | async">
            <a href="javascript:void(0)" [routerLink]="breadcrumb.route" *ngIf="!breadcrumb.active; else inactive">{{breadcrumb.label}}</a>
            <ng-template #inactive>{{breadcrumb.label}}</ng-template>
          </li>
          <li class="breadcrumb-item active" [attr.aria-current]="label" *ngIf="label">{{label}}</li>
        </ol>
        <ng-content></ng-content>
      </div>
    </nav>
  `, isInline: true, styles: [""], directives: [{ type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-breadcrumb',
                    template: `
    <nav aria-label="breadcrumb" class="container-fluid">
      <div class="d-flex justify-content-between align-items-center">
        <ol class="breadcrumb p-0">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" [routerLink]="['/']">{{'BREADCRUMB.HOME' | translate}}</a>
          </li>
          <li class="breadcrumb-item" [class.active]="breadcrumb.active" *ngFor="let breadcrumb of breadcrumbs$ | async">
            <a href="javascript:void(0)" [routerLink]="breadcrumb.route" *ngIf="!breadcrumb.active; else inactive">{{breadcrumb.label}}</a>
            <ng-template #inactive>{{breadcrumb.label}}</ng-template>
          </li>
          <li class="breadcrumb-item active" [attr.aria-current]="label" *ngIf="label">{{label}}</li>
        </ol>
        <ng-content></ng-content>
      </div>
    </nav>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styleUrls: ['./breadcrumb.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CategoryService }, { type: i1$1.AObjectService }, { type: i2$1.TranslateService }]; }, propDecorators: { sobject: [{
                type: Input
            }], label: [{
                type: Input
            }], route: [{
                type: Input
            }], breadcrumbs: [{
                type: Input
            }], autoGenerated: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class BreadcrumbModule {
}
BreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent], imports: [CommonModule,
        FormsModule,
        RouterModule, i2$1.TranslateModule], exports: [BreadcrumbComponent] });
BreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbModule, imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        RouterModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [BreadcrumbComponent],
                    exports: [BreadcrumbComponent]
                }]
        }] });

/**
 * Product attribute component is used to configure attributes on a product.
 * @ignore
 * <h3>Usage</h3>
 *
 ```typescript
 import { ProductAttributeModule } from '@congacommerce/elements';

 @NgModule({
  imports: [ProductAttributeModule, ...]
})
 export class AppModule {}
 ```
 *
 * @example
 * <apt-product-attribute
 *             [product]="product"
 *             [container]="productContainer"
 *             lineType="Option"
 *             [(productAttributeValue)]="productAttributeValue"
 *             (productAttributeValueChange)="handleAttributeValueChange($event)"
 * ></apt-product-attribute>
 */
class ProductAttributeComponent {
    constructor(attributeValueMatrixService, productOptionService, attributeRuleService) {
        this.attributeValueMatrixService = attributeValueMatrixService;
        this.productOptionService = productOptionService;
        this.attributeRuleService = attributeRuleService;
        /**
         * Sets what type of line this is. Either Product or Option.
         */
        this.lineType = 'Product';
        /**
         * Property binding to control expand/collapse multiple attribute groups.
         */
        this.accordion = true;
        /**
         * Property binding to control expand/collapse of attribute groups.
         */
        this.collapseAll = true;
        /**
         * Event emitter for when the attribute value changes.
         */
        this.productAttributeValueChange = new EventEmitter();
        /**
        * Event emitter with the boolean value when the attribute value changes.
        */
        this.attributeValueChange = new EventEmitter();
        this.attributeValueCopy = new ProductAttributeValue();
        this.userselected = {};
        this.usercleared = {};
        this.attrClicked = false;
    }
    ngOnChanges() {
        this.product$ = _.isString(this.product) ? this.productOptionService.getProductOptionTree(this.product) : of(this.product);
        if (!this.metadata$)
            this.metadata$ = this.attributeValueMatrixService.describe(ProductAttributeValue);
        this.attributeRules$ = _.isString(this.product) ? this.attributeRuleService.getAttributeRulesForProducts([this.product]) : this.attributeRuleService.getAttributeRulesForProducts([this.product]);
        this.attributeValueCopy = _.cloneDeep(this.productAttributeValue);
        this.subscription = combineLatest(this.attributeRules$, this.metadata$, this.product$)
            .subscribe(([ruleInfo, metadata, product]) => {
            if (_.get(ruleInfo, 'length') > 0) {
                this.attrRuleInfo = ruleInfo;
                const attributes = _.flatten(_.map(_.flatten(_.map(product.AttributeGroups, r => _.get(r, 'AttributeGroup'))), r => r.ProductAttributes));
                this.applyRule(this.attrRuleInfo, attributes, this.productAttributeValue, metadata);
            }
            if (_.get(product.ProductAttributeMatrixViews, 'length') > 0) {
                const matrixResult = this.attributeValueMatrixService.processAttributeMatrices(product.ProductAttributeMatrixViews, metadata, this.productAttributeValue, this.userselected, this.lastTouched, this.usercleared, this.attributeValueCopy);
                this.applyMatrixViews(matrixResult, product.AttributeGroups, this.productAttributeValue);
                this.attributeValueCopy = _.cloneDeep(this.productAttributeValue);
            }
            this.productAttributeValueChange.emit(this.productAttributeValue);
        });
    }
    /**
     * @ignore
     */
    trackById(index, record) {
        return _.get(record, 'Id');
    }
    /**
     * Method gets invoked whenever there is change in the attribute value and set the ProductAttributeValue object,
     * after validating ProductAttributeRule/ ProductAttributeMatrixview if set any.
     * @param attrValue is an instance of product attribute value.
     * @param field is of type string the value of the field.
     * @param attributeGroupList is an Array of Product Attribute group member object.
     * @param matrixView optional paramenter to pass Array of Product Attribute matrix view if exist.
     * @param metadata optional paramenter to pass the metadata of the attribute if available.
     * @param attribute optional paramenter is an instance of Product Attributeis exists.
     */
    attributeChange(attrValue, field, attributeGroupList, matrixView, metadata, attribute) {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.productAttributeValue = attrValue;
            if (!_.isEqual(this.productAttributeValue[field], this.attributeValueCopy[field]) && _.get(this.attrRuleInfo, 'length') > 0) {
                const fieldType = metadata.fields.find(r => r.name === field).type;
                const attrVal = _.get(attrValue, `${field}`);
                if (_.get(attribute, '_metadata.rules.isDefaultAction') || _.get(attribute, '_metadata.rules.isConstraintAction')) {
                    if ((!attrVal || _.get(attrVal, 'length') === 0) && _.get(attribute, '_metadata.rules.isReset')) {
                        const val = _.get(attribute, '_metadata.rules.resetValues');
                        if (fieldType === 'multipicklist')
                            _.set(this.productAttributeValue, `${attribute.Field}`, val);
                        else
                            _.set(this.productAttributeValue, `${attribute.Field}`, val[0]);
                    }
                }
                if (_.get(matrixView, 'length') > 0) {
                    if (!_.isEqual(this.productAttributeValue[field], this.attributeValueCopy[field]) && _.get(matrixView, 'length') > 0 && metadata) {
                        const columnList = _.cloneDeep(matrixView.map(k => k.Columns));
                        let availableColumns = [];
                        columnList.forEach(r => availableColumns.push(Object.values(JSON.parse(r).columns)));
                        availableColumns = _.uniq(availableColumns).join().split(',');
                        if (availableColumns.find(k => k === field)) {
                            if ((typeof _.get(this.productAttributeValue, `${field}`) === 'string' && _.get(this.productAttributeValue, `${field}`)) || (_.get(this.productAttributeValue, `${field}`) instanceof Array && _.get(this.productAttributeValue, `${field}.length`) > 0)) {
                                this.userselected[field] = true;
                            }
                            else {
                                this.userselected[field] = false;
                                this.usercleared[field] = true;
                            }
                            this.lastTouched = field;
                        }
                        const matrixResult = this.attributeValueMatrixService.processAttributeMatrices(matrixView, metadata, this.productAttributeValue, this.userselected, this.lastTouched, this.usercleared, this.attributeValueCopy);
                        this.applyMatrixViews(matrixResult, attributeGroupList, attrValue);
                    }
                }
            }
            const attrChanged = !_.isEqual(this.attributeValueCopy, this.productAttributeValue);
            this.attributeValueCopy = _.cloneDeep(this.productAttributeValue);
            if (attrChanged && this.attrClicked)
                this.attributeValueChange.emit(this.attrClicked);
            this.productAttributeValueChange.emit(this.productAttributeValue);
        }, 10);
    }
    /**
     * @ignore
     */
    applyMatrixViews(matrixResult, attributeGroupList, attrValue) {
        const attributes = _.flatten(attributeGroupList.map(r => _.get(r, 'AttributeGroup')).map(r => r.ProductAttributes));
        _.forEach(matrixResult, (view) => {
            if (view.allowedValues && !_.isEmpty(view.resetValues)) {
                const resttemp = Object.keys(view.resetValues);
                for (let i = 0; i < resttemp.length; i++) {
                    if (_.get(view.resetValues, `${resttemp[i]}.length`) > 0) {
                        _.forEach(attributes.filter(r => r.Field === resttemp[i]), attribute => {
                            _.set(attribute, '_metadata.picklist', view.resetValues[resttemp[i]]);
                            _.set(attribute, '_metadata.enableValues', view.resetValues[resttemp[i]]);
                        });
                        if (!_.isEqual(_.get(attrValue, `${resttemp[i]}`), view.items.value))
                            _.set(this.productAttributeValue, `${resttemp[i]}`, view.items.value);
                        if (((typeof _.get(attrValue, `${resttemp[i]}`) === 'string' || typeof _.get(attrValue, `${resttemp[i]}`) === 'object') && !_.get(attrValue, `${resttemp[i]}`)) || (_.get(attrValue, `${resttemp[i]}`) instanceof Array && _.get(attrValue, `${resttemp[i]}.length`) === 0)) {
                            this.userselected[resttemp[i]] = false;
                        }
                        else {
                            this.userselected[resttemp[i]] = true;
                        }
                    }
                }
            }
            else {
                if (view.allowedValues && !_.isEmpty(view.constraints)) {
                    const temp = Object.keys(view.constraints);
                    for (let i = 0; i < temp.length; i++) {
                        _.forEach(attributes.filter(r => r.Field === temp[i]), attribute => {
                            _.set(attribute, '_metadata.picklist', view.constraints[temp[i]]);
                            _.set(attribute, '_metadata.enableValues', view.constraints[temp[i]]);
                        });
                        if (!_.isEqual(_.get(attrValue, `${temp[i]}`), view.items.value))
                            _.set(this.productAttributeValue, `${temp[i]}`, view.items.value);
                        if (((typeof _.get(attrValue, `${temp[i]}`) === 'string' || typeof _.get(attrValue, `${temp[i]}`) === 'object') && !_.get(attrValue, `${temp[i]}`)) || (_.get(attrValue, `${temp[i]}`) instanceof Array && _.get(attrValue, `${temp[i]}.length`) === 0)) {
                            this.userselected[temp[i]] = false;
                            this.usercleared[temp[i]] = true;
                        }
                        else {
                            this.userselected[temp[i]] = true;
                            this.usercleared[temp[i]] = false;
                        }
                        // if (this.usercleared.hasOwnProperty(temp[i])) this.usercleared[temp[i]] = false;
                    }
                }
                if (view.allowedValues && !_.isEmpty(view.forceSets)) {
                    const forcesettemp = Object.keys(view.forceSets);
                    for (let i = 0; i < forcesettemp.length; i++) {
                        _.forEach(attributes.filter(r => r.Field === forcesettemp[i]), attribute => {
                            _.set(attribute, '_metadata.picklist', []);
                        });
                        if (!_.isEqual(_.get(attrValue, `${forcesettemp[i]}`), view.items.value))
                            _.set(this.productAttributeValue, `${forcesettemp[i]}`, view.items.value);
                        if (((typeof _.get(attrValue, `${forcesettemp[i]}`) === 'string' || typeof _.get(attrValue, `${forcesettemp[i]}`) === 'object') && !_.get(attrValue, `${forcesettemp[i]}`)) || (_.get(attrValue, `${forcesettemp[i]}`) instanceof Array && _.get(attrValue, `${forcesettemp[i]}.length`) === 0)) {
                            this.userselected[forcesettemp[i]] = false;
                            this.usercleared[forcesettemp[i]] = true;
                        }
                        else {
                            this.userselected[forcesettemp[i]] = true;
                            this.usercleared[forcesettemp[i]] = false;
                        }
                    }
                }
                if (view.allowedValues && !_.isEmpty(view.defaults)) {
                    const defaulttemp = Object.keys(view.defaults);
                    for (let i = 0; i < defaulttemp.length; i++) {
                        _.forEach(attributes.filter(r => r.Field === defaulttemp[i]), attribute => {
                            _.set(attribute, '_metadata.picklist', []);
                        });
                        if (_.get(this.userselected, `${defaulttemp[i]}`))
                            this.usercleared[defaulttemp[i]] = false;
                        if (!_.isEqual(_.get(attrValue, `${defaulttemp[i]}`), view.items.value))
                            _.set(this.productAttributeValue, `${defaulttemp[i]}`, view.items.value);
                    }
                }
            }
        });
    }
    /**
     * @ignore
     */
    applyRule(ruleActions, attributes, attrValue, metadata) {
        attributes.forEach(attribute => {
            if (ruleActions && ruleActions.find(action => action.field === attribute.Field)) {
                _.set(attribute, '_metadata.rules', ruleActions.find(action => action.field === attribute.Field));
                const ruleVal = _.get(attribute, '_metadata.rules.values', []);
                const defaultVal = _.get(attribute, '_metadata.rules.defaultValue');
                const resetVal = _.get(attribute, '_metadata.rules.resetValues');
                const resetAction = _.get(attribute, '_metadata.rules.isReset');
                const defaultAction = _.get(attribute, '_metadata.rules.isDefaultAction');
                const allowAction = _.get(attribute, '_metadata.rules.isConstraintAction');
                const requiredAction = _.get(attribute, '_metadata.rules.isRequiredAction');
                const hiddenAction = _.get(attribute, '_metadata.rules.isHiddenAction');
                // checking if rule applied for the attriute is hidden the reset the value to null.
                if (hiddenAction)
                    _.set(this.productAttributeValue, `${attribute.Field}`, null);
                if (!_.get(attribute, '_metadata.rules.sfDefaultValue')) {
                    // checking if rule applied for the attribute is required then set the value as empty on load if no default value is set.
                    if (requiredAction && ruleVal.length > 0)
                        _.set(this.productAttributeValue, `${attribute.Field}`, null);
                }
                // checking if rule applied for the attribute has  Default action then set default
                // value as default value for the attribute if default action from the rule has no value then check if Rest action is true
                // then set the reset value as default on load.
                if (defaultAction && (!_.get(attrValue, `${attribute.Field}`) || !attrValue.hasOwnProperty(attribute.Field))) {
                    if (defaultVal)
                        _.set(this.productAttributeValue, `${attribute.Field}`, defaultVal.join(';'));
                    else if (resetAction)
                        _.set(this.productAttributeValue, `${attribute.Field}`, resetVal.join(';'));
                }
                // checking if rule applied for the attribute Allow then check if Rest action is true set reset
                // value as default value for the attribute if reset false is false then set first value as default value.
                // if allow action has no value then set default value as reset value.
                if (allowAction) {
                    if (ruleVal && (!_.get(attrValue, `${attribute.Field}`) || !attrValue.hasOwnProperty(attribute.Field))) {
                        if (resetAction) {
                            _.set(this.productAttributeValue, `${attribute.Field}`, resetVal.join(';'));
                            attribute._metadata.filterValues = resetAction;
                        }
                        else {
                            _.set(this.productAttributeValue, `${attribute.Field}`, ruleVal.join(';'));
                            attribute._metadata.filterValues = ruleVal;
                        }
                    }
                    else {
                        if (ruleVal)
                            attribute._metadata.filterValues = ruleVal;
                        else if (resetAction)
                            attribute._metadata.filterValues = resetAction;
                    }
                }
            }
        });
        this.attributeValueCopy = _.cloneDeep(this.productAttributeValue);
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
ProductAttributeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeComponent, deps: [{ token: i1.AttributeValueMatrixService }, { token: i1.ProductOptionService }, { token: i1.AttributeRuleService }], target: i0.ɵɵFactoryTarget.Component });
ProductAttributeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductAttributeComponent, selector: "apt-product-attribute", inputs: { product: "product", container: "container", lineType: "lineType", productAttributeValue: "productAttributeValue", accordion: "accordion", collapseAll: "collapseAll" }, outputs: { productAttributeValueChange: "productAttributeValueChange", attributeValueChange: "attributeValueChange" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"product$ | async as product\">\r\n    <ng-container *ngIf=\"lineType === 'Product'\">\r\n        <div class=\"card\" *ngFor=\"let attributeGroupMember of product?.AttributeGroups; let attrIndex = index; trackBy: trackById\" [hidden]=\"attributeGroupMember.get('hide')\">\r\n            \r\n            <div [id]=\"'ac' + attributeGroupMember.Id\" class=\"accordion\">\r\n            <div class=\"card-header px-2 py-1\" *ngIf=\"lineType === 'Product'\">\r\n                <h2 class=\"mb-0\">\r\n                    <ng-container *ngTemplateOutlet=\"groupHeaderTemplate; context: {attributeGroupMember: attributeGroupMember, index: attrIndex}\"></ng-container>\r\n                </h2>\r\n            </div>\r\n\r\n            <div [id]=\"container + '-' + attributeGroupMember?.Id\" class=\"collapse\" [ngClass]=\"{'show': (attrIndex === 0 && collapseAll) || !accordion}\" [attr.data-parent]=\"'#' + container\">\r\n                <div class=\"card-body pl-3\">\r\n                    <ng-container *ngTemplateOutlet=\"groupTemplate; context: {metadata: metadata$ | async, attributeGroupMember: attributeGroupMember, attributeValue: productAttributeValue, matrixView: product?.ProductAttributeMatrixViews,product: product}\">\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"lineType === 'Option'\">\r\n        <div class=\"mb-3\" *ngFor=\"let attributeGroupMember of product?.AttributeGroups; let attrIndex = index; trackBy: trackById\">\r\n            <div [id]=\"'ac' + attributeGroupMember.Id\" class=\"accordion\">\r\n            <h5 class=\"mb-0 border-bottom\">\r\n                <ng-container *ngTemplateOutlet=\"groupHeaderTemplate; context: {attributeGroupMember: attributeGroupMember, index: attrIndex}\">\r\n                </ng-container>\r\n            </h5>\r\n            <div class=\"pl-4 collapse\" [id]=\"container + '-' + attributeGroupMember?.Id\"\r\n                [ngClass]=\"{'show': (attrIndex === 0 && collapseAll) || !accordion}\"\r\n                [attr.data-parent]=\"'#ac' + attributeGroupMember.Id\">\r\n                <ng-container *ngTemplateOutlet=\"groupTemplate; context: {metadata: metadata$ | async, attributeGroupMember: attributeGroupMember, attributeValue: productAttributeValue, matrixView: product?.ProductAttributeMatrixViews, product: product}\">\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <ng-template #groupHeaderTemplate let-attributeGroupMember=\"attributeGroupMember\" let-index=\"index\">\r\n        <button class=\"btn btn-link chevron\" type=\"button\" data-toggle=\"collapse\"\r\n            [attr.data-target]=\"'#' + container + '-' + attributeGroupMember?.Id\"\r\n            [attr.aria-expanded]=\"(index === 0 && collapseAll) || !accordion ? 'true' : 'false'\">\r\n            {{attributeGroupMember?.AttributeGroup?.Name}}\r\n        </button>\r\n    </ng-template>\r\n\r\n    <ng-template #groupTemplate let-metadata=\"metadata\" let-attributeGroupMember=\"attributeGroupMember\" let-attributeValue=\"attributeValue\" let-matrixView=\"matrixView\"\r\n                 let-product=\"product\">\r\n        <div class=\"row no-gutters\">\r\n            <ng-container *ngFor=\"let attribute of attributeGroupMember?.AttributeGroup?.ProductAttributes;let i= index; trackBy: trackById\">\r\n                <div *ngIf=\"!attribute?._metadata?.rules?.isHiddenAction && attributeValue\" class=\"col-12 p-3\" [class.col-md-4]=\"attributeGroupMember?.AttributeGroup?.ThreeColumnAttributeDisplay\" [class.col-md-6]=\"attributeGroupMember?.AttributeGroup?.TwoColumnAttributeDisplay\">\r\n                    <apt-input-field [entity]=\"attributeValue\" [field]=\"attribute.Field\" [id]=\"'#' + attributeGroupMember?.Id + i\"\r\n                                     [(ngModel)]=\"attributeValue[attribute.Field]\" [defaultValue]=\"((matrixView && matrixView.length > 0) || (attrRuleInfo && attrRuleInfo.length > 0))  ? false : true\"\r\n                                     (ngModelChange)=\"attributeChange(attributeValue, attribute.Field, product?.AttributeGroups, matrixView, metadata, attribute)\"\r\n                                     [required]=\"attribute?._metadata?.rules?.isRequiredAction\" [readonly]=\"attribute?._metadata?.rules?.isReadOnlyAction\"\r\n                                     [hide]=\"attribute?._metadata?.rules?.isHiddenAction\" [filterValues]=\"(attribute?._metadata?.picklist?.length > 0) ? attribute?._metadata?.picklist : attribute?._metadata?.filterValues\"\r\n                                     [enableValues]=\"attribute?._metadata?.enableValues?.length === 0 ? attribute?._metadata?.enableValues: attribute?._metadata?.filterValues\"\r\n                                     [hideOptions]=\"attribute?._metadata?.hideOptions\" (click)=\"attrClicked = true\">\r\n                    </apt-input-field>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </ng-template>\r\n\r\n</ng-container>", styles: [":host .card:last-child{margin-bottom:-1px}\n"], components: [{ type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-attribute',
                    templateUrl: './product-attribute.component.html',
                    styleUrls: ['./product-attribute.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.AttributeValueMatrixService }, { type: i1.ProductOptionService }, { type: i1.AttributeRuleService }]; }, propDecorators: { product: [{
                type: Input
            }], container: [{
                type: Input
            }], lineType: [{
                type: Input
            }], productAttributeValue: [{
                type: Input
            }], accordion: [{
                type: Input
            }], collapseAll: [{
                type: Input
            }], productAttributeValueChange: [{
                type: Output
            }], attributeValueChange: [{
                type: Output
            }] } });

/**
 * @ignore
 */
class ProductAttributeModule {
}
ProductAttributeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductAttributeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeModule, declarations: [ProductAttributeComponent], imports: [CommonModule,
        InputFieldModule], exports: [ProductAttributeComponent] });
ProductAttributeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeModule, imports: [[
            CommonModule,
            InputFieldModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductAttributeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        InputFieldModule
                    ],
                    declarations: [ProductAttributeComponent],
                    exports: [ProductAttributeComponent]
                }]
        }] });

/**
 * The Alert component is used to display alert messages in the application. This alert display varies with the message type. Errors will be displayed as alert-danger.
 * Warnings will be dispalyed as alert-warning.Information will be displayed as alert-info.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/alert.png" style="max-width: 100%">
 *
 *  <h3>Usage</h3>
 *
 ```typescript
import { AlertModule } from '@congacommerce/elements';
@NgModule({
  imports: [AlertModule, ...]
})
export class AppModule {}
```
*
* @example
```typescript
*  <apt-alert
*           [record]="record"
*           layout="alert"
*           message="error message"
*  ></apt-alert>
```
*/
class AlertComponent {
    constructor(cartService, storefrontService, revalidateCartService, apiService, config) {
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        this.revalidateCartService = revalidateCartService;
        this.apiService = apiService;
        this.config = config;
        /**
         * Use to set the layout for error messages to be displayed
         * either in alert with accordian or inline message.
         */
        this.layout = 'alert';
        /**
         * Boolean flag to expand error message.
         */
        this.expand = true;
        /**
         * Use to hold dyanmic error message.
         */
        this.message = 'ERROR.RECORD_ERROR';
        /**
         * The flag which indicates to invoke  the Pricing call automatically.
         */
        this.autoRun = true;
        /**
         * Flag to show loader
         * @ignore
         */
        this.loading = false;
        /**
        * Defined default value if one not found in configuration.
        */
        this.identifier = 'Id';
        /**
         * To hold the custom message alert
         * @ignore
         */
        this.customMessageAlert$ = new BehaviorSubject(null);
        /**
         * To hold the list of custom message
         * @ignore
         */
        this.customErrorList = [];
        /** @ignore */
        this.alertColorMap = {
            error: 'alert-danger',
            warning: 'alert-warning',
            info: 'alert-info',
            primary: 'alert-primary'
        };
    }
    /** @ignore */
    ngOnInit() {
        this.identifier = this.config.get('productIdentifier');
        this.priceError$ = this.cartService.getCartPriceStatus();
        this.subscription = this.apiService.onApiError.subscribe((res) => {
            const productId = get(first(get(res, 'requestPayload')), 'ProductId');
            const productName = get(first(get(res, 'requestPayload')), 'ProductName');
            let errorMsg = get(get(get(res, 'error'), 'data'), 'message');
            if (includes(errorMsg, 'FIELD_CUSTOM_VALIDATION_EXCEPTION')) {
                errorMsg = `${productName} : ${last(split(errorMsg, 'FIELD_CUSTOM_VALIDATION_EXCEPTION,'))}`;
                errorMsg = errorMsg.substring(0, errorMsg.lastIndexOf(':'));
                this.customErrorList.push({ errorMsg: errorMsg, productInfo: { Id: productId, Name: productName } });
                this.customMessageAlert$.next(this.customErrorList);
            }
        });
    }
    ngOnChanges() {
        this.loading = false;
        this.deferredPrice$ = this.storefrontService.getDeferredPrice().pipe(map(r => {
            return !this.autoRun && this.record instanceof Cart
                && (((get(this.record, 'IsPricePending') || this.record.get('IsPriced')) && this.record.LineItems.length > 0)
                    || filter$1(get(this.record, 'LineItems'), r => r.PricingStatus == 'Pending').length > 0)
                && r;
        }));
        if (this.record instanceof Cart && (get(this.record, 'IsPricePending') || this.record.get('IsPriced') || find(get(this.record, 'LineItems'), r => r.PricingStatus == 'Pending')) && this.autoRun) {
            this.cartReprice();
        }
        this.revalidateLines$ = this.revalidateCartService.getRevalidateLines().pipe(map(res => this.record instanceof Cart && res && get(res.required, 'length') === 0 && get(res.optional, 'length') > 0));
    }
    /** @ignore */
    ngDoCheck() {
        this.errorList = filter$1(get(this.record, 'errors'), er => er.message !== 'INVALID_QUANTITY');
    }
    /** @ignore */
    trackByFn(index, item) {
        return item.message;
    }
    /**
     * Open revalidate cart modal popup
     */
    openRevalidateCartModal() {
        const modalOptions = {
            backdrop: true,
            keyboard: true,
            class: 'modal-lg'
        };
        this.revalidateCartService.openRevalidateModal(modalOptions);
    }
    /**
     * An attempt to price cart is made.
     */
    cartReprice() {
        this.loading = true;
        this.cartService.priceCart();
    }
    /**
     * Creates new cart and set it as active.
     */
    createCart() {
        this.loading = true;
        this.cartService.createNewCart().pipe(take(1))
            .subscribe(() => this.loading = false);
    }
    /**
     * @ignore
     * To dismiss error message.
     */
    removeError(index) {
        this.customErrorList.splice(index, 1);
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertComponent, deps: [{ token: i1.CartService }, { token: i1.StorefrontService }, { token: RevalidateCartService }, { token: i1$1.ApiService }, { token: i1$1.ConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AlertComponent, selector: "apt-alert", inputs: { record: "record", layout: "layout", expand: "expand", message: "message", autoRun: "autoRun" }, usesOnChanges: true, ngImport: i0, template: "<ng-container>\r\n  <ng-container [ngSwitch]=\"layout\" *ngIf=\"errorList?.length > 0\">\r\n    <ng-container *ngSwitchCase=\"'inline'\">\r\n      <button type=\"button\" class=\"btn btn-link\" [popover]=\"popTemplate\"\r\n        *ngIf=\"expand && errorList.length > 1; else mainError\">\r\n        <small class=\"text-danger d-block\">\r\n          <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\r\n          {{message | translate}}\r\n        </small>\r\n      </button>\r\n      <ng-template #mainError>\r\n        <ng-template [ngTemplateOutlet]=\"mainBlock\" [ngTemplateOutletContext]=\"{error: errorList[0]}\"></ng-template>\r\n      </ng-template>\r\n\r\n      <ng-template #popTemplate>\r\n        <ng-template [ngTemplateOutlet]=\"mainBlock\" [ngTemplateOutletContext]=\"{error: error}\"\r\n          *ngFor=\"let error of errorList\"></ng-template>\r\n      </ng-template>\r\n\r\n      <ng-template #mainBlock let-error=\"error\">\r\n        <small class=\"text-danger d-block\">\r\n          <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\r\n          {{error?.message | translate:error?.parameter}}\r\n        </small>\r\n      </ng-template>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"'alert'\">\r\n      <ng-template [ngTemplateOutlet]=\"collapseError\" [ngTemplateOutletContext]=\"{error: error, index: i}\"\r\n        *ngFor=\"let error of errorList; let i = index; trackBy: trackByFn\"></ng-template>\r\n      <ng-template #collapseError let-error=\"error\" let-index=\"index\">\r\n        <ng-container *ngIf=\"error?.children?.length > 0; else singleError\">\r\n          <div class=\"alert alert-danger accordion\" [id]=\"'alert' + index\">\r\n            <button class=\"btn btn-link text-dark\" type=\"button\" data-toggle=\"collapse\"\r\n              [attr.data-target]=\"'#collapse' + index\" aria-expanded=\"false\">\r\n              <i class=\"fa fa-exclamation-triangle mr-3\" aria-hidden=\"true\"></i>\r\n              {{message | translate}}\r\n            </button>\r\n\r\n            <div [id]=\"'collapse' + index\" class=\"collapse\" [attr.data-parent]=\"'#alert' + index\">\r\n              <div *ngFor=\"let childError of error.children\" class=\"mb-0 pl-5\">\r\n                <i class=\"fa fa-exclamation-triangle pl-3 mr-3\" aria-hidden=\"true\"></i>\r\n                {{childError?.message | translate:childError?.parameter}}\r\n                <a *ngIf=\"childError?.reference\" href=\"javascript:void(0)\" [routerLink]=\"childError?.reference?.value\">\r\n                  {{childError?.reference?.key}}\r\n                </a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #singleError>\r\n          <div [class]=\"'alert ' + alertColorMap[error?.type] + ' flex-grow-1'\">\r\n            <i class=\"fa fa-exclamation-triangle mr-3\" aria-hidden=\"true\"></i>\r\n            {{error?.message | translate:error?.parameter}}\r\n          </div>\r\n        </ng-template>\r\n      </ng-template>\r\n\r\n    </ng-container>\r\n  </ng-container>\r\n\r\n  <alert type=\"danger\" *ngIf=\"priceError$ | async\">\r\n    <i class=\"fas fa-exclamation-circle text-danger mr-2\"></i>\r\n    {{'COMMON.PRICE_ERROR' | translate}}\r\n    <button type=\"button\" class=\"btn btn-link\" (click)=\"createCart()\" [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\">\r\n      {{ \"COMMON.CLEAR_CART\" | translate }}</button>\r\n    <button type=\"button\" class=\"btn btn-link\" (click)=\"cartReprice()\" [attr.data-style]=\"'zoom-in'\">\r\n      {{ \"COMMON.REPRICE_CART\" | translate }}</button>\r\n  </alert>\r\n\r\n  <div class=\"alert alert-warning mb-0 pt-2 pb-2\" *ngIf=\"deferredPrice$ | async\">\r\n    <i class=\"fas fa-exclamation-triangle text-warning mr-2\"></i>\r\n    <span>{{'COMMON.PRICE_NOT_AUTOUPDATED' | translate}}</span>\r\n    <button type=\"button\" class=\"btn btn-link p-0 ml-1\" (click)=\"cartReprice()\" [ladda]=\"loading\"\r\n      [attr.data-style]=\"'zoom-in'\">\r\n      {{ \"COMMON.UPDATE_PRICE\" | translate }}</button>\r\n  </div>\r\n\r\n  <div class=\"alert alert-primary mb-0 py-1\" *ngIf=\"revalidateLines$ | async\">\r\n    <i class=\"fas fa-exclamation-circle text-primary mr-2\"></i>\r\n    {{'REVALIDATE_CART.REVALIDATION_WARNING' | translate}}\r\n    <button type=\"button\" class=\"btn btn-link\" [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\"\r\n      (click)=\"openRevalidateCartModal()\">\r\n      {{ \"REVALIDATE_CART.VALIDATE_CART\" | translate }}</button>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"customMessageAlert$ | async as customError\">\r\n    <div class=\"alert alert-danger mb-0 py-1 position-relative\" *ngIf=\"customError.length > 0\">\r\n      <ng-container *ngFor=\"let item of customError; let i = index\">\r\n        <div>\r\n          <span>\r\n            <i class=\"fas fa-exclamation-circle text-danger mr-2\"></i>\r\n            {{item?.errorMsg}}\r\n          </span>\r\n          <a class=\"ml-2\" href=\"javascript:void(0)\" [routerLink]=\"['/products', item.productInfo[identifier]]\">\r\n            {{'COMMON.CHANGE_CONFIGURATION' | translate}}</a>\r\n          <span (click)=\"removeError(i)\" class=\"error-dismissal\"><i class=\"fas fa-times-circle text-danger mb-0 py-1\"></i></span>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </ng-container>\r\n\r\n</ng-container>", styles: ["@charset \"UTF-8\";button[aria-expanded]{padding:0}button[aria-expanded]:before,button[aria-expanded]:after{font-weight:400;font-size:larger;margin-right:1rem}button[aria-expanded=false]:before{content:\"\\f0da\"}button[aria-expanded=true]:before{content:\"\\f0d7\"}.collapse,.collapsing{background-color:inherit}.error-dismissal{position:absolute;right:1em;cursor:pointer}\n"], components: [{ type: i3.AlertComponent, selector: "alert,bs-alert", inputs: ["type", "dismissible", "isOpen", "dismissOnTimeout"], outputs: ["onClose", "onClosed"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-alert',
                    templateUrl: './alert.component.html',
                    styleUrls: ['./alert.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.StorefrontService }, { type: RevalidateCartService }, { type: i1$1.ApiService }, { type: i1$1.ConfigurationService }]; }, propDecorators: { record: [{
                type: Input
            }], layout: [{
                type: Input
            }], expand: [{
                type: Input
            }], message: [{
                type: Input
            }], autoRun: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class AlertModule {
}
AlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertModule, declarations: [AlertComponent], imports: [CommonModule,
        RouterModule, i2$1.TranslateModule, i1$4.PopoverModule, LaddaModule,
        AlertModule$1], exports: [AlertComponent] });
AlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertModule, imports: [[
            CommonModule,
            RouterModule,
            TranslateModule.forChild(),
            PopoverModule.forRoot(),
            LaddaModule,
            AlertModule$1
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        TranslateModule.forChild(),
                        PopoverModule.forRoot(),
                        LaddaModule,
                        AlertModule$1
                    ],
                    declarations: [AlertComponent],
                    exports: [AlertComponent]
                }]
        }] });

/**
 * Product configuration component is used to show the hierarchical view of the configurations for a given product or cart line item.
 * This component is responsible for loading configuration of product
 *
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productConfiguration.png" style="max-width: 100%">
 *
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductConfigurationModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductConfigurationModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-product-configuration
*               [product]="product.Id"
*               [relatedTo]="parent"
                [accordion]="true"
* ></apt-product-configuration>
```
*/
class ProductConfigurationComponent {
    constructor(cdr, productOptionService, cartItemService, cartService, clientConstraintRuleService, productConfigurationService) {
        this.cdr = cdr;
        this.productOptionService = productOptionService;
        this.cartItemService = cartItemService;
        this.cartService = cartService;
        this.clientConstraintRuleService = clientConstraintRuleService;
        this.productConfigurationService = productConfigurationService;
        // Accordion value for expand/collapse
        this.accordion = true;
        /**
         * The view object used to hold information for rendering the view,
         * of type ConfigurationView.
         */
        this.view$ = new BehaviorSubject(null);
        /** Search query to filter configuration.*/
        this.searchText = null;
        /** Flag determines config change.*/
        this.onConfigChange = false;
        /** Flag determines changes in attribute.*/
        this.attributeChanged = false;
        /** Used to hold quantity of product.*/
        this.productQuantity = 1;
        /** Used for all configuration accordian collapse.*/
        this.collapseAll = true;
        /** @ignore */
        this.subscriptions = [];
    }
    ngOnChanges() {
        this.ngOnDestroy();
        this.accordion = true;
        this.collapseAll = true;
        this.view$.next(null);
        const cartItems = !isNil(get(this, 'view$')) ? this.getItems(get(this, 'view$.value.product'), get(this, 'view$.value')) : undefined;
        this.subscriptions.push(this.productOptionService.getProductOptionTree(get(this, 'product.Id', this.product), this.relatedTo, 'none', defaultTo(cartItems, []))
            .pipe(switchMap(Product => combineLatest([
            this.clientConstraintRuleService.getConstraintRulesForProducts(Product, this.relatedTo),
            this.cartService.getMyCart()
        ])
            .pipe(map(([ruleList, cart]) => {
            const view = {
                product: Product,
                cart: cart,
                ruleList: ruleList
            };
            this.accordion = !Product.get('expandAll');
            return view;
        }))), filter(view => !isNil(get(view, 'product')))).subscribe(view => {
            this.clientConstraintRuleService.setCurrentSelection(this.getSelectedComponents(view), true);
            this.loadCRForOptions(view);
            this.attributeChanged = false;
            this.onConfigChange = false;
            this.emitChange(view);
            this.view$.next(view);
        }));
    }
    ngOnDestroy() {
        this.clientConstraintRuleService.loadAlertMessages([]);
        this.clientConstraintRuleService.performAction$.next(null);
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    /** @ignore */
    trackById(index, record) {
        return get(record, 'Id');
    }
    /** @ignore */
    onAttributeChange(attrValue, view) {
        this.emitChange(view);
    }
    /** @ignore */
    handleAttributeValueChange(attrValue) {
        this.attributeChanged = attrValue;
    }
    /**
     * Method returns a flat array of components and their children of the product option
     * @param component it is an object type of ProductOptionComponent
     */
    getComponentArray(component) {
        const items = [component];
        const handleComponent = (c) => {
            items.push(c);
            forEach(get(c, 'ComponentProduct.OptionGroups', []), handleGroup);
        };
        const handleGroup = (g) => {
            forEach(get(g, 'ChildOptionGroups', []), handleGroup);
            forEach(get(g, 'Options'), handleComponent);
        };
        handleComponent(component);
        return items;
    }
    /**
     * Method traverses the component and its children and assigns the cart items to their corresponding component
     *
     * @param component The input component
     * @param parentBundleNumber The starting components parent bundle number
     * @param cartItems Array of cart items to assign
     */
    assignCartItems(component, parentBundleNumber, cartItems) {
        const handleComponent = (c, parent) => {
            const item = find(cartItems, i => i.ProductOptionId === c.Id && i.ParentBundleNumber === parent);
            set(c, 'ComponentProduct._metadata.item', item);
            forEach(get(c, 'ComponentProduct.OptionGroups', []), g => handleGroup(g, get(item, 'PrimaryLineNumber')));
        };
        const handleGroup = (g, parent) => {
            forEach(get(g, 'ChildOptionGroups', []), cg => handleGroup(cg, parent));
            forEach(get(g, 'Options'), o => handleComponent(o, parent));
        };
        handleComponent(component, parentBundleNumber);
    }
    /** @ignore */
    searchChange() {
        if (get(this.searchText, 'length') > 2) {
            // Hide attribute groups that don't have names matching the search text.
            each(this.view$.value.product.AttributeGroups, (group) => {
                let lowercaseSearchTerm = lowerCase(get(group, 'AttributeGroup.Name'));
                if (lowercaseSearchTerm) {
                    if (lowercaseSearchTerm.indexOf(lowerCase(this.searchText)) > -1) {
                        group.set('hide', false);
                    }
                    else {
                        group.set('hide', true);
                    }
                }
            });
            // Hide option groups that don't have options matching the search text.
            each(this.view$.value.product.OptionGroups, (group) => {
                group.set('hide', isEmpty(filter$1(group.Options, (option) => {
                    let lowercaseSearchTerm = lowerCase(get(option, 'ComponentProduct.Name'));
                    if (lowercaseSearchTerm) {
                        // Hide options that don't match the search term.
                        if (lowercaseSearchTerm.indexOf(lowerCase(this.searchText)) > -1) {
                            option.set('hide', false);
                            return true;
                        }
                        else {
                            option.set('hide', true);
                            return false;
                        }
                    }
                    return false;
                })));
            });
        }
        else {
            // Set all the hide flags back to false.
            each(this.view$.value.product.AttributeGroups, (group) => {
                group.set('hide', false);
                this.cdr.detectChanges();
            });
            this.view$.next(this.view$.value);
            each(this.view$.value.product.OptionGroups, (group) => {
                group.set('hide', false);
                each(group.Options, option => option.set('hide', false));
            });
        }
    }
    /** @ignore */
    getItems(product, view) {
        if (!isNil(product) && product.get('item')) {
            const primaryItem = plainToClass(CartItem, product.get('item'), { ignoreDecorators: true });
            set(primaryItem, 'Quantity', this.productConfigurationService.productQuantity);
            set(primaryItem, 'Product', product);
            // Add cart error for danger validation messages
            const constraintErrors = filter$1(this.clientConstraintRuleService.appliedRuleActionInfoRec, rule => rule.MessageType === 'Error' && rule.Pending);
            if (!isEmpty(constraintErrors))
                view.product.setError('ERROR.PRODUCT.CONSTRAINT_RULES');
            else
                view.product.clearError();
            const items = [primaryItem];
            const handleComponent = (c) => {
                if (!isNil(get(c, 'ComponentProduct._metadata.item'))) {
                    const item = get(c, 'ComponentProduct._metadata.item');
                    // Mark the item amended if the cart item doesn't match the asset item
                    if (!isNil(get(item, 'AssetLineItem')) && get(item, 'LineStatus') !== LineStatus.Cancel) {
                        const attributeFields = map(flatten(map(get(c, 'ComponentProduct.AttributeGroups'), 'AttributeGroup.Attributes')), 'Field');
                        if (get(item, 'Quantity') !== get(item, 'AssetLineItem.Quantity')
                            || !isEqual(pickBy(pick(get(item, 'AssetLineItem.AttributeValue'), attributeFields), identity), pickBy(pick(get(item, 'AttributeValue'), attributeFields)), identity)) {
                            set(item, 'LineStatus', LineStatus.Amend);
                        }
                        else if (get(item, 'LineStatus') === LineStatus.Amend) {
                            set(item, 'LineStatus', LineStatus.Existing);
                        }
                    }
                    set(item, 'PricingStatus', 'Pending');
                    set(item, 'Option', get(c, 'ComponentProduct'));
                    items.push(item);
                }
                forEach(get(c, 'ComponentProduct.OptionGroups', []), g => handleGroup(g));
            };
            const handleGroup = (g) => {
                forEach(get(g, 'ChildOptionGroups', []), handleGroup);
                forEach(get(g, 'Options'), handleComponent);
            };
            forEach(get(product, 'OptionGroups'), handleGroup);
            const cartItems = compact(uniqBy(items, i => get(i, 'PrimaryLineNumber')));
            forEach(cartItems, (c) => c.PricingStatus = 'Pending');
            return cartItems;
        }
        else
            return new Array();
    }
    /** @ignore */
    getParentComponent(component, product) {
        let parentComponent;
        const handleComponent = (c, p) => {
            if (c.Id === component.Id)
                parentComponent = p;
            else {
                forEach(get(c, 'ComponentProduct.OptionGroups', []), g => handleGroup(g, c));
            }
        };
        const handleGroup = (g, p) => {
            forEach(get(g, 'ChildOptionGroups', []), handleGroup);
            forEach(get(g, 'Options'), c => handleComponent(c, p));
        };
        forEach(get(product, 'OptionGroups'), handleGroup);
        return parentComponent;
    }
    /** @ignore */
    removeComponent(component, view) {
        const selectedList = this.getSelectedComponents(view);
        const selectedComplist = filter$1(selectedList, (comp) => comp.ComponentProduct.Id === component.ComponentProduct.Id && comp.ProductOptionGroupId === component.ProductOptionGroupId && get(comp, 'ComponentProduct._metadata.item.ParentBundleNumber') === get(component, 'ComponentProduct._metadata.item.ParentBundleNumber'));
        remove(selectedList, (item) => item.ComponentProduct.Id === component.ComponentProduct.Id);
        this.clientConstraintRuleService.setCurrentSelection(selectedList);
        forEach(selectedComplist, (r) => {
            if (!isNil(get(r, 'ComponentProduct._metadata.item.AssetLineItemId')))
                forEach(this.getComponentArray(r), c => set(c, 'ComponentProduct._metadata.item.LineStatus', LineStatus.Cancel));
            else
                forEach(this.getComponentArray(r), c => set(c, 'ComponentProduct._metadata.item', null));
        });
        return of(view);
    }
    /** @ignore */
    addComponent(component, quantity = 1, group, view) {
        let selectedList = this.getSelectedComponents(view);
        selectedList = selectedList.concat(component);
        this.clientConstraintRuleService.setCurrentSelection(selectedList);
        // Add the component
        const allItems = compact(this.getItems(view.product, view), CartItem);
        const parentComponent = this.getParentComponent(component, get(view, 'product'));
        const parentBundleNumber = defaultTo(get(parentComponent, 'ComponentProduct._metadata.item.PrimaryLineNumber'), get(view, 'product._metadata.item.PrimaryLineNumber'));
        const lineNumber = defaultTo(get(this, 'relatedTo.LineNumber'), get(view, 'product._metadata.item.LineNumber'));
        let lineStatus = !isNil(get(view, 'product._metadata.item.AssetLineItemId')) && get(group, 'MaxOptions') === 1 ? LineStatus.Upgrade : LineStatus.New;
        if (!isNil(get(component, 'ComponentProduct._metadata.item.AssetLineItemId'))) {
            set(component, 'ComponentProduct._metadata.item.LineStatus', LineStatus.Existing);
            return of(view);
        }
        else {
            return this.cartItemService.getCartItemsForProduct(view.product, quantity, get(view, 'cart'), allItems, component, parentBundleNumber, lineNumber, lineStatus)
                .pipe(take(1), map(items => {
                this.assignCartItems(component, parentBundleNumber, items);
                return view;
            }));
        }
    }
    /**
     * This function allows you to add or remove options for a product.
     * @param component object of type ProductOptionComponent required for add /remove on toggling.
     * @param group Product option group of type ProductOptionGroup of the option toggled.
     * @param view An interface Object of type ConfigurationView which consist product, cart, rule list.
     * @param evt Optional Parameters for events of type any.
     */
    toggleOption(component, group, reference, view, evt) {
        if (evt)
            evt.preventDefault();
        if (!get(group, '_metadata.summary.disabled')) {
            const obsv$ = (this.isItemSelected(component)) ? this.removeComponent(component, view) : this.addComponent(component, 1, group, view);
            this.subscriptions.push(obsv$.pipe(take(1))
                .subscribe(v => {
                this.onConfigChange = true;
                this.emitChange(v);
                this.processRules(v);
            }));
        }
    }
    /** @ignore */
    isItemSelected(component) {
        return !isNil(get(component, 'ComponentProduct._metadata.item')) && get(component, 'ComponentProduct._metadata.item.LineStatus') !== LineStatus.Cancel;
    }
    /**
     * This method will triggered on the change of option, quantity, or quantity and emit the behaviour subject of type ConfigurationState.
     * @param view instance of ConfigurationView
     * @ignore
     */
    emitChange(view) {
        const primaryItem = this.productConfigurationService.getPrimaryItem(view.product);
        const items = this.getItems(view.product, view);
        if (primaryItem)
            view.product.set('item', primaryItem);
        if (view.product)
            view.product.set('cartItems', items);
        this.productConfigurationService.onChangeConfiguration({
            product: view.product,
            itemList: items,
            configurationChanged: this.onConfigChange || this.attributeChanged
        });
    }
    /**
     * This method will return list of option product
     */
    getAllComponents(view) {
        return this.productOptionService.getProductOptions(view.product);
    }
    /** @ignore */
    getSelectedComponents(view) {
        return filter$1(this.productOptionService.getProductOptions(view.product), c => !isNil(get(c, 'ComponentProduct._metadata.item')) && get(c, 'ComponentProduct._metadata.item.LineStatus') !== LineStatus.Cancel);
    }
    /**
     * Method returns an instance of product option component for the product Id passed.
     * @param productId String value representing the product Id.
     */
    getProductOptionComponent(productId, view) {
        return find(this.getAllComponents(view), (c) => c.ComponentProduct.Id === productId);
    }
    /**
      * constraint rule stuff
      */
    /**
     * The on load fetched constraint rule is executed on options to show the error or warning.
     * @param view instance of ConfigurationView
     * @ignore
     */
    loadCRForOptions(view) {
        this.processRules(view);
        /**
         * This get's subscribed when option is selected/deselected from side-menu.
         */
        this.subscriptions.push(this.clientConstraintRuleService.performAction$.subscribe((res) => {
            if (!isNil(res)) {
                this.selectDeselectOption(get(res, 'prod'), get(res, 'type'), view, get(res, 'quantity'));
                this.processRules(view);
                this.emitChange(view);
            }
        }));
    }
    /**
     * Method invoked from side-menu it invokes adds/remove component method based on type Inclusion/Exclusion..
     * @param product product option to be added/removed from the selected product configuration.
     * @param type Type of constraint rule action.
     * @param action list of constraint rule actions for the given product.
     * @ignore
     */
    selectDeselectOption(product, type, view, quantity) {
        const components = this.getAllComponents(view).filter(r => r.ComponentProduct.Id === get(product, 'Id'));
        if (!isNil(components) && type === 'Inclusion') {
            forEach(components, (component) => {
                const group = get(component, 'ProductOptionGroup');
                if (isEmpty(get(group, 'Options')))
                    set(group, 'Options', this.productOptionService.getProductOptionsForGroup(view.product, group));
                this.subscriptions.push(this.addComponent(component, quantity, group, view).subscribe());
            });
        }
        else if (!isNil(components) && type === 'Exclusion') {
            forEach(components, (component) => {
                this.subscriptions.push(this.removeComponent(component, view).subscribe());
            });
        }
    }
    /**
     * Method process the rules by validating  the scope and condition of the rule.
     * If the condition is satisfied add or remove the options. Also, Shows the error or warning messages.
     * @param view  instance of ConfigurationView.
     * @ignore
     */
    processRules(view) {
        const optionRules = get(view, 'ruleList');
        const allComponents = this.getAllComponents(view);
        const selectedComponents = this.getSelectedComponents(view);
        const options = this.clientConstraintRuleService.validateRules(optionRules, view.product, { allComponents: allComponents, selectedComponents: selectedComponents });
        forEach(options.addOption, (opt) => {
            if (!includes(map$1(selectedComponents, 'ComponentProduct.Id'), opt.Id))
                this.selectDeselectOption(opt, 'Inclusion', view, 1);
        });
        forEach(options.removeOption, (opt) => {
            if (includes(map$1(selectedComponents, 'ComponentProduct.Id'), opt.Id))
                this.selectDeselectOption(opt, 'Exclusion', view);
        });
        forEach(options.disableOrHideOption, (opt) => {
            const comp = find(allComponents, c => c.Id === opt.Id);
            comp.set('disabled', opt.get('disabled'));
            comp.set('hidden', opt.get('hidden'));
        });
        this.emitChange(view);
    }
}
ProductConfigurationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.ProductOptionService }, { token: i1.CartItemService }, { token: i1.CartService }, { token: i1.ClientConstraintRuleService }, { token: ProductConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
ProductConfigurationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductConfigurationComponent, selector: "apt-product-configuration", inputs: { product: "product", relatedTo: "relatedTo", accordion: "accordion" }, viewQueries: [{ propertyName: "childConfigurationComponents", predicate: ["childConfiguration"], descendants: true }, { propertyName: "popover", predicate: ["popover"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"card\">\r\n    <div class=\"card-body\">\r\n        <ng-container *ngIf=\"(view$ | async) as view; else loading\">\r\n            <ng-container *ngIf=\"view?.product?.OptionGroups?.length > 0 || view?.product?.HasAttributes && view?.product?.AttributeGroups?.length > 0\r\n                            ; else empty\">\r\n                <div>\r\n                    <div class=\"d-flex justify-content-between mb-2\">\r\n\r\n                        <form class=\"input-group input-group-sm col-4\">\r\n                            <input type=\"search\" class=\"form-control\"\r\n                                placeholder=\"{{'COMMON.SEARCH_CONFIGURATION' | translate}}\" [(ngModel)]=\"searchText\"\r\n                                name=\"searchText\" (ngModelChange)=\"searchChange()\">\r\n                            <div class=\"input-group-append\">\r\n                                <button class=\"btn btn-link\">\r\n                                    <i class=\"fas fa-search\"></i>\r\n                                </button>\r\n                            </div>\r\n                        </form>\r\n                        <div>\r\n                            <button class=\"btn btn-link\" [disabled]=\"accordion\"\r\n                                (click)=\"accordion = true; collapseAll = false;\">\r\n                                <i class=\"fa fa-angle-double-up fa-lg\" title=\"Collapse All\"></i>\r\n                            </button>\r\n                            <button class=\"btn btn-link\" [disabled]=\"!accordion\"\r\n                                (click)=\"accordion = false; collapseAll = true;\">\r\n                                <i class=\"fa fa-angle-double-down fa-lg\" title=\"Expand All\"></i>\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"accordion\" id=\"optionAccordion\">\r\n                        <ng-container *ngIf=\"view?.product?.AttributeGroups?.length > 0\">\r\n                            <apt-product-attribute [product]=\"view.product\"\r\n                                [(productAttributeValue)]=\"view.product._metadata.item.AttributeValue\"\r\n                                (productAttributeValueChange)=\"onAttributeChange($event, view)\"\r\n                                container=\"optionAccordion\" (attributeValueChange)=\"handleAttributeValueChange($event)\"\r\n                                [accordion]=\"accordion\" [collapseAll]=\"collapseAll\">\r\n                            </apt-product-attribute>\r\n                        </ng-container>\r\n\r\n                        <ng-container *ngIf=\"view?.product?.HasOptions && view?.product?.OptionGroups?.length > 0\">\r\n                            <div class=\"card border\"\r\n                                *ngFor=\"let productOptionGroup of view?.product?.OptionGroups; let optionIndex = index; trackBy: trackById\"\r\n                                [hidden]=\"productOptionGroup.get('hide')\">\r\n                                <ng-container *ngIf=\"!productOptionGroup?.IsHidden\">\r\n                                    <div [id]=\"'ac' + productOptionGroup.Id\" class=\"accordion\">\r\n                                        <div class=\"card-header px-2 py-1\">\r\n                                            <h2 class=\"mb-0 d-flex justify-content-between align-items-center\">\r\n                                                <button class=\"btn btn-link chevron\" type=\"button\"\r\n                                                    data-toggle=\"collapse\"\r\n                                                    [attr.data-target]=\"'#a' + productOptionGroup.Id\"\r\n                                                    [attr.aria-expanded]=\"((optionIndex + view?.product?.AttributeGroups?.length === 0 || productOptionGroup._metadata.expand) && collapseAll) || !accordion ? 'true' : 'false'\">\r\n                                                    {{productOptionGroup?.OptionGroup?.Label}}\r\n                                                </button>\r\n                                                <apt-alert [record]=\"productOptionGroup\"\r\n                                                    message=\"ERROR.OPTION_GROUP.ERROR\" layout=\"inline\"\r\n                                                    *ngIf=\"productOptionGroup?.ModifiableType !== 'Fixed'\">\r\n                                                </apt-alert>\r\n                                            </h2>\r\n                                        </div>\r\n\r\n                                        <div [id]=\"'a' + productOptionGroup.Id\" class=\"collapse\"\r\n                                            [class.show]=\"((optionIndex + view?.product?.AttributeGroups?.length === 0 || productOptionGroup._metadata.expand) && collapseAll) || !accordion\"\r\n                                            [attr.data-parent]=\"'#ac' + productOptionGroup.Id\">\r\n                                            <div class=\"card-body\">\r\n                                                <ng-template [ngTemplateOutlet]=\"productOptionGroupTemplate\"\r\n                                                    [ngTemplateOutletContext]=\"{optionGroupList: productOptionGroup?.ChildOptionGroups, parent: productOptionGroup.Id}\">\r\n                                                </ng-template>\r\n                                                <div class=\"pl-4\">\r\n                                                    <ng-template [ngTemplateOutlet]=\"componentListTemplate\"\r\n                                                        [ngTemplateOutletContext]=\"{componentList: productOptionGroup?.Options, parent: productOptionGroup.Id, group: productOptionGroup}\">\r\n                                                    </ng-template>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </ng-container>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n\r\n                    <ng-template #productOptionGroupTemplate let-optionGroupList=\"optionGroupList\" let-parent=\"parent\"\r\n                        let-parentProduct=\"parentProduct\">\r\n                        <div class=\"accordion\" [id]=\"parent\">\r\n\r\n                            <div *ngFor=\"let subProductOptionGroup of optionGroupList; let categoryIndex = index; let l = last; let f = first; trackBy: trackById\"\r\n                                class=\"mb-3\">\r\n                                <ng-container *ngIf=\"!subProductOptionGroup?.IsHidden\">\r\n                                    <h5 class=\"d-flex justify-content-between align-items-center border-bottom\">\r\n                                        <button class=\"btn btn-link chevron\" type=\"button\" data-toggle=\"collapse\"\r\n                                            [attr.data-target]=\"'#' + parent + '-' + subProductOptionGroup.Id\"\r\n                                            [attr.aria-expanded]=\"((subProductOptionGroup._metadata.expand) && collapseAll) || !accordion ? 'true' : 'false'\">\r\n                                            {{subProductOptionGroup?.OptionGroup?.Label}}\r\n                                        </button>\r\n                                        <apt-alert message=\"ERROR.OPTION_GROUP.ERROR\" layout=\"inline\"\r\n                                            [record]=\"subProductOptionGroup\"\r\n                                            *ngIf=\"subProductOptionGroup?.ModifiableType !== 'Fixed'\"></apt-alert>\r\n                                    </h5>\r\n\r\n                                    <div [id]=\"parent + '-' + subProductOptionGroup.Id\" class=\"collapse pl-4\"\r\n                                        [attr.data-parent]=\"'#' + parent\"\r\n                                        [class.show]=\"((subProductOptionGroup._metadata.expand) && collapseAll) || !accordion\">\r\n                                        <ng-template [ngTemplateOutlet]=\"componentListTemplate\"\r\n                                            [ngTemplateOutletContext]=\"{componentList: subProductOptionGroup?.Options, parent: parent + '-' + subProductOptionGroup.Id, group: subProductOptionGroup}\">\r\n                                        </ng-template>\r\n                                    </div>\r\n                                </ng-container>\r\n                            </div>\r\n                        </div>\r\n                    </ng-template>\r\n\r\n                    <ng-template #componentListTemplate let-componentList=\"componentList\" let-parent=\"parent\"\r\n                        let-group=\"group\">\r\n                        <ng-container\r\n                            *ngIf=\"componentList?.length > 0 || group?.ChildOptionGroups?.length > 0; else cLoading\">\r\n                            <ng-container\r\n                                *ngFor=\"let component of componentList; let f = first; let l = last; trackBy: trackById\">\r\n                                <div class=\"option\" *ngIf=\"!component.get('hidden')\"\r\n                                    [class.border-bottom]=\"!l && !((component?.ComponentProduct.HasOptions || component?.ComponentProduct?.HasAttributes) && component?.ComponentProduct?._metadata?.item)\"\r\n                                    [hidden]=\"component.get('hide')\">\r\n\r\n                                    <ng-template\r\n                                        *ngIf=\"component?.ComponentProduct?._metadata?.item?.AssetLineItem?.PriceType === 'One Time'\"\r\n                                        [ngTemplateOutlet]=\"readOnlyComponent\" [ngTemplateOutletContext]=\"{\r\n                                                                component: component,\r\n                                                                parent: parent,\r\n                                                                selected: isItemSelected(component),\r\n                                                                cartItem: component?.ComponentProduct?._metadata?.item,\r\n                                                                group: group\r\n                                                            }\"></ng-template>\r\n\r\n                                    <ng-template\r\n                                        *ngIf=\"component?.ComponentProduct?._metadata?.item?.AssetLineItem?.PriceType !== 'One Time'\"\r\n                                        [ngTemplateOutlet]=\"componentTemplate\" [ngTemplateOutletContext]=\"{\r\n                                                            component: component, \r\n                                                            parent: parent, \r\n                                                            selected: isItemSelected(component), \r\n                                                            cartItem: component?.ComponentProduct?._metadata?.item,\r\n                                                            group: group}\">\r\n                                    </ng-template>\r\n                                </div>\r\n                            </ng-container>\r\n                        </ng-container>\r\n                        <ng-template #cLoading>\r\n                            <div class=\"d-flex justify-content-center pt-5\">\r\n                                <apt-dots></apt-dots>\r\n                            </div>\r\n                        </ng-template>\r\n                    </ng-template>\r\n\r\n                    <ng-template #readOnlyComponent let-component=\"component\" let-parent=\"parent\"\r\n                        let-cartItem=\"cartItem\" let-group=\"group\" let-selected=\"selected\">\r\n                        <div class=\"d-flex py-2\">\r\n                            <div class=\"d-flex flex-grow-1\">\r\n                                <div class=\"d-flex\">\r\n                                    <div class=\"mr-2\">\r\n                                        <i class=\"fa fa-check-square-o fa-lg\"></i>\r\n                                    </div>\r\n                                    <div class=\"image-container d-flex justify-content-center\">\r\n                                        <img [src]=\"component?.ComponentProduct?.IconId | image\" height=\"50\">\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"mx-3\">\r\n                                    <p class=\"m-0 font-weight-bold\">{{component?.ComponentProduct?.Name}}</p>\r\n                                    <small class=\"d-block desc\">{{component?.ComponentProduct?.Description}}</small>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"width-fixed border-left d-flex\">\r\n                                <div class=\"form-group col\">\r\n                                    <label>{{'COMMON.PRICE' | translate}}</label>\r\n                                    <h5 class=\"pt-1\">\r\n                                        <apt-price [record]=\"component?.ComponentProduct\" [quantity]=\"1\"></apt-price>\r\n                                    </h5>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col\">\r\n                                    <label for=\"qty\">{{'COMMON.QTY' | translate}}</label>\r\n                                    <input type=\"number\" min=\"0\" class=\"form-control form-control-sm text-center\"\r\n                                        [disabled]=\"true\" id=\"qty\" [value]=\"cartItem?.Quantity\" name=\"quantity\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"pl-3\" [hidden]=\"!selected\">\r\n                            <ng-container *ngIf=\"component?.ComponentProduct?._metadata?.item?.AttributeValue\">\r\n                                <apt-product-attribute [product]=\"component.ComponentProduct\"\r\n                                    [container]=\"parent + '-' + component.Id\" lineType=\"Option\"\r\n                                    [(productAttributeValue)]=\"component.ComponentProduct._metadata.item.AttributeValue\"\r\n                                    (productAttributeValueChange)=\"onAttributeChange($event, view)\"\r\n                                    (attributeValueChange)=\"handleAttributeValueChange($event)\" [accordion]=\"accordion\"\r\n                                    [collapseAll]=\"collapseAll\"></apt-product-attribute>\r\n                            </ng-container>\r\n\r\n\r\n                            <ng-template [ngTemplateOutlet]=\"productOptionGroupTemplate\"\r\n                                [ngTemplateOutletContext]=\"{optionGroupList: component?.ComponentProduct?.OptionGroups, parent: parent + '-' + component.Id, parentProduct: component?.ComponentProduct}\">\r\n                            </ng-template>\r\n                        </div>\r\n                    </ng-template>\r\n\r\n                    <ng-template #componentTemplate let-component=\"component\" let-parent=\"parent\"\r\n                        let-selected=\"selected\" let-cartItem=\"cartItem\" let-group=\"group\">\r\n                        <div class=\"d-flex py-2\">\r\n                            <div class=\"d-flex flex-grow-1\">\r\n                                <div class=\"d-flex cr-popover-container\">\r\n                                    <apt-cr-popover [ruleList]=\"view?.ruleList\" [triggers]=\"''\" [outsideClick]=\"false\"\r\n                                        [optionRules]=\"true\" [product]=\"component?.ComponentProduct\"\r\n                                        [parentProduct]=\"view?.product\" [containerClass]=\"'CRPopover optionPopover'\">\r\n                                        <div class=\"custom-control custom-checkbox\">\r\n                                            <input type=\"checkbox\" class=\"custom-control-input\"\r\n                                                [id]=\"parent + '-' + component.Id\" [checked]=\"selected\"\r\n                                                [disabled]=\"group?._metadata?.summary?.disabled || component?._metadata?.disabled || group.ModifiableType === 'Fixed'\">\r\n                                            <label class=\"custom-control-label\" [for]=\"parent + '-' + component.Id\"\r\n                                                (click)=\"toggleOption(component, group, parent, view, $event)\">&nbsp;</label>\r\n                                        </div>\r\n                                    </apt-cr-popover>\r\n\r\n                                    <div class=\"image-container d-flex justify-content-center\">\r\n                                        <img [src]=\"component?.ComponentProduct?.IconId | image\" height=\"50\">\r\n                                    </div>\r\n\r\n                                </div>\r\n                                <div class=\"mx-3\">\r\n                                    <p class=\"m-0 font-weight-bold\">{{component?.ComponentProduct?.Name}}\r\n                                        <i *ngIf='component?.Required' class=\"fa fa-asterisk text-danger fa-xs\"\r\n                                            aria-hidden=\"true\"></i></p>\r\n                                    <small class=\"d-block desc\">{{component?.ComponentProduct?.Description}}</small>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"width-fixed border-left d-flex\">\r\n                                <div class=\"form-group col\">\r\n                                    <label>{{'COMMON.PRICE' | translate}}</label>\r\n                                    <h5 class=\"pt-1\">\r\n                                        <apt-price [record]=\"component?.ComponentProduct\" [quantity]=\"1\"></apt-price>\r\n                                    </h5>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col\">\r\n                                    <label for=\"qty\">{{'COMMON.QTY' | translate}}</label>\r\n                                    <input type=\"number\" [min]=\"component?.Required ? 1 : 0\"\r\n                                        class=\"form-control form-control-sm text-center\"\r\n                                        *ngIf=\"cartItem; else disabledInput\"\r\n                                        [disabled]=\"!selected || group.ModifiableType === 'Fixed'\" id=\"qty\"\r\n                                        placeholder=\"1\" name=\"quantity\" (change)=\"emitChange(view)\"\r\n                                        [(ngModel)]=\"!selected ? 0 : cartItem.Quantity\">\r\n                                    <ng-template #disabledInput>\r\n                                        <input type=\"number\" min=\"0\" class=\"form-control form-control-sm text-center\"\r\n                                            [disabled]=\"true\" id=\"qty\" placeholder=\"0\" name=\"quantity\">\r\n                                    </ng-template>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"pl-3\" [hidden]=\"!selected\">\r\n                            <ng-container *ngIf=\"component?.ComponentProduct?._metadata?.item?.AttributeValue\">\r\n                                <apt-product-attribute [product]=\"component.ComponentProduct\"\r\n                                    [container]=\"parent + '-' + component.Id\" lineType=\"Option\"\r\n                                    [(productAttributeValue)]=\"component.ComponentProduct._metadata.item.AttributeValue\"\r\n                                    (productAttributeValueChange)=\"onAttributeChange($event, view)\"\r\n                                    (attributeValueChange)=\"handleAttributeValueChange($event)\" [accordion]=\"accordion\"\r\n                                    [collapseAll]=\"collapseAll\"></apt-product-attribute>\r\n                            </ng-container>\r\n\r\n\r\n                            <ng-template [ngTemplateOutlet]=\"productOptionGroupTemplate\"\r\n                                [ngTemplateOutletContext]=\"{optionGroupList: component?.ComponentProduct?.OptionGroups, parent: parent + '-' + component.Id, parentProduct: component?.ComponentProduct}\">\r\n                            </ng-template>\r\n                        </div>\r\n                    </ng-template>\r\n                </div>\r\n            </ng-container>\r\n            <ng-template #empty>\r\n                <div class=\"d-flex justify-content-center flex-column align-items-center py-5 my-5\">\r\n                    <i class=\"fa fa-cog fa-5x text-primary xl text-faded\"></i>\r\n                    <div class=\"mt-4\">{{'CONFIGURATION.NO_CONFIGURATION' | translate}}</div>\r\n                </div>\r\n            </ng-template>\r\n        </ng-container>\r\n        <ng-template #loading>\r\n            <div class=\"d-flex justify-content-center py-5\">\r\n                <apt-dots></apt-dots>\r\n            </div>\r\n        </ng-template>\r\n    </div>\r\n</div>", styles: [".accordion .cr-popover-container{min-width:10%}.accordion .image-container{width:64px}.accordion .image-container img{max-height:50px;max-width:64px}.accordion .form-group{margin-bottom:0}.accordion input{max-width:70px}.accordion .custom-control{margin-top:-3px}.accordion .width-fixed{min-width:20vw;max-width:20vw}.accordion .desc{max-height:40px;overflow-y:hidden}.accordion .card{overflow:visible}.search{min-width:300px}apt-cr-popover .custom-checkbox input[type=checkbox][disabled]+label{pointer-events:none}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){apt-product-configuration div.accordion div.card div.option div.py-2 div.mx-3{margin-left:3rem}}\n"], components: [{ type: ProductAttributeComponent, selector: "apt-product-attribute", inputs: ["product", "container", "lineType", "productAttributeValue", "accordion", "collapseAll"], outputs: ["productAttributeValueChange", "attributeValueChange"] }, { type: AlertComponent, selector: "apt-alert", inputs: ["record", "layout", "expand", "message", "autoRun"] }, { type: DotsComponent, selector: "apt-dots", inputs: ["large", "color"] }, { type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: CRPopoverComponent, selector: "apt-cr-popover", inputs: ["product", "parentProduct", "message", "items", "options", "optionRules", "triggers", "outsideClick", "containerClass", "ruleList"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "image": i1$1.ImagePipe } });
__decorate([
    debounce(100),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProductConfigurationComponent.prototype, "emitChange", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-configuration',
                    templateUrl: './product-configuration.component.html',
                    styleUrls: ['./product-configuration.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.ProductOptionService }, { type: i1.CartItemService }, { type: i1.CartService }, { type: i1.ClientConstraintRuleService }, { type: ProductConfigurationService }]; }, propDecorators: { product: [{
                type: Input
            }], relatedTo: [{
                type: Input
            }], accordion: [{
                type: Input
            }], childConfigurationComponents: [{
                type: ViewChildren,
                args: ['childConfiguration']
            }], popover: [{
                type: ViewChildren,
                args: ['popover']
            }], emitChange: [] } });

/**
 * @ignore
 */
class ProductConfigurationModule {
}
ProductConfigurationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductConfigurationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationModule, declarations: [ProductConfigurationComponent], imports: [CommonModule,
        PriceModule,
        ButtonModule,
        InputFieldModule,
        FormsModule,
        ApttusModule,
        ConstraintPopoverModule,
        IconModule,
        ProductAttributeModule,
        AlertModule], exports: [ProductConfigurationComponent] });
ProductConfigurationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationModule, imports: [[
            CommonModule,
            PriceModule,
            ButtonModule,
            InputFieldModule,
            FormsModule,
            ApttusModule,
            ConstraintPopoverModule,
            IconModule,
            ProductAttributeModule,
            AlertModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductConfigurationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PriceModule,
                        ButtonModule,
                        InputFieldModule,
                        FormsModule,
                        ApttusModule,
                        ConstraintPopoverModule,
                        IconModule,
                        ProductAttributeModule,
                        AlertModule
                    ],
                    declarations: [
                        ProductConfigurationComponent
                    ],
                    exports: [ProductConfigurationComponent]
                }]
        }] });

/**
 * Promotion modal component is used to show a modal window with all the details of promotions that are applied to items in the cart.
 * <h3>Preview</h3>
 * <img class='jumbotron' src='https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/promotionModal.png' style='max-width: 100%'>
 * <h3>Usage</h3>
 *
 ```typescript
import { PromotionModalModule } from '@congacommerce/elements';

@NgModule({
  imports: [PromotionModalModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-pr-modal></apt-pr-modal>
```
*/
class PromotionModalComponent {
    constructor(modalService, cartItemService, orderLineItemService, quoteLineItemService, promotionService) {
        this.modalService = modalService;
        this.cartItemService = cartItemService;
        this.orderLineItemService = orderLineItemService;
        this.quoteLineItemService = quoteLineItemService;
        this.promotionService = promotionService;
        /**
         * @ignore
         */
        this.adjustmentItem = new AdjustmentItem();
    }
    ngAfterViewInit() {
        this.recordMap = [
            {
                service: this.cartItemService,
                type: this.cartItemService.type,
                template: this.appliedPromotionTemplate
            },
            {
                service: this.orderLineItemService,
                type: this.orderLineItemService.type,
                template: this.appliedPromotionTemplate
            },
            {
                service: this.quoteLineItemService,
                type: this.quoteLineItemService.type,
                template: this.appliedPromotionTemplate
            }
        ];
    }
    /**
     * Open the Modal popup when promotion(s) are applied to the lineItem of type
     * CartItem | OrderLineItem | QuoteLineItem. It shows the details of adjustemntmentLineItems
     * for the linetitems applied and the total adjusted amount.
     * @param record consists of object type of CartItem | OrderLineItem | QuoteLineItem.
    */
    openLineItemModal(record) {
        const iface = _.find(this.recordMap, (i) => record instanceof i.type);
        this.adjustmentList$ = this.promotionService.getAppliedPromotionForLineItem(record.LineNumber);
        this.record$ = iface.service.get([record.Id], false).pipe(map((list) => _.first(list)));
        this.totalAmt$ = this.adjustmentList$.pipe(map((items) => _.sumBy(items, 'IncentiveAdjustmentAmount')));
        this.modalRef = this.modalService.show(iface.template, iface.config);
    }
    /**
     * Opens the modal dialog on promotion applied to the cart. It displays the list of
     * adjustment lineitem created for the cart and the total adjusted amount of the incentive.
     * @param record is an object of type Incentive.
     */
    openIncentiveModal(record) {
        this.record$ = of(record);
        this.adjustmentList$ = this.promotionService
            .getAppliedPromotionForCart(record.IncentiveCode)
            .pipe(tap((adjList) => {
            const option = _.find(adjList, (r) => r.LineItem.LineType === 'Option');
            if (!_.isEmpty(option))
                adjList[0].set('columns', option);
        }));
        this.totalAmt$ = this.adjustmentList$.pipe(map((items) => _.sumBy(items, 'IncentiveAdjustmentAmount')));
        this.modalRef = this.modalService.show(this.promotionAppliedToTemplate, { class: 'modal-lg' });
    }
}
PromotionModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalComponent, deps: [{ token: i1$2.BsModalService }, { token: i1.CartItemService }, { token: i1.OrderLineItemService }, { token: i1.QuoteLineItemService }, { token: i1.PromotionService }], target: i0.ɵɵFactoryTarget.Component });
PromotionModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PromotionModalComponent, selector: "apt-pr-modal", viewQueries: [{ propertyName: "appliedPromotionTemplate", first: true, predicate: ["appliedPromotionTemplate"], descendants: true }, { propertyName: "promotionAppliedToTemplate", first: true, predicate: ["promotionAppliedToTemplate"], descendants: true }], ngImport: i0, template: "<ng-template #appliedPromotionTemplate>\r\n  <div class=\"modal-header\">\r\n    <h5 class=\"modal-title pl-3\">{{'PROMOTION.APPLIED_PROMOTIONS' | translate}}</h5>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <ng-container *ngIf=\"record$ | async as record; else loadingA\">\r\n    <div class=\"modal-body small\">\r\n      <span class=\"pl-3\">\r\n        {{'PROMOTION.PROMOTION_APPLIED' | translate}} <strong [innerHTML]=\"record?.Product?.Name\"></strong>\r\n      </span>\r\n      <ul class=\"list-group mt-3\">\r\n        <li class=\"list-group-item dashed-border border-secondary bg-light d-flex justify-content-between\"\r\n          *ngFor=\"let adjustment of record?.AdjustmentLineItems\">\r\n          <div>\r\n            <div class=\"d-flex align-items-center\">\r\n              <div class=\"font-weight-bold\">{{adjustment?.Incentive?.Name}}</div>\r\n              <span class=\"badge badge-success ml-2\">{{adjustment.CouponCode ? adjustment.CouponCode : adjustment.Incentive.IncentiveCode}}</span>\r\n            </div>\r\n            \r\n            <p [innerHTML]=\"adjustment?.Incentive?.Description\"></p>\r\n\r\n            <small class=\"text-muted\">\r\n              {{adjustment?.Incentive?.ExpirationDate | date:'mediumDate'}} <span class=\"mx-2\">|</span> {{adjustment?.LineType}}\r\n            </small>\r\n          </div>\r\n          <div class=\"d-flex align-items-center\">\r\n            <span class=\"badge badge-info p-2\">{{adjustment?.IncentiveAdjustmentAmount | localCurrency | async}}</span>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n\r\n      \r\n  </ng-container>\r\n  <ng-template #loadingA>\r\n    <div class=\"d-flex justify-content-center my-5\">\r\n      <apt-dots></apt-dots>\r\n    </div>\r\n  </ng-template>\r\n</ng-template>\r\n\r\n<ng-template #promotionAppliedToTemplate>\r\n  <div class=\"modal-header\">\r\n    <h5 class=\"modal-title\">{{'PROMOTION.PROMOTION_APPLIEDTO' | translate}}</h5>\r\n    <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body small\">\r\n    <ng-container *ngIf=\"record$ | async as record\">\r\n      <p>\r\n        {{'PROMOTION.TITLE' | translate}} <strong>{{record?.Name}}</strong>\r\n        {{'PROMOTION.APPLIED_PROMOTION' | translate}}\r\n      </p>\r\n\r\n      <table class=\"table table-sm table-responsive\" *ngIf=\"adjustmentList$ | async as adjustmentList; else loadingB\">\r\n        <thead>\r\n          <tr>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]?.LineItem?.Product\" field=\"Name\" [labelOnly]=\"true\">\r\n              </apt-output-field>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]?._metadata?.columns?.LineItem?.Option\" field=\"Name\" [labelOnly]=\"true\" label=\"Option\">\r\n              </apt-output-field>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]?.LineItem\" field=\"ChargeType\" [labelOnly]=\"true\">\r\n              </apt-output-field>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]?.LineItem\" field=\"Quantity\" [labelOnly]=\"true\">\r\n              </apt-output-field>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]?.LineItem\" field=\"LineNumber\" [labelOnly]=\"true\">\r\n              </apt-output-field>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]\" field=\"IncentiveCode\" [labelOnly]=\"true\" *ngIf=\"!adjustmentList[0].CouponCode\"></apt-output-field>\r\n              <span *ngIf=\"adjustmentList[0].CouponCode\">{{'PROMOTION.COUPON_CODE' | translate}}</span>\r\n            </th>\r\n            <th scope=\"col\">\r\n              <apt-output-field [record]=\"adjustmentList[0]\" field=\"IncentiveAdjustmentAmount\" [labelOnly]=\"true\">\r\n              </apt-output-field>\r\n            </th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of adjustmentList\">\r\n            <td>{{item?.LineItem?.Product?.Name}}</td>\r\n            <td>{{item?.LineItem?.Option?.Name}}</td>\r\n            <td>{{item?.LineItem?.ChargeType}}</td>\r\n            <td>{{item?.LineItem?.Quantity}}</td>\r\n            <td>{{item?.LineItem?.LineNumber}}</td>\r\n            <td>{{item?.CouponCode ? item?.CouponCode : item?.IncentiveCode}}</td>\r\n            <td>{{item?.IncentiveAdjustmentAmount | localCurrency | async}}</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n      <ng-template #loadingB>\r\n        <div class=\"d-flex justify-content-center my-5\">\r\n          <apt-dots></apt-dots>\r\n        </div>\r\n      </ng-template>\r\n    </ng-container>\r\n    <div class=\"modal-footer d-flex justify-content-between font-weight-bold\">\r\n      <span>{{'PROMOTION.TOTAL_PROMOTION_AMOUNT' | translate}}</span>\r\n      <span>{{totalAmt$ | async | localCurrency | async}}</span>\r\n    </div>\r\n  </div>\r\n</ng-template>", styles: [""], components: [{ type: DotsComponent, selector: "apt-dots", inputs: ["large", "color"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe, "date": i5.DatePipe, "localCurrency": i1.LocalCurrencyPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-pr-modal',
                    templateUrl: './promotion-modal.component.html',
                    styleUrls: ['./promotion-modal.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalService }, { type: i1.CartItemService }, { type: i1.OrderLineItemService }, { type: i1.QuoteLineItemService }, { type: i1.PromotionService }]; }, propDecorators: { appliedPromotionTemplate: [{
                type: ViewChild,
                args: ['appliedPromotionTemplate']
            }], promotionAppliedToTemplate: [{
                type: ViewChild,
                args: ['promotionAppliedToTemplate']
            }] } });

/**
 * Promotion component is used to apply and remove promtoions on the cart.
 * Also fetches the list of adjustment line item associated with the cart.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/promotion.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { PromotionModule } from '@congacommerce/elements';

@NgModule({
  imports: [PromotionModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-promotion [cart]="cart"></apt-promotion>
```
*/
class PromotionComponent {
    constructor(promotionService, exceptionService, storefrontService, cdr) {
        this.promotionService = promotionService;
        this.exceptionService = exceptionService;
        this.storefrontService = storefrontService;
        this.cdr = cdr;
        /** @ignore */
        this.promocode = null;
        /** @ignore */
        this.loading = false;
    }
    ngOnChanges() {
        this.storefront$ = this.storefrontService.getStorefront();
        const adjustmentLI = flatten(filter$1(get(this, 'cart.LineItems'), r => get(r, 'AdjustmentLineItems')).map(k => k.AdjustmentLineItems));
        this.adjustmentItemList$ = of(adjustmentLI);
        const incentiveCodes = adjustmentLI.map(k => k.IncentiveCode);
        const incentiveList$ = isEmpty(incentiveCodes) ? of(null) : this.promotionService.getIncentiveByCode(toString(incentiveCodes));
        this.promoList$ = zip(this.adjustmentItemList$, incentiveList$)
            .pipe(map(([adjustmentItems, incentives]) => uniqBy(map$1(adjustmentItems, item => {
            const incentive = find(incentives, (i) => i.IncentiveCode === item.IncentiveCode);
            incentive.set('total', sumBy(filter$1(adjustmentItems, ai => get(ai, 'IncentiveCode') === get(incentive, 'IncentiveCode')), 'IncentiveAdjustmentAmount'));
            const couponCode = get(find(adjustmentItems, (ai) => get(ai, 'IncentiveCode') === get(incentive, 'IncentiveCode')), 'Apttus_Config2__CouponCode__c');
            if (couponCode)
                incentive.set('couponCode', couponCode);
            return incentive;
        }), 'Id')));
    }
    /** @ignore */
    trackById(index, record) {
        return get(record, 'Id');
    }
    /**
     * Method triggers to open modal dialog using name of the promotion link from the view at cart level.
     * @param incentiveName The applied promotion name.
     * @param adjustmentItem Adjustment line item from the promotion applied to the cart.
     * @ignore
     */
    openModalForCartPromo(incentive) {
        this.promotionModal.openIncentiveModal(incentive);
    }
    /**
     * Method applies the promotion to the cart using the promocode property.
     * @fires promotionService.applyPromotions
     * @ignore
     */
    applyPromotions() {
        this.loading = true;
        this.promotionService.applyPromotions(this.promocode).pipe(take(1)).subscribe(res => {
            if (get(res, 'error.data.message')) {
                const title = get(res, 'error.data.message') === 'PROMOTION_OR_COUPON_NOT_AVAILABLE' ? 'INVALID_PROMOTION_TITLE' : 'INVALID_COUPON_TITLE';
                this.exceptionService.showWarning(`ERROR.PROMOTION.${get(res, 'error.data.message')}`, `ERROR.PROMOTION.${title}`, { name: this.promocode });
            }
            else if (res) {
                this.exceptionService.showSuccess('SUCCESS.PROMOTION.VALID_PROMOTION_MESSAGE', 'SUCCESS.PROMOTION.VALID_PROMOTION_TITLE', { name: this.promocode });
            }
            else {
                this.exceptionService.showWarning('ERROR.PROMOTION.PROMOTION_OR_COUPON_NOT_AVAILABLE', 'ERROR.PROMOTION.INVALID_PROMOTION_TITLE', { name: this.promocode });
            }
            this.loading = false;
            this.promocode = null;
            this.cdr.detectChanges();
        });
    }
    /**
     * Method removes the promotion from the cart using the promocode property
     * and displays a toaster with the name of the promotion which gets removed.
     * @fires promotionService.removeAppliedPromotion
     * @ignore
     */
    removePromotion(incentive) {
        set(incentive, '_metadata.loading', true);
        const code = incentive.get('couponCode') ? incentive.get('couponCode') : get(incentive, 'IncentiveCode');
        this.promotionService.removeAppliedPromotion(incentive).pipe(take(1)).subscribe(res => {
            this.exceptionService.showSuccess('SUCCESS.PROMOTION.REMOVED_TOASTR_MESSAGE', 'SUCCESS.PROMOTION.REMOVED_TOASTR_TITLE', { name: code });
        });
    }
}
PromotionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionComponent, deps: [{ token: i1.PromotionService }, { token: ExceptionService }, { token: i1.StorefrontService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PromotionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PromotionComponent, selector: "apt-promotion", inputs: { cart: "cart" }, viewQueries: [{ propertyName: "promotionModal", first: true, predicate: ["promotionModal"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"card \" *ngIf=\"(storefront$ | async)?.EnablePromotions\">\r\n  <h5 class=\"card-header mb-0\">\r\n    {{ 'PROMOTION.PROMOTION_TITLE' | translate }}\r\n  </h5>\r\n  <div class=\"card-body\">\r\n    <form class=\"input-group pb-3\">\r\n      <input type=\"text\" class=\"form-control promo-form-control\" placeholder=\"{{'PROMOTION.PROMO_CODE' | translate}}\" [(ngModel)]=\"promocode\"\r\n        [ngModelOptions]=\"{standalone: true}\">\r\n      <div class=\"ml-2\">\r\n        <button type=\"submit\" class=\"btn btn-outline-primary\" (click)=\"applyPromotions()\" [ladda]=\"loading\" [attr.data-style]=\"'zoom-in'\">\r\n          {{ 'PROMOTION.APPLY' | translate }} </button>\r\n      </div>\r\n    </form>\r\n    <div>\r\n\r\n      <ul class=\"list-group\">\r\n        <li class=\"list-group-item dashed-border border-secondary\" *ngFor=\"let incentive of promoList$ | async; trackBy: trackById\">\r\n          <div class=\"d-flex justify-content-between align-items-center\">\r\n            <button class=\"btn btn-link text-primary p-0 btn-sm font-weight-bold\" (click)=\"promotionModal.openIncentiveModal(incentive)\">{{incentive?.Name}}</button>\r\n            <span class=\"badge badge-light p-2\">{{incentive?._metadata?.total | localCurrency | async}}</span>\r\n          </div>\r\n          <apt-output-field field=\"IncentiveCode\" labelClass=\"font-weight-normal text-uppercase\" [editable]=\"false\" [record]=\"incentive\"\r\n            layout=\"inline\" class=\"d-block my-2\" *ngIf=\"!incentive._metadata.couponCode\"></apt-output-field>\r\n          <span *ngIf=\"incentive._metadata.couponCode\" class=\"coupon\">\r\n            <dt>{{'PROMOTION.COUPON_CODE' | translate}}:</dt>\r\n            <dd>{{ incentive._metadata.couponCode }}</dd>\r\n          </span>\r\n          <p [innerHTML]=\"incentive?.Description\"></p>\r\n          <button *ngIf=\"incentive?.AutoApply === false\" class=\"btn btn-link p-0 btn-sm\" (click)=\"removePromotion(incentive)\" [ladda]=\"incentive?._metadata?.loading\"\r\n            [attr.data-style]=\"'zoom-in'\"> {{'PROMOTION.REMOVE' | translate}} </button>\r\n        </li>\r\n      </ul>\r\n\r\n      <!-- <ng-container *ngFor=\"let item of cartPromotionList\">\r\n        <div class=\"list-group-item d-flex justify-content-between small p-1 promo-border promo-li-height\">\r\n          <div class=\"d-flex flex-grow-1 flex-column\">\r\n            <p class=\"mb-2\">\r\n              <a href=\"javascript:void(0)\" class=\"font-weight-bold small\" (click)=\"openModalForCartPromo(item?.Incentive?.Name, item)\">{{item?.Incentive?.Name}}</a>\r\n            </p>\r\n            <div class=\"mb-2 small\">\r\n              <span class=\"font-weight-bold\"> {{'PROMOTION.PROMO_CODE' | translate}}: </span>\r\n              <span>{{item?.IncentiveCode}}</span>\r\n            </div>\r\n            <div class=\"text-muted small\">\r\n              {{item?.Incentive?.Description}}\r\n            </div>\r\n          </div>\r\n          <div class=\"d-flex align-items-end flex-column\">\r\n            <p class=\"pt-1 m-0 small\">\r\n              <a *ngIf=\"item?.Incentive?.AutoApply === false\" href=\"javascript:void(0)\" class=\"text-secondary\" (click)=\"removePromotion(item?.IncentiveCode, item?.Incentive?.Name)\"> {{'PROMOTION.REMOVE' | translate}} </a>\r\n            </p>\r\n            <div class=\"mt-auto\">\r\n              <span class=\"badge badge-secondary small\">{{totalPromotionAmt(item?.Incentive?.Name, item) | localCurrency | async}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container> -->\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<apt-pr-modal #promotionModal></apt-pr-modal>", styles: [":host{display:block;font-size:small}:host .promo-border{border-style:dashed}:host .badge{font-size:inherit}:host p{max-height:60px;overflow-y:hidden}:host .coupon{display:flex;align-items:baseline;margin-top:5px}:host .coupon dt{text-transform:uppercase}:host .coupon dd{padding:0 .25rem}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: PromotionModalComponent, selector: "apt-pr-modal" }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "localCurrency": i1.LocalCurrencyPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-promotion',
                    templateUrl: './promotion.component.html',
                    styleUrls: ['./promotion.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.PromotionService }, { type: ExceptionService }, { type: i1.StorefrontService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { cart: [{
                type: Input
            }], promotionModal: [{
                type: ViewChild,
                args: ['promotionModal', { static: false }]
            }] } });

/**
 * @ignore
 */
class PromotionModalModule {
}
PromotionModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PromotionModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalModule, declarations: [PromotionModalComponent], imports: [CommonModule,
        PricingModule, i1$2.ModalModule, i2$1.TranslateModule, OutputFieldModule,
        IconModule], exports: [PromotionModalComponent] });
PromotionModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalModule, imports: [[
            CommonModule,
            PricingModule,
            ModalModule.forRoot(),
            TranslateModule.forChild(),
            OutputFieldModule,
            IconModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PricingModule,
                        ModalModule.forRoot(),
                        TranslateModule.forChild(),
                        OutputFieldModule,
                        IconModule
                    ],
                    declarations: [PromotionModalComponent],
                    exports: [PromotionModalComponent]
                }]
        }] });

/**
 * @ignore
 */
class PromotionModule {
}
PromotionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PromotionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModule, declarations: [PromotionComponent], imports: [CommonModule,
        PromotionModalModule,
        FormsModule,
        PricingModule,
        OutputFieldModule,
        LaddaModule, i2$1.TranslateModule], exports: [PromotionComponent] });
PromotionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModule, imports: [[
            CommonModule,
            PromotionModalModule,
            FormsModule,
            PricingModule,
            OutputFieldModule,
            LaddaModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PromotionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PromotionModalModule,
                        FormsModule,
                        PricingModule,
                        OutputFieldModule,
                        LaddaModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [PromotionComponent],
                    exports: [PromotionComponent]
                }]
        }] });

/**
 * The Input Quantity component is an input element with controls to increase/decrease the quantity of cart line items added to user's active cart.
 * @ignore
 * The comonent has an input text box where user can directly update the quantity of items to be added to the cart. It also has two control buttons to decrease/increase the added quantity. The quantity is always defaulted to value 1.
 * <h3>Preview</h3>
 * <img src="https://github.com/Apttus-Ecom/Summer19/blob/master/res/input-qty.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { InputQuantityModule } from '@congacommerce/elements';

@NgModule({
  imports: [InputQuantityModule, ...]
})
export class AppModule {}
 ```
*
* @example
 ```typescript
* <apt-input-quantity
*              [(ngModel)]="myModel"
*              (ngModelChange)="handleChange($event)"
*              [disabled]="isDisabled"
*              [min]="minValue"
*              [max]="maxValue"
*              [default]="defaultValue"
* ></apt-input-quantity>
 ```
*/
class InputQuantityComponent {
    constructor() {
        /**
         * A numberic value representing the quantity of line items to be added to user's active cart.
         */
        this.quantity = 1;
        /**
         * Event emitter for when the value changes.
         */
        this.change = new EventEmitter();
        /**
         * Flag to disable the input.
         */
        this.disabled = false;
        this.propagateChange = (_) => { };
    }
    /**
    * The quantity is always set to 1 or the minimum value specified for the line item.
    */
    ngOnInit() {
        this.quantity = (this.min) ? this.min : 1;
    }
    /**
     * Calls the writeValue method to update the quantity every time user changes the input controller. The quantity value ranges from 1 through 9999999.
     */
    ngOnChanges() {
        if (!this.min)
            this.min = 1;
        if (!this.max)
            this.max = 9999999;
        this.writeValue((this.default) ? this.default : this.min);
    }
    /**
     * @param value representing the quantity of items to be added to cart.
     * Updates the quantity every time user changes the input controller. The quantity value ranges from 1 through 9999999.
     */
    writeValue(value) {
        if (value < this.min)
            value = this.min;
        this.quantity = value;
        this.propagateChange(this.quantity);
    }
    registerOnChange(fn) {
        this.propagateChange = (evt) => {
            fn(evt);
            this.change.emit(evt);
        };
    }
    registerOnTouched(fn) { }
    /**
     * @param evt represnting the event associated with the user action.
     * Increases the quantity value by 1 when the increase button is clicked.
     * Propagates the event associated wit the user action in the event chain.
     */
    increase(evt) {
        this.quantity = (this.quantity < this.max) ? Number(this.quantity) + 1 : this.max;
        this.propagateChange(this.quantity);
        evt.stopPropagation();
    }
    /**
     * @param evt represnting the event associated with the user action.
     * Decreases the quantity value by 1 when the decrease button is clicked.
     * Propagates the event associated wit the user action in the event chain.
     */
    decrease(evt) {
        this.quantity = (this.quantity > this.min) ? Number(this.quantity) - 1 : this.min;
        this.propagateChange(this.quantity);
        evt.stopPropagation();
    }
}
InputQuantityComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputQuantityComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InputQuantityComponent, selector: "apt-input-quantity", inputs: { disabled: "disabled", min: "min", max: "max", default: "default" }, outputs: { change: "change" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputQuantityComponent,
            multi: true
        }], usesOnChanges: true, ngImport: i0, template: "<div class=\"input-group input-group-sm quantity-controls flex-nowrap\">\r\n  <div class=\"input-group-prepend\">\r\n    <button class=\"btn btn-outline-secondary btn-icon\" type=\"button\" (click)=\"decrease($event)\" [disabled]=\"disabled\">\r\n      <i class=\"fas fa-minus\"></i>\r\n    </button>\r\n  </div>\r\n  <input type=\"number\" class=\"form-control text-center quantity\" min=\"1\" placeholder=\"{{'COMMON.QUANTITY' | translate}}\"\r\n    [(ngModel)]=\"quantity\" name=\"quantity\" aria-label=\"\" aria-describedby=\"basic-addon1\"\r\n    (click)=\"$event.stopPropagation()\" [disabled]=\"disabled\" [min]=\"min\" [max]=\"max\"\r\n    (change)=\"propagateChange(quantity)\">\r\n  <div class=\"input-group-append\">\r\n    <button class=\"btn btn-outline-secondary btn-icon\" type=\"button\" (click)=\"increase($event)\" [disabled]=\"disabled\">\r\n      <i class=\"fas fa-plus\"></i>\r\n    </button>\r\n  </div>\r\n</div>", styles: ["input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}input[type=number]{width:34px}\n"], directives: [{ type: i6.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { type: i6.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i6.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-input-quantity',
                    templateUrl: './input-quantity.component.html',
                    styleUrls: ['./input-quantity.component.scss'],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: InputQuantityComponent,
                            multi: true
                        }]
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { change: [{
                type: Output
            }], disabled: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], default: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class InputQuantityModule {
}
InputQuantityModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InputQuantityModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityModule, declarations: [InputQuantityComponent], imports: [CommonModule,
        FormsModule, i2$1.TranslateModule], exports: [InputQuantityComponent] });
InputQuantityModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityModule, imports: [[
            CommonModule,
            FormsModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputQuantityModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [InputQuantityComponent],
                    exports: [InputQuantityComponent]
                }]
        }] });

/**
 * The compare table is a table of product features with a product compare card as each column header.
 * @ignore
 */
/**
 * Compare table component is used to create a table of products to compare features.
 */
class CompareTableComponent {
    constructor() {
        /**
         * Array of features between all products
         */
        this.features = [];
        /**
         * Object used to set the min-width style property for the table based on the number of columns.
         */
        this.widths = {
            2: '600px',
            3: '800px',
            4: '1000px',
            5: '1200px'
        };
        /**
         * Data used to populate the cells in the table.
         */
        this.tableData = [];
    }
    /**
     * @ignore
     */
    ngOnChanges() {
        if (this.products) {
            const allFeatureSets = [];
            const allFeatures = [];
            this.products.forEach(product => {
                product.ProductFeatureValues.forEach(productFeature => {
                    allFeatureSets.push(productFeature.Feature.FeatureSet);
                    allFeatures.push(productFeature.Feature);
                });
            });
            this.features = _.uniqBy(allFeatures, 'Id');
            // Before any new change clear out existing array of featureSet
            this.tableData = new Array();
            _.uniqBy(allFeatureSets, 'Id').forEach(featureSet => {
                this.tableData.push({
                    featureSet: featureSet,
                    featuresInSet: this.featuresInSet(featureSet).map(feature => {
                        return {
                            feature: feature,
                            featureValuePerProduct: this.products.map(product => {
                                return this.featureValue(product, feature);
                            })
                        };
                    })
                });
            });
        }
    }
    /**
     * Gets the features that are in the given FeatureSet object.
     * @param featureSet Feature set to check against.
     * @returns Array<Feature> representing Array of features between products
     */
    featuresInSet(featureSet) {
        const featuresInSet = [];
        this.features.forEach(feature => {
            if (feature.FeatureSet.Id === featureSet.Id)
                featuresInSet.push(feature);
        });
        return featuresInSet;
    }
    /**
     * Gets the value of a given feature on a given product.
     * @param product Product to check for feature values.
     * @param feature Feature to get value of.
     * @returns the value of a given feature on a given product
     */
    featureValue(product, feature) {
        let value = 'n/a';
        product.ProductFeatureValues.forEach(productFeatureValue => {
            if (productFeatureValue.Feature.Id === feature.Id)
                value = productFeatureValue.Value;
        });
        return value;
    }
}
CompareTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CompareTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CompareTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: CompareTableComponent, selector: "apt-compare-table", inputs: { products: "products" }, usesOnChanges: true, ngImport: i0, template: "<table class=\"table\" [style.min-width]=\"(products?.length > 5) ? '1200px' : widths[products?.length]\">\r\n  <thead>\r\n    <tr>\r\n      <th></th>\r\n      <th scope=\"col\" *ngFor=\"let product of products\">\r\n        <apt-compare-product-card\r\n          [product]=\"product\"\r\n        ></apt-compare-product-card>\r\n      </th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <ng-container *ngFor=\"let featureSet of tableData\">\r\n      <tr>\r\n        <th class=\"featureSetCell py-2\" [attr.colspan]=\"products?.length + 1\">\r\n          {{featureSet?.featureSet?.Name}}\r\n        </th>\r\n      </tr>\r\n      <tr *ngFor=\"let feature of featureSet.featuresInSet\">\r\n        <th class=\"bg-light\">{{feature?.feature?.Name}}</th>\r\n        <td class=\"bg-white\" *ngFor=\"let value of feature?.featureValuePerProduct\">{{value}}</td>\r\n      </tr>\r\n    </ng-container>\r\n  </tbody>\r\n</table>", styles: [".table{table-layout:fixed}.table td{padding-left:32px}\n"], components: [{ type: CompareProductCardComponent, selector: "apt-compare-product-card" }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CompareTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-compare-table',
                    templateUrl: './compare-table.component.html',
                    styleUrls: ['./compare-table.component.scss']
                }]
        }], propDecorators: { products: [{
                type: Input
            }] } });

/**
 * The Product Compare component is used to display a side by side comparison of product records.
 * Each product is shown as a card at the top of the component with a table below each card listing the features.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productCompare.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductCompareModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductCompareModule, ...]
})
export class AppModule {}
 ```
* @example
```typescript
* <apt-product-compare [identifiers]="identifierArray"></apt-product-compare>
```
*/
class ProductCompareComponent {
    constructor(config, productService) {
        this.config = config;
        this.productService = productService;
        /**
         * The product identifier set in the configuration file.
         * @ignore
         */
        this.identifier = 'Id';
        /**
         * Object used to set the min-width style property for the table based on the number of columns.
         * @ignore
         */
        this.widths = {
            2: '600px',
            3: '800px',
            4: '1000px',
            5: '1200px'
        };
        this.identifier = this.config.get('productIdentifier');
    }
    ngOnChanges() {
        const conditions = new Array(new ACondition(this.productService.type, this.identifier, 'In', this.identifiers));
        this.products$ = this.productService.getProducts(null, null, null, null, null, null, conditions).pipe(map(res => res.Products));
    }
}
ProductCompareComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareComponent, deps: [{ token: i1$1.ConfigurationService }, { token: i1.ProductService }], target: i0.ɵɵFactoryTarget.Component });
ProductCompareComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductCompareComponent, selector: "apt-product-compare", inputs: { identifiers: "identifiers" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"container-fluid\">\r\n  <div class=\"row px-3 pb-5\">\r\n    <div class=\"col d-flex justify-content-center\" [style.min-width]=\"((products$ | async)?.length > 5) ? '1200px' : widths[(products$ | async)?.length]\">\r\n      <apt-compare-table\r\n        [products]=\"products$ | async\"\r\n        [style.min-width]=\"((products$ | async)?.length > 5) ? '1200px' : widths[(products$ | async)?.length]\"\r\n      ></apt-compare-table>\r\n    </div>\r\n  </div>\r\n</div>", styles: [""], components: [{ type: CompareTableComponent, selector: "apt-compare-table", inputs: ["products"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-compare',
                    templateUrl: './product-compare.component.html',
                    styleUrls: ['./product-compare.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ConfigurationService }, { type: i1.ProductService }]; }, propDecorators: { identifiers: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class ProductCompareModule {
}
ProductCompareModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductCompareModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareModule, declarations: [ProductCompareComponent, CompareTableComponent], imports: [CommonModule,
        ProductCardModule], exports: [ProductCompareComponent] });
ProductCompareModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareModule, imports: [[
            CommonModule,
            ProductCardModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductCompareModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ProductCardModule
                    ],
                    declarations: [ProductCompareComponent, CompareTableComponent],
                    exports: [ProductCompareComponent]
                }]
        }] });

/**
 * The asset batch action service is used to provide a filtered set of batch actions specific to assets.
 * This service contains methods for checking if given actions are disabled along with tooltip messages for disabled actions.
 * @ignore
 */
class AssetBatchActionService extends BatchActionService {
    constructor(assetSelectionService, config, BatchSelectionService, router, cartService, storefrontService, translateService, userService) {
        super(config, BatchSelectionService, router, cartService, storefrontService, translateService, userService);
        this.assetSelectionService = assetSelectionService;
        this.config = config;
        this.BatchSelectionService = BatchSelectionService;
        this.router = router;
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        this.translateService = translateService;
        this.userService = userService;
        this.subs.push(combineLatest(this.assetSelectionService.getSelectedAssets(), this.cartService.getMyCart())
            .subscribe(([assets, cart]) => {
            this.filterAssetBatchActions(assets, cart);
        }));
    }
    /**
     * Filters the asset batch actions based on the currently selected assets.
     * @param assets The array of selected assets used to filter batch actions.
     * @ignore
     */
    filterAssetBatchActions(assets, cart) {
        this.actionMap['Renew'].setDisabled(false);
        this.actionMap['Terminate'].setDisabled(false);
        if (assets.length > 0) {
            assets.forEach(asset => {
                if (asset.PriceType === 'One Time' || asset.AssetStatus !== 'Activated') {
                    this.actionMap['Renew'].setDisabled(true);
                    this.translateService.stream('SERVICES.UNABLE_TO_RENEW_TOOLTIP').subscribe((val) => {
                        this.actionMap['Renew'].setTooltipText(val);
                    });
                    this.actionMap['Terminate'].setDisabled(true);
                    this.translateService.stream('SERVICES.UNABLE_TO_TERMINATE_TOOLTIP').subscribe((val) => {
                        this.actionMap['Terminate'].setTooltipText(val);
                    });
                }
                _.forEach(_.get(cart, 'LineItems'), lineItem => {
                    if (lineItem.AssetLineItemId === asset.Id) {
                        this.actionMap['Renew'].setDisabled(true);
                        this.actionMap['Terminate'].setDisabled(true);
                        this.translateService.stream('SERVICES.ITEMS_ARE_ALREADY_ADDED_TO_CART_TOOLTIP').subscribe((val) => {
                            this.actionMap['Renew'].setTooltipText(val);
                            this.actionMap['Terminate'].setTooltipText(val);
                        });
                    }
                });
            });
        }
        else {
            this.actionMap['Renew'].setDisabled(true);
            this.actionMap['Terminate'].setDisabled(true);
            this.translateService.stream('SERVICES.SELECTION_OF_ASSETS_MUST_TOOLTIP').subscribe((val) => {
                this.actionMap['Renew'].setTooltipText(val);
                this.actionMap['Terminate'].setTooltipText(val);
            });
        }
        const currentActions = [
            this.actionMap['Renew'],
            this.actionMap['Terminate']
        ];
        this._assetBatchActions.next(currentActions);
    }
    /**
     * Gets the current asset batch actions observable.
     * @returns Observable array of batch action objects.
     */
    getAssetBatchActions() {
        return this._assetBatchActions;
    }
    /**
     * Checks if a batch action is disabled based on the given action key.
     * @param action String key of the represented action.
     */
    isActionDisabled(action) {
        return this.actionMap[action].isDisabled();
    }
    /**
     * Gets the tooltip text for a given action.
     * @param action String key of the represented action.
     */
    getTooltipForAction(action) {
        return this.actionMap[action].getTooltipText();
    }
}
AssetBatchActionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetBatchActionService, deps: [{ token: AssetSelectionService }, { token: i1$1.ConfigurationService }, { token: BatchSelectionService }, { token: i4$1.Router }, { token: i1.CartService }, { token: i1.StorefrontService }, { token: i2$1.TranslateService }, { token: i1.UserService }], target: i0.ɵɵFactoryTarget.Injectable });
AssetBatchActionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetBatchActionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetBatchActionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AssetSelectionService }, { type: i1$1.ConfigurationService }, { type: BatchSelectionService }, { type: i4$1.Router }, { type: i1.CartService }, { type: i1.StorefrontService }, { type: i2$1.TranslateService }, { type: i1.UserService }]; } });

/**
 * Asset list header is used to create the header for the asset list component that holds the batch action buttons.
 * @ignore
 */
class AssetListHeaderComponent {
    /**
     * Observable array of all the assets pertaining to the current search filters.
     */
    // totalAssets$: string;
    constructor(assetBatchActionService, assetService, assetSelectionService, storefrontService, assetModalService, cdr) {
        this.assetBatchActionService = assetBatchActionService;
        this.assetService = assetService;
        this.assetSelectionService = assetSelectionService;
        this.storefrontService = storefrontService;
        this.assetModalService = assetModalService;
        this.cdr = cdr;
        this.searchConditions = [];
        /**
         * Event emitter for when to show selected assets only.
         */
        this.onSelectedAmountClick = new EventEmitter();
        /**
         * Event emitter for when to show all assets both selected and not selected.
         */
        this.onFullListClick = new EventEmitter();
        /**
         * Array of batch action keys that are enabled.
         */
        this.enabledActions = [];
    }
    ngOnInit() {
        // this.currentConditions.push(new ACondition(this.assetService.type, 'IsPrimaryLine', 'Equal', true));
        // _.concat(this.searchConditions, this.currentConditions, new ACondition(this.assetService.type, 'IsPrimaryLine', 'Equal', true));
        this.selectedAssets$ = this.assetSelectionService.getSelectedAssets();
        this.storefrontSubscription = this.storefrontService.getStorefront().subscribe(storefront => {
            this.enabledActions = (_.get(storefront, 'AssetActions')) ? _.get(storefront, 'AssetActions').split(';') : [];
        });
    }
    ngOnChanges() {
        // this.totalAssets$ = this.assetService.getAssetLineItemForAccount(null, _.concat(this.searchConditions, this.currentConditions, new ACondition(this.assetService.type, 'IsPrimaryLine', 'Equal', true)));
    }
    /**
     * Event handler for showing only the selected assets in the asset list.
     * @param event Array of asset line items that was fired on this event.
     */
    handleSelectedAmountClick(event) {
        event.preventDefault();
        this.selectedAssets$.pipe(take(1)).subscribe(assets => {
            this.onSelectedAmountClick.emit(assets);
        });
    }
    /**
     * Event handler for showing the full list of assets both selected and not selected.
     */
    handleFullListClick(event) {
        event.preventDefault();
        this.onFullListClick.emit();
    }
    /**
     * Event handler for when a batch action button is clicked.
     * @param action The action event that was fired.
     */
    handleBatchButtonClick(action) {
        let selectedAssets;
        this.selectedAssets$.pipe(take(1)).subscribe(assets => selectedAssets = assets);
        switch (action) {
            case 'Renew':
                this.assetModalService.openRenewModal(selectedAssets[0], selectedAssets);
                break;
            case 'Terminate':
                this.assetModalService.openTerminateModal(selectedAssets[0], selectedAssets);
                break;
        }
    }
    ngOnDestroy() {
        this.assetSelectionService.clearSelection();
        this.storefrontSubscription.unsubscribe();
    }
    /** @ignore */
    notAMassAction(action) {
        return (action.toLowerCase() !== 'buy more' && action.toLowerCase() !== 'change configuration');
    }
}
AssetListHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListHeaderComponent, deps: [{ token: AssetBatchActionService }, { token: i1.AssetService }, { token: AssetSelectionService }, { token: i1.StorefrontService }, { token: AssetModalService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AssetListHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetListHeaderComponent, selector: "apt-asset-list-header", inputs: { operation: "operation", totalAssets: "totalAssets" }, outputs: { onSelectedAmountClick: "onSelectedAmountClick", onFullListClick: "onFullListClick" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"bg-white d-flex align-items-center p-3\">\r\n  <div class=\"custom-control custom-checkbox custom-checkbox-lg\">\r\n    <input id=\"selectAllResults\" type=\"checkbox\" class=\"custom-control-input\"/>\r\n    <label class=\"custom-control-label ml-2\" for=\"selectAllResults\">&nbsp;</label>\r\n  </div>\r\n  <span class=\"border-right pr-3 mr-3\">\r\n    {{'ASSET_LIST.SELECTED_ASSETS' | translate}}\r\n    <ng-container *ngIf=\"(selectedAssets$ | async); else noResults\">\r\n      (\r\n      <a href=\"javascript.void(0)\" (click)=\"handleSelectedAmountClick($event)\">\r\n        {{ (selectedAssets$ | async)?.length }}\r\n      </a>\r\n       / \r\n      <a href=\"javascript.void(0)\" (click)=\"handleFullListClick($event)\">\r\n        {{ totalAssets }}\r\n      </a>\r\n      )\r\n    </ng-container>\r\n    <ng-template #noResults>0</ng-template>\r\n  </span>\r\n  <div class=\"d-flex\">\r\n    <ng-container *ngIf=\"operation !== null && operation !== undefined\">\r\n      <div\r\n        *ngIf=\"assetBatchActionService.isActionDisabled(operation) && notAMassAction(operation)\"\r\n        [tooltip]=\"assetBatchActionService.getTooltipForAction(operation)\"\r\n        container=\"body\"\r\n      >\r\n        <button\r\n          class=\"btn btn-link btn-sm\"\r\n          [ngClass]=\"operation === 'Terminate' ? 'btn-danger' : 'btn-primary'\"\r\n          disabled=\"true\"\r\n        >\r\n          {{ ('BUTTON.' + operation) | translate }}\r\n        </button>\r\n      </div>\r\n      <button\r\n        *ngIf=\"!assetBatchActionService.isActionDisabled(operation) && notAMassAction(operation)\"\r\n        class=\"btn btn-sm\"\r\n        [ngClass]=\"operation === 'Terminate' ? 'btn-outline-danger' : 'btn-outline-primary'\"\r\n        (click)=\"handleBatchButtonClick(operation)\"\r\n      >\r\n        {{ ('BUTTON.' + operation) | translate }}\r\n      </button>\r\n    </ng-container>\r\n    <ng-container\u00A0*ngIf=\"operation === null || operation === undefined\">\r\n      <ng-container *ngFor=\"let action of enabledActions\">\r\n        <div\r\n          *ngIf=\"assetBatchActionService.isActionDisabled(action) && notAMassAction(action)\"\r\n          [tooltip]=\"assetBatchActionService.getTooltipForAction(action)\"\r\n          container=\"body\"\r\n        >\r\n          <button\r\n            class=\"btn btn-link mx-1 btn-sm\"\r\n            [ngClass]=\"action === 'Terminate' ? 'btn-outline-danger' : 'btn-outline-primary'\"\r\n            disabled=\"true\"\r\n          >\r\n            {{ ('BUTTON.' + action) | translate }}\r\n          </button>\r\n        </div>\r\n        <button\r\n          *ngIf=\"!assetBatchActionService.isActionDisabled(action) && notAMassAction(action)\"\r\n          class=\"btn mx-1 btn-sm\"\r\n          [ngClass]=\"action === 'Terminate' ? 'btn-outline-danger' : 'btn-outline-primary'\"\r\n          (click)=\"handleBatchButtonClick(action)\"\r\n        >\r\n          {{ ('BUTTON.' + action) | translate }}\r\n        </button>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>", styles: [""], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-list-header',
                    templateUrl: './asset-list-header.component.html',
                    styleUrls: ['./asset-list-header.component.scss'],
                    changeDetection: ChangeDetectionStrategy.Default
                }]
        }], ctorParameters: function () { return [{ type: AssetBatchActionService }, { type: i1.AssetService }, { type: AssetSelectionService }, { type: i1.StorefrontService }, { type: AssetModalService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { operation: [{
                type: Input
            }], totalAssets: [{
                type: Input
            }], onSelectedAmountClick: [{
                type: Output
            }], onFullListClick: [{
                type: Output
            }] } });

/**
 * Asset accordion item component is used to display each asset line item within each group in the asset accordion.
 * @ignore
 */
class AssetAccordionItemComponent {
    constructor(assetSelectionService, modalService, cartService, assetModalService, translateService) {
        this.assetSelectionService = assetSelectionService;
        this.modalService = modalService;
        this.cartService = cartService;
        this.assetModalService = assetModalService;
        this.translateService = translateService;
        /**
         * Model value of the checkbox state.
         */
        this.checkState = false;
        /**
         * Event emitter for when the checkbox value changes.
         */
        this.checkChange = new EventEmitter();
        /**
         * Flag to set the asset action button disabled.
         */
        this.buttonDisabled = false;
        /**
         * Current subscriptions in this class.
         * @ignore
         */
        this.subs = [];
    }
    ngOnInit() {
        this.buttonDisabled = get(this.item, 'parent.AssetStatus') !== 'Activated';
        this.subs.push(this.assetSelectionService.getSelectedAssets().subscribe(assets => {
            this.checkState = this.assetSelectionService.isAssetSelected(this.item.parent);
        }));
        this.subs.push(this.cartService.getMyCart().subscribe(cart => {
            this.buttonDisabled = get(this.item, 'parent.AssetStatus') !== 'Activated';
            this.buttonTooltip = 'Asset status is not Activated.';
            if (get(cart, 'LineItems')) {
                cart.LineItems.forEach(lineItem => {
                    if (lineItem.AssetLineItemId === get(this.item, 'parent.Id')) {
                        this.buttonDisabled = true;
                        this.translateService.stream('ASSET_LIST.ASSET_ALREADY_EXIST_IN_CART_TOOLTIP').subscribe((val) => {
                            this.buttonTooltip = val;
                        });
                    }
                });
            }
        }));
    }
    /**
     * Checks if the asset dropdown button should be displayed.
     * @returns True if the criteria to show asset dropdown button is met.
     */
    showAssetDropdownButton() {
        const bool = this.operation !== 'Renew' && this.operation !== 'Terminate' && (get(this.item, 'parent.Product.ConfigurationType') === 'Standalone' || get(this.item, 'parent.Product.ConfigurationType') === 'Bundle') && (get(this.item, 'parent.PriceType') === 'Recurring' || get(this.item, 'parent.PriceType') === 'Usage');
        if (!bool)
            return this.showBuyMoreButton();
        return bool;
    }
    /**
     * @ignore
     */
    showBuyMoreButton() {
        return (get(this.item, 'parent.Product.ConfigurationType') === 'Standalone' && get(this.item, 'parent.PriceType') === 'One Time');
    }
    /**
     * Event handler for when the checkbox value changes.
     * @param event Event object that was fired.
     */
    handleCheckbox(event) {
        if (this.checkState)
            this.assetSelectionService.addAssetToSelection(this.item.parent);
        else
            this.assetSelectionService.removeAssetFromSelection(this.item.parent);
        this.checkChange.emit(this.checkState);
    }
    /**
     * Event handler for when the asset dropdown is clicked.
     * @param event The event that was fired.
     */
    handleAssetDropdownButton(event) {
        switch (event) {
            case 'Renew':
                this.assetModalService.openRenewModal(this.item.parent, [this.item.parent]);
                break;
            case 'Terminate':
                this.assetModalService.openTerminateModal(this.item.parent, [this.item.parent]);
                break;
            case 'Buy More':
                this.assetModalService.openBuyMoreModal(this.item.parent, [this.item.parent]);
                break;
            case 'Change Configuration':
                this.assetModalService.openChangeConfigurationModal(this.item.parent, [this.item.parent]);
                break;
        }
    }
    /**
     * @ignore
     */
    openModal(item) {
        this.selectedAsset = item;
        setTimeout(() => this.configurationSummary.show());
    }
    /** @ignore */
    showAssetCheckBox(operation) {
        return (operation !== 'Buy More' && operation !== 'Change Configuration');
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }
}
AssetAccordionItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionItemComponent, deps: [{ token: AssetSelectionService }, { token: i1$2.BsModalService }, { token: i1.CartService }, { token: AssetModalService }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
AssetAccordionItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetAccordionItemComponent, selector: "apt-asset-accordion-item", inputs: { checkState: "checkState", item: "item", operation: "operation" }, outputs: { checkChange: "checkChange" }, viewQueries: [{ propertyName: "configurationSummary", first: true, predicate: ["configurationSummary"], descendants: true }], ngImport: i0, template: "<div class=\"d-flex flex-column bg-white\" [class.border-bottom]=\"item.children.length > 0\">\r\n  <div class=\"d-flex pl-5\" [class.border-bottom]=\"item.children.length === 0\">\r\n    <div class=\"pl-5 flex-grow-1 tableWrapper\">\r\n      <div class=\"custom-control custom-checkbox custom-checkbox-lg\">\r\n        <ng-container *ngIf=\"showAssetCheckBox(operation); else ShowOnlyChargeType\">\r\n          <input [id]=\"item.parent.Id\" type=\"checkbox\" class=\"custom-control-input\" [(ngModel)]=\"checkState\"\r\n            (change)=\"handleCheckbox($event)\" />\r\n          <label class=\"custom-control-label mt-2 ml-2 font-weight-bold\"\r\n            [for]=\"item.parent.Id\">{{item.parent.ChargeType}}</label>\r\n        </ng-container>\r\n        <ng-template #ShowOnlyChargeType>\r\n          <label class=\"mt-2 ml-2 font-weight-bold\">{{item.parent.ChargeType}}</label>\r\n        </ng-template>\r\n        <ng-container *ngIf=\"(item.parent.HasAttributes || item.parent.HasOptions) && item?.parent?.BusinessLineItemId\">\r\n          <button class=\"text-muted btn btn-link btn-sm p-0 ml-2\" (click)=\"openModal(item.parent)\" *ngIf=\"item?.parent\">\r\n            <i class=\"fas fa-wrench\"></i>\r\n          </button>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"table-responsive mt-3\">\r\n        <ng-container *ngTemplateOutlet=\"attributeTable\"></ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"buttonWrapper\">\r\n      <div\r\n        *ngIf=\"showAssetDropdownButton()\"\r\n        class=\"btn-group p-3 dropleft align-self-start d-flex\"\r\n      >\r\n        <apt-asset-dropdown-button\r\n          [buttonType]=\"'btn-outline-primary'\"\r\n          [setDisabled]=\"buttonDisabled\"\r\n          [setTooltipText]=\"buttonTooltip\"\r\n          [priceType]=\"item.parent.PriceType\"\r\n          [configurationType]=\"item.parent.Product.ConfigurationType\"\r\n          [hasAttributes]=\"item.parent.HasAttributes\"\r\n          [operation]=\"operation\"\r\n          (onClick)=\"handleAssetDropdownButton($event)\"\r\n        ></apt-asset-dropdown-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    *ngIf=\"item.children.length != 0\"\r\n    class=\"accordion pl-5 ml-5\"\r\n  >\r\n    <div\r\n      *ngFor=\"let subItem of item.children\"\r\n      class=\"border-0\"\r\n    >\r\n      <div class=\"py-3 accordionHeader border-top border-bottom-0 bg-transparent d-flex collapsed\" [attr.data-target]=\"'#collapse' + subItem.Id\" role=\"button\" data-toggle=\"collapse\">\r\n        <span class=\"downArrow small\">&#9660;</span>\r\n        <span class=\"ml-3 font-weight-bold\">{{subItem.ChargeType}}</span>\r\n      </div>\r\n      <div [attr.id]=\"'collapse' + subItem.Id\" class=\"collapse px-5 table-responsive\">\r\n        <ng-container *ngTemplateOutlet=\"subItemTable;context:{chargeType:subItem.ChargeType}\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<apt-product-configuration-summary\r\n        [relatedTo]=\"item?.parent\"\r\n        *ngIf=\"item?.parent\"\r\n        [product]=\"item?.parent?.ProductId\"\r\n        #configurationSummary>\r\n</apt-product-configuration-summary>\r\n\r\n<ng-template #attributeTable>\r\n  <table class=\"table table-borderless\">\r\n    <tbody>\r\n      <tr>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"SellingFrequency\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"NetUnitPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"PriceType\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n      </tr>\r\n      <tr>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"AssetStatus\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n      </tr>\r\n      <tr>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n        <td>\r\n          <apt-output-field [record]=\"item.parent\" field=\"NetPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</ng-template>\r\n\r\n<ng-template #subItemTable let-chargeType=\"chargeType\">\r\n  <table class=\"table table-borderless\">\r\n    <ng-container *ngFor=\"let child of item.children\">\r\n      <tbody *ngIf=\"child.ChargeType==chargeType\">\r\n        <tr>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"SellingFrequency\" layout=\"inline\" [editable]=\"false\">\r\n            </apt-output-field>\r\n          </td>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"NetUnitPrice\" layout=\"inline\" [editable]=\"false\">\r\n            </apt-output-field>\r\n          </td>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"PriceType\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"StartDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </td>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"Quantity\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </td>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"AssetStatus\" layout=\"inline\" [editable]=\"false\">\r\n            </apt-output-field>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"EndDate\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </td>\r\n          <td>\r\n            <apt-output-field [record]=\"child\" field=\"NetPrice\" layout=\"inline\" [editable]=\"false\"></apt-output-field>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </ng-container>\r\n  </table>\r\n</ng-template>\r\n", styles: [".custom-control{position:relative;left:-30px}.tableWrapper{overflow-x:auto}table{font-size:12px}table td{padding:2px;min-width:200px}.buttonWrapper{flex-basis:200px}button.dropdown-toggle:before{display:none}div.dropdown-menu{top:35px!important;left:25px!important}div.btn-group-sm{width:150px}.btn.btn-outline-secondary.dropdown-toggle.dropdown-toggle-split{height:35%}.accordionHeader{cursor:pointer}.accordionHeader .downArrow{transition:transform .35s ease}.accordionHeader.collapsed .downArrow{transform:rotate(-90deg)}\n"], components: [{ type: AssetDropdownButtonComponent, selector: "apt-asset-dropdown-button", inputs: ["operation", "priceType", "configurationType", "primaryAction", "setDisabled", "setTooltipText", "buttonType", "hasAttributes"], outputs: ["onClick"] }, { type: ProductConfigurationSummaryComponent, selector: "apt-product-configuration-summary", inputs: ["product", "relatedTo", "changes", "preload", "position", "quantity", "showActionButtons"], outputs: ["onProductAdd", "onNavigate"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-accordion-item',
                    templateUrl: './asset-accordion-item.component.html',
                    styleUrls: ['./asset-accordion-item.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: AssetSelectionService }, { type: i1$2.BsModalService }, { type: i1.CartService }, { type: AssetModalService }, { type: i2$1.TranslateService }]; }, propDecorators: { checkState: [{
                type: Input
            }], item: [{
                type: Input
            }], operation: [{
                type: Input
            }], checkChange: [{
                type: Output
            }], configurationSummary: [{
                type: ViewChild,
                args: ['configurationSummary']
            }] } });

/**
 * Asset accordion group is used to create each group in the asset accordion component.
 * @ignore
 */
class AssetAccordionGroupComponent {
    constructor(assetSelectionService) {
        this.assetSelectionService = assetSelectionService;
        /**
         * Model value for the checkbox for the entire group.
         */
        this.checkState = false;
        /**
         * Flag to indicate that all children in this group have been checked. If true will check the main checkbox.
         */
        this.checkAll = false;
    }
    ngOnInit() {
        this.checkState = this.checkIfAllSelected();
    }
    /**
     * Event handler for when the main checkbox is changed.
     * @param event Event object that was fired.
     */
    handleCheckbox(event) {
        if (this.checkAll === this.checkState)
            this.checkAll = !this.checkState;
        setTimeout(() => {
            this.checkAll = this.checkState;
            this.group.forEach(asset => {
                if (this.checkState) {
                    this.assetSelectionService.addAssetToSelection(asset.parent);
                }
                else {
                    this.assetSelectionService.removeAssetFromSelection(asset.parent);
                }
            });
        });
    }
    /**
     * Event handler for when a checkbox on an item within the group is changed.
     * @param event Event object that was fired.
     */
    handleCheckChange(event) {
        if (!event)
            this.checkState = false;
        else {
            this.checkState = this.checkIfAllSelected();
        }
    }
    /**
     * Checks if all the asset line items within this group are selected.
     * @returns Will return true if all asset line items are selected.
     * @ignore
     */
    checkIfAllSelected() {
        let allSelected = true;
        this.group.forEach(asset => {
            if (!this.assetSelectionService.isAssetSelected(asset.parent))
                allSelected = false;
        });
        return allSelected;
    }
    /** @ignore */
    showAssetCheckBox(operation) {
        return (operation !== 'Buy More' && operation !== 'Change Configuration');
    }
}
AssetAccordionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionGroupComponent, deps: [{ token: AssetSelectionService }], target: i0.ɵɵFactoryTarget.Component });
AssetAccordionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetAccordionGroupComponent, selector: "apt-asset-accordion-group", inputs: { index: "index", group: "group", operation: "operation" }, ngImport: i0, template: "<div class=\"card\" [class.border-top]=\"index === 0\">\r\n  <div class=\"card-header accordionHeader d-flex p-3\" role=\"button\" data-toggle=\"collapse\" [attr.data-target]=\"'#collapse' + index\" aria-expanded=\"true\" [attr.aria-controls]=\"'collapse' + index\">\r\n    <div class=\"position-absolute ml-4\" *ngIf=\"showAssetCheckBox(operation);\">\r\n      <input [id]=\"group[0]?.parent?.Product.Name\" type=\"checkbox\" class=\"custom-control-input\" [(ngModel)]=\"checkState\" (change)=\"handleCheckbox($event)\"/>\r\n      <label class=\"custom-control-label ml-2\" [for]=\"group[0]?.parent?.Product.Name\">&nbsp;</label>\r\n    </div>\r\n\r\n    <span class=\"downArrow ml-5\">&#9660;</span>\r\n    <span class=\"assetName ml-3\">\r\n      {{group[0]?.parent?.Product.Name}}\r\n    </span>\r\n  </div>\r\n  \r\n  <div [attr.id]=\"'collapse' + index\" class=\"collapse show\">\r\n    <apt-asset-accordion-item\r\n      *ngFor=\"let item of group;let i=index\"\r\n      [item]=\"item\"\r\n      [operation]=\"operation\"\r\n      (checkChange)=\"handleCheckChange($event)\"\r\n      [checkState]=\"checkAll\"\r\n    ></apt-asset-accordion-item>\r\n  </div>\r\n</div>", styles: [".accordionHeader{cursor:pointer}.accordionHeader .downArrow{transition:transform .35s ease}.accordionHeader.collapsed .downArrow{transform:rotate(-90deg)}.accordionHeader .assetName{font-size:14px;font-weight:bold}.custom-control-label{pointer-events:none}.custom-control-label:before,.custom-control-label:after{pointer-events:all}\n"], components: [{ type: AssetAccordionItemComponent, selector: "apt-asset-accordion-item", inputs: ["checkState", "item", "operation"], outputs: ["checkChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-accordion-group',
                    templateUrl: './asset-accordion-group.component.html',
                    styleUrls: ['./asset-accordion-group.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: AssetSelectionService }]; }, propDecorators: { index: [{
                type: Input
            }], group: [{
                type: Input
            }], operation: [{
                type: Input
            }] } });

/**
 * Asset accordion is used to create the accordion list of assets grouped by product for the asset list component.
 * @ignore
 */
class AssetAccordionComponent {
    ngOnChanges() {
        this.assetGroups = _.values(_.groupBy(this.assets, 'parent.Product.Name'));
    }
}
AssetAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AssetAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetAccordionComponent, selector: "apt-asset-accordion", inputs: { assets: "assets", operation: "operation" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"accordion\">\r\n  <apt-asset-accordion-group\r\n    *ngFor=\"let group of assetGroups; let i = index\"\r\n    [index]=\"i\"\r\n    [group]=group\r\n    [operation]=\"operation\"\r\n  ></apt-asset-accordion-group>\r\n</div>", styles: [""], components: [{ type: AssetAccordionGroupComponent, selector: "apt-asset-accordion-group", inputs: ["index", "group", "operation"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetAccordionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-accordion',
                    templateUrl: './asset-accordion.component.html',
                    styleUrls: ['./asset-accordion.component.scss']
                }]
        }], propDecorators: { assets: [{
                type: Input
            }], operation: [{
                type: Input
            }] } });

/**
 * Asset list component is used to show a list of assets grouped by product.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/assetList.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { AssetListModule } from '@congacommerce/elements';

@NgModule({
  imports: [AssetListModule, ...]
})
export class AppModule {}
 ```
* @example
```typescript
* <apt-asset-list
*              [pageAssets]="pageItems"
*              [operation]="operation"
*              (onSelectedAmountClick)="handleSelectedAmountClick($event)"
*              (onFullListClick)="handleFullListClick()"
* ></apt-asset-list>
```
*/
class AssetListComponent {
    constructor() {
        /**
         * Event emitter for when to show selected assets only.
         */
        this.onSelectedAmountClick = new EventEmitter();
        /**
         * Event emitter for when to show all assets both selected and not selected.
         */
        this.onFullListClick = new EventEmitter();
    }
    /**
     * Event handler for showing only the selected assets in the asset list.
     * @param event Array of asset line items that was fired on this event.
     * @ignore
     */
    handleSelectedAmountClick(event) {
        this.onSelectedAmountClick.emit(event);
    }
    /**
     * Event handler for showing the full list of assets both selected and not selected.
     * @ignore
     */
    handleFullListClick() {
        this.onFullListClick.emit();
    }
    /** @ignore */
    showAssetHeader(operation) {
        return (operation !== 'Buy More' && operation !== 'Change Configuration');
    }
}
AssetListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AssetListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AssetListComponent, selector: "apt-asset-list", inputs: { pageAssets: "pageAssets", totalAssets: "totalAssets", operation: "operation" }, outputs: { onSelectedAmountClick: "onSelectedAmountClick", onFullListClick: "onFullListClick" }, ngImport: i0, template: "<apt-asset-list-header *ngIf=\"showAssetHeader(operation)\"\r\n  [operation]=\"operation\"\r\n  [totalAssets]=\"totalAssets\"\r\n  (onSelectedAmountClick)=\"handleSelectedAmountClick($event)\"\r\n  (onFullListClick)=\"handleFullListClick()\"\r\n></apt-asset-list-header>\r\n\r\n<apt-asset-accordion\r\n  *ngIf=\"(pageAssets && pageAssets?.length>0); else loading;\"\r\n  [assets]=\"pageAssets\"\r\n  [operation]=\"operation\"\r\n></apt-asset-accordion>\r\n\r\n<ng-template #loading>\r\n  <ng-container *ngIf=\"!pageAssets; else noContent\">\r\n    <div class=\"d-flex justify-content-center py-5\">\r\n      <apt-spinner></apt-spinner>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #noContent>\r\n  <div class=\"d-flex justify-content-center align-items-center m-5 p-5 flex-column\">\r\n    <i class=\"fa fa-database fa-5x text-primary xl text-faded\"></i>\r\n    <div class=\"mt-4\">No data to display</div>\r\n  </div>\r\n</ng-template>", styles: [""], components: [{ type: AssetListHeaderComponent, selector: "apt-asset-list-header", inputs: ["operation", "totalAssets"], outputs: ["onSelectedAmountClick", "onFullListClick"] }, { type: AssetAccordionComponent, selector: "apt-asset-accordion", inputs: ["assets", "operation"] }, { type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-asset-list',
                    templateUrl: './asset-list.component.html',
                    styleUrls: ['./asset-list.component.scss']
                }]
        }], propDecorators: { pageAssets: [{
                type: Input
            }], totalAssets: [{
                type: Input
            }], onSelectedAmountClick: [{
                type: Output
            }], onFullListClick: [{
                type: Output
            }], operation: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class ApttusModalModule {
}
ApttusModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ApttusModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModalModule, declarations: [RenewModalComponent, TerminateModalComponent, BuyMoreModalComponent, ChangeConfigurationModalComponent], imports: [CommonModule, i2$1.TranslateModule, FormsModule,
        LaddaModule,
        PricingModule, i7.BsDatepickerModule, i4$2.TooltipModule, OutputFieldModule,
        InputFieldModule] });
ApttusModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModalModule, imports: [[
            CommonModule,
            TranslateModule.forChild(),
            FormsModule,
            LaddaModule,
            PricingModule,
            BsDatepickerModule.forRoot(),
            TooltipModule.forRoot(),
            OutputFieldModule,
            InputFieldModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FormsModule,
                        LaddaModule,
                        PricingModule,
                        BsDatepickerModule.forRoot(),
                        TooltipModule.forRoot(),
                        OutputFieldModule,
                        InputFieldModule
                    ],
                    declarations: [RenewModalComponent, TerminateModalComponent, BuyMoreModalComponent, ChangeConfigurationModalComponent],
                    entryComponents: [RenewModalComponent, TerminateModalComponent, BuyMoreModalComponent, ChangeConfigurationModalComponent]
                }]
        }] });

/**
 * @ignore
 */
class AssetListModule {
}
AssetListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AssetListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListModule, declarations: [AssetListComponent, AssetListHeaderComponent, AssetAccordionComponent, AssetAccordionGroupComponent, AssetAccordionItemComponent], imports: [CommonModule,
        FormsModule,
        ButtonModule,
        ApttusModalModule,
        IconModule,
        TooltipModule,
        PricingModule,
        ConfigurationSummaryModule, i2$1.TranslateModule, OutputFieldModule], exports: [AssetListComponent] });
AssetListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListModule, imports: [[
            CommonModule,
            FormsModule,
            ButtonModule,
            ApttusModalModule,
            IconModule,
            TooltipModule,
            PricingModule,
            ConfigurationSummaryModule,
            TranslateModule.forChild(),
            OutputFieldModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AssetListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ButtonModule,
                        ApttusModalModule,
                        IconModule,
                        TooltipModule,
                        PricingModule,
                        ConfigurationSummaryModule,
                        TranslateModule.forChild(),
                        OutputFieldModule
                    ],
                    declarations: [AssetListComponent, AssetListHeaderComponent, AssetAccordionComponent, AssetAccordionGroupComponent, AssetAccordionItemComponent],
                    exports: [AssetListComponent]
                }]
        }] });

/**
 * Input select component is used to create a single or multi select input. This input uses the angular ng-select third party component to create the picklists.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/input-select.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { InputSelectModule } from '@congacommerce/elements';

@NgModule({
  imports: [InputSelectModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* <apt-input-select
*              [picklistType]="picklist"
*              [values]="picklistValues"
*              (onChange)="handleChange($event)"
* ></apt-input-select>
 ```
*/
class InputSelectComponent {
    constructor() {
        /**
         * The type of picklist to be rendered.
         */
        this.picklistType = 'picklist';
        /**
         * Event emitter for the change event of the picklist.
         */
        this.onChange = new EventEmitter();
        /**
         * Array of picklist values to populate the picklist.
         */
        this.values = [];
        /**
         * The placeholder value for a select tag to be rendered.
         */
        this.placeholder = 'Select values';
    }
}
InputSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InputSelectComponent, selector: "apt-input-select", inputs: { picklistType: "picklistType", values: "values", placeholder: "placeholder" }, outputs: { onChange: "onChange" }, ngImport: i0, template: "<ng-select\r\n  [multiple]=\"picklistType === 'multipicklist'\"\r\n  [items]=\"values\"\r\n  [(ngModel)]=\"modelValue\"\r\n  [placeholder]=\"placeholder\"\r\n  (change)=\"onChange.emit(modelValue)\"\r\n></ng-select>", styles: [""], components: [{ type: i4.NgSelectComponent, selector: "ng-select", inputs: ["markFirst", "dropdownPosition", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "bufferAmount", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "bindLabel", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "virtualScroll", "openOnEnter", "appendTo", "bindValue", "appearance", "maxSelectedItems", "groupBy", "groupValue", "tabIndex", "typeahead"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }], directives: [{ type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-input-select',
                    templateUrl: './input-select.component.html',
                    styleUrls: ['./input-select.component.scss']
                }]
        }], propDecorators: { picklistType: [{
                type: Input
            }], onChange: [{
                type: Output
            }], values: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class InputSelectModule {
}
InputSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InputSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectModule, declarations: [InputSelectComponent], imports: [CommonModule,
        FormsModule,
        NgSelectModule, i2$1.TranslateModule], exports: [InputSelectComponent] });
InputSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectModule, imports: [[
            CommonModule,
            FormsModule,
            NgSelectModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgSelectModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [InputSelectComponent],
                    exports: [InputSelectComponent]
                }]
        }] });

/**
 * The date range component includes two date input fields one for start date and one for end date. The input fields use the ngx-bootstrap date picker component.
 *
 * By default the date range component will calculate the begining and ending date for the cart item that is passed to it based on the frequency and term of the product.
 * When the user selects a date in the start date or end date inputs the onStartDateChange and onEndDateChange methods will be fired respectively.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/inputDate.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { InputDateModule } from '@congacommerce/elements';

@NgModule({
  imports: [InputDateModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage.
 ```typescript
* <apt-date-range-input
*             [cartItem]="item"
*             (onStartDateChange)="handleStartChange($event, item)"
*             (onEndDateChange)="handleEndDateChange($event, item)"
* ></apt-date-range-input>
 ```
*
* // Implementation with custom options.
 ```typescript
* <apt-date-range-input
*             (onStartDateChange)="handleStartChange($event, item)"
*             (onEndDateChange)="handleEndDateChange($event, item)"
*             [cartItem]="item"
*             [disableStartDate]="disableStartDate"
*             [disableEndDate]="disableEndDate"
*             [readonly]="false"
* ></apt-date-range-input>
 ```
*/
class InputDateComponent {
    constructor(cartItemService, sanitizer) {
        this.cartItemService = cartItemService;
        this.sanitizer = sanitizer;
        /**
         * Event emitter that fires when start date input is changed.
         */
        this.onStartDateChange = new EventEmitter();
        /**
         * Event emitter that fires when the end date input is changed.
         */
        this.onEndDateChange = new EventEmitter();
        /**
         * Flag to disable the start date input.
         */
        this.disableStartDate = false;
        /**
         * Flag to disable the end date input.
         */
        this.disableEndDate = false;
        /**
         * Flag to check if this component should be read only.
         */
        this.readonly = false;
        /**
         * Flag to apply small class on input field.
         */
        this.small = false;
        /** @ignore */
        this.startDate = new Date();
        /** @ignore */
        this.endDate = new Date();
        /** @ignore */
        this.moment = moment;
        /** @ignore */
        this.today = new Date();
        this.bsConfig = Object.assign({}, {
            showWeekNumbers: false,
            dateInputFormat: 'MM/DD/YYYY'
        });
    }
    ngOnInit() { }
    ngOnChanges() {
        const today = new Date().toISOString().split('T')[0], sellingTerm = _.get(this.cartItem, 'PriceListItem.DefaultSellingTerm', 1) || 1, frequency = _.get(this.cartItem, 'PricingFrequency'), cartItemStartDate = _.get(this.cartItem, 'StartDate'), cartItemEndDate = _.get(this.cartItem, 'EndDate'), startDate = this.moment(cartItemStartDate || today, 'YYYY-MM-DD').toDate(), endDate = this.cartItemService.getEndDate(startDate, sellingTerm, frequency);
        this.startDate = startDate;
        this.endDate = this.moment(cartItemEndDate || endDate).toDate();
        // Assign values to cart
        this.cartItem.StartDate = this.moment(this.startDate).format('YYYY-MM-DD');
        this.cartItem.EndDate = this.moment(this.endDate).format('YYYY-MM-DD');
    }
    /**
     * Called when user changes the start date input.
     * @param event The date object from the start date input.
     * @ignore
     */
    startDateChange(event) {
        const sanitizedDate = this.sanitizer.sanitize(SecurityContext.NONE, event);
        const startDate = this.moment(sanitizedDate).format('YYYY-MM-DD');
        if (_.get(this, 'cartItem.StartDate') !== startDate) {
            this.cartItem.StartDate = startDate;
            this.endDate = this.moment(this.cartItemService.getEndDate(_.get(this.cartItem, 'StartDate'), _.get(this.cartItem, 'PriceListItem.DefaultSellingTerm', 1), _.get(this.cartItem, 'PricingFrequency')).getTime()).toDate();
            this.cartItem.EndDate = this.moment(this.endDate).format('YYYY-MM-DD');
            this.cartItem.SellingTerm = this.cartItemService.getTerm(this.moment(_.get(this.cartItem, 'StartDate'), 'YYYY-MM-DD'), this.moment(_.get(this.cartItem, 'EndDate'), 'YYYY-MM-DD'), _.get(this.cartItem, 'PricingFrequency'));
            this.onStartDateChange.emit();
        }
    }
    /**
     * Called when user changes the end date input.
     * @param event The date object from the end date input.
     * @ignore
     */
    endDateChange(event) {
        const sanitizedDate = this.sanitizer.sanitize(SecurityContext.NONE, event);
        const endDate = this.moment(sanitizedDate).format('YYYY-MM-DD');
        if (_.get(this, 'cartItem.EndDate') !== endDate) {
            this.cartItem.EndDate = endDate;
            this.cartItem.SellingTerm = this.cartItemService.getTerm(this.moment(_.get(this.cartItem, 'StartDate'), 'YYYY-MM-DD'), this.moment(_.get(this.cartItem, 'EndDate'), 'YYYY-MM-DD'), _.get(this.cartItem, 'PricingFrequency'));
            this.onEndDateChange.emit();
        }
    }
    /** @ignore */
    isValidDate(date) {
        return !(_.isNil(date) || date === 'Invalid date');
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
InputDateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateComponent, deps: [{ token: i1.CartItemService }, { token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
InputDateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InputDateComponent, selector: "apt-date-range-input", inputs: { cartItem: "cartItem", disableStartDate: "disableStartDate", disableEndDate: "disableEndDate", readonly: "readonly", small: "small", displayDate: "displayDate" }, outputs: { onStartDateChange: "onStartDateChange", onEndDateChange: "onEndDateChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"d-flex date-range-container\">\r\n  <div class=\"form-group pr-1\" *ngIf=\"displayDate!=='EndDate'\">\r\n    <apt-output-field [record]=\"cartItem\" class=\"StartDate\" field=\"StartDate\" [labelOnly]=\"true\" [labelClass]=\"'mb-1'\">\r\n    </apt-output-field>\r\n    <input type=\"text\" id=\"startDate\" class=\"form-control\" #startDateTemplate=\"bsDatepicker\" [minDate]=\"startDate\"\r\n      bsDatepicker [(ngModel)]=\"startDate\" [bsConfig]=\"bsConfig\" (ngModelChange)=\"startDateChange(startDate)\"\r\n      [disabled]=\"disableStartDate || readonly\" [readonly]=\"readonly\" [class.form-control-sm]=\"small\">\r\n    <i class=\"fa fa-calendar pl-3 mb-3\"></i>\r\n  </div>\r\n  <div class=\"form-group pr-1\" *ngIf=\"displayDate!=='StartDate'\">\r\n    <apt-output-field [record]=\"cartItem\" class=\"EndDate\" field=\"EndDate\" [labelOnly]=\"true\" [labelClass]=\"'mb-1'\">\r\n    </apt-output-field>\r\n    <input type=\"text\" id=\"endDate\" class=\"form-control\" #endDateTemplate=\"bsDatepicker\" [minDate]=\"startDate\"\r\n      bsDatepicker [(ngModel)]=\"endDate\" [bsConfig]=\"bsConfig\" (ngModelChange)=\"endDateChange(endDate)\"\r\n      [disabled]=\"disableEndDate || readonly\" [readonly]=\"readonly\" [class.form-control-sm]=\"small\">\r\n    <i class=\"fa fa-calendar pl-3 mb-3\"></i>\r\n  </div>\r\n</div>", styles: [".date-range-container>div{position:relative}.date-range-container>div i{position:absolute;top:61%;right:5%}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts"], outputs: ["bsValueChange", "onShown", "onHidden"], exportAs: ["bsDatepicker"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-date-range-input',
                    templateUrl: './input-date.component.html',
                    styleUrls: ['./input-date.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.CartItemService }, { type: i1$3.DomSanitizer }]; }, propDecorators: { cartItem: [{
                type: Input
            }], onStartDateChange: [{
                type: Output
            }], onEndDateChange: [{
                type: Output
            }], disableStartDate: [{
                type: Input
            }], disableEndDate: [{
                type: Input
            }], readonly: [{
                type: Input
            }], small: [{
                type: Input
            }], displayDate: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class InputDateModule {
}
InputDateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InputDateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateModule, declarations: [InputDateComponent], imports: [CommonModule,
        FormsModule, i7.DatepickerModule, i7.BsDatepickerModule, i2$1.TranslateModule, OutputFieldModule], exports: [InputDateComponent] });
InputDateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateModule, imports: [[
            CommonModule,
            FormsModule,
            DatepickerModule.forRoot(),
            BsDatepickerModule.forRoot(),
            TranslateModule.forChild(),
            OutputFieldModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InputDateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        DatepickerModule.forRoot(),
                        BsDatepickerModule.forRoot(),
                        TranslateModule.forChild(),
                        OutputFieldModule
                    ],
                    declarations: [InputDateComponent],
                    exports: [InputDateComponent]
                }]
        }] });

/**
 * Tax popover component is used to create a popover displaying the breakdown of the taxes charged to the given order, quote or cart.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/taxPopover.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { TaxPopHoverModule } from '@congacommerce/elements';

@NgModule({
  imports: [TaxPopHoverModule, ...]
})
export class AppModule {}
```
* @example
```typescript
* <apt-tax-pophover
*              [taxItems]="taxItems"
*              [totalEstimatedTax]="totalEstimatedTax"
*              [showTaxPopUp]="true"
* ></apt-tax-pophover>
```
*/
class TaxPopHoverComponent {
    constructor() {
        /**
         * Flag to show or not show the tax popover.
         */
        this.showTaxPopUp = false;
    }
    ngOnInit() {
    }
}
TaxPopHoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TaxPopHoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TaxPopHoverComponent, selector: "apt-tax-pophover", inputs: { taxItems: "taxItems", totalEstimatedTax: "totalEstimatedTax", showTaxPopUp: "showTaxPopUp" }, ngImport: i0, template: "<div class=\"card bg-white\" *ngIf=\"showTaxPopUp\">\r\n    <div class=\"card-header bg-white pt-0 pb-2\">\r\n        <div class=\"row\">\r\n            <div class=\"col-10 p-0 mt-2 header\">\r\n                <span class=\"modal-title pull-left\">{{'TAX.TAX_SUMMARY' | translate }} </span>\r\n            </div>\r\n            <div class=\"col-2 p-0\">\r\n                <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"this.showTaxPopUp = false;\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-body p-0 mt-2 ml-2 pr-2 mb-2\">\r\n        <div class=\"row mb-1\" *ngFor=\"let item of taxItems\">\r\n            <ng-container *ngIf='item.BreakupType !== \"Total\"'>\r\n            <div class=\"col-7 small\">\r\n                <span>{{item.TaxType}}</span>\r\n            </div>\r\n            <div class=\"col-5 small text-right pl-0\">\r\n                <span>{{item.TaxAmount | localCurrency | async}}</span>\r\n            </div>\r\n        </ng-container>\r\n        </div>\r\n    </div>\r\n    <div class=\"card-footer pl-2 pr-2 pb-1 bg-white\">\r\n        <div class=\"row\">\r\n            <div class=\"col-7 small pr-0\">\r\n                <span>{{'TAX.TOTAL_ESTIMATED_TAX' | translate }}</span>\r\n            </div>\r\n            <div class=\"col-5 small text-right \">\r\n                <span class=\"font-weight-bold\"> {{totalEstimatedTax | localCurrency | async}}</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".card{border-radius:7px;border:3px;width:220px}.border-primary{border-color:#ebebeb!important}.small{font-size:90%}.header{font-size:100%}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe, "localCurrency": i1.LocalCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-tax-pophover',
                    templateUrl: './tax-popover.component.html',
                    styleUrls: ['./tax-popover.component.scss']
                }]
        }], propDecorators: { taxItems: [{
                type: Input
            }], totalEstimatedTax: [{
                type: Input
            }], showTaxPopUp: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class TaxPopHoverModule {
}
TaxPopHoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TaxPopHoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverModule, declarations: [TaxPopHoverComponent], imports: [CommonModule,
        ApttusModule,
        PricingModule], exports: [TaxPopHoverComponent] });
TaxPopHoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverModule, imports: [[
            CommonModule,
            ApttusModule,
            PricingModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TaxPopHoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        PricingModule
                    ],
                    declarations: [TaxPopHoverComponent],
                    exports: [TaxPopHoverComponent]
                }]
        }] });

/**
 * User view mapping service maps the response from user view service to CartItemView interface.
 * <h3>Usage</h3>
 *
 ```typescript
    import { UserViewMappingService } from '@congacommerce/ecommerce';
 *
    constructor(private mappingService: UserViewMappingService) { }

// or

    export class MyService extends AObjectService {
     private mappingService: UserViewMappingService = this.injector.get(UserViewMappingService);
    }
 ```
 */
class UserViewMappingService {
    constructor(userViewService) {
        this.userViewService = userViewService;
        /**
         * Behavior subject containing list of cart item views, for all cart item field selections available on cart page.
         */
        this.cartItemView$ = new BehaviorSubject(null);
        /**
         * Behavior subject containing list of cart item views, for the selected cart item fields on cart page.
         */
        this.selectedItems$ = new BehaviorSubject(null);
        /** @ignore */
        this.currentSelections = [];
        /** @ignore */
        this.subscriptions = new Array();
        this.subscriptions.push(this.userViewService.getUserView().subscribe(res => {
            const myView = this.mapUserView(res);
            this.updateUserView(myView);
        }));
    }
    /**
     * This method saves the cart item fields selected from line item menu component.
     * ### Example:
       ```typescript
      import { UserViewMappingService } from '@congacommerce/ecommerce';
     *
      constructor(private mappingService: UserViewMappingService) { }
     *
      saveSelections(): void {
      this.mappingService.saveUserSelections(this.menuItems$.value);
    }
     ```
     * @fires userViewService.updateUserView().
     * @param view list of cart item view records to be saved.
     */
    saveUserSelections(view) {
        // Save changes only if current selections are changed.
        if (!isEqual(view, this.currentSelections)) {
            this.updateUserView(view);
            const userViews = this.userViewService.userViews;
            const selectedFieldIds = map$1(this.selectedItems$.value, item => item.id);
            forEach(userViews, view => {
                view.IsSelected = includes(selectedFieldIds, view.DisplayColumn.Id);
            });
            this.subscriptions.push(this.userViewService.updateUserView(userViews).subscribe());
        }
    }
    /**
     * @ignore
     */
    updateUserView(view) {
        this.currentSelections = cloneDeep(view);
        this.cartItemView$.next(view);
        const selectedItems = filter$1(this.cartItemView$.value, item => item.isSelected);
        this.selectedItems$.next(selectedItems);
    }
    /**
     * This method returns the list of CartItemView records, for all cart item field selections available on cart page.
     * ### Example:
       ```typescript
      import { UserViewMappingService } from '@congacommerce/ecommerce';
     *
      constructor(private mappingService: UserViewMappingService) { }
     *
      ngOnInit(): void {
      this.menuItems$ = this.mappingService.getCurrentView();
    }
     ```
     * @returns List of CartItemView records.
     */
    getCurrentView() {
        return this.cartItemView$;
    }
    /**
     * This method returns the list of CartItemView records, for the selected cart item fields on cart page.
     * @returns List of CartItemView records.
     */
    getSelectedItems() {
        return this.selectedItems$;
    }
    /**
     * This method maps list of user view records to a list of CartItemView.
     * ### Example:
       ```typescript
      import { UserViewMappingService } from '@congacommerce/ecommerce';
     *
      constructor(private mappingService: UserViewMappingService) { }
       this.subscriptions.push(this.userViewService.getUserView().subscribe(res => {
              const myView = this.mappingService.mapUserView(res);
       }));
       }
     ```
     * @param userView list of user view records to be mapped to CartItemView.
     * @returns list of CartItemView records mapped from user views.
     */
    mapUserView(userView) {
        const views = new Array();
        map$1(userView, item => {
            const view = {
                id: get(item, 'displayColumn.Id'),
                fieldName: get(item, 'displayColumn.FieldName'),
                sequence: get(item, 'displayColumn.Sequence'),
                label: this.getFieldLabel(get(item, 'displayColumn.FieldName')),
                isEditable: get(item, 'displayColumn.IsEditable'),
                isSelected: get(item, 'isSelected')
            };
            views.push(view);
        });
        return views;
    }
    /**
     * @ignore
     */
    getFieldLabel(field) {
        const cartItemFields = new CartItem().getMetadataFromExpose();
        const label = first(keys(pickBy(cartItemFields, { name: field })));
        return label ? label : field;
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
UserViewMappingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewMappingService, deps: [{ token: i1.UserViewService }], target: i0.ɵɵFactoryTarget.Injectable });
UserViewMappingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewMappingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: UserViewMappingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.UserViewService }]; } });

/**
 * Creates the child rows on line items.
 * @ignore
 */
class TableRowSubItemComponent {
    constructor(cartService, storefrontService) {
        this.cartService = cartService;
        this.storefrontService = storefrontService;
        /**
         * Flag defines whether line item fields should be editable.
         */
        this.editableFields = true;
        /**
         * Flag defines whether custom fields to be shown or not.
         */
        this.showCustomFields = false;
        /**
         * Flag to check if this component should be read only.
         */
        this.readonly = false;
        /**
        * Flag to check favorite configuration item
        */
        this.isFavoriteConfigurationItem = false;
    }
    ngOnInit() {
        this.storefront$ = this.storefrontService.getStorefront();
        if (!(this.subItem instanceof CartItem) || get(this.subItem, 'IsOptionRollupLine')) {
            this.readonly = true;
        }
    }
    ngOnChanges() {
        this.quantity = this.subItem.Quantity;
    }
    /**
     * Changes the quantity of the cart item passed to this method.
     * @param cartItem Cart item reference to change quantity.
     * @param event The event object
     * @fires CartService.updateCartItems()
     */
    changeItemQuantity(cartItem) {
        if (!cartItem.Quantity || cartItem.Quantity <= 0) {
            cartItem.Quantity = this.quantity;
        }
        else {
            this.cartService.updateCartItems([cartItem]).pipe(take(1)).subscribe();
        }
    }
    /**
     * Event handler for when the start date changes.
     * @param cartItem Cart item to update.
     */
    handleStartChange(cartItem) {
        this.cartService.updateCartItems([cartItem])
            .pipe(take(1)).subscribe();
    }
    /**
     * Event handler for when the end date changes.
     * @param cartItem Cart item to update.
     */
    handleEndDateChange(cartItem) {
        this.cartService.updateCartItems([cartItem])
            .pipe(take(1)).subscribe();
    }
    /**
     * method checks if the lineitem is of type cartlineitem.
     * @param lineItem is the lineitem to check the type.
     */
    isCartLineItem(lineItem) {
        return lineItem instanceof CartItem && !this.isFavoriteConfigurationItem;
    }
    /**
      * Changes the values of the cart item passed to this method.
      * @param subItem Cart item reference to change values of the fields.
      * @param  view is the view object that has changes done on the fields
      * @fires CartService.updateCartItems()
      */
    updateValues(view, subItem) {
        if (!isEqual(view, subItem)) {
            if (!subItem.Quantity || subItem.Quantity <= 0) {
                subItem.Quantity = this.quantity;
            }
            subItem[view.fieldName] = view;
            this.cartService.updateCartItems([subItem]).pipe(take(1)).subscribe(res => { }, err => set(this.cart, 'IsPricePending', false));
        }
    }
}
TableRowSubItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableRowSubItemComponent, deps: [{ token: i1.CartService }, { token: i1.StorefrontService }], target: i0.ɵɵFactoryTarget.Component });
TableRowSubItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TableRowSubItemComponent, selector: "apt-table-row-sub-item", inputs: { subItem: "subItem", cart: "cart", editableFields: "editableFields", userView: "userView", showCustomFields: "showCustomFields" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"card border-right-0 border-left-0 border-bottom-0\">\r\n  <div class=\"card-header accordionHeader bg-transparent collapsed pr-0 border-bottom-0\" role=\"button\"\r\n    data-toggle=\"collapse\" [attr.data-target]=\"'#collapse' + subItem.ItemSequence + subItem.LineNumber\">\r\n    <span class=\"downArrow\">&#9660;</span>\r\n    <div class=\"d-flex\">\r\n      <span class=\"ml-3 inputSection\">\r\n        {{subItem?.ChargeType}}\r\n        <ng-template [ngTemplateOutlet]=\"statusBadge\" [ngTemplateOutletContext]=\"{subItem: subItem}\"></ng-template>\r\n      </span>\r\n      <span class=\"pl-3 priceSection d-flex headerPrice\">\r\n        <apt-output-field [record]=\"subItem\" field=\"NetPrice\" [labelOnly]=\"true\" [labelClass]=\"'font-weight-normal'\">\r\n        </apt-output-field>\r\n        <apt-price class=\"ml-auto chargeType\" [record]=\"subItem\" type=\"net\"></apt-price>\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div [id]=\"'collapse' + subItem.ItemSequence + subItem.LineNumber\" class=\"collapse\">\r\n    <div class=\"d-flex py-3 pl-3\">\r\n      <div class=\"inputSection h-100 d-flex flex-column pr-4\">\r\n        <div class=\"row\" *ngIf=\"!isCartLineItem(subItem)\">\r\n          <div class=\"col mb-2\" *ngIf=\"subItem?.PriceType === 'Recurring' || subItem?.PriceType === 'Usage'\">\r\n            <apt-output-field [record]=\"subItem\" field=\"PricingFrequency\" layout=\"stacked\" label=\"Frequency\"\r\n              [editable]=\"editableFields\"></apt-output-field>\r\n          </div>\r\n          <div class=\"col mb-2\" *ngIf=\"subItem?.PriceType === 'Recurring' || subItem?.PriceType === 'Usage'\">\r\n            <apt-output-field [record]=\"subItem\" field=\"PriceType\" layout=\"stacked\" label=\"Price Type\"\r\n              [editable]=\"editableFields\"></apt-output-field>\r\n          </div>\r\n          <div class=\"col mb-2\" *ngIf=\"subItem?.PriceType === 'Recurring' || subItem?.PriceType === 'Usage'\">\r\n            <apt-output-field [record]=\"subItem\" label=\"SellingTerm\" field=\"SellingTerm\" layout=\"stacked\"\r\n              [editable]=\"editableFields\">\r\n            </apt-output-field>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\" *ngIf=\"!isCartLineItem(subItem) ; else displayFields\">\r\n          <div class=\"col-8 mb-2\" *ngIf=\"subItem?.PriceType === 'Recurring' || subItem?.PriceType === 'Usage'\">\r\n            <apt-date-range-input [disableStartDate]=\"subItem?.LineStatus?.toLowerCase() !=='new'\"\r\n              (onStartDateChange)=\"handleStartChange(subItem)\" (onEndDateChange)=\"handleEndDateChange(subItem)\"\r\n              [small]=\"true\" [cartItem]=\"subItem\" [readonly]=\"readonly\"></apt-date-range-input>\r\n          </div>\r\n          <div class=\"col-4 mb-2\">\r\n            <apt-input-field [(ngModel)]=\"subItem.Quantity\" field=\"Quantity\" [entity]=\"subItem\"\r\n              (change)=\"changeItemQuantity(subItem)\" [readonly]=\"subItem?.LineStatus?.toLowerCase() ==='cancelled'\"\r\n              class=\"w-75\" [errorMsg]=\"'ERROR.INVALID_QUANTITY'\" [asterisk]=\"false\" [required]=\"true\" *ngIf=\"!readonly\"\r\n              [small]=\"true\">\r\n            </apt-input-field>\r\n            <apt-output-field [record]=\"subItem\" field=\"Quantity\" label=\"{{'COMMON.QUANTITY' | translate}}\" class=\"w-50\"\r\n              *ngIf=\"readonly\" [editable]=\"editableFields\"></apt-output-field>\r\n          </div>\r\n        </div>\r\n        <ng-template #displayFields>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\" *ngFor=\"let view of userView; let i=index\">\r\n              <!-- Render input field -->\r\n              <ng-container *ngIf=\"view?.label !== 'StartDate' && view?.label !== 'EndDate'; else date\">\r\n                <apt-input-field *ngIf=\"view.isEditable; else outputField\" [entity]=\"subItem\"\r\n                  [(ngModel)]=\"subItem[view.label]\" [small]=\"true\" [class]=\"view.label\" [field]=\"view.label\" [rows]=\"1\"\r\n                  (change)=\"updateValues(view,subItem)\" [displayFieldType]=\"'radio'\">\r\n                </apt-input-field>\r\n              </ng-container>\r\n              <!-- Render output field -->\r\n              <ng-template #outputField>\r\n                <apt-output-field [record]=\"subItem\" [class]=\"view.label\" layout=\"stacked\" [field]=\"view.label\"\r\n                  [label]=\"view.label\" [editable]=\"editableFields\">\r\n                </apt-output-field>\r\n              </ng-template>\r\n              <!-- Render Start/End date -->\r\n              <ng-template #date>\r\n                <apt-date-range-input (onStartDateChange)=\"changeItemQuantity(subItem)\"\r\n                  (onEndDateChange)=\"changeItemQuantity(subItem)\" [cartItem]=\"subItem\" small=\"true\"\r\n                  [readonly]=\"!view?.isEditable || (subItem?.PriceType !== 'Recurring' && subItem?.PriceType !== 'Usage')\"\r\n                  [displayDate]=\"view.label\">\r\n                </apt-date-range-input>\r\n              </ng-template>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n      <div class=\"border-left pl-4 priceSection\">\r\n        <div class=\"d-flex justify-content-between mt-1 text-muted\">\r\n          <span> {{'MANAGE_CART.CART_TABLE.STANDARD_PRICE' | translate }} </span>\r\n          <span>\r\n            <apt-price [record]=\"subItem\" type=\"list\"></apt-price>\r\n          </span>\r\n        </div>\r\n        <div class=\"d-flex justify-content-between mt-1 text-muted\"\r\n          *ngIf=\"subItem?.IncentiveAdjustmentAmount && (storefront$ | async)?.EnablePromotions && (storefront$ | async) !== null ? true : false\">\r\n          <button class=\"btn btn-link text-primary btn-sm p-0 \"\r\n            (click)=\"promotionModal.openLineItemModal(subItem)\">{{'PROMOTION.PROMOTION_APPLIED_TO' |\r\n            translate}}</button>\r\n          <span class=\"mt-1\">{{subItem?.IncentiveAdjustmentAmount | localCurrency | async}}</span>\r\n        </div>\r\n        <div class=\"d-flex justify-content-between mt-1\">\r\n          <apt-output-field [record]=\"subItem\" field=\"NetPrice\" [labelOnly]=\"true\" [labelClass]=\"'font-weight-normal'\">\r\n          </apt-output-field>\r\n          <apt-price [record]=\"subItem\" type=\"net\"></apt-price>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<apt-pr-modal #promotionModal></apt-pr-modal>\r\n<ng-template #statusBadge let-subItem=\"subItem\">\r\n  <ng-container [ngSwitch]=\"subItem?.LineStatus\">\r\n    <span class=\"badge ml-2 badge-danger\" *ngSwitchCase=\"'Cancelled'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Renewed'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-info\" *ngSwitchCase=\"'Upgraded'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Amended'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Incremented'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-light\" *ngSwitchCase=\"'Existing'\">\r\n      {{subItem?.LineStatus}}\r\n    </span>\r\n  </ng-container>\r\n</ng-template>", styles: [":host>div{font-size:inherit}.headerPrice{opacity:0;transition:opacity .35s ease}.inputSection{width:66%}.priceSection{width:36%}.qtyInput{height:31px}.accordionHeader{cursor:pointer}.accordionHeader .downArrow{position:absolute;left:6px;transition:transform .35s ease}.accordionHeader.collapsed .downArrow{transform:rotate(-90deg)}.accordionHeader.collapsed .headerPrice{opacity:1}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: InputDateComponent, selector: "apt-date-range-input", inputs: ["cartItem", "disableStartDate", "disableEndDate", "readonly", "small", "displayDate"], outputs: ["onStartDateChange", "onEndDateChange"] }, { type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }, { type: PromotionModalComponent, selector: "apt-pr-modal" }], directives: [{ type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe, "localCurrency": i1.LocalCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableRowSubItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-table-row-sub-item',
                    templateUrl: './table-row-sub-item.component.html',
                    styleUrls: ['./table-row-sub-item.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1.StorefrontService }]; }, propDecorators: { subItem: [{
                type: Input
            }], cart: [{
                type: Input
            }], editableFields: [{
                type: Input
            }], userView: [{
                type: Input
            }], showCustomFields: [{
                type: Input
            }] } });

/**
 * Additional information component is used to show additional info section when there are more than three line item fields
 * to be displayed on cart page.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/additional-information.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
 import { LineItemTableRowModule } from '@congacommerce/elements';

 @NgModule({
  imports: [LineItemTableRowModule, ...]
})
 export class AppModule {}
 ```
 * @example
 ```typescript
 * <apt-additional-information
 * [parent]="parent"
 * [cart]="cart"
 * [editableFields]="editableFields"
 * [userView]="userView"
 * [quantity]="quantity">
 * </apt-additional-information>
 ```
 */
class AdditionalInformationComponent {
    constructor(cartService) {
        this.cartService = cartService;
        /**
         * Flag defines whether line item fields should be editable.
         */
        this.editableFields = true;
    }
    /**
       * Changes the quantity of the cart item passed to this method.
       * @param cartItem Cart item reference to change quantity.
       * @param event The event object
       * @fires CartService.updateCartItems()
       * @ignore
       */
    changeItemQuantity(cartItem) {
        if (!cartItem.Quantity || cartItem.Quantity <= 0) {
            cartItem.Quantity = this.quantity;
        }
        else {
            this.cartService.updateCartItems([cartItem]).pipe(take(1)).subscribe(res => { }, err => set(this.cart, 'IsPricePending', false));
        }
    }
    /**
     * This method updates the cart item field on cart page.
     * @param view record of type CartItemView with cart item field to be updated.
     * @param parent cart item record to be updated.
     */
    updateValues(view, parent) {
        if (!isEqual(view, parent)) {
            if (!parent.Quantity || parent.Quantity <= 0) {
                parent.Quantity = this.quantity;
            }
            parent[view.fieldName] = view;
            this.cartService.updateCartItems([parent]).pipe(take(1)).subscribe(res => { }, err => set(this.cart, 'IsPricePending', false));
        }
    }
}
AdditionalInformationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AdditionalInformationComponent, deps: [{ token: i1.CartService }], target: i0.ɵɵFactoryTarget.Component });
AdditionalInformationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: AdditionalInformationComponent, selector: "apt-additional-information", inputs: { parent: "parent", editableFields: "editableFields", userView: "userView", cart: "cart", quantity: "quantity" }, ngImport: i0, template: "<div class=\"card border-right-0 border-left-0 border-bottom-0\">\r\n  <div class=\"card-header accordionHeader bg-transparent collapsed pr-0 border-bottom-0\" role=\"button\"\r\n    data-toggle=\"collapse\" [attr.data-target]=\"'#adtlInformation_' + parent.Id\">\r\n    <span class=\"downArrow\">&#9660;</span>\r\n    <span class=\"ml-3\">\r\n      {{'COMMON.ADDITIONAL_INFORMATION' | translate}}\r\n    </span>\r\n  </div>\r\n  <div class=\"collapse\" [id]=\"'adtlInformation_' + parent.Id\">\r\n    <div class=\"py-3 pl-3\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-4\" *ngFor=\"let view of userView; let i=index\">\r\n          <div *ngIf=\"i>= 3\">\r\n            <!-- Render input field -->\r\n            <ng-container *ngIf=\"view?.label !== 'StartDate' && view?.label !== 'EndDate'; else date\">\r\n              <apt-input-field *ngIf=\"view.isEditable; else outputField\" [entity]=\"parent\"\r\n                [(ngModel)]=\"parent[view.label]\" [small]=\"true\" [class]=\"view.label\" [field]=\"view.label\" [rows]=\"1\"\r\n                (change)=\"updateValues(view,parent)\" [displayFieldType]=\"'radio'\">\r\n              </apt-input-field>\r\n            </ng-container>\r\n            <!-- Render output field -->\r\n            <ng-template #outputField>\r\n              <apt-output-field [record]=\"parent\" [class]=\"view.label\" layout=\"stacked\" [field]=\"view.label\"\r\n                [label]=\"view.label\" [editable]=\"editableFields\">\r\n              </apt-output-field>\r\n            </ng-template>\r\n            <!-- Render Start/End date -->\r\n            <ng-template #date>\r\n              <apt-date-range-input\r\n                [disableStartDate]=\"parent?.LineStatus?.toLowerCase() ==='cancelled' || parent?.LineStatus?.toLowerCase() ==='renewed'\"\r\n                (onStartDateChange)=\"changeItemQuantity(parent)\" (onEndDateChange)=\"changeItemQuantity(parent)\"\r\n                [cartItem]=\"parent\" small=\"true\"\r\n                [readonly]=\"!view?.isEditable || (parent?.PriceType !== 'Recurring' && parent?.PriceType !== 'Usage')\"\r\n                [displayDate]=\"view.label\">\r\n              </apt-date-range-input>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [":host>div{font-size:inherit}.accordionHeader{cursor:pointer}.accordionHeader .downArrow{position:absolute;left:6px;transition:transform .35s ease}.accordionHeader.collapsed .downArrow{transform:rotate(-90deg)}.accordionHeader.collapsed .headerPrice{opacity:1}\n"], components: [{ type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: InputDateComponent, selector: "apt-date-range-input", inputs: ["cartItem", "disableStartDate", "disableEndDate", "readonly", "small", "displayDate"], outputs: ["onStartDateChange", "onEndDateChange"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AdditionalInformationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-additional-information',
                    templateUrl: './additional-information.component.html',
                    styleUrls: ['./additional-information.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }]; }, propDecorators: { parent: [{
                type: Input
            }], editableFields: [{
                type: Input
            }], userView: [{
                type: Input
            }], cart: [{
                type: Input
            }], quantity: [{
                type: Input
            }] } });

/**
 * Line item table row component is used to display line items on cart, quote, and order detail pages.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/line-item-table-row.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
 import { LineItemTableRowModule } from '@congacommerce/elements';

 @NgModule({
  imports: [LineItemTableRowModule, ...]
})
 export class AppModule {}
 ```
 * @example
 ```typescript
 * <apt-line-item-table-row
 *              [cart]="cart"
 *              [parent]="parentItem"
 *              [children]="childItems"
 *              [index]="index"
 * ></apt-line-item-table-row>
 ```
 */
class LineItemTableRowComponent {
    constructor(cartService, userViewMappingService, storefrontService, BatchSelectionService, cdr) {
        this.cartService = cartService;
        this.userViewMappingService = userViewMappingService;
        this.storefrontService = storefrontService;
        this.BatchSelectionService = BatchSelectionService;
        this.cdr = cdr;
        /**
         * Flag defines whether line item fields should be editable.
         */
        this.editableFields = true;
        this.userView$ = new BehaviorSubject(new Array());
        /**
         * Flag to check if this component should be read only.
         * @ignore
         */
        this.readonly = false;
        /**
         * The product identifier set in the configuration file.
         * @ignore
         */
        this.identifier = this.cartService.configurationService.get('productIdentifier');
        /** @ignore */
        this.showTaxPopUp = false;
        /** @ignore */
        this.totalEstimatedTax = 0;
        this.renderSummary = false;
        /** @ignore */
        this.isFavoriteConfigurationItem = false;
        /** @ignore */
        this.subs = [];
        this.selected$ = of(false);
    }
    ngOnChanges() {
        this.userView$ = this.userViewMappingService.getSelectedItems();
        if (this.cart && this.cart.BusinessObjectType === 'Favorite Configuration') {
            this.readonly = true;
            this.isFavoriteConfigurationItem = true;
        }
        if (this.parent instanceof CartItem) {
            const totalIncentiveAmount = _.sumBy(_.filter(this.cart.LineItems, (li) => (li.LineNumber === this.parent.LineNumber)), 'IncentiveAdjustmentAmount');
            this.parent.set('totalIncentiveAmount', totalIncentiveAmount);
            if (this.parent.AssetLineItem) {
                this.parent.Quantity = (this.parent.Quantity == null) ? this.parent.TotalQuantity : this.parent.Quantity;
            }
        }
        this.quantity = this.parent.Quantity;
    }
    ngOnInit() {
        this.storefront$ = this.storefrontService.getStorefront();
        if (!(this.parent instanceof CartItem)) {
            this.parent.PricingFrequency = this.parent.Frequency;
            this.parent._metadata = {};
            this.parent._metadata.totalIncentiveAmount = this.parent.IncentiveAdjustmentAmount; // To display the IncentiveAdjustmentAmount on order and quote details page
            this.readonly = true;
            if (_.get(this.parent, 'Taxable')) {
                this.calculateTotalTax();
            }
        }
        this.subs.push(this.BatchSelectionService.getSelectedLineItems().subscribe(cartItems => {
            this.selected$ = this.BatchSelectionService.isLineItemSelected(this.parent).pipe(take(1));
            this.cdr.detectChanges();
        }));
    }
    /**
     * Changes the quantity of the cart item passed to this method.
     * @param cartItem Cart item reference to change quantity.
     * @param event The event object
     * @fires CartService.updateCartItems()
     * @ignore
     */
    changeItemQuantity(cartItem) {
        if (!cartItem.Quantity || cartItem.Quantity <= 0) {
            cartItem.Quantity = this.quantity;
        }
        else {
            this.cartService.updateCartItems([cartItem]).pipe(take(1)).subscribe(res => { }, err => _.set(this.cart, 'IsPricePending', false));
        }
    }
    /**
     * Removes the provided CartItem from the user's current active cart.
     * @param item CartItem instance to remove from cart.
     * @param evt Event associated with the user action.
     * @fires CartService.removeCartItem()
     * @ignore
     */
    removeCartItem(item, evt) {
        _.set(item, '_metadata._loading', true);
        this.cartService.removeCartItem(item).pipe(take(1)).subscribe(() => {
            _.set(item, '_metadata._loading', false);
        }, () => {
            _.set(item, '_metadata._loading', false);
        });
    }
    /**@ignore */
    showSummary() {
        this.renderSummary = true;
        setTimeout(() => this.summaryDialog.show());
    }
    /** @ignore */
    trackById(index, record) {
        return _.get(record, 'Id');
    }
    /**
     * This will open a popup for selected line item and show the tax breakup for product and its options.
     * @param lineItemId Line item for which you want to see pop-up.
     * @ignore
     */
    openEstimateTaxPopup() {
        let items = this.getTaxItemsBasedOnType();
        this.taxItems = [];
        Object.entries(_.groupBy(_.omitBy(_.concat(this.optionsTaxItems, items), _.isNil), 'TaxType'))
            .forEach(([key, value]) => {
            let singleTaxItem = new TaxBreakup();
            singleTaxItem.TaxType = key;
            _.forEach(value, (ti) => {
                singleTaxItem.BreakupType = _.get(ti, 'BreakupType');
                singleTaxItem.TaxAmount += _.get(ti, 'TaxAmount');
            });
            this.taxItems.push(singleTaxItem);
        });
        this.showTaxPopUp = true;
    }
    /**
     * This method calculates total tax for given line item.
     * @ignore
     */
    calculateTotalTax() {
        this.optionsTaxItems = this.options.every((item) => item instanceof OrderLineItem) ? _.flatten(_.map(this.options, 'OrderTaxBreakups')) : _.flatten(_.map(this.options, 'TaxBreakups'));
        this.totalEstimatedTax = _.sumBy(_.concat(this.getTaxItemsBasedOnType(), this.optionsTaxItems), 'TaxAmount');
    }
    /** @ignore */
    showTaxPopupLink() {
        return (this.parent && !(this.parent instanceof CartItem) && _.get(this.parent, 'Taxable'));
    }
    /** @ignore */
    getTaxItemsBasedOnType() {
        let taxItems;
        if (this.parent instanceof OrderLineItem) {
            taxItems = _.get(this.parent, 'OrderTaxBreakups');
        }
        else {
            taxItems = _.get(this.parent, 'TaxBreakups');
        }
        return taxItems;
    }
    /** @ignore */
    trackByFn(index, item) {
        return item.Id ? item.Id : index;
    }
    /** @ignore */
    isOrderOrProposal(parentRecord) {
        return _.get(parentRecord, 'OrderId') || _.get(parentRecord, 'Proposal');
    }
    /** @ignore */
    handleCheckbox(e) {
        if (e.target.checked)
            this.BatchSelectionService.addLineItemToSelection(this.parent);
        else
            this.BatchSelectionService.removeLineItemFromSelection(this.parent);
    }
    /** @ignore */
    isCartLineItem(lineItem) {
        return lineItem instanceof CartItem && !this.isFavoriteConfigurationItem;
    }
    /** @ignore */
    updateValues(view, parent) {
        if (!_.isEqual(view, parent)) {
            if (!parent.Quantity || parent.Quantity <= 0) {
                parent.Quantity = this.quantity;
            }
            parent[view.fieldName] = view;
            this.cartService.updateCartItems([parent]).pipe(take(1)).subscribe(res => { }, err => _.set(this.cart, 'IsPricePending', false));
        }
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        if (this.subs.length > 0) {
            this.subs.forEach(sub => sub.unsubscribe());
        }
    }
}
LineItemTableRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowComponent, deps: [{ token: i1.CartService }, { token: UserViewMappingService }, { token: i1.StorefrontService }, { token: BatchSelectionService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LineItemTableRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LineItemTableRowComponent, selector: "apt-line-item-table-row", inputs: { cart: "cart", parent: "parent", options: "options", children: "children", index: "index", editableFields: "editableFields" }, viewQueries: [{ propertyName: "summaryDialog", first: true, predicate: ["productConfiguration"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"parent?.LineType === 'Product/Service' && userView$ | async as userView\">\r\n  <tr [attr.data-index]=\"index\">\r\n    <td width=\"2%\" class=\"pt-4 pr-0 pl-3\" *ngIf=\"isCartLineItem(parent)\">\r\n      <div class=\"custom-control custom-checkbox custom-checkbox-lg card-title\">\r\n        <input [id]=\"parent.Id\" type=\"checkbox\" class=\"custom-control-input\" (change)=\"handleCheckbox($event)\"\r\n          [checked]=\"selected$ | async\" />\r\n        <label class=\"custom-control-label d-flex justify-content-between\" [for]=\"parent.Id\"></label>\r\n      </div>\r\n    </td>\r\n    <td width=\"15%\" class=\"pt-4\">\r\n      <img [src]=\"parent?.Product?.IconId | image\" class=\"w-100\" />\r\n    </td>\r\n    <td class=\"w-50 pt-4\">\r\n      <div class=\"h-100 d-flex flex-column border-right pr-3\">\r\n        <div class=\"d-flex align-items-center mb-2\">\r\n          <h5 class=\"mr-2 mb-0\">\r\n            <!-- For Orders and Proposal details page dont show line items as link. -->\r\n            <ng-container *ngIf=\"isOrderOrProposal(parent); else showLink\">\r\n              <span *ngIf=\"parent?.Product && parent?.Product[identifier]\">\r\n                {{parent?.Product?.Name}}\r\n              </span>\r\n            </ng-container>\r\n            <!-- For other pages show line items as link. -->\r\n            <ng-template #showLink>\r\n              <a href=\"javascript:void(0)\" *ngIf=\"parent?.Product && parent?.Product[identifier]\"\r\n                [routerLink]=\"isFavoriteConfigurationItem? ['/products', parent.Product[identifier]] : ['/products', parent.Product[identifier], parent.Id]\">\r\n                {{parent?.Product?.Name}}\r\n              </a>\r\n            </ng-template>\r\n            <span *ngIf=\"parent?.HasAttributes || parent?.HasOptions\">\r\n              <button class=\"text-muted btn btn-link btn-sm p-0\" (click)=\"showSummary()\">\r\n                <i class=\"fas fa-wrench\"></i>\r\n              </button>\r\n            </span>\r\n          </h5>\r\n          <ng-template [ngTemplateOutlet]=\"statusBadge\" [ngTemplateOutletContext]=\"{cartItem: parent}\"></ng-template>\r\n        </div>\r\n\r\n        <p class=\"text-muted subtitle\">\r\n          <span *ngIf=\"parent?.Product?.ProductCode\" [innerHTML]=\"parent.Product?.ProductCode\"></span>\r\n          <span *ngIf=\"parent?.Product?.Family\" [innerHTML]=\"parent.Product?.Family\"></span>\r\n          <span *ngIf=\"parent?.ChargeType\" [innerHTML]=\"parent.ChargeType\"></span>\r\n        </p>\r\n        <p class=\"description\">\r\n          {{parent?.Description}}\r\n        </p>\r\n        <div class=\"row\" *ngIf=\"!isCartLineItem(parent)\">\r\n          <!-- frequency -->\r\n          <div class=\"col-sm-6 col-xl-3\" *ngIf=\"parent?.PriceType !== 'One Time'\">\r\n            <apt-output-field [record]=\"parent\" layout=\"stacked\" label=\"Frequency\" field=\"PricingFrequency\"\r\n              [editable]=\"editableFields\"></apt-output-field>\r\n          </div>\r\n\r\n          <!-- Price Type -->\r\n          <div class=\"col-sm-6 col-xl-3\">\r\n            <apt-output-field [record]=\"parent\" layout=\"stacked\" label=\"Price Type\" field=\"PriceType\"\r\n              [editable]=\"editableFields\"></apt-output-field>\r\n          </div>\r\n\r\n          <!-- Selling Term -->\r\n          <div class=\"col-sm-6 col-xl-3\">\r\n            <apt-output-field [record]=\"parent\" layout=\"stacked\" label=\"SellingTerm\" field=\"SellingTerm\"\r\n              [editable]=\"editableFields\">\r\n            </apt-output-field>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Start Date / End Date -->\r\n        <div class=\"row\" *ngIf=\"!isCartLineItem(parent); else displayFields\">\r\n          <div class=\"col-8\">\r\n            <apt-date-range-input *ngIf=\"parent?.PriceType === 'Recurring' || parent?.PriceType === 'Usage'\"\r\n              [disableStartDate]=\"parent?.LineStatus?.toLowerCase() ==='cancelled' || parent?.LineStatus?.toLowerCase() ==='renewed'\"\r\n              (onStartDateChange)=\"changeItemQuantity(parent)\" (onEndDateChange)=\"changeItemQuantity(parent)\"\r\n              class=\"d-block mr-3 mt-3\" [cartItem]=\"parent\" [readonly]=\"readonly\" small=\"true\">\r\n            </apt-date-range-input>\r\n          </div>\r\n          <div class=\"col-8 d-flex align-items-end\">\r\n            <apt-input-field [(ngModel)]=\"parent.Quantity\" field=\"Quantity\" (change)=\"changeItemQuantity(parent)\"\r\n              [entity]=\"parent\" [readonly]=\"parent?.LineStatus?.toLowerCase() ==='cancelled'\"\r\n              [errorMsg]=\"'ERROR.INVALID_QUANTITY'\" [asterisk]=\"false\" [required]=\"true\" class=\"w-75\" *ngIf=\"!readonly\"\r\n              [small]=\"true\">\r\n            </apt-input-field>\r\n            <apt-output-field [record]=\"parent\" field=\"Quantity\" label=\"Quantity\" class=\"w-75\" *ngIf=\"readonly\"\r\n              [editable]=\"editableFields\">\r\n            </apt-output-field>\r\n          </div>\r\n        </div>\r\n        <ng-template #displayFields>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\" *ngFor=\"let view of userView; let i=index\">\r\n              <div *ngIf=\"i < 3\">\r\n                <!-- Render input field -->\r\n                <ng-container *ngIf=\"view?.label !== 'StartDate' && view?.label !== 'EndDate'; else date\">\r\n                  <apt-input-field *ngIf=\"view.isEditable; else outputField\" [entity]=\"parent\"\r\n                    [(ngModel)]=\"parent[view.label]\" [small]=\"true\" [class]=\"view.label\" [field]=\"view.label\" [rows]=\"1\"\r\n                    (change)=\"updateValues(view,parent)\" [displayFieldType]=\"'radio'\">\r\n                  </apt-input-field>\r\n                </ng-container>\r\n                <!-- Render output field -->\r\n                <ng-template #outputField>\r\n                  <apt-output-field [record]=\"parent\" [class]=\"view.label\" layout=\"stacked\" [label]=\"view.label\"\r\n                    [editable]=\"editableFields\" [field]=\"view.label\">\r\n                  </apt-output-field>\r\n                </ng-template>\r\n                <!-- Render Start/End date -->\r\n                <ng-template #date>\r\n                  <apt-date-range-input\r\n                    [disableStartDate]=\"parent?.LineStatus?.toLowerCase() ==='cancelled' || parent?.LineStatus?.toLowerCase() ==='renewed'\"\r\n                    (onStartDateChange)=\"changeItemQuantity(parent)\" (onEndDateChange)=\"changeItemQuantity(parent)\"\r\n                    [cartItem]=\"parent\" small=\"true\"\r\n                    [readonly]=\"!view?.isEditable || (parent?.PriceType !== 'Recurring' && parent?.PriceType !== 'Usage')\"\r\n                    [displayDate]=\"view.label\">\r\n                  </apt-date-range-input>\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </td>\r\n    <td class=\"pt-4 w-25\">\r\n      <div class=\"d-flex flex-column h-100 justify-content-between\" *ngIf=\"(storefront$ | async) as storefront\">\r\n        <div>\r\n          <div class=\"d-flex justify-content-between align-items-center text-muted mt-1\">\r\n            <span> {{'MANAGE_CART.CART_TABLE.STANDARD_PRICE' | translate }} </span>\r\n            <span>\r\n              <apt-price [record]=\"parent\" type=\"list\"></apt-price>\r\n            </span>\r\n          </div>\r\n          <div class=\"d-flex justify-content-between align-items-center text-muted mt-1\"\r\n            *ngIf=\"parent?.IncentiveAdjustmentAmount && storefront?.EnablePromotions\">\r\n            <button class=\"btn btn-link text-primary btn-sm text-capitalize p-0\"\r\n              (click)=\"promotionModal.openLineItemModal(parent)\">{{'PROMOTION.PROMOTION_APPLIED_TO' |\r\n              translate}}</button>\r\n            <span>{{parent?._metadata?.totalIncentiveAmount | localCurrency | async}}</span>\r\n          </div>\r\n          <div class=\"d-flex justify-content-between small mt-1 text-muted\"\r\n            *ngIf=\"storefront?.EnableTaxCalculations && showTaxPopupLink();\">\r\n            <span>\r\n              <button placement=\"auto\" [popover]=\"popTemplate\" [outsideClick]=\"true\"\r\n                class=\"btn btn-link text-primary btn-sm text-capitalize p-0\" data-toggle=\"popover\"\r\n                data-placement=\"bottom\" (click)=\"openEstimateTaxPopup()\">\r\n                {{'MANAGE_CART.CART_SUMMARY.TAX' | translate }} </button>\r\n            </span>\r\n            <span>{{totalEstimatedTax | localCurrency | async}}</span>\r\n          </div>\r\n          <div class=\"d-flex justify-content-between align-items-center mt-1\">\r\n            <apt-output-field [record]=\"parent\" field=\"NetPrice\" [labelOnly]=\"true\" [labelClass]=\"'font-weight-normal'\">\r\n            </apt-output-field>\r\n            <ng-container *ngIf=\"storefront?.EnableTaxCalculations && !showTaxPopupLink(); else showNetPrice\">\r\n              <apt-price [record]=\"parent\" type=\"baseExtended\" [options]=\"options\"></apt-price>\r\n            </ng-container>\r\n            <ng-template #showNetPrice>\r\n              <apt-price [record]=\"parent\" type=\"net\" [options]=\"options\"></apt-price>\r\n            </ng-template>\r\n          </div>\r\n          <ng-template #popTemplate>\r\n            <apt-tax-pophover *ngIf=\"showTaxPopUp\" [taxItems]=\"taxItems\" [totalEstimatedTax]=\"totalEstimatedTax\"\r\n              [showTaxPopUp]=\"true\"></apt-tax-pophover>\r\n          </ng-template>\r\n        </div>\r\n        <div class=\"d-flex justify-content-end my-3\">\r\n          <button *ngIf=\"parent?.IsPrimaryLine && !readonly\" class=\"btn btn-outline-danger btn-sm\"\r\n            (click)=\"removeCartItem(parent, $event)\" [ladda]=\"parent?._metadata?._loading\" data-style=\"zoom-in\"\r\n            data-spinner-color=\"black\">\r\n            {{'MANAGE_CART.CART_TABLE.REMOVE' | translate }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </td>\r\n  </tr>\r\n  <tr *ngIf=\"children\">\r\n    <td class=\"border-0\" *ngIf=\"isCartLineItem(parent)\"></td>\r\n    <td class=\"border-0\" width=\"15%\"></td>\r\n    <td class=\"border-0 pb-0\" colspan=\"2\">\r\n      <div class=\"accordion\">\r\n\r\n        <apt-table-row-sub-item *ngFor=\"let subItem of children; trackBy: trackByFn\" [subItem]=\"subItem\" [cart]=\"cart\"\r\n          [userView]=\"userView\" [editableFields]=\"editableFields\" [showCustomFields]=true></apt-table-row-sub-item>\r\n\r\n        <!-- Additional info section: show additional info section when custom fields are more than 3 -->\r\n        <div *ngIf=\"isCartLineItem(parent) && userView.length > 3\">\r\n          <apt-additional-information [parent]=\"parent\" [cart]=\"cart\" [editableFields]=\"editableFields\"\r\n            [userView]=\"userView\" [quantity]=\"quantity\">\r\n          </apt-additional-information>\r\n        </div>\r\n      </div>\r\n    </td>\r\n  </tr>\r\n</ng-container>\r\n\r\n<ng-template #statusBadge let-cartItem=\"cartItem\">\r\n  <ng-container [ngSwitch]=\"cartItem?.LineStatus\">\r\n    <span class=\"badge ml-2 badge-danger\" *ngSwitchCase=\"'Cancelled'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Renewed'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-info\" *ngSwitchCase=\"'Upgraded'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Amended'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-warning\" *ngSwitchCase=\"'Incremented'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n    <span class=\"badge ml-2 badge-light\" *ngSwitchCase=\"'Existing'\">\r\n      {{cartItem?.LineStatus}}\r\n    </span>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<apt-pr-modal #promotionModal></apt-pr-modal>\r\n<apt-product-configuration-summary *ngIf=\"renderSummary\" [product]=\"parent?.Product.Id\" [relatedTo]=\"parent\"\r\n  [showActionButtons]=\"!isFavoriteConfigurationItem\" #productConfiguration>\r\n</apt-product-configuration-summary>", styles: [":host{display:contents;font-size:smaller}.description{max-height:50px;overflow-y:hidden}.quantity{width:4rem}u{text-decoration:underline;cursor:pointer}.subtitle>span:not(:last-child):after{margin:0 8px;content:\"|\"}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){p.description{max-width:400px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}tr[data-index=\"0\"] td{border-top:none}\n"], components: [{ type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: InputDateComponent, selector: "apt-date-range-input", inputs: ["cartItem", "disableStartDate", "disableEndDate", "readonly", "small", "displayDate"], outputs: ["onStartDateChange", "onEndDateChange"] }, { type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }, { type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: TaxPopHoverComponent, selector: "apt-tax-pophover", inputs: ["taxItems", "totalEstimatedTax", "showTaxPopUp"] }, { type: TableRowSubItemComponent, selector: "apt-table-row-sub-item", inputs: ["subItem", "cart", "editableFields", "userView", "showCustomFields"] }, { type: AdditionalInformationComponent, selector: "apt-additional-information", inputs: ["parent", "editableFields", "userView", "cart", "quantity"] }, { type: PromotionModalComponent, selector: "apt-pr-modal" }, { type: ProductConfigurationSummaryComponent, selector: "apt-product-configuration-summary", inputs: ["product", "relatedTo", "changes", "preload", "position", "quantity", "showActionButtons"], outputs: ["onProductAdd", "onNavigate"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "async": i5.AsyncPipe, "image": i1$1.ImagePipe, "translate": i2$1.TranslatePipe, "localCurrency": i1.LocalCurrencyPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-line-item-table-row',
                    templateUrl: './line-item-table-row.component.html',
                    styleUrls: ['./line-item-table-row.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: UserViewMappingService }, { type: i1.StorefrontService }, { type: BatchSelectionService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { cart: [{
                type: Input
            }], parent: [{
                type: Input
            }], options: [{
                type: Input
            }], children: [{
                type: Input
            }], index: [{
                type: Input
            }], editableFields: [{
                type: Input
            }], summaryDialog: [{
                type: ViewChild,
                args: ['productConfiguration']
            }] } });

/**
 * Line item menu component is used to display configurable view of cart item fields for a user on cart page.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/line-item-menu.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
 import { LineItemTableRowModule } from '@congacommerce/elements';

 @NgModule({
  imports: [LineItemTableRowModule, ...]
})
 export class AppModule {}
 ```
 * @example
 ```typescript
 * <apt-line-item-menu></apt-line-item-menu>
 ```
 */
class LineItemMenuComponent {
    constructor(mappingService) {
        this.mappingService = mappingService;
    }
    ngOnInit() {
        this.menuItems$ = this.mappingService.getCurrentView();
    }
    /**
     * Method used to save user selection for menu items.
     */
    saveSelections() {
        this.mappingService.saveUserSelections(this.menuItems$.value);
    }
    handleCheckbox(item) {
        item.isSelected = !item.isSelected;
    }
}
LineItemMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemMenuComponent, deps: [{ token: UserViewMappingService }], target: i0.ɵɵFactoryTarget.Component });
LineItemMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LineItemMenuComponent, selector: "apt-line-item-menu", ngImport: i0, template: "<div class=\"dropdown\" dropdown (onHidden)=\"saveSelections()\" [insideClick]=\"true\">\r\n    <button id=\"dropdownLabel\" class=\"dropdown-toggle btn btn-icon btn-link text-primary bg-white\" dropdownToggle\r\n        aria-controls=\"dropdownMenu\">\r\n        <i class=\"fa fa-md fa-table mr-1\"></i>\r\n        {{'COMMON.EDIT_LAYOUT' | translate }}\r\n    </button>\r\n    <div id=\"dropdownMenu\" *dropdownMenu class=\"dropdown-menu overflow-auto\" aria-labelledby=\"dropdownLabel\">\r\n        <span *ngFor=\"let item of (menuItems$ | async)\" class=\"dropdown-item\">\r\n            <div class=\"ml-2\">\r\n                <input class=\"form-check-input checkbox\" type=\"checkbox\" [checked]=\"item.isSelected\"\r\n                    (change)=\"handleCheckbox(item)\" value=\"item?.id\" [id]=\"item?.id\">\r\n                <label class=\"form-check-label\" [class.font-weight-bold]=\"item.isSelected\"\r\n                    [for]=\"item?.id\">{{item?.label}}</label>\r\n            </div>\r\n        </span>\r\n    </div>\r\n</div>", styles: [".dropdown-menu>span:hover{background-color:#c3e6cb}.dropdown-menu{min-width:12rem;max-height:17rem}button{font-size:medium}::-webkit-scrollbar{width:.35rem;background:white}::-webkit-scrollbar-thumb{background:#dedede;border-radius:.35rem}.dropdown-menu .dropdown-item{line-height:unset;padding-bottom:unset;min-height:unset}\n"], directives: [{ type: i2$2.BsDropdownDirective, selector: "[bsDropdown],[dropdown]", inputs: ["autoClose", "isAnimated", "insideClick", "isDisabled", "isOpen", "placement", "triggers", "container", "dropup"], outputs: ["onShown", "onHidden", "isOpenChange"], exportAs: ["bs-dropdown"] }, { type: i2$2.BsDropdownToggleDirective, selector: "[bsDropdownToggle],[dropdownToggle]", exportAs: ["bs-dropdown-toggle"] }, { type: i2$2.BsDropdownMenuDirective, selector: "[bsDropdownMenu],[dropdownMenu]", exportAs: ["bs-dropdown-menu"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-line-item-menu',
                    templateUrl: './line-item-menu.component.html',
                    styleUrls: ['./line-item-menu.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: UserViewMappingService }]; } });

/**
 * @ignore
 */
class LineItemTableRowModule {
}
LineItemTableRowModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LineItemTableRowModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowModule, declarations: [LineItemTableRowComponent, TableRowSubItemComponent, LineItemMenuComponent, AdditionalInformationComponent], imports: [CommonModule,
        ApttusModule,
        RouterModule,
        InputDateModule,
        PriceModule,
        PricingModule,
        FormsModule,
        LaddaModule,
        OutputFieldModule,
        InputFieldModule,
        PromotionModalModule,
        TaxPopHoverModule, i1$4.PopoverModule, ConfigurationSummaryModule, i2$2.BsDropdownModule], exports: [LineItemTableRowComponent, LineItemMenuComponent] });
LineItemTableRowModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowModule, imports: [[
            CommonModule,
            ApttusModule,
            RouterModule,
            InputDateModule,
            PriceModule,
            PricingModule,
            FormsModule,
            LaddaModule,
            OutputFieldModule,
            InputFieldModule,
            PromotionModalModule,
            TaxPopHoverModule,
            PopoverModule.forRoot(),
            ConfigurationSummaryModule,
            BsDropdownModule.forRoot()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LineItemTableRowModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        RouterModule,
                        InputDateModule,
                        PriceModule,
                        PricingModule,
                        FormsModule,
                        LaddaModule,
                        OutputFieldModule,
                        InputFieldModule,
                        PromotionModalModule,
                        TaxPopHoverModule,
                        PopoverModule.forRoot(),
                        ConfigurationSummaryModule,
                        BsDropdownModule.forRoot()
                    ],
                    declarations: [LineItemTableRowComponent, TableRowSubItemComponent, LineItemMenuComponent, AdditionalInformationComponent],
                    exports: [LineItemTableRowComponent, LineItemMenuComponent]
                }]
        }] });

/**
 * @ignore
 */
class CreditCardExtractorPipe {
    transform(value, args) {
        return value.replace(/x/g, "");
    }
}
CreditCardExtractorPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CreditCardExtractorPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CreditCardExtractorPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CreditCardExtractorPipe, name: "creditCardExtractor" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CreditCardExtractorPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'creditCardExtractor'
                }]
        }] });

/**
 * This payment Iframe component layout has iframe which will integrate with payment gateway to create payment method.
 * <h3>Preview</h3>
 *  <div>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/paymentIFrame.PNG" style="max-width: 100%">
 *  </div>
 * <h3>Usage</h3>
 *
```typescript
import { PaymentComponentModule } from '../payment/payment.module';

@NgModule({
  imports: [PaymentComponentModule, ...]
})
export class AppModule {}
```
*
* @example
```typescript
* <apt-payment-iframe
*              [account]="account"
*              [primaryContact]="primaryContact"
*              [user]="user"
* ></apt-payment-iframe>
```
*/
class PaymentIFrameComponent {
    constructor(ngZone, paymentService, _compiler) {
        this.ngZone = ngZone;
        this.paymentService = paymentService;
        this._compiler = _compiler;
        /**
         * Output parameter for sending payment response.
         */
        this.onSubmitPaymentRequest = new EventEmitter();
        /** @ignore */
        this.subscriptions = [];
    }
    ngOnInit() {
        this.isLoading = true;
        this.transactionRequestModel = {};
        this.paymentTransaction.PaymentType = this.paymentType;
        if (this.paymentType === 'SilentSale')
            this.paymentForOrder();
        else
            this.saleCaptureMethod();
    }
    /**
    * Method to get transaction details and redirect to third party payment system for transaction.
    * @ignore
    */
    saleCaptureMethod() {
        this.subscriptions.push(this.paymentService.saleCaptureMethod(this.paymentTransaction).subscribe(response => {
            this.ngZone.run(() => {
                if (response === null)
                    return;
                this.transactionRequestModel = response[0];
                this.gatewayTransactionId = response[1];
            });
            setTimeout(() => {
                let element = document.getElementById('addPaymentMethod');
                if (element)
                    element.click();
            }, 100);
        }));
    }
    /**
    * Method to get transaction details and do the transaction silent at client side.
    * @ignore
    */
    paymentForOrder() {
        this.subscriptions.push(this.paymentService.silentOrderPayment(this.paymentTransaction).subscribe(response => {
            this.ngZone.run(() => {
                if (response === null)
                    return;
                this.transactionRequestModel = response[0];
                this.gatewayTransactionId = response[1];
            });
            setTimeout(() => {
                let element = document.getElementById('addPaymentMethod');
                if (element)
                    element.click();
            }, 100);
        }));
    }
    /**
    * This method has been called everytime the page loads inside IFrame.
    * @ignore
    */
    onLoadIframe() {
        setTimeout(() => this.isLoading = false, 5000);
    }
    /** @ignore */
    /** @ignore */
    getCommunicationResponse(e) {
        if (this.gatewayTransactionId && lowerCase(get(e.data, 'paymentStatus')) === 'success') {
            this.isLoading = false;
            this.onSubmitPaymentRequest.emit(get(e.data, 'paymentStatus'));
        }
    }
    ngOnDestroy() {
        this._compiler.clearCache();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
PaymentIFrameComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentIFrameComponent, deps: [{ token: i0.NgZone }, { token: i1.PaymentService }, { token: i0.Compiler }], target: i0.ɵɵFactoryTarget.Component });
PaymentIFrameComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PaymentIFrameComponent, selector: "apt-payment-iframe", inputs: { paymentTransaction: "paymentTransaction", paymentType: "paymentType" }, outputs: { onSubmitPaymentRequest: "onSubmitPaymentRequest" }, host: { listeners: { "window:message": "getCommunicationResponse($event)" } }, viewQueries: [{ propertyName: "iframe", first: true, predicate: ["iframeAuthorizeNet"], descendants: true }], ngImport: i0, template: "<div [hidden]=\"isLoading\">\r\n<span>{{'CART.PAYMENT.PAYMENT_INPUT' | translate}}</span>\r\n  <form ngNoForm [action]=\"transactionRequestModel['IFram_Url__c']\" hidden target=\"iframeAuthorizeNet\" method=\"post\" hidden>\r\n    <ng-container *ngFor=\"let item of transactionRequestModel | keyvalue\">\r\n      <input type=\"hidden\" [id]=\"item.key\" [name]=\"item.key\" [value]=\"item.value\" />\r\n    </ng-container>\r\n    <button id=\"addPaymentMethod\" type=\"submit\" class=\"btn btn-success\">\r\n      <i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> Save\r\n    </button>\r\n  </form>\r\n  <iframe height=\"500\" width=\"100%\" #iframeAuthorizeNet (load)=\"onLoadIframe()\" name=\"iframeAuthorizeNet\"\r\n    id=\"iframeAuthorizeNet\" src=\"\" frameborder=\"0\" scrolling=\"no\"></iframe>\r\n</div>\r\n<div *ngIf=\"isLoading\" class=\"d-flex justify-content-center py-5\">\r\n  <apt-spinner></apt-spinner>\r\n</div>", styles: [""], components: [{ type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i2$1.TranslatePipe, "keyvalue": i5.KeyValuePipe }, viewProviders: [{
            provide: ControlContainer,
            useExisting: NgForm
        }], changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentIFrameComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-payment-iframe',
                    templateUrl: './payment-iframe.component.html',
                    styleUrls: ['./payment-iframe.component.scss'],
                    changeDetection: ChangeDetectionStrategy.Default,
                    viewProviders: [{
                            provide: ControlContainer,
                            useExisting: NgForm
                        }]
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i1.PaymentService }, { type: i0.Compiler }]; }, propDecorators: { paymentTransaction: [{
                type: Input
            }], paymentType: [{
                type: Input
            }], onSubmitPaymentRequest: [{
                type: Output
            }], iframe: [{
                type: ViewChild,
                args: ['iframeAuthorizeNet']
            }], 
        /** @ignore */
        getCommunicationResponse: [{
                type: HostListener,
                args: ['window:message', ['$event']]
            }] } });

/**
 * using moment library for date compare
 */
/** @ignore  */
const _moment = moment;
/**
 * The payment method layout component is a listing component for payment method object
 * It is used to display all available payment method for logged in user and will select add credit/debit card option if no payment method exist.
 * @ignore
 ```typescript
import { PaymentComponentModule } from '../payment/payment.module';

@NgModule({
  imports: [PaymentComponentModule, ...]
})
export class AppModule {}
```
*
* @example
* <apt-payment-method
*              [account]="account"
*              (isAnyMethodExist)='selectDefaultPaymentOption($event)'
* ></apt-payment-method>
*/
class PaymentMethodComponent {
    constructor(paymentService, toastr, _compiler, translateService, exceptionService) {
        this.paymentService = paymentService;
        this.toastr = toastr;
        this._compiler = _compiler;
        this.translateService = translateService;
        this.exceptionService = exceptionService;
        /**
         * To check is any existing payment method is selected for payment or not
         */
        this.isPaymentByMethod = true;
        /**
        * Send true/false on payment method availability or selection
        */
        this.callForNewPaymentMethod = new EventEmitter();
        this.subscriptions = [];
    }
    ;
    ngOnInit() {
        this.subscriptions.push(this.paymentService.getActiveCardsForAccount(this.paymentTransaction.CustomerBillingAccountID).subscribe((result) => {
            /*If no method found send true status so payment Iframe auto open */
            if (result.length == 0)
                this.callForNewPaymentMethod.emit(true);
            else
                this.callForNewPaymentMethod.emit(false);
            this.paymentMethodList = result;
        }, err => {
            this.exceptionService.showError(err);
        }));
    }
    /**
    * Update default method for account and removed existing default method
    *
    * @param paymentItem PaymentMethod which need to make default
    *
    */
    ondefaultMethodChange(paymentItem) {
        if (paymentItem) {
            let updatePaymnetsItems = new Array();
            const existingDefaultmethod = this.paymentMethodList.find(f => f.IsDefault);
            if (existingDefaultmethod) {
                existingDefaultmethod.IsDefault = false;
                updatePaymnetsItems.push(existingDefaultmethod);
            }
            paymentItem.IsDefault = true;
            updatePaymnetsItems.push(paymentItem);
            this.paymentService.update(updatePaymnetsItems);
            this.callForNewPaymentMethod.emit(false);
            this.isPaymentByMethod = true;
        }
        else {
            this.callForNewPaymentMethod.emit(true);
            this.isPaymentByMethod = false;
        }
    }
    /**
     * Make it inactive only if it's not default method
     *
     * @param paymentItem PaymentMethod which need to make delete(inactive)
     *
     */
    deletePayment(paymentItem) {
        if (paymentItem.IsDefault) {
            this.subscriptions.push(this.translateService.stream(['PAYMENT_METHOD_LABELS.DEFAULT_MSG', 'PAYMENT_METHOD_LABELS.DEFAULT_TITLE']).subscribe((val) => {
                this.toastr.error(val['PAYMENT_METHOD_LABELS.DEFAULT_MSG'], val['PAYMENT_METHOD_LABELS.DEFAULT_TITLE']);
            }));
            return;
        }
        paymentItem.Status = 'Inactive';
        this.subscriptions.push(this.paymentService.update([paymentItem])
            .pipe(switchMap(res => this.paymentService.getActiveCardsForAccount(this.paymentTransaction.CustomerBillingAccountID))).subscribe((res) => {
            this.paymentMethodList = res;
            this.exceptionService.showInfo('PAYMENT_METHOD_LABELS.DELETE_MSG', 'PAYMENT_METHOD_LABELS.DELETE_TITLE');
        }, err => {
            this.exceptionService.showError(err);
        }));
    }
    /**
     * Comparing current date with credit card expire date
     *
     * @param month credit card month
     * @param year credit card year
     * @return return true if date has not expired else false
     *
     */
    IsDateExpired(month, year) {
        const beforeInMoment = _moment(month + '-' + year, "MM-YYYY").add('months', 1).date(0);
        const afterInMoment = _moment(new Date(), "MM-YYYY");
        if (beforeInMoment.isBefore(afterInMoment)) {
            return false;
        }
        else {
            return true;
        }
    }
    ngOnDestroy() {
        this._compiler.clearCache();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
PaymentMethodComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentMethodComponent, deps: [{ token: i1.PaymentService }, { token: i2.ToastrService }, { token: i0.Compiler }, { token: i2$1.TranslateService }, { token: ExceptionService }], target: i0.ɵɵFactoryTarget.Component });
PaymentMethodComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PaymentMethodComponent, selector: "apt-payment-method", inputs: { paymentTransaction: "paymentTransaction" }, outputs: { callForNewPaymentMethod: "callForNewPaymentMethod" }, ngImport: i0, template: "<ng-container>\r\n  <div *ngIf=\"paymentMethodList; else spinner\" class=\"table-responsive-lg\">\r\n    <table *ngIf=\"paymentMethodList.length > 0\" class=\"table table-hover\">\r\n      <thead>\r\n        <tr class=\"d-flex\">\r\n          <th class=\"col-sm-6 lead\" colspan=\"2\">\r\n            <h5>{{'PAYMENT_METHOD_LABELS.Detail_Item1' | translate}}</h5>\r\n          </th>\r\n          <th class=\"col-sm-3 font-weight-normal\">{{'PAYMENT_METHOD_LABELS.Detail_Item2' | translate}}</th>\r\n          <th class=\"col-sm-2 font-weight-normal\">{{'PAYMENT_METHOD_LABELS.Detail_Item3' | translate}}</th>\r\n          <th class=\"col-sm-1\">&nbsp;</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr class=\"d-flex\" *ngFor=\"let paymentMethod of paymentMethodList; let i = index;\">\r\n          <td class=\"col-sm-1\">\r\n            <div class=\"custom-control custom-radio\">\r\n              <input type=\"radio\" class=\"custom-control-input\" name=\"paymentmethodgroup\" [value]=\"paymentMethod.Id\"\r\n                [id]=\"paymentMethod.Id\" [checked]=\"(paymentMethod.IsDefault) ? true:false\"\r\n                [disabled] =\"!IsDateExpired(paymentMethod.CardExpirationMonth,paymentMethod.CardExpirationYear)\"\r\n                (change)=\"ondefaultMethodChange(paymentMethod)\">\r\n              <label class=\"custom-control-label mr-auto\" [for]=\"paymentMethod.Id\"> <span class=\"text-muted fa fa-2x\"\r\n                  [class.fa-cc-visa]=\"paymentMethod.CardType.toLowerCase() ==='visa'\"\r\n                  [class.fa-cc-mastercard]=\"paymentMethod.CardType.toLowerCase() ==='mastercard'\"\r\n                  [class.fa-cc-amex]=\"paymentMethod.CardType.toLowerCase() ==='amex'\"\r\n                  [class.fa-cc-discover]=\"paymentMethod.CardType.toLowerCase() ==='discover'\"\r\n                  [class.fa-cc-diner-club]=\"paymentMethod.CardType.toLowerCase() ==='diners'\" \r\n                  [class.fa-credit-card]=\"paymentMethod.CardType.toLowerCase() != 'visa'\r\n                                       && paymentMethod.CardType.toLowerCase()  != 'mastercard'\r\n                                       && paymentMethod.CardType.toLowerCase()  != 'discover'\r\n                                       && paymentMethod.CardType.toLowerCase()  != 'diners'\">\r\n                </span></label>\r\n            </div>\r\n          </td>\r\n          <td class=\"col-sm-5\">\r\n            <strong class=\"ml-4\">{{paymentMethod.CardType}}\r\n            </strong>{{'PAYMENT_METHOD_LABELS.Detail_Ending' | translate}}\r\n            {{paymentMethod.CardNumber | creditCardExtractor}}           \r\n          </td>\r\n          <td class=\"col-sm-3\">{{paymentMethod.PaymentMethodName}}</td>\r\n          <td class=\"col-sm-2\">\r\n            <section *ngIf=\"IsDateExpired(paymentMethod.CardExpirationMonth,paymentMethod.CardExpirationYear)\">\r\n              {{paymentMethod.CardExpirationMonth}}/{{paymentMethod.CardExpirationYear}}\r\n            </section>\r\n            <section *ngIf=\"!IsDateExpired(paymentMethod.CardExpirationMonth,paymentMethod.CardExpirationYear)\">\r\n              <span\r\n                class=\"text-danger\">{{paymentMethod.CardExpirationMonth}}/{{paymentMethod.CardExpirationYear}}</span>\r\n            </section>\r\n          </td>\r\n          <td class=\"col-sm-1\">\r\n            <div class=\"dropdown\" dropdown>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-toggle\" dropdownToggle>\r\n                <i class=\"fas fa-ellipsis-v\"></i>\r\n              </a>\r\n              <ul *dropdownMenu class=\"dropdown-menu\">\r\n                <li role=\"menuitem\">\r\n                  <a class=\"dropdown-item text-danger\" href=\"javascript:void(0)\"\r\n                    (click)=\"deletePayment(paymentMethod)\">{{'COMMON.DELETE' | translate}}</a>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n        <tr class=\"d-flex\">\r\n          <td class=\"col-sm-6\" colspan=\"2\">\r\n            <div class=\"custom-control custom-radio\">\r\n              <input type=\"radio\" class=\"custom-control-input\" name=\"paymentmethodgroup\" id=\"newCard\"\r\n                (change)=\"ondefaultMethodChange(null)\">\r\n              <label class=\"custom-control-label mr-auto\" for=\"newCard\">{{'CART.PAYMENT.USE_NEW_METHOD' | translate}}</label>\r\n            </div>\r\n          </td>\r\n          <td class=\"col-sm-3\"></td>\r\n          <td class=\"col-sm-2\">\r\n          </td>\r\n          <td class=\"col-sm-1\">\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #spinner>\r\n  <div class=\"d-flex justify-content-center py-5\">\r\n    <apt-spinner></apt-spinner>\r\n  </div>\r\n</ng-template>", styles: ["input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}.table{background-color:#fff}.table th{border-top:0px}\n"], components: [{ type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$2.BsDropdownDirective, selector: "[bsDropdown],[dropdown]", inputs: ["autoClose", "isAnimated", "insideClick", "isDisabled", "isOpen", "placement", "triggers", "container", "dropup"], outputs: ["onShown", "onHidden", "isOpenChange"], exportAs: ["bs-dropdown"] }, { type: i2$2.BsDropdownToggleDirective, selector: "[bsDropdownToggle],[dropdownToggle]", exportAs: ["bs-dropdown-toggle"] }, { type: i2$2.BsDropdownMenuDirective, selector: "[bsDropdownMenu],[dropdownMenu]", exportAs: ["bs-dropdown-menu"] }], pipes: { "translate": i2$1.TranslatePipe, "creditCardExtractor": CreditCardExtractorPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentMethodComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-payment-method',
                    templateUrl: './payment-method.component.html',
                    styleUrls: ['./payment-method.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i1.PaymentService }, { type: i2.ToastrService }, { type: i0.Compiler }, { type: i2$1.TranslateService }, { type: ExceptionService }]; }, propDecorators: { paymentTransaction: [{
                type: Input
            }], callForNewPaymentMethod: [{
                type: Output
            }] } });

/**
 * Payment component is used for processing order payments.
 * <h3>Preview</h3>
 *  <div>
 *    <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/payment.PNG" style="max-width: 100%">
 *  </div>
 * <h3>Usage</h3>
 *
 ```typescript
import { PaymentComponentModule } from '@congacommerce/elements';

@NgModule({
  imports: [PaymentComponentModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-payment
*             [paymentTransaction]="paymentTransaction"
*             (onSelectingPayment)="handleSelectPayment($event)"
*             (onPaymentComplete)="handlePaymentComplete($event)"
* ></apt-payment>
```
*/
class PaymentComponent {
    constructor() {
        /**
          * Output parameter from payment method component for checking is payment is selected or availble
        */
        this.onSelectingPayment = new EventEmitter();
        /**
          * Output parameter from payment Iframe component for checking is payment completed
        */
        this.onPaymentComplete = new EventEmitter();
        /**
          * Is requesting for payment for order
          * @ignore
        */
        this.paymentForOrder = false;
        /**
          * Requested payment type
          * @ignore
        */
        this.paymentType = 'Sale';
        /**
          * Is requesting for saving credit card details
          * @ignore
        */
        this.isSalesCardSaved = false;
    }
    ngOnInit() {
        if (!this.paymentTransaction.isUserLoggedIn) {
            this.paymentForOrder = true;
            this.onSelectingPayment.emit(false);
        }
    }
    /**
    * Check is user requesting for new payment method.
    * @param isNewRequest flag to check the request status
    * @ignore
    */
    requestNewPaymentMethod(isNewRequest) {
        if (isNewRequest) {
            this.isSalesCardSaved = false;
            this.paymentType = 'Sale';
            this.paymentForOrder = true;
            this.onSelectingPayment.emit(false);
        }
        else {
            this.paymentForOrder = false;
            this.onSelectingPayment.emit(true);
        }
    }
    /**
    * Check the status after paymenty submit
    * @param transactionResponse contain status message after payment
    * @ignore
    */
    onSubmitPaymentRequestForOrder(transactionResponse) {
        this.paymentForOrder = false;
        this.onPaymentComplete.emit(transactionResponse);
    }
    /**
    * Set flag and load payment Iframe based on the selection for saving credit card details.
    * @param isRequestForSave flag to check save request
    * @ignore
    */
    transactionType(isRequestForSave) {
        this.paymentForOrder = false;
        if (isRequestForSave)
            this.paymentType = 'SaleCapture';
        else {
            this.paymentType = 'Sale';
        }
        setTimeout(() => this.paymentForOrder = true, 50);
    }
}
PaymentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PaymentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PaymentComponent, selector: "apt-payment", inputs: { paymentTransaction: "paymentTransaction" }, outputs: { onSelectingPayment: "onSelectingPayment", onPaymentComplete: "onPaymentComplete" }, ngImport: i0, template: "<!-- <div class=\"card p-3\">\r\n    <label>{{ 'CART.PAYMENT.ORDER_CONFIRMATION_MESSAGE' | translate }}</label>\r\n    <h5 class=\"text-left my-3\">{{ 'CART.PAYMENT.ORDER_NUMBER' | translate }} {{paymentTransaction?.OrderName}}</h5>\r\n    <small class=\"text-left\">{{ 'CART.PAYMENT.ORDER_SUBTITLE' | translate }}</small>\r\n  </div>\r\n<div class=\"mt-4 mb-3\">\r\n  <h5 class=\"mb-0 text-muted\">{{'CART.PAYMENT.PAYMENT_TITLE' | translate}}</h5>\r\n</div> -->\r\n<div class=\"card p-3\">\r\n  <div *ngIf=\"paymentTransaction.isUserLoggedIn\" class=\"d-block my-3\">\r\n    <apt-payment-method [paymentTransaction]=\"paymentTransaction\" (callForNewPaymentMethod)='requestNewPaymentMethod($event)'>\r\n    </apt-payment-method>\r\n  </div>\r\n  <div *ngIf=\"paymentForOrder\" class=\"d-block pl-3\">  \r\n    <apt-payment-iframe class=\"d-block pl-3\" [paymentTransaction]=\"paymentTransaction\" [paymentType]=\"paymentType\" (onSubmitPaymentRequest)='onSubmitPaymentRequestForOrder($event)' >\r\n    </apt-payment-iframe>    \r\n    <div *ngIf=\"paymentTransaction.isUserLoggedIn\" class=\"custom-control custom-checkbox\">\r\n      <input type=\"checkbox\" class=\"custom-control-input\" id=\"save-payment\" (ngModelChange)=\"transactionType($event)\"\r\n        [(ngModel)]=\"isSalesCardSaved\" name=\"savePaymentCard\">\r\n      <label class=\"custom-control-label\" for=\"save-payment\">{{'CART.PAYMENT.PAYMENT_INPUTSAVE' | translate}}</label>\r\n    </div>\r\n  </div>\r\n</div>", components: [{ type: PaymentMethodComponent, selector: "apt-payment-method", inputs: ["paymentTransaction"], outputs: ["callForNewPaymentMethod"] }, { type: PaymentIFrameComponent, selector: "apt-payment-iframe", inputs: ["paymentTransaction", "paymentType"], outputs: ["onSubmitPaymentRequest"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-payment',
                    templateUrl: './payment.component.html',
                    styles: []
                }]
        }], propDecorators: { paymentTransaction: [{
                type: Input
            }], onSelectingPayment: [{
                type: Output
            }], onPaymentComplete: [{
                type: Output
            }] } });

/**
 * @ignore
 */
class PaymentComponentModule {
}
PaymentComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaymentComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponentModule, declarations: [CreditCardExtractorPipe, PaymentIFrameComponent, PaymentMethodComponent, PaymentComponent], imports: [CommonModule,
        IconModule,
        FormsModule,
        BsDropdownModule, i7.BsDatepickerModule, LaddaModule, i2$1.TranslateModule, i4$2.TooltipModule], exports: [PaymentComponent, PaymentIFrameComponent, CreditCardExtractorPipe] });
PaymentComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponentModule, providers: [], imports: [[CommonModule,
            IconModule,
            FormsModule,
            BsDropdownModule,
            BsDatepickerModule.forRoot(),
            LaddaModule,
            TranslateModule.forChild(),
            TooltipModule.forRoot()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaymentComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule,
                        IconModule,
                        FormsModule,
                        BsDropdownModule,
                        BsDatepickerModule.forRoot(),
                        LaddaModule,
                        TranslateModule.forChild(),
                        TooltipModule.forRoot()],
                    providers: [],
                    declarations: [CreditCardExtractorPipe, PaymentIFrameComponent, PaymentMethodComponent, PaymentComponent],
                    exports: [PaymentComponent, PaymentIFrameComponent, CreditCardExtractorPipe]
                }]
        }] });

/**
 * The price summary component displays the total price, promotion(s) applied, tax, sub total and action button(s) as per the need.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/priceSummary.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { PriceSummaryModule } from '@congacommerce/elements';

@NgModule({
  imports: [PriceSummaryModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-price-summary
*              [record]="cart"
*              [form]="form"
*              [spinner]="isLoading"
*              [page]="'checkout'"
*              (onSubmitOrder)="handleClick()"
*              (onRequestQuote)="handleClick()"
* ></apt-price-summary>
```
*/
class PriceSummaryComponent {
    constructor(storefrontService, userService, crService, modalService, quoteService, cartService, taxService, exceptionService, proposalTaxService, orderTaxService, router, accountService, orderService) {
        this.storefrontService = storefrontService;
        this.userService = userService;
        this.crService = crService;
        this.modalService = modalService;
        this.quoteService = quoteService;
        this.cartService = cartService;
        this.taxService = taxService;
        this.exceptionService = exceptionService;
        this.proposalTaxService = proposalTaxService;
        this.orderTaxService = orderTaxService;
        this.router = router;
        this.accountService = accountService;
        this.orderService = orderService;
        /**
         * Flag to disable the submit button.
         */
        this.disableSubmit = false;
        /** Flag to set the loading spinner active */
        this.loading = false;
        /**
         * Flag to show the payment status on the summary card.
         */
        this.showStatus = false;
        /**
         * Event emitter fired when the order is summited.
         */
        this.onSubmitOrder = new EventEmitter();
        /**
         * Event emitter fired when the request quote button is pressed.
         */
        this.onRequestQuote = new EventEmitter();
        /**
         * Event emitter fired when the Finalize and Submit button is pressed.
         */
        this.onFinalizeQuote = new EventEmitter();
        /**
         * Event emitter fired when the make payment button is pressed.
         */
        this.onPaymentRequest = new EventEmitter();
        /** @ignore */
        this.view$ = new BehaviorSubject({});
        /** @ignore */
        this.showTaxPopup = false;
        /**@ignore */
        this.calculateTaxForOrder = false;
        /** @ignore */
        this.fieldMap = [
            {
                type: this.orderService.type,
                field: 'OrderLineItems',
                taxBreakups: bind(this.orderTaxService.getTaxBreakupForOrder, this.orderTaxService)
            },
            {
                type: this.quoteService.type,
                field: 'QuoteLineItems',
                taxBreakups: bind(this.proposalTaxService.getTaxBreakupForQuote, this.proposalTaxService)
            },
            {
                type: this.cartService.type,
                field: 'LineItems',
                taxBreakups: bind(this.taxService.getTaxBreakUpsForConfiguration, this.taxService)
            }
        ];
    }
    /** @ignore */
    calculateTotalEstimatedTax(lineItems) {
        return sumBy(filter$1(lineItems, lineItem => get(lineItem, 'LineType') === 'Misc'), 'NetPrice');
    }
    /** @ignore */
    calculateTotalTax() {
        if (this.page === 'create-proposal' || this.page === 'checkout' || this.calculateTaxForOrder) {
            this.setLoading(true);
            return this.storefrontService.getStorefront().pipe(mergeMap(storefront => {
                if (get(storefront, 'EnableTaxCalculations') && this.record instanceof Cart)
                    return this.taxService.computeTaxForCart().pipe(tap(r => {
                        this.exceptionService.showSuccess('TAX.COMPUTE_TAX_SUCCESS', 'TAX.COMPUTE_TAX_SUCCESS_TITLE');
                        return r;
                    }), tap(() => this.setLoading(false)), catchError(e => {
                        this.setLoading(false);
                        this.exceptionService.showWarning(e, 'TAX.COMPUTE_TAX_ERROR_TITLE');
                        return throwError(e);
                    }));
                else
                    return of(null);
            }), take(1));
        }
        return of(null);
    }
    /** @ignore */
    calculateTotalPromotions() {
        return sumBy(filter$1(get(this, `record.${get(find(this.fieldMap, f => f.type === this.record.getType()), 'field')}`), line => line.PriceType !== 'Usage'), 'IncentiveAdjustmentAmount');
    }
    /** @ignore */
    setLoading(value) {
        const view = this.view$.value;
        view.loading = value;
        this.view$.next(view);
    }
    /** @ignore */
    openEstimateTaxPopup() {
        this.showTaxPopup = true;
    }
    ngOnDestroy() {
        if (!isNil(this.subscription))
            this.subscription.unsubscribe();
        if (this.taxSubscription)
            this.taxSubscription.unsubscribe();
    }
    ngOnChanges() {
        if (!isNil(this.record)) {
            this.ngOnDestroy();
            const fieldMap = find(this.fieldMap, f => f.type === this.record.getType());
            this.subscription = combineLatest(this.storefrontService.getStorefront(), this.crService.hasPendingErrors(), this.userService.isLoggedIn(), this.cartService.getMyCart(), this.accountService.getCurrentAccount(), this.page === 'carts' ? of(null) : fieldMap.taxBreakups(get(this, 'record.Id')))
                .pipe(map(([storefront, hasPendingErrors, isLoggedIn, cart, account, taxBreakups]) => {
                const hasErrors = hasPendingErrors || get(cart, 'hasErrors', false);
                return {
                    storefront: storefront,
                    accountId: get(storefront, 'DefaultAccountforGuestUsers') ? get(account, 'Id') : null,
                    isLoggedIn: isLoggedIn,
                    totalPromotions: this.calculateTotalPromotions(),
                    hasErrors: hasErrors,
                    lineItemCount: defaultTo((this.record instanceof Quote) ? get(this, 'record.QuoteLineItems.length') : get(this, 'record.OrderLineItems.length'), get(this, 'record.LineItems.length')),
                    order: get(this, 'record.Order'),
                    quote: (this.record instanceof Cart) ? get(this, 'record.Proposald') : get(this, 'record.Quote'),
                    totalEstimatedTax: this.calculateTotalEstimatedTax(get(this, `record.${fieldMap.field}`)),
                    showTaxLink: get(storefront, 'EnableTaxCalculations') && this.showEstimatedTaxLink(),
                    enableTaxCalculations: get(storefront, 'EnableTaxCalculations'),
                    taxItems: taxBreakups,
                    paymentStatus: get(this.record, 'PaymentStatus'),
                    loading: this.loading || (this.cartService.isPricePending(cart) && !hasErrors) || ((this.cartService.isPricePending(cart) || cart.get('IsPriced')) || !isEmpty(filter$1(cart.LineItems, r => r.PricingStatus === 'Pending')))
                };
            }))
                .subscribe(r => this.view$.next(r));
        }
    }
    ngOnInit() {
        // If cart has any line item with Taxable flag, calculateTax for the cart.
        if (this.record instanceof Cart && some(get(this, 'record.LineItems'), i => get(i, 'Taxable') === true))
            this.taxSubscription = this.calculateTotalTax().subscribe();
    }
    /**
     * Method opens the discard changes confirmation modal dialog.
     * @ignore
     */
    openDiscardChangeModals() {
        this.discardChangesModal = this.modalService.show(this.discardChangesTemplate);
    }
    /**
     * Method is invoked when abonding the cart while editing the quote line item.
     * @fires this.quoteService.abandonCart()
     * @ignore
     */
    onDiscardChanges() {
        this.setLoading(true);
        const record = this.record;
        this.cartService.getMyCart().pipe(take(1), mergeMap(cart => {
            return this.cartService.abandonCart(get(cart, 'Id')).pipe(mergeMap(() => this.cartService.createNewCart()), mergeMap(newCart => this.cartService.setCartActive(newCart)));
        })).subscribe(() => {
            this.setLoading(false);
            isNil(get(record, 'Proposald')) ? this.router.navigate(['/orders', get(record, 'Order.Id')]) : this.router.navigate(['/proposals', get(record, 'Proposald.Id')]);
            this.discardChangesModal.hide();
        });
    }
    /** @ignore */
    submitOrder() {
        this.onSubmitOrder.emit();
    }
    /** @ignore */
    submitPayment() {
        this.onPaymentRequest.emit();
    }
    /** @ignore */
    requestQuote() {
        this.onRequestQuote.emit();
    }
    /** @ignore */
    finalizeQuote() {
        this.onFinalizeQuote.emit();
    }
    /** @ignore */
    getCartState() {
        return (this.record instanceof Cart) ? get(this.record, '_state', '') : '';
    }
    /** @ignore */
    showEstimatedTaxLink() {
        return this.page === 'quotes' ||
            this.page === 'orders' ||
            this.page === 'checkout' ||
            this.page === 'create-proposal' ||
            this.page === 'paymentForOrder' ||
            this.page === '';
    }
    /** @ignore */
    disableButton() {
        return !(this.record instanceof Cart && get(this.record, 'LineItems.length') > 0);
    }
    /** @ignore */
    isQuoteOnCart() {
        return this.record instanceof Cart && get(this.record, 'Proposald.Id');
    }
    /** @ignore */
    computeTaxForOrder() {
        if (this.record instanceof Cart && some(get(this, 'record.LineItems'), i => get(i, 'Taxable') === true)) {
            this.calculateTaxForOrder = true;
            return this.calculateTotalTax();
        }
        return of(null);
    }
    /**
     * Function used to save the changes after editing the order,
     * It will calculate the tax first and convert cart to order.
     */
    confirmOrderChanges() {
        this.setLoading(true);
        let orderRequestObj = new Order();
        const contact = new Contact();
        combineLatest([this.cartService.getMyCart(), this.computeTaxForOrder()]).pipe(take(1), switchMap(([res]) => combineLatest([of(res), this.orderService.getOrder(get(res, 'OrderId'))])), switchMap(([cart, order]) => {
            orderRequestObj = order;
            if (get(orderRequestObj, 'PrimaryContactId')) {
                set(orderRequestObj, 'PrimaryContact.Id', orderRequestObj.PrimaryContactId);
                contact.FirstName = get(orderRequestObj.PrimaryContact, 'FirstName');
                contact.LastName = get(orderRequestObj.PrimaryContact, 'LastName');
                contact.Email = get(orderRequestObj.PrimaryContact, 'Email');
                return this.orderService.convertCartToOrder(orderRequestObj, contact, cart, null, false);
            }
        })).subscribe(order => {
            this.calculateTaxForOrder = false;
            this.setLoading(false);
            this.router.navigate(['/orders', order.Id]);
        }, err => {
            this.setLoading(false);
            this.calculateTaxForOrder = false;
        });
    }
}
PriceSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryComponent, deps: [{ token: i1.StorefrontService }, { token: i1.UserService }, { token: i1.ConstraintRuleService }, { token: i1$2.BsModalService }, { token: i1.QuoteService }, { token: i1.CartService }, { token: i1.TaxService }, { token: ExceptionService }, { token: i1.ProposalTaxService }, { token: i1.OrderTaxService }, { token: i4$1.Router }, { token: i1.AccountService }, { token: i1.OrderService }], target: i0.ɵɵFactoryTarget.Component });
PriceSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PriceSummaryComponent, selector: "apt-price-summary", inputs: { record: "record", form: "form", disableSubmit: "disableSubmit", page: "page", paymentState: "paymentState", loading: "loading", showStatus: "showStatus" }, outputs: { onSubmitOrder: "onSubmitOrder", onRequestQuote: "onRequestQuote", onFinalizeQuote: "onFinalizeQuote", onPaymentRequest: "onPaymentRequest" }, viewQueries: [{ propertyName: "discardChangesTemplate", first: true, predicate: ["discardChangesTemplate"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"view$ | async as view\">\r\n    <div class=\"card \" *ngIf=\"record\">\r\n        <div class=\"card-header\">\r\n            <h5 class=\"card-title mb-0\">{{'DETAILS.PRICE_SUMMARY' | translate }}</h5>\r\n        </div>\r\n        <div class=\"card-body\">\r\n            <div class=\"d-flex justify-content-between\">\r\n                <span> {{'MANAGE_CART.CART_SUMMARY.SUB_TOTAL' | translate }} </span>\r\n                <span class=\"font-weight-bold\">\r\n                    <apt-price [record]=\"record\" type=\"listExtended\"></apt-price>\r\n                </span>\r\n            </div>\r\n\r\n            <!-- Promotion field for Manage Cart & Checkout pages which does require storefront.EnablePromotions check -->\r\n            <div *ngIf=\"view?.storefront?.EnablePromotions && view?.totalPromotions\" class=\"d-flex mt-2 justify-content-between\">\r\n                <span> {{'MANAGE_CART.CART_SUMMARY.PROMOTIONS_APPLIED' | translate }} </span>\r\n                <span>{{view?.totalPromotions | localCurrency | async}}</span>\r\n            </div>\r\n\r\n            <!-- Tax field is required only on Quote Details, Create Proposal & Checkout pages -->\r\n            <div class=\"d-flex mt-2 justify-content-between\" *ngIf=\"view?.totalEstimatedTax != null && view?.showTaxLink\">\r\n                <span>\r\n                    <button [popover]=\"taxPophover\" [outsideClick]=\"true\" class=\"btn btn-link text-primary text-capitalize p-0\"\r\n                        *ngIf=\"view?.totalEstimatedTax !== 0\" data-toggle=\"popover\" data-placement=\"auto bottom\"\r\n                        (click)=\"openEstimateTaxPopup()\">\r\n                        {{'MANAGE_CART.CART_SUMMARY.TAX' | translate }} </button>\r\n                    <span *ngIf=\"view?.totalEstimatedTax === 0\"> {{'MANAGE_CART.CART_SUMMARY.TAX' | translate }} </span>\r\n                </span>\r\n                <span>{{view?.totalEstimatedTax | localCurrency | async}}</span>\r\n            </div>\r\n\r\n            <hr class=\"mt-3 mb-2\" />\r\n\r\n            <div class=\"d-flex justify-content-between\">\r\n                <span> {{'MANAGE_CART.CART_SUMMARY.TOTAL_PRICE' | translate }} </span>\r\n                <span class=\"font-weight-bold\">\r\n                    <ng-container *ngIf=\"!view?.showTaxLink; else showNetPrice\">\r\n                        <apt-price [record]=\"record\" type=\"listExtended\"></apt-price>\r\n                    </ng-container>\r\n                    <ng-template #showNetPrice>\r\n                        <apt-price [record]=\"record\" type=\"net\"></apt-price>\r\n                    </ng-template>\r\n                </span>\r\n            </div>\r\n\r\n            <!-- Show order payment status on order details page -->\r\n            <hr class=\"mt-3 mb-2\" *ngIf=\"page === 'orders' && showStatus\"/>\r\n            <div class=\"d-flex justify-content-between\" *ngIf=\"page === 'orders' && showStatus\">\r\n                <span>{{'PRICE_SUMMARY.PAYMENT_STATUS' | translate}}</span>\r\n\r\n                <div role=\"group\" [ngSwitch]=\"view?.paymentStatus\">\r\n                    <ng-container *ngSwitchCase=\"'Pending'\">\r\n                        <i class=\"fas fa-circle text-warning\"></i>\r\n                        <span> {{view?.paymentStatus}}</span>\r\n                    </ng-container>\r\n                \r\n                    <ng-container *ngSwitchCase=\"'Processed'\">\r\n                        <i class=\"fas fa-circle text-success\"></i>\r\n                        <span> {{view?.paymentStatus}}</span>\r\n                    </ng-container>\r\n                \r\n                    <ng-container *ngSwitchCase=\"'Error'\">\r\n                        <i class=\"fas fa-circle text-danger\"></i>\r\n                        <span> {{view?.paymentStatus}}</span>\r\n                    </ng-container>\r\n                    <ng-container *ngSwitchDefault>\r\n                        <i class=\"fas fa-circle text-warning\"></i>\r\n                        <span> Pending</span>\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Few pages doesn't require any action button; in that case no need to show <hr> -->\r\n            <hr class=\"mt-2 mb-3\" *ngIf=\"page !== 'quotes' && page !== 'orders'\" />\r\n\r\n            <!-- Action buttons for Manage Cart page -->\r\n            <div class=\"d-flex justify-content-end\" *ngIf=\"page === 'carts' && !view?.quote?.Id && !view?.order\">\r\n                <button *ngIf=\"view?.isLoggedIn && view?.storefront?.EnableRequestQuote\" class=\"btn btn-link\"\r\n                    [routerLink]=\"['/proposals/create']\" [hidden]=\"view?.loading\" data-style=\"zoom-in\"\r\n                    [disabled]=\"!(view?.lineItemCount > 0) || view?.hasErrors === true || record?.hasErrors\">\r\n                    {{'COMMON.REQUEST_QUOTE' | translate }}\r\n                </button>\r\n                <button class=\"btn btn-primary btn-raised\" [routerLink]=\"['/checkout']\" [ladda]=\"view?.loading\"\r\n                    data-style=\"zoom-in\" [disabled]=\"!(view?.lineItemCount > 0) || view?.hasErrors === true || record?.hasErrors\">\r\n                    {{ 'COMMON.PLACE_ORDER' | translate }}\r\n                </button>\r\n            </div>\r\n            <div class=\"d-flex justify-content-end\" *ngIf=\"page === 'carts' && (view?.quote?.Id || view?.order?.Id)\">\r\n                <button class=\"btn btn-outline-danger mr-2\" (click)=\"openDiscardChangeModals()\" [hidden]=\"view?.loading\"\r\n                    data-style=\"zoom-in\" [disabled]=\"view?.hasErrors === true || record?.hasErrors\">\r\n                    {{'MANAGE_CART.CART_SUMMARY.DISCARD_CHANGES' | translate }}\r\n                </button>\r\n                <button *ngIf=\"view?.quote?.Id\" class=\"btn btn-primary btn-raised px-2\" (click)=\"finalizeQuote()\" [ladda]=\"view?.loading\"\r\n                    data-style=\"zoom-in\" [disabled]=\"!(view?.lineItemCount > 0) || view?.hasErrors === true || record?.hasErrors\">\r\n                    {{'MANAGE_CART.CART_SUMMARY.FINALIZE_AND_SUBMIT' | translate }}\r\n                </button>\r\n                <button *ngIf=\"view?.order?.Id\" class=\"btn btn-primary btn-raised px-2\" (click)=\"confirmOrderChanges()\" [ladda]=\"view?.loading\"\r\n                    data-style=\"zoom-in\" [disabled]=\"!(view?.lineItemCount > 0) || view?.hasErrors === true || record?.hasErrors\">\r\n                    {{'COMMON.CONFIRM_CHANGES' | translate }}\r\n                </button>\r\n            </div>\r\n\r\n            <!-- Action buttons for Checkout page -->\r\n            <div *ngIf=\"page === 'checkout'\">\r\n                <div class=\"d-flex\" *ngIf=\"!view?.accountId && !view?.isLoggedIn; else showButton\"\r\n                    tooltip=\"{{'CART.DEFAULT_ACC_NOT_AVAILABLE' | translate}}\">\r\n                    <button class=\"btn btn-primary btn-block btn-raised\" [ladda]=\"view?.loading\" data-style=\"zoom-in\"\r\n                        (click)=\"submitOrder()\" [disabled]=\"true\">\r\n                        {{ 'COMMON.PLACE_ORDER' | translate }}\r\n                    </button>\r\n                </div>\r\n                <ng-template #showButton>\r\n                    <div class=\"d-flex\">\r\n                        <ng-content select=\".cancel-button\"></ng-content>\r\n                        <button class=\"btn btn-primary btn-block btn-raised\" [ladda]=\"view?.loading\" data-style=\"zoom-in\"\r\n                            (click)=\"submitOrder()\" [disabled]=\"!form.valid || !(view?.lineItemCount > 0)\">\r\n                            <span *ngIf=\"paymentState != 'PAYNOW'\">{{ 'COMMON.PLACE_ORDER' | translate }}</span>\r\n                            <span *ngIf=\"paymentState === 'PAYNOW'\">{{ 'COMMON.PLACE_ORDER_PAY' | translate }}</span>\r\n                        </button>\r\n                    </div>\r\n                </ng-template>\r\n            </div>\r\n            <div *ngIf=\"page === 'paymentForOrder'\">\r\n                <button class=\"btn btn-primary btn-block btn-raised\" [ladda]=\"view?.loading\" data-style=\"zoom-in\"\r\n                    (click)=\"submitPayment()\">\r\n                    {{'PAYMENT_METHOD_LABELS.MAKE_PAYMENT' | translate}}\r\n                </button>\r\n            </div>\r\n\r\n            <!-- Action buttons for Create Proposal page -->\r\n            <div class=\"d-flex justify-content-end\" *ngIf=\"page === 'create-proposal'\">\r\n                <button class=\"btn btn-link\" [routerLink]=\"['/carts/active']\" [hidden]=\"view?.loading\">\r\n                    {{'COMMON.CANCEL' | translate }}\r\n                </button>\r\n                <button class=\"btn btn-primary btn-raised\" (click)=\"requestQuote()\" [disabled]=\"disableSubmit\" *ngIf=\"!view?.quote?.Id\"\r\n                    [ladda]=\"view?.loading\" data-style=\"zoom-in\">\r\n                    {{'COMMON.REQUEST_QUOTE' | translate }}\r\n                </button>\r\n                <button class=\"btn btn-primary btn-raised\" (click)=\"requestQuote()\" [disabled]=\"disableSubmit\" *ngIf=\"view?.quote?.Id\"\r\n                    [ladda]=\"view?.loading\" data-style=\"zoom-in\">\r\n                    {{'COMMON.SUBMIT' | translate }}\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <ng-template #taxPophover>\r\n        <apt-tax-pophover [taxItems]=\"view?.taxItems\" [totalEstimatedTax]=\"view?.totalEstimatedTax\" class=\"small\" [showTaxPopUp]=\"true\">\r\n        </apt-tax-pophover>\r\n    </ng-template>\r\n    <ng-template #discardChangesTemplate>\r\n        <div class=\"modal-header\">\r\n            <h4 class=\"modal-title pull-left\"> {{'MANAGE_CART.DISCARD_CHANGES_MODAL.DISCARD_CHANGES_TITLE' | translate}}\r\n            </h4>\r\n            <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"discardChangesModal.hide()\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"modal-body flex-column justify-content-center\">\r\n            <p>{{'MANAGE_CART.DISCARD_CHANGES_MODAL.DISCARD_CHANGES_Message' | translate}}</p>\r\n            <p>{{'MANAGE_CART.DISCARD_CHANGES_MODAL.DISCARD_CHANGES_CONFIRMATION' | translate}}</p>\r\n            <div class=\"d-flex justify-content-end flex-wrap flex-md-nowrap\">\r\n                <button class=\"btn btn-link\" (click)=\"discardChangesModal.hide()\"> {{ 'COMMON.CANCEL' | translate }}\r\n                </button>\r\n                <button class=\"btn btn-primary btn-raised m-2\" (click)=\"onDiscardChanges()\" [ladda]=\"view?.loading\" data-style=\"zoom-in\">\r\n                    {{ 'MANAGE_CART.DISCARD_CHANGES_MODAL.DISCARD_CHANGES' | translate }} </button>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</ng-container>\r\n\r\n<!--\r\nNot part of Nov 15 deliverable\r\n-->\r\n<!-- <div class=\"card mt-3\" *ngIf=\"cart\">\r\n<div class=\"card-header\">\r\n    Request a Quote\r\n</div>\r\n<div class=\"card-body\">\r\n    <small class=\"mb-3 d-block\">\r\n    Request a quote for your configuration and someone will be in touch to discuss next steps.\r\n    </small>\r\n    <button class=\"btn btn-block btn-outline-primary\" [ladda]=\"state.requestQuote view?.loading\" data-style=\"zoom-in\" (click)=\"createQuote()\"\r\n    data-spinner-color=\"black\" [disabled]=\"!record?.LineItems || view?.lineItemCount === 0\">Request a Quote</button>\r\n</div>\r\n</div> -->\r\n\r\n\r\n\r\n", styles: [""], components: [{ type: PriceComponent, selector: "apt-price", inputs: ["record", "attributeValue", "term", "quantity", "bundle", "formatted", "type", "options"] }, { type: TaxPopHoverComponent, selector: "apt-tax-pophover", inputs: ["taxItems", "totalEstimatedTax", "showTaxPopUp"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { type: i4$1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { type: i4$2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["containerClass", "tooltipAnimation", "tooltipFadeDuration", "isOpen", "tooltipHtml", "tooltip", "tooltipPlacement", "placement", "tooltipIsOpen", "tooltipEnable", "isDisabled", "tooltipAppendToBody", "container", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "delay", "tooltipTrigger", "triggers", "adaptivePosition"], outputs: ["tooltipChange", "tooltipStateChanged", "onShown", "onHidden"], exportAs: ["bs-tooltip"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "localCurrency": i1.LocalCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-price-summary',
                    templateUrl: './price-summary.component.html',
                    styleUrls: ['./price-summary.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.StorefrontService }, { type: i1.UserService }, { type: i1.ConstraintRuleService }, { type: i1$2.BsModalService }, { type: i1.QuoteService }, { type: i1.CartService }, { type: i1.TaxService }, { type: ExceptionService }, { type: i1.ProposalTaxService }, { type: i1.OrderTaxService }, { type: i4$1.Router }, { type: i1.AccountService }, { type: i1.OrderService }]; }, propDecorators: { record: [{
                type: Input
            }], form: [{
                type: Input
            }], disableSubmit: [{
                type: Input
            }], page: [{
                type: Input
            }], paymentState: [{
                type: Input
            }], loading: [{
                type: Input
            }], showStatus: [{
                type: Input
            }], onSubmitOrder: [{
                type: Output
            }], onRequestQuote: [{
                type: Output
            }], onFinalizeQuote: [{
                type: Output
            }], onPaymentRequest: [{
                type: Output
            }], discardChangesTemplate: [{
                type: ViewChild,
                args: ['discardChangesTemplate']
            }] } });

/**
 * @ignore
 */
class PriceSummaryModule {
}
PriceSummaryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PriceSummaryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryModule, declarations: [PriceSummaryComponent], imports: [PriceModule,
        PricingModule,
        CommonModule,
        RouterModule,
        LaddaModule,
        TaxPopHoverModule, i1$4.PopoverModule, i4$2.TooltipModule, i2$1.TranslateModule], exports: [PriceSummaryComponent] });
PriceSummaryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryModule, imports: [[
            PriceModule,
            PricingModule,
            CommonModule,
            RouterModule,
            LaddaModule,
            TaxPopHoverModule,
            PopoverModule.forRoot(),
            TooltipModule.forRoot(),
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceSummaryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PriceModule,
                        PricingModule,
                        CommonModule,
                        RouterModule,
                        LaddaModule,
                        TaxPopHoverModule,
                        PopoverModule.forRoot(),
                        TooltipModule.forRoot(),
                        TranslateModule.forChild()
                    ],
                    declarations: [PriceSummaryComponent],
                    exports: [PriceSummaryComponent]
                }]
        }] });

/**
 * Chart component displays the data as a chart based on the configuration passed in to this component.
 * <h3>Preview</h3>
 * <strong>Bar Chart</strong>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/barChart.png" style="max-width: 100%">
 * <strong>Doughnut Chart</strong>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/doughnutChart.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ChartModule } from '@congacommerce/elements';
@NgModule({
  imports: [ChartModule, ...]
})
export class AppModule {}
 ```
*
* @example
* // Basic Usage.
```typescript
* <apt-chart
*             [data]="chartData"
*             [type]="chartType"
* ></apt-chart>
```
*
* // Chart with override settings.
```typescript
* <apt-chart
*             [data]="chartData"
*             [type]="chartType"
*             [chartTitle]="myTitle"
*             [colorPalette]="colors"
*             [showLegend]="flag"
*             [legendPosition]="'top'"
*             [currencyConversionCode]="'USD'"
* ></apt-chart>
```
*/
class ChartComponent {
    constructor(conversionService, currencyPipe, userService, configService) {
        this.conversionService = conversionService;
        this.currencyPipe = currencyPipe;
        this.userService = userService;
        this.configService = configService;
        /**
         * Flag to show/hide legend on the chart.
         */
        this.showLegend = true;
        /**
         * Position of legend on the chart.
         */
        this.legendPosition = 'top';
    }
    ngOnInit() {
        const currencyType$ = (this.currencyConversionCode) ? this.conversionService.getConversionRates().pipe(map(rates => find(rates, r => r != null && r.IsoCode === this.currencyConversionCode))) : this.conversionService.getCurrencyTypeForPricelist();
        this.subscription = combineLatest([currencyType$, this.userService.getLocale()])
            .subscribe(([currency, locale]) => {
            this.currencyType = currency;
            this.userLocale = locale;
        });
    }
    ngOnChanges() {
        if (this.data && this.type) {
            this.renderChartWithData(this.chartRef, this.data);
        }
    }
    /**
     * @ignore
     */
    renderChartWithData(chartRef, chartDataset) {
        if (this.myChart)
            this.myChart.destroy();
        const data = {};
        this.chartOptions = this.getDefaultChartOptions();
        // Define custom options for doughnut chart.
        if (this.type === 'doughnut') {
            this.chartOptions.animation = {
                animateScale: true
            };
            this.chartOptions.center = {
                text: this.centerText,
                color: 'rgba(111, 111, 111, 1)',
                sidePadding: 30
            };
            this.chartOptions.tooltips = {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: (tooltipItem, value) => {
                        const label = value.labels[tooltipItem.index];
                        const dataset = value.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        const datasetLabel = (this.labelDataTransform === 'currency') ? this.transformCurrency(dataset) : dataset;
                        return label + ': ' + datasetLabel;
                    }
                }
            };
            this.chartOptions['onClick'] = (evt, item) => {
                this.myChart.update();
                if (get(item, 'length') > 0)
                    get(first(item), '_model').outerRadius += 8;
            };
        }
        // Define custom options for bar chart.
        if (this.type === 'bar') {
            this.chartOptions.scales = this.getScaleOptions();
            this.chartOptions.tooltips = {
                enabled: false,
                custom: tooltipModel => {
                    if (tooltipModel.dataPoints) {
                        this.tooltipTitle = tooltipModel.dataPoints[0].xLabel.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
                        this.tooltipAmount = tooltipModel.dataPoints[0].yLabel;
                    }
                    this.tooltipTotal = get(this.amountsByStatus, this.tooltipTitle);
                    this.customTooltipClass = tooltipModel.yAlign;
                    if (tooltipModel.opacity === 0) {
                        this.customTooltip.nativeElement.style.opacity = 0;
                        this.customTooltip.nativeElement.style.zIndex = -1;
                        return;
                    }
                    this.customTooltip.nativeElement.style.opacity = .95;
                    this.customTooltip.nativeElement.style.zIndex = 2;
                    this.customTooltip.nativeElement.style.position = 'absolute';
                    this.customTooltip.nativeElement.style.left = tooltipModel.caretX + 16 + 'px';
                    this.customTooltip.nativeElement.style.top = tooltipModel.caretY - 32 + 'px';
                }
            };
        }
        // Load chart dataset
        data.datasets = new Array({
            data: values(chartDataset),
            backgroundColor: (this.colorPalette) ? this.colorPalette : this.getDefaultColorPalette(chartDataset)
        });
        // Set data labels
        data.labels = keys(chartDataset).map(res => res.toUpperCase());
        // Create chart component.
        this.myChart = new Chart(chartRef.nativeElement, {
            type: this.type,
            data: data,
            options: this.chartOptions
        });
        this.myChart.update();
    }
    /**
     * @ignore
     */
    getDefaultChartOptions() {
        return {
            title: {
                text: this.chartTitle,
                display: (this.chartTitle) ? true : false
            },
            legend: {
                display: this.showLegend,
                position: this.legendPosition,
                labels: {
                    usePointStyle: true
                }
            },
            tooltips: null,
            responsive: true
        };
    }
    /**
     * @ignore
     */
    getDefaultColorPalette(data) {
        let colors = [];
        keys(data).map(res => colors.push('rgba(59, 161, 217, 1)'));
        return colors;
    }
    /**
     * @ignore
     */
    getScaleOptions() {
        return {
            yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        precision: 0,
                        autoSkip: false,
                        userCallback: (label) => {
                            // Return labels with no decimals.
                            if (Math.floor(label) === label) {
                                return label;
                            }
                        },
                    }
                }],
            xAxes: [{
                    ticks: {
                        autoSkip: false
                    },
                    gridLines: {
                        display: false
                    }
                }]
        };
    }
    /**
     * @ignore
     */
    transformCurrency(value) {
        const conversionRate = (this.currencyType && this.currencyType.ConversionRate) ? this.currencyType.ConversionRate : 1;
        const convertedValue = value * conversionRate;
        return this.currencyPipe.transform(convertedValue, get(this.currencyType, 'IsoCode', this.configService.get('defaultCurrency', 'USD')), 'symbol-narrow', '1.' + get(this.currencyType, 'DecimalPlaces', 2) + '-' + get(this.currencyType, 'DecimalPlaces', 2), this.userLocale);
    }
    /**
     * @ignore
     */
    handleMouseEnter() {
        this.customTooltip.nativeElement.style.opacity = 1;
        this.customTooltip.nativeElement.style.zIndex = 2;
    }
    /**
     * @ignore
     */
    handleMouseLeave() {
        this.customTooltip.nativeElement.style.opacity = 0;
        this.customTooltip.nativeElement.style.zIndex = -1;
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
ChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartComponent, deps: [{ token: i1.ConversionService }, { token: i5.CurrencyPipe }, { token: i1.UserService }, { token: i1$1.ConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
ChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ChartComponent, selector: "apt-chart", inputs: { data: "data", type: "type", chartTitle: "chartTitle", colorPalette: "colorPalette", showLegend: "showLegend", legendPosition: "legendPosition", centerText: "centerText", labelDataTransform: "labelDataTransform", amountsByStatus: "amountsByStatus", currencyConversionCode: "currencyConversionCode" }, viewQueries: [{ propertyName: "chartRef", first: true, predicate: ["chart"], descendants: true, static: true }, { propertyName: "customTooltip", first: true, predicate: ["customTooltip"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div id=\"myChart\" style=\"position: relative;\">\r\n  <canvas #chart id=\"chart\"></canvas>\r\n  <div #customTooltip id=\"chartjs-tooltip\" [class]=\"customTooltipClass + ' bg-white border p-3'\" style=\"position: absolute; opacity: 0; pointer-events: initial; min-width: 200px; transition: opacity .25s ease;\" (mouseenter)=\"handleMouseEnter()\" (mouseleave)=\"handleMouseLeave()\">\r\n    <div class=\"carrot\"></div>\r\n    <h5>{{tooltipTitle}}</h5>\r\n    <hr>\r\n    <div class=\"d-flex flex-column\">\r\n      <span>{{'COMMON.QUANTITY' | translate}}: <strong>{{tooltipAmount}}</strong></span>\r\n      <span *ngIf=\"amountsByStatus\"> {{'COMMON.AMOUNT' | translate}}: <strong>{{tooltipTotal | convertCurrency: currencyConversionCode | async}}</strong></span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".carrot{position:absolute;content:\"\";border-top:16px solid transparent;border-bottom:16px solid transparent;border-right:16px solid white;left:-16px;top:calc(50% - 16px);opacity:inherit}#chartjs-tooltip{border-radius:5px;box-shadow:0 1px 4px #0000003d}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe, "convertCurrency": i1.ConvertCurrencyPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-chart',
                    templateUrl: './chart.component.html',
                    styleUrls: ['./chart.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.ConversionService }, { type: i5.CurrencyPipe }, { type: i1.UserService }, { type: i1$1.ConfigurationService }]; }, propDecorators: { data: [{
                type: Input
            }], type: [{
                type: Input
            }], chartTitle: [{
                type: Input
            }], colorPalette: [{
                type: Input
            }], showLegend: [{
                type: Input
            }], legendPosition: [{
                type: Input
            }], centerText: [{
                type: Input
            }], labelDataTransform: [{
                type: Input
            }], amountsByStatus: [{
                type: Input
            }], currencyConversionCode: [{
                type: Input
            }], chartRef: [{
                type: ViewChild,
                args: ['chart', { static: true }]
            }], customTooltip: [{
                type: ViewChild,
                args: ['customTooltip', { static: false }]
            }] } });
// Set animation speed in milliseconds to render the chart faster.
Chart.defaults.global.animation.duration = 150;
// Chart plugin to show text at the center of the chart.
Chart.pluginService.register({
    beforeDraw: function (c) {
        if (get(c, 'config.options.center')) {
            // Get ctx from chart
            let ctx = get(c, 'chart.ctx');
            // Get options from the center object in options
            let centerConfig = get(c, 'config.options.center');
            let fontStyle = centerConfig.fontStyle || 'Arial';
            let txt = centerConfig.text;
            let color = centerConfig.color || '#000';
            let sidePadding = centerConfig.sidePadding || 20;
            let sidePaddingCalculated = (sidePadding / 100) * (get(c, 'innerRadius') * 2);
            // Start with a base font of 30px
            ctx.font = '34px ' + fontStyle;
            // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            let stringWidth = ctx.measureText(txt).width;
            let elementWidth = (get(c, 'innerRadius') * 2) - sidePaddingCalculated;
            // Find out how much the font can grow in width.
            let widthRatio = elementWidth / stringWidth;
            let newFontSize = Math.floor(30 * widthRatio);
            let elementHeight = (get(c, 'innerRadius') * 1.8);
            // Pick a new font size so it will not be larger than the height of label.
            let fontSizeToUse = Math.min(newFontSize, elementHeight);
            // Set font settings to draw it correctly.
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            let centerX = ((c.chartArea.left + c.chartArea.right) / 2);
            let centerY = ((c.chartArea.top + c.chartArea.bottom) / 2) + 10;
            ctx.font = fontSizeToUse + 'px ' + fontStyle;
            ctx.fillStyle = color;
            // Draw text in center
            if (txt)
                ctx.fillText(txt, centerX, centerY);
        }
    }
});

/**
 * @ignore
 */
class ChartModule {
}
ChartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ChartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartModule, declarations: [ChartComponent], imports: [CommonModule,
        PricingModule, i2$1.TranslateModule], exports: [ChartComponent] });
ChartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartModule, imports: [[
            CommonModule,
            PricingModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChartModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PricingModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [ChartComponent],
                    exports: [ChartComponent]
                }]
        }] });

/** @ignore */
var CheckState;
(function (CheckState) {
    CheckState["CHECKED"] = "checked";
    CheckState["INDETERMINATE"] = "indeterminate";
    CheckState["UNCHECKED"] = "unchecked";
})(CheckState || (CheckState = {}));

/**
 * Table component allows users to show list of AObject records in a grid view.
 * User can pass table options with list of fields to be displayed as table columns.
 * The table also provides more advanced features like data search, pagination, sortable columns, row selections with mass actions etc.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/table.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { TableModule } from '@congacommerce/elements';
@NgModule({
  imports: [TableModule, ...]
})
export class AppModule {}
```
* @example
* // Basic usage.
 ```typescript
* <apt-table
*             [type]="aObjectType"
*             [options]="TableOptions"></apt-table>
 ```
*/
class TableComponent {
    constructor(metadataService, cdr) {
        this.metadataService = metadataService;
        this.cdr = cdr;
        /**
         * Used to hold information for rendering the view.
         * @ignore
         */
        this.view$ = new BehaviorSubject(null);
        /**
         * Use for pagination.
         */
        this.page = 1;
        /** Flag to determines Whether the AccordionItem is expanded for table data. */
        this.expanded = true;
        /** Flag to check if data can grouped in the table . */
        this.disableGrouping = false;
        /** Array of selected data from table. */
        this.selectedRecords = [];
        /** Use to to show popover after given number of character for data in the table. */
        this.maxCharacterLength = 20;
        /** To hold previous searched string value while switiching window  */
        this.searchedStringValue = '';
    }
    /**
     * @ignore
     */
    ngOnChanges() {
        if (_.isNil(this.type))
            throw new Error('An AObject type must be provided');
        const columnKeys = _.filter(_.slice(new this.type().getKeys(), 0, 10), o => o !== 'Name');
        columnKeys.unshift('Name');
        const columns = _.map(columnKeys, k => {
            return {
                prop: k
            };
        });
        this.service = this.metadataService.getAObjectServiceForType(this.type, true);
        this.options = _.assign({}, {
            columns: columns,
            stickyColumnCount: 1,
            limit: 10,
            defaultSort: {
                column: _.get(this.options, 'defaultSort.column', 'LastModifiedDate'),
                direction: _.get(this.options, 'defaultSort.direction', 'DESC')
            }
        }, this.options);
        if (_.isNil(this.sortColumn))
            this.sortColumn = _.get(this.options, 'defaultSort.column', 'LastModifiedDate');
        if (_.isNil(this.sortDirection))
            this.sortDirection = _.get(this.options, 'defaultSort.direction', 'DESC');
        this.loadData();
    }
    /**
     * @ignore
     */
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
        this.reset();
    }
    /**
     * @ignore
     */
    reset() {
        this.view$.next(_.assign({}, this.view$.value, {
            data: null,
            groupedData: null,
            groups: null,
            type: new this.type(),
            columns: _.slice(this.options.columns, this.options.stickyColumnCount),
            stickyColumns: _.slice(this.options.columns, 0, this.options.stickyColumnCount),
            page: this.page,
            limit: _.defaultTo(_.get(this, 'view$.value.limit'), this.options.limit),
            limitOptions: [this.options.limit, this.options.limit * 2, this.options.limit * 3, this.options.limit * 4]
        }));
    }
    /**
     * @ignore
     */
    loadDataDebounce(event) {
        if (this.searchedStringValue !== event.target.value) {
            this.searchedStringValue = event.target.value;
            this.loadData();
        }
    }
    /**
     * @ignore
     */
    loadData() {
        this.ngOnDestroy();
        const view = this.view$.value;
        const groupArray = (!_.isNil(this.options.groupBy)) ? [this.options.groupBy, 'Id'] : null;
        const viewType = _.isNil(this.options.fields) ? 'detail' : 'list';
        const dataQuery$ = this.service.query({
            filters: _.get(this.options, 'filters', []),
            searchString: this.searchString,
            groupBy: groupArray,
            expand: false,
            children: _.get(this.options, 'children', []).map(f => ({ field: f })),
            page: new APageInfo(view.limit, this.page),
            fieldList: this.options.fields,
            lookups: _.get(this.options, 'lookups'),
            view: viewType,
            sortOrder: [new ASort(this.type, this.sortColumn, this.sortDirection)],
            skipCache: true
        }).pipe(mergeMap(results => {
            if (!_.isNil(this.options.groupBy))
                return this.service.query({
                    conditions: [new ACondition(this.type, 'Id', 'In', _.map(results, 'Id'))],
                    fieldList: this.options.fields,
                    lookups: _.get(this.options, 'lookups'),
                    view: viewType,
                    sortOrder: [new ASort(this.type, this.sortColumn, this.sortDirection)]
                });
            else
                return of(results);
        }));
        const getChildRecords = (records) => {
            let obs$ = of(null);
            if (!_.isNil(this.options.childRecordOptions)) {
                const childFilters = _.cloneDeep(this.options.childRecordOptions.filters);
                if (!_.isEmpty(records)) {
                    _.first(childFilters).conditions.push(new ACondition(this.type, this.options.childRecordOptions.relationshipField, 'In', _.map(records, 'Id')));
                }
                obs$ = this.service.query({
                    filters: childFilters,
                    expand: false
                });
            }
            return obs$.pipe(map(res => {
                const childRecords = {};
                _.forEach(res, record => {
                    if (_.isEmpty(childRecords[record[this.options.childRecordOptions.relationshipField]]))
                        childRecords[record[this.options.childRecordOptions.relationshipField]] = [record];
                    else
                        childRecords[record[this.options.childRecordOptions.relationshipField]].push(record);
                });
                return childRecords;
            }));
        };
        const aggregateQuery$ = (_.get(this, 'searchString.length', 0) >= 2)
            ? this.service.query({
                filters: _.get(this.options, 'filters', []),
                searchString: this.searchString,
                groupBy: groupArray,
                skipCache: true,
                view: 'list'
            }).pipe(map(searchResults => {
                return { total_records: searchResults ? searchResults.length : 0 };
            }))
            : this.service.query({ aggregate: true, filters: _.get(this.options, 'filters', []), skipCache: true })
                .pipe(map(aggregateResult => _.first(aggregateResult)));
        const describeQuery$ = this.service.describe();
        this.subscription = combineLatest(dataQuery$, aggregateQuery$, describeQuery$)
            .subscribe(([recordData, aggregateData, describe]) => {
            getChildRecords(recordData).subscribe(childRecords => {
                // Set the actions on each of the records
                if (!_.isEmpty(_.get(this, 'options.actions'))) {
                    _.forEach(recordData, record => {
                        record.set('actions', _.filter(_.get(this.options, 'actions'), a => a.validate(record, childRecords)));
                    });
                    this.options.selectItemsInGroupFunc && this.options.selectItemsInGroupFunc(recordData);
                }
                this.view$.next(_.assign({}, view, {
                    groupedData: !_.isNil(this.options.groupBy) ? _.groupBy(recordData, this.options.groupBy) : null,
                    data: _.defaultTo(recordData, []),
                    totalRecords: _.get(aggregateData, 'total_records'),
                    childRecords: childRecords,
                    route: `/${_.defaultTo(_.get(this, 'options.routingLabel'), _.get(describe, 'labelPlural', '')).toLowerCase()}`,
                    label: _.get(describe, 'labelPlural', 'Records'),
                    groups: !_.isNil(this.options.groupBy)
                        ? _.map(_.keys(_.groupBy(recordData, this.options.groupBy)), groupName => {
                            return {
                                state: CheckState.UNCHECKED,
                                label: groupName
                            };
                        })
                        : null
                }));
                this.updateView();
            });
        });
    }
    /**
     * @ignore
     */
    onLimitChange() {
        this.loadData();
    }
    /**
     * @ignore
     */
    onPageChange(evt) {
        if (this.page !== evt.page) {
            this.page = evt.page;
            this.cdr.detectChanges();
            this.loadData();
        }
    }
    /**
     * @ignore
     */
    trackById(index, record) {
        return _.get(record, 'Id');
    }
    /**
     * Updates the selected records array with the currently selected records in the table.
     * @param state The check state of the record being updated.
     * @param record The record being updated.
     */
    updateSelectedRecordList(state, record) {
        const massActions = this.getMassActions(record);
        if (state === CheckState.CHECKED && !_.includes(_.map(this.selectedRecords, r => _.get(r, 'Id')), _.get(record, 'Id'))) {
            // Add records to the selection only if it has mass action enabled.
            if (!_.isEmpty(massActions)) {
                this.selectedRecords.push(record);
            }
        }
        else if (state === CheckState.UNCHECKED) {
            _.remove(this.selectedRecords, r => _.get(r, 'Id') === _.get(record, 'Id'));
        }
    }
    /**
     * @ignore
     */
    toggleAll(event) {
        event.target.checked = false;
        const view = this.view$.value;
        let newState;
        // If main checkbox is unchecked or indeterminate with not every record on the current page with actions selected.
        if (view.checkState === CheckState.UNCHECKED || (view.checkState === CheckState.INDETERMINATE && !_.every(_.map(_.filter(view.data, record => _.get(this.getMassActions(record), 'length') > 0), r => r.Id), id => _.includes(_.map(this.selectedRecords, r => r.Id), id))))
            newState = CheckState.CHECKED;
        // Else if main checkbox is checked or indeterminated with every record on the current page with actions selected.
        else if (view.checkState === CheckState.CHECKED || (view.checkState === CheckState.INDETERMINATE && _.every(_.map(_.filter(view.data, record => _.get(this.getMassActions(record), 'length') > 0), r => r.Id), id => _.includes(_.map(this.selectedRecords, r => r.Id), id))))
            newState = CheckState.UNCHECKED;
        _.forEach(_.get(view, 'groups'), g => g.state = newState);
        _.forEach(_.get(view, 'data'), d => {
            if (_.get(this.getMassActions(d), 'length') > 0) {
                d.set('state', newState);
                this.updateSelectedRecordList(newState, d);
            }
        });
        // If selected records are less than the total in the table set main checkbox to indeterminate.
        if (this.selectedRecords.length < _.get(view, 'totalRecords'))
            event.target.indeterminate = this.selectedRecords.length === 0 ? false : true;
        // Else if all records in the table are selected set the main checkbox to checked.
        else if (this.selectedRecords.length === _.get(view, 'totalRecords'))
            event.target.checked = true;
        this.updateView();
    }
    /**
     * @ignore
     */
    toggleRecord(record, group) {
        const view = this.view$.value;
        const state = record.get('state') === CheckState.CHECKED ? CheckState.UNCHECKED : CheckState.CHECKED;
        record.set('state', state);
        this.updateSelectedRecordList(state, record);
        if (!_.isNil(group)) {
            const groupedData = _.get(view, `groupedData.${group.label}`);
            if (_.every(groupedData, child => child.get('state') === CheckState.CHECKED))
                group.state = CheckState.CHECKED;
            else if (_.some(groupedData, child => child.get('state') === CheckState.CHECKED))
                group.state = CheckState.INDETERMINATE;
            else
                group.state = CheckState.UNCHECKED;
        }
        this.updateView();
    }
    /**
     * @ignore
     */
    toggleGroup(group) {
        const view = this.view$.value;
        const state = group.state === CheckState.CHECKED ? CheckState.UNCHECKED : CheckState.CHECKED;
        group.state = state;
        _.forEach(_.get(view, `groupedData.${group.label}`), r => {
            r.set('state', state);
            this.updateSelectedRecordList(state, r);
        });
        this.updateView();
    }
    /**
     * @ignore
     */
    updateView() {
        const view = this.view$.value;
        // Add any checked record to the selectedRecords array. This handles programmatically checked records.
        _.forEach(_.filter(view.data, d => d.get('state') === CheckState.CHECKED), checkedRecord => {
            if (!_.includes(_.map(this.selectedRecords, rec => _.get(rec, 'Id')), _.get(checkedRecord, 'Id')))
                this.selectedRecords.push(checkedRecord);
        });
        // Select records that are in the selected records list
        _.forEach(view.data, r => {
            if (_.includes(_.map(this.selectedRecords, rec => _.get(rec, 'Id')), _.get(r, 'Id')))
                r.set('state', CheckState.CHECKED);
        });
        // Check the main checkbox based on the state of the selected records.
        if (this.selectedRecords.length === 0)
            view.checkState = CheckState.UNCHECKED;
        else if (this.selectedRecords.length < _.get(view, 'totalRecords'))
            view.checkState = CheckState.INDETERMINATE;
        else if (this.selectedRecords.length === _.get(view, 'totalRecords'))
            view.checkState = CheckState.CHECKED;
        // Check the groups based on the state of the selected records.
        _.forEach(_.keys(_.get(view, 'groupedData')), key => {
            if (_.every(_.map(_.get(view.groupedData, key), record => _.get(record, 'Id')), id => _.includes(_.map(this.selectedRecords, r => _.get(r, 'Id')), id)))
                _.set(_.find(_.get(view, 'groups'), { label: key }), 'state', CheckState.CHECKED);
            else if (_.some(_.map(_.get(view.groupedData, key), record => _.get(record, 'Id')), id => _.includes(_.map(this.selectedRecords, r => _.get(r, 'Id')), id)))
                _.set(_.find(_.get(view, 'groups'), { label: key }), 'state', CheckState.INDETERMINATE);
        });
        view.selectedItemCount = this.selectedRecords.length;
        view.totalPages = Math.ceil(view.totalRecords / view.limit);
        view.pageStats = {
            minVal: view.totalRecords > 0 ? ((view.page - 1) * view.limit + 1) : 0,
            maxVal: ((view.limit * view.page) >= view.totalRecords) ? view.totalRecords : (view.limit * view.page),
            totalVal: view.totalRecords
        };
        view.actions = _.filter(_.get(this.options, 'actions'), 'massAction');
        _.forEach(view.actions, a => {
            a.enabled = this.selectedRecords.length > 0 && _.every(this.selectedRecords, a.validate);
        });
    }
    /**
     * This methods sorts the table column.
     * @param column referenced by the table.
     */
    sort(column) {
        if (this.sortColumn === column)
            this.sortDirection = (this.sortDirection === 'ASC') ? 'DESC' : 'ASC';
        else {
            this.sortColumn = column;
            this.sortDirection = 'ASC';
        }
        this.loadData();
    }
    /**
     * Executes row action or mass action on selected table record(s).
     * @param action table action on the record(s) to be executed.
     * @param record list of selected table records.
     */
    executeAction(action, record) {
        if (_.isArray(record) && action.massAction) {
            const selectedItems = _.filter(record, d => d.get('state') === CheckState.CHECKED);
            _.forEach(record, r => r.set('state', 'processing'));
            action.enabled = false;
            if (_.every(selectedItems, action.validate)) {
                const obsv$ = action.action(selectedItems);
                obsv$.pipe(take(1)).subscribe(() => {
                    _.forEach(record, r => r.set('state', 'ready'));
                    if (!action.disableReload)
                        this.loadData();
                });
                const view = this.view$.value;
                this.selectedRecords = [];
                view.selectedItemCount = this.selectedRecords.length;
            }
        }
        else if (!_.isArray(record) && record instanceof AObject) {
            record.set('state', 'processing');
            const childRecords = this.view$.value.childRecords;
            if (action.validate(record, childRecords)) {
                const obsv$ = action.action([record]);
                obsv$.pipe(take(1)).subscribe(() => {
                    record.set('state', 'ready');
                    if (!action.disableReload)
                        this.loadData();
                    else
                        this.updateView();
                });
            }
        }
    }
    /**
     * @ignore
     */
    canHighlightRow(record) {
        return this.options.highlightRow ? this.options.highlightRow(record) : of(false);
    }
    /**
     * Opens the product configuration summary modal with the given product.
     * @param product The product referenced by the configuration modal.
     * @param relatedTo Cart item or asset item.
     */
    openModal(product, relatedTo) {
        this.configProduct = product;
        this.relatedTo = relatedTo;
        setTimeout(() => { this.productConfigurationSummary.show(); });
    }
    /**
     * @ignore
     */
    showCheckbox(record) {
        const massActions = this.getMassActions(record);
        return !_.isEmpty(massActions);
    }
    /**
     * @ignore
     */
    getMassActions(record) {
        return _.filter(record.get('actions'), record => record.massAction);
    }
}
TableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableComponent, deps: [{ token: i1$1.MetadataService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
TableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TableComponent, selector: "apt-table", inputs: { type: "type", options: "options" }, viewQueries: [{ propertyName: "productConfigurationSummary", first: true, predicate: ["productConfigurationSummary"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngTemplateOutlet=\"dataTable; context: {view: view$ | async}\"></ng-container>\r\n\r\n<ng-template #dataTable let-view=\"view\">\r\n    <div>\r\n        <div class=\"table-controls\">\r\n            <div class=\"row border-bottom py-2 no-gutters align-items-center\">\r\n                <form class=\"input-group input-group-sm col-4\" (ngSubmit)=\"loadData()\">\r\n                    <input type=\"text\" class=\"form-control\" [placeholder]=\"'TABLE.SEARCH' | translate\"\r\n                        [(ngModel)]=\"searchString\" name=\"searchString\" (keyup)=\"loadDataDebounce($event)\">\r\n                    <div class=\"input-group-append\">\r\n                        <button class=\"btn btn-link\">\r\n                            <i class=\"fas fa-search\"></i>\r\n                        </button>\r\n                    </div>\r\n                </form>\r\n\r\n                <div class=\"col-8 d-flex justify-content-end\" *ngIf=\"view?.pageStats\">\r\n                    <div class=\"border-right d-flex\">\r\n                        <div class=\"px-2\">\r\n                            {{'PRODUCT_LIST.SHOW_COUNT_OF_RECORDS_MESSAGE' | translate:view?.pageStats}}\r\n                        </div>\r\n                        <div class=\"px-3 d-flex\">\r\n                            <pagination [totalItems]=\"view?.totalRecords\" [(ngModel)]=\"page\" [maxSize]=\"1\"\r\n                                [itemsPerPage]=\"view.limit\" pageBtnClass=\"btn btn-link\" class=\"mr-2\"\r\n                                (pageChanged)=\"onPageChange($event)\" nextText=\"&nbsp;\" previousText=\"&nbsp;\">\r\n                            </pagination>\r\n                            <span>{{'TABLE.OF' | translate}} {{view?.totalPages}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"input-group input-group-sm px-3\">\r\n                        <select class=\"custom-select custom-select-sm\" id=\"size\" [(ngModel)]=\"view.limit\" name=\"limit\"\r\n                            (change)=\"onLimitChange()\">\r\n                            <option [value]=\"option\" *ngFor=\"let option of view?.limitOptions\">{{option}}</option>\r\n                        </select>\r\n                        <div class=\"input-group-append\">\r\n                            <label class=\"input-group-text\" for=\"sort\">{{'TABLE.PER_PAGE' | translate}}</label>\r\n                        </div>\r\n                    </div>\r\n                    <div *ngIf=\"options?.groupBy\" class=\"border-left d-flex align-items-center\">\r\n                        <button class=\"btn btn-link\" [class.disabled]=\"disableGrouping !== true\"\r\n                            [disabled]=\"disableGrouping !== true\" (click)=\"disableGrouping = false\">\r\n                            <i class=\"fa fa-layer-group\"></i>\r\n                        </button>\r\n                        <button class=\"btn btn-link\" [class.disabled]=\"disableGrouping === true\"\r\n                            [disabled]=\"disableGrouping === true\" (click)=\"disableGrouping = true\">\r\n                            <i class=\"fa fa-list\"></i>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"d-flex\" *ngIf=\"options?.actions?.length\">\r\n                <div class=\"border-right pr-3\">\r\n                    {{'TABLE.SELECTED' | translate}} {{view?.label}} ({{view?.selectedItemCount}})\r\n                </div>\r\n                <div class=\"d-flex\">\r\n                    <button class=\"btn btn-link\" [ngClass]=\"'text-' + action?.theme\"\r\n                        *ngFor=\"let action of view?.actions\" [disabled]=\"!action.enabled\"\r\n                        (click)=\"executeAction(action, selectedRecords)\">\r\n                        <i class=\"fa\" [ngClass]=\"action?.icon\" [title]=\"action?.label\"></i>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"d-flex align-items-stretch\" *ngIf=\"view?.data?.length > 0\">\r\n            <div class=\"border-right\">\r\n                <ng-container\r\n                    *ngTemplateOutlet=\"table; context: {view: view, columns: view?.stickyColumns, actions: options?.actions?.length > 0, stickySection: true}\">\r\n                </ng-container>\r\n            </div>\r\n            <div class=\"table-responsive\">\r\n                <ng-scrollbar [track]=\"'horizontal'\">\r\n                    <ng-container\r\n                        *ngTemplateOutlet=\"table; context: {view: view, columns: view?.columns, actions: false}\">\r\n                    </ng-container>\r\n                </ng-scrollbar>\r\n            </div>\r\n        </div>\r\n\r\n        <ng-container #empty *ngIf=\"view?.data?.length === 0\">\r\n            <div class=\"d-flex justify-content-center align-items-center m-5 p-5 flex-column\">\r\n                <i class=\"fa fa-database fa-5x text-primary xl text-faded\"></i>\r\n                <div class=\"mt-4\">{{'TABLE.NO_DATA_TO_DISPLAY' | translate}}</div>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <ng-container #dataLoading *ngIf=\"!view?.data\">\r\n            <div class=\"d-flex justify-content-center align-items-center m-5 p-5 flex-column\">\r\n                <apt-dots></apt-dots>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <ng-template #table let-actions=\"actions\" let-view=\"view\" let-columns=\"columns\"\r\n            let-stickySection=\"stickySection\">\r\n            <table class=\"table table-sm mb-0\">\r\n                <thead class=\"thead-light\">\r\n                    <tr>\r\n                        <!-- Checkbox header -->\r\n                        <th scope=\"col\" class=\"action\" *ngIf=\"actions\">\r\n                            <div class=\"custom-control custom-checkbox pl-5\">\r\n                                <input type=\"checkbox\" class=\"custom-control-input\" id=\"mainCheckbox\"\r\n                                    [indeterminate]=\"view?.checkState === 'indeterminate'\"\r\n                                    [checked]=\"view?.checkState === 'checked'\" (click)=\"toggleAll($event)\">\r\n                                <label class=\"custom-control-label\" for=\"mainCheckbox\">&nbsp;</label>\r\n                            </div>\r\n                        </th>\r\n\r\n                        <!-- Column headers -->\r\n                        <th class=\"pl-2\" scope=\"col\" *ngFor=\"let column of columns; let f = first\"\r\n                            [attr.colspan]=\"actions ? 2 : 1\">\r\n                            <div [class.pl-1]=\"actions\" class=\"pr-4 d-flex text-truncate\">\r\n                                <button class=\"btn btn-link chevron p-0\" *ngIf=\"options?.groupBy && f && actions\"\r\n                                    [attr.aria-expanded]=\"expanded\" (click)=\"expanded = !expanded\"></button>\r\n                                <button class=\"btn btn-icon p-0 text-truncate\"\r\n                                    *ngIf=\"column?.sortable !== false; else nonSortableColumn\"\r\n                                    (click)=\"sort(column.prop)\">\r\n                                    <apt-output-field [record]=\"view?.type\" [field]=\"column.prop\" layout=\"inline\"\r\n                                        [labelOnly]=\"true\" [label]=\"column.label\">\r\n                                        <i class=\"fa fa-chevron-down ml-2\" *ngIf=\"column.prop === sortColumn\"\r\n                                            [class.fa-chevron-down]=\"sortDirection === 'DESC'\"\r\n                                            [class.fa-chevron-up]=\"sortDirection === 'ASC'\"></i>\r\n                                    </apt-output-field>\r\n                                </button>\r\n                                <ng-template #nonSortableColumn>\r\n                                    <apt-output-field [record]=\"view?.type\" [field]=\"column.prop\" layout=\"inline\"\r\n                                        [labelOnly]=\"true\" [label]=\"column.label\">\r\n                                        <i class=\"fa fa-chevron-down ml-2\" *ngIf=\"column.prop === sortColumn\"\r\n                                            [class.fa-chevron-down]=\"sortDirection === 'DESC'\"\r\n                                            [class.fa-chevron-up]=\"sortDirection === 'ASC'\"></i>\r\n                                    </apt-output-field>\r\n                                </ng-template>\r\n                            </div>\r\n                        </th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <ng-container *ngIf=\"view?.groups?.length > 0 && !disableGrouping; else flat\">\r\n                        <ng-container *ngFor=\"let group of view?.groups; let i = index\">\r\n                            <tr class=\"table-info\">\r\n\r\n                                <!-- Checkbox column -->\r\n                                <td class=\"action\" *ngIf=\"actions\">\r\n                                    <div class=\"custom-control custom-checkbox pl-5\">\r\n                                        <input type=\"checkbox\" class=\"custom-control-input\" [id]=\"'check-'+ group.label\"\r\n                                            [indeterminate]=\"group.state === 'indeterminate'\"\r\n                                            [checked]=\"group.state === 'checked'\" (click)=\"toggleGroup(group)\">\r\n                                        <label class=\"custom-control-label\" [for]=\"'check-'+ group.label\">&nbsp;</label>\r\n                                    </div>\r\n                                </td>\r\n\r\n                                <!-- Data columns -->\r\n                                <td [attr.colspan]=\"actions ? columns?.length + 1 : columns?.length\"\r\n                                    class=\"text-truncate pl-2\">\r\n                                    <button class=\"btn btn-link btn-sm chevron\" type=\"button\" data-toggle=\"collapse\"\r\n                                        [attr.data-target]=\"'#child-' + i\" [attr.aria-expanded]=\"expanded\"\r\n                                        *ngIf=\"options?.groupBy && stickySection\">\r\n                                        <ng-container *ngIf=\"group?.label?.length > maxCharacterLength; else simple\">\r\n                                            <span [popover]=\"group?.label\" triggers=\"mouseenter:mouseleave\"\r\n                                                container=\"body\">\r\n                                                {{group?.label.substring(0, maxCharacterLength - 3) + '...'}}\r\n                                            </span>\r\n                                        </ng-container>\r\n                                        <ng-template #simple>\r\n                                            {{group?.label}}\r\n                                        </ng-template>\r\n                                    </button>\r\n                                </td>\r\n                            </tr>\r\n                            <ng-container\r\n                                *ngTemplateOutlet=\"rowData; context: {data: view?.groupedData[group.label], group: group, groupIndex: i, actions: actions, columns: columns, route: view?.route}\">\r\n                            </ng-container>\r\n                        </ng-container>\r\n                    </ng-container>\r\n                    <ng-template #flat>\r\n                        <ng-container\r\n                            *ngTemplateOutlet=\"rowData; context: {data: view?.data, actions: actions, columns: columns, route: view?.route}\">\r\n                        </ng-container>\r\n                    </ng-template>\r\n\r\n                    <ng-template #rowData let-data=\"data\" let-group=\"group\" let-groupIndex=\"groupIndex\"\r\n                        let-actions=\"actions\" let-columns=\"columns\" let-route=\"route\">\r\n                        <tr *ngFor=\"let record of data; trackBy: trackById\" class=\"collapse childSection\"\r\n                            [class.show]=\"expanded\" [id]=\"'child-' + groupIndex\"\r\n                            [ngClass]=\"(canHighlightRow(record) | async) ? 'table-success' : ''\"\r\n                            [class.table-primary]=\"record?._metadata?.state === 'indeterminate' || record?._metadata?.state === 'checked'\">\r\n\r\n                            <!-- Checkbox column -->\r\n                            <td class=\"action\" *ngIf=\"actions\">\r\n                                <div class=\"custom-control custom-checkbox pl-5\" *ngIf=\"showCheckbox(record)\">\r\n                                    <input type=\"checkbox\" class=\"custom-control-input\" [id]=\"'check-' + record?.Id\"\r\n                                        [checked]=\"record?.get('state') === 'checked'\"\r\n                                        (click)=\"toggleRecord(record, group)\">\r\n                                    <label class=\"custom-control-label\" [for]=\"'check-' + record?.Id\">&nbsp;</label>\r\n                                </div>\r\n                            </td>\r\n\r\n                            <!-- Action columns -->\r\n                            <td class=\"action\" *ngIf=\"actions\">\r\n                                <div class=\"btn-group m-0\" *ngIf=\"record?.get('actions')?.length > 0\" dropdown\r\n                                    [dropup]=\"true\">\r\n                                    <button class=\"btn btn-link\" dropdownToggle>\r\n                                        <div *ngIf=\"record?.get('state') === 'processing'\">\r\n                                            <i class=\"fas fa-spinner fa-spin d-flex align-self-center\"></i>\r\n                                        </div>\r\n                                        <div *ngIf=\"record?.get('state') !== 'processing'\">\r\n                                            <i class=\"fa fa-ellipsis-v d-flex align-self-center fa-sm\"></i>\r\n                                        </div>\r\n                                    </button>\r\n                                    <div *dropdownMenu class=\"dropdown-menu\">\r\n                                        <h6 class=\"dropdown-header font-weight-bold\">{{record?.Name}}</h6>\r\n                                        <div class=\"dropdown-divider\"></div>\r\n                                        <a href=\"javascript:void(0)\" class=\"dropdown-item flex-nowrap\"\r\n                                            *ngFor=\"let action of record?.get('actions')\"\r\n                                            [ngClass]=\"'text-' + action?.theme\" (click)=\"executeAction(action, record)\">\r\n                                            <i class=\"fa mr-2\" [ngClass]=\"action?.icon\"></i>\r\n                                            {{action?.label}}\r\n                                        </a>\r\n                                    </div>\r\n                                </div>\r\n\r\n                            </td>\r\n\r\n                            <td *ngFor=\"let column of columns; let firstColumn = first\" class=\"text-truncate pl-2\">\r\n                                <!-- If custom values provided, render that. else show backend data. -->\r\n                                <div *ngIf=\"column.value; else renderRecord\"> {{column.value(record) | async}}\r\n                                </div>\r\n                                <!-- No Custom data provided. -->\r\n                                <ng-template #renderRecord>\r\n                                    <div class=\"d-flex align-items-center\">\r\n                                        <a href=\"javascript:void(0)\" [routerLink]=\"[route, record?.Id]\"\r\n                                            *ngIf=\"(column.prop === 'Name' && !options.disableLink); else read\">\r\n                                            <apt-output-field [record]=\"record\" [field]=\"column.prop\" valueOnly=\"true\"\r\n                                                [editable]=\"false\" [maxCharacterLength]=\"maxCharacterLength\">\r\n                                            </apt-output-field>\r\n                                        </a>\r\n                                        <ng-template #read>\r\n                                            <div>\r\n                                                <apt-output-field [record]=\"record\" [field]=\"column.prop\"\r\n                                                    valueOnly=\"true\" [editable]=\"false\" [maxCharacterLength]=\"column.showPopOver ? maxCharacterLength : null \" [showQuickView]=\"column.showPopOver ? false : true\">\r\n                                                </apt-output-field>\r\n                                            </div>\r\n                                        </ng-template>\r\n                                        <i *ngIf=\"firstColumn && stickySection && view?.childRecords[record?.Id]?.length > 0\"\r\n                                            class=\"fas fa-info-circle ml-2 text-primary\" [popover]=\"popTemplate\"\r\n                                            containerClass=\"childPopover p-2\" [outsideClick]=\"true\"></i>\r\n                                        <button class=\"text-muted btn btn-link btn-sm p-0 ml-2\"\r\n                                            (click)=\"openModal(record?.Product, record)\"\r\n                                            *ngIf=\"firstColumn && stickySection && (record?.HasAttributes || record?.HasOptions) && record?.BusinessLineItemId\">\r\n                                            <i class=\"fas fa-wrench\"></i>\r\n                                        </button>\r\n                                        <ng-template #popTemplate>\r\n                                            <div>\r\n                                                <table class=\"table mb-0\">\r\n                                                    <thead>\r\n                                                        <tr>\r\n                                                            <th *ngFor=\"let column of options?.childRecordOptions?.childRecordFields\"\r\n                                                                scope=\"col\">{{column}}</th>\r\n                                                        </tr>\r\n                                                    </thead>\r\n                                                    <tbody>\r\n                                                        <tr *ngFor=\"let childRecord of view?.childRecords[record?.Id]\">\r\n                                                            <td\r\n                                                                *ngFor=\"let column of options?.childRecordOptions?.childRecordFields\">\r\n                                                                <apt-output-field [record]=\"childRecord\"\r\n                                                                    [field]=\"column\" valueOnly=\"true\"\r\n                                                                    [editable]=\"false\"></apt-output-field>\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </tbody>\r\n                                                </table>\r\n                                            </div>\r\n                                        </ng-template>\r\n                                    </div>\r\n                                </ng-template>\r\n                            </td>\r\n                        </tr>\r\n                    </ng-template>\r\n\r\n                </tbody>\r\n            </table>\r\n        </ng-template>\r\n    </div>\r\n    <apt-product-configuration-summary *ngIf=\"configProduct\" #productConfigurationSummary [product]=\"configProduct.Id\"\r\n        [relatedTo]=\"relatedTo\">\r\n    </apt-product-configuration-summary>\r\n</ng-template>", styles: ["@charset \"UTF-8\";apt-table .collapsing{transition:none;display:none}apt-table .table-controls>div{padding:0 .5rem 0 1rem}apt-table .table-controls div.d-flex{align-items:center}apt-table .table-controls .input-group{width:auto;align-items:center}apt-table .table-controls pagination ul{margin-bottom:0}apt-table .table-controls pagination ul li{display:flex;align-items:center}apt-table .table-controls pagination ul li.pagination-next>a:before{font-family:\"Font Awesome 5 Free\";font-weight:400;content:\"\\f054\"}apt-table .table-controls pagination ul li.pagination-prev>a:before{font-family:\"Font Awesome 5 Free\";font-weight:400;content:\"\\f053\"}apt-table .table-controls pagination ul li.page-item.active .page-link{background-color:inherit;color:inherit}apt-table .table-controls pagination ul li.page-item.disabled .page-link{background:transparent}apt-table .table-controls pagination ul li .page-link{background:transparent;border:none;min-width:initial;padding:0 .5rem}apt-table .table-controls button.btn.btn-link{padding:.25rem .5rem}apt-table table.table td,apt-table table.table th{vertical-align:middle;height:39px}apt-table table.table .action{width:3rem;vertical-align:middle;text-align:center}apt-table table.table .loading-indicator{height:10px;border-radius:5px}apt-table .childPopover{max-width:unset}\n"], components: [{ type: i2$3.PaginationComponent, selector: "pagination", inputs: ["itemsPerPage", "totalItems", "maxSize", "rotate", "boundaryLinks", "directionLinks", "pageBtnClass", "align", "firstText", "previousText", "nextText", "lastText", "disabled", "customPageTemplate", "customNextTemplate", "customPreviousTemplate", "customFirstTemplate", "customLastTemplate"], outputs: ["numPages", "pageChanged"] }, { type: i3$1.NgScrollbar, selector: "ng-scrollbar", inputs: ["viewClass", "trackClass", "thumbClass", "minThumbSize", "trackClickScrollDuration", "pointerEventsMethod", "track", "visibility", "appearance", "position", "sensorDebounce", "scrollAuditTime", "disabled", "sensorDisabled", "pointerEventsDisabled", "viewportPropagateMouseMove"], outputs: ["updated"], exportAs: ["ngScrollbar"] }, { type: DotsComponent, selector: "apt-dots", inputs: ["large", "color"] }, { type: OutputFieldComponent, selector: "apt-output-field", inputs: ["field", "record", "layout", "dateFormat", "displayValue", "label", "default", "labelOnly", "labelClass", "valueClass", "editable", "showQuickView", "valueOnly", "lookupOptions", "required", "maxCharacterLength"], outputs: ["onChange"] }, { type: ProductConfigurationSummaryComponent, selector: "apt-product-configuration-summary", inputs: ["product", "relatedTo", "changes", "preload", "position", "quantity", "showActionButtons"], outputs: ["onProductAdd", "onNavigate"] }], directives: [{ type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$4.PopoverDirective, selector: "[popover]", inputs: ["outsideClick", "containerClass", "isOpen", "adaptivePosition", "popover", "popoverContext", "popoverTitle", "placement", "triggers", "container", "delay"], outputs: ["onShown", "onHidden"], exportAs: ["bs-popover"] }, { type: i2$2.BsDropdownDirective, selector: "[bsDropdown],[dropdown]", inputs: ["autoClose", "isAnimated", "insideClick", "isDisabled", "isOpen", "placement", "triggers", "container", "dropup"], outputs: ["onShown", "onHidden", "isOpenChange"], exportAs: ["bs-dropdown"] }, { type: i2$2.BsDropdownToggleDirective, selector: "[bsDropdownToggle],[dropdownToggle]", exportAs: ["bs-dropdown-toggle"] }, { type: i2$2.BsDropdownMenuDirective, selector: "[bsDropdownMenu],[dropdownMenu]", exportAs: ["bs-dropdown-menu"] }, { type: i4$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
__decorate([
    debounce(1000),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TableComponent.prototype, "loadDataDebounce", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-table',
                    templateUrl: './table.component.html',
                    styleUrls: ['./table.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MetadataService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { type: [{
                type: Input
            }], options: [{
                type: Input
            }], productConfigurationSummary: [{
                type: ViewChild,
                args: ['productConfigurationSummary', { static: false }]
            }], loadDataDebounce: [] } });

/**
 * @ignore
 */
class TableModule {
}
TableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableModule, declarations: [TableComponent], imports: [CommonModule,
        OutputFieldModule,
        TranslateModule,
        FormsModule,
        ConfigurationSummaryModule,
        NgScrollbarModule,
        PopoverModule, i2$2.BsDropdownModule, i2$3.PaginationModule, RouterModule,
        IconModule], exports: [TableComponent] });
TableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableModule, imports: [[
            CommonModule,
            OutputFieldModule,
            TranslateModule,
            FormsModule,
            ConfigurationSummaryModule,
            NgScrollbarModule,
            PopoverModule,
            BsDropdownModule.forRoot(),
            PaginationModule.forRoot(),
            RouterModule,
            IconModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TableComponent],
                    exports: [TableComponent],
                    imports: [
                        CommonModule,
                        OutputFieldModule,
                        TranslateModule,
                        FormsModule,
                        ConfigurationSummaryModule,
                        NgScrollbarModule,
                        PopoverModule,
                        BsDropdownModule.forRoot(),
                        PaginationModule.forRoot(),
                        RouterModule,
                        IconModule
                    ]
                }]
        }] });

/**
 * Converts/Splits pascal case string to regular form
 *
 * ### Example:
 ```html
 *   {{ PascalCase | splitPascalCase }}
 ```
 *   converts to: Pascal Case
*/
class SplitPascalCasePipe {
    transform(value) {
        return value.split(/(?=[A-Z])/).join(' ');
    }
}
SplitPascalCasePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SplitPascalCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SplitPascalCasePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SplitPascalCasePipe, name: "splitPascalCase" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SplitPascalCasePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'splitPascalCase'
                }]
        }] });

/**
 * The data filter component allows users to set multiple filters for a single object type within a single UI component.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/filter.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { DataFilterModule } from '@congacommerce/elements';

@NgModule({
  imports: [DataFilterModule, ...]
})
export class AppModule {}
```
* @example
* // Basic usage.
 ```typescript
* <apt-data-filter
*             [type]="aObjectType"
*             (filterListChange)="handleFilterListChange()"></apt-data-filter>
```
*
* // Initialize with array of default filters.
 ```typescript
* <apt-data-filter
*             [type]="aObjectType"
*             [filterList]="defaultFilters"
*             (filterListChange)="handleFilterListChange()"></apt-data-filter>
```
*/
class DataFilterComponent {
    constructor(metadataService) {
        this.metadataService = metadataService;
        /**
         * Event emitter for when the filter list values change.
         */
        this.filterListChange = new EventEmitter();
        /** @ignore */
        this.operatorMap = {
            Equal: '=',
            NotEqual: '!=',
            GreaterThan: '>',
            LessThan: '<',
            GreaterEqual: '>=',
            LessEqual: '<='
        };
        this.expressionOperator = 'AND';
    }
    ngOnInit() {
        this.instance = new this.type();
        // Determine the aobject service for the input type
        const service = this.metadataService.getAObjectServiceForType(this.type, true);
        this.view$ = service.describe(this.type)
            .pipe(map(metadata => {
            // Get the list of field labels
            let fieldList = this.getFieldOptions(!_.isEmpty(_.get(this.filterOptions, 'visibleFieldsWithOperators'))
                ? _.map(_.get(this.filterOptions, 'visibleFieldsWithOperators'), (fieldOp) => fieldOp.field)
                : _.get(this.filterOptions, 'visibleFields'), _.get(metadata, 'fields'), this.instance);
            if (this.customfilter && this.customfilter.length > 0) {
                fieldList = fieldList.concat(this.getCustomFields());
            }
            return {
                fieldList: _.sortBy(fieldList, 'label'),
                conditionList: _.map(_.flatten(_.map(_.get(this, 'filterList'), 'conditions')), c => new ConditionView(c, fieldList)),
                appliedConditions: _.map(_.flatten(_.map(_.get(this, 'filterList'), 'conditions')), c => new ConditionView(c, fieldList)),
                operatorList: _.defaultTo(_.get(this.filterOptions, 'visibleOperators', _.values(Operator))),
                fieldListWithOperators: this.getFieldListWithOperators(_.get(this.filterOptions, 'visibleFieldsWithOperators'))
            };
        }));
    }
    /** @ignore */
    addCriteria(view) {
        if (_.isNil(_.get(this, 'filterList')))
            _.set(this, 'filterList', new Array());
        view.conditionList.push(new ConditionView(new ACondition(this.type, null, null, null), view.fieldList));
    }
    /** @ignore */
    removeCriteria(conditionView, view) {
        _.remove(view.conditionList, conditionView);
    }
    /** @ignore */
    deleteCriteria(conditionView, view) {
        _.remove(view.conditionList, conditionView);
        _.remove(view.appliedConditions, conditionView);
        _.each(this.filterList, (filter, index) => {
            if (_.includes(_.get(filter, 'conditions'), conditionView.condition)) {
                _.remove(filter.conditions, conditionView.condition);
                if (_.isEmpty(filter.conditions))
                    _.remove(this.filterList, (f, i) => i === index);
            }
        });
        this.filterListChange.emit(this.filterList);
    }
    /** @ignore */
    handleApply($event, view) {
        this.filterList = [];
        view.conditionList = _.filter(view.conditionList, conditionView => {
            return !_.isNil(_.get(conditionView, 'condition.field')) && !_.isNil(_.get(conditionView, 'condition.filterOperator')) && !_.isNil(_.get(conditionView, 'condition.val'));
        });
        view.appliedConditions = _.slice(view.conditionList);
        _.each(view.conditionList, conditionView => {
            this.filterList.push(new AFilter(this.type, [conditionView.condition]));
        });
        this.filterListChange.emit(this.filterList);
        this.dropdown.hide();
    }
    /** @ignore */
    handleDropdownHide(view) {
        view.conditionList = _.slice(view.appliedConditions);
        this.dropdown.hide();
    }
    /** @ignore */
    changeValue(value, condition, field) {
        if (field.execute) {
            value = field.execute(value, condition);
        }
        condition.setValue(value);
    }
    /**@ignore */
    changeField(field, condition) {
        condition.field = field.value;
    }
    /** @ignore */
    getFieldListWithOperators(visibleFieldsWithOperators) {
        if (!_.isEmpty(visibleFieldsWithOperators)) {
            let returnOb = {};
            _.forEach(visibleFieldsWithOperators, (fieldAndOp) => {
                returnOb[fieldAndOp.field] = fieldAndOp.operators;
            });
            return returnOb;
        }
        return null;
    }
    /** @ignore */
    getFieldOptions(visibleFields, fieldMetadata, instance) {
        // Get the list of field labels
        const fieldList = new Array();
        _.forEach(fieldMetadata, field => {
            let referenceType;
            if (_.get(field, 'type') === 'reference')
                referenceType = this.metadataService.getAObjectServiceForType(this.metadataService.getTypeByApiName(_.first(_.get(field, 'referenceTo'))), true);
            const key = instance.getKey(_.get(field, 'name'));
            if (!_.isNil(key) && (_.includes(visibleFields, key) || _.isNil(visibleFields)))
                fieldList.push({
                    value: key,
                    label: _.get(field, 'label'),
                    referenceType: referenceType
                });
        });
        return fieldList;
    }
    getCustomFields() {
        const fieldList = new Array();
        _.forEach(this.customfilter, field => {
            const min = _.get(field, 'minVal');
            const obj = {
                value: _.get(field, 'mapApiField'),
                label: _.get(field, 'label'),
                type: _.get(field, 'type'),
                execute: _.get(field, 'execute')
            };
            if (min)
                _.set(obj, 'min', min);
            fieldList.push(obj);
        });
        return fieldList;
    }
}
DataFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterComponent, deps: [{ token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Component });
DataFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DataFilterComponent, selector: "apt-data-filter", inputs: { type: "type", filterList: "filterList", customfilter: "customfilter", filterOptions: "filterOptions" }, outputs: { filterListChange: "filterListChange" }, viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["dropdown"], descendants: true }], ngImport: i0, template: "<div\r\n    *ngIf=\"view$ | async as view\"\r\n    class=\"d-flex\"\r\n    dropdown\r\n    #dropdown=\"bs-dropdown\"\r\n    [autoClose]=\"false\"\r\n    (onHidden)=\"handleDropdownHide(view)\"\r\n>\r\n    <button class=\"btn text-primary btn-link dropdown-toggle btn-sm\" dropdownToggle>\r\n        <i class=\"fa fa-filter\"></i>\r\n    </button>\r\n\r\n    <div class=\"d-flex flex-wrap\">\r\n        <div *ngFor=\"let conditionView of view?.appliedConditions\" class=\"badge badge-info mr-2 my-1 pl-2 d-flex align-items-center\">\r\n            {{conditionView?.label}} {{conditionView?.operator}} {{conditionView?.value}}\r\n            <button class=\"btn btn-link text-primary\" (click)=\"deleteCriteria(conditionView, view)\">\r\n                <i class=\"fas fa-minus-circle\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <div *dropdownMenu class=\"dropdown-menu p-0\">\r\n        <div class=\"card\">\r\n            <div class=\"card-header\">\r\n                <h4 class=\"card-title mb-0\">{{ 'FILTER.ADVANCED_FILTERS' | translate }}</h4>\r\n            </div>\r\n            <div class=\"card-body\">\r\n                <!-- <form (change)=\"handleExpressionOperatorChange($event)\">\r\n                    <div class=\"custom-control custom-radio custom-control-inline\">\r\n                        <input\r\n                            id=\"andOperator\"\r\n                            name=\"expressionOperator\"\r\n                            class=\"custom-control-input\"\r\n                            [(ngModel)]=\"expressionOperator\"\r\n                            type=\"radio\"\r\n                            value=\"AND\"\r\n                            checked\r\n                        >\r\n                        <label class=\"custom-control-label\" for=\"andOperator\">\r\n                            {{ 'COMMON.AND' }}\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"custom-control custom-radio custom-control-inline\">\r\n                        <input\r\n                            id=\"orOperator\"\r\n                            name=\"expressionOperator\"\r\n                            class=\"custom-control-input\"\r\n                            [(ngModel)]=\"expressionOperator\"\r\n                            type=\"radio\"\r\n                            value=\"OR\"\r\n                        >\r\n                        <label class=\"custom-control-label\" for=\"orOperator\">\r\n                            {{ 'COMMON.OR' }}\r\n                        </label>\r\n                    </div>\r\n                </form> -->\r\n                <table class=\"table table-borderless table-sm\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th scope=\"col\" class=\"shrink\">#</th>\r\n                            <th scope=\"col\">{{ 'COMMON.FIELD' | translate }}</th>\r\n                            <th scope=\"col\">{{ 'COMMON.OPERATOR' | translate }}</th>\r\n                            <th scope=\"col\">{{ 'COMMON.VALUE' | translate }}</th>\r\n                            <th class=\"shrink\">&nbsp;</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let filter of view.conditionList; let i = index;\">\r\n                            <th scope=\"row\">{{ i + 1 }}</th>\r\n                            <td>\r\n                                <select class=\"form-control\" [(ngModel)]=\"filter.val\" (ngModelChange)=\"changeField(filter.val, filter.condition)\">\r\n                                    <option disabled selected value=\"null\">Select Option</option>\r\n                                    <option *ngFor=\"let field of view?.fieldList\" [ngValue]=\"field\">{{field.label}}</option>\r\n                                </select>\r\n                            </td>\r\n                            <td>\r\n                                <ng-container *ngIf=\"view?.fieldListWithOperators; else allVisible\">\r\n                                    <select class=\"form-control\"  [(ngModel)]=\"filter.condition.filterOperator\" [disabled]=\"!filter.condition.field\">\r\n                                        <option disabled selected value=\"null\">Select Option</option>\r\n                                        <option *ngFor=\"let operator of view?.fieldListWithOperators[filter.condition.field]\" [value]=\"operator\">{{operator | splitPascalCase}}</option>\r\n                                    </select>\r\n                                </ng-container>\r\n                                <ng-template #allVisible>\r\n                                    <select class=\"form-control\"  [(ngModel)]=\"filter.condition.filterOperator\" [disabled]=\"!filter.condition.field\">\r\n                                        <option disabled selected value=\"null\">Select Option</option>\r\n                                        <option *ngFor=\"let operator of view?.operatorList\" [value]=\"operator\">{{operator | splitPascalCase}}</option>\r\n                                    </select>\r\n                                </ng-template>\r\n                            </td>\r\n                            <td>\r\n                                <apt-input-field [entity]=\"instance\" [field]=\"filter?.condition.field\" [lookupOptions]=\"filter?.lookupOptions\" [showLabel]=\"false\" [(ngModel)]=\"filter.condition.val\" (ngModelChange)=\"changeValue($event, filter.condition, filter.val)\" [multiple]=\"filter.condition.filterOperator === 'In' || filter.condition.filterOperator === 'NotIn'\" *ngIf=\"filter?.condition.field; else blank\"\r\n                                [fieldType]=\"filter.val?.type\" [minVal]=\"filter.val?.min\"></apt-input-field>\r\n                                <ng-template #blank>\r\n                                    <input type=\"text\" disabled=\"disabled\" class=\"form-control\"/>\r\n                                </ng-template>\r\n                            </td>\r\n                            <td>\r\n                                <button class=\"btn btn-link text-primary\" type=\"button\" (click)=\"removeCriteria(filter, view)\"><i class=\"fas fa-times-circle\"></i></button>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n                <button class=\"btn btn-link text-primary btn-icon\" type=\"button\" (click)=\"addCriteria(view)\">\r\n                    <i class=\"fas fa-plus-circle mr-3\"></i>\r\n                    {{ 'FILTER.ADD_CRITERIA' | translate }}\r\n                </button>\r\n            </div>\r\n            <div class=\"card-footer d-flex justify-content-end\">\r\n                <button class=\"btn btn-link text-primary\" (click)=\"dropdown.hide()\">\r\n                    {{ 'COMMON.CANCEL' | translate }}\r\n                </button>\r\n                <button class=\"btn btn-primary btn-raised\" (click)=\"handleApply($event, view)\">{{ 'COMMON.APPLY' | translate }}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n", styles: [":host .badge{max-height:1.7rem}div.dropdown-menu.show{min-width:700px;z-index:1000}table thead th.shrink{width:5%}table thead th:not(.shrink){width:26%}table tbody th{padding-top:.8rem}\n"], components: [{ type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$2.BsDropdownDirective, selector: "[bsDropdown],[dropdown]", inputs: ["autoClose", "isAnimated", "insideClick", "isDisabled", "isOpen", "placement", "triggers", "container", "dropup"], outputs: ["onShown", "onHidden", "isOpenChange"], exportAs: ["bs-dropdown"] }, { type: i2$2.BsDropdownToggleDirective, selector: "[bsDropdownToggle],[dropdownToggle]", exportAs: ["bs-dropdown-toggle"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$2.BsDropdownMenuDirective, selector: "[bsDropdownMenu],[dropdownMenu]", exportAs: ["bs-dropdown-menu"] }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe, "splitPascalCase": SplitPascalCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-data-filter',
                    templateUrl: './filter.component.html',
                    styleUrls: ['./filter.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MetadataService }]; }, propDecorators: { type: [{
                type: Input
            }], filterList: [{
                type: Input
            }], customfilter: [{
                type: Input
            }], filterOptions: [{
                type: Input
            }], filterListChange: [{
                type: Output
            }], dropdown: [{
                type: ViewChild,
                args: ['dropdown', { static: false }]
            }] } });
/** @ignore */
class ConditionView {
    constructor(condition, fieldLabels) {
        this.condition = condition;
        this.fieldLabels = fieldLabels;
        this.operatorMap = {
            Equal: '=',
            NotEqual: '!=',
            GreaterThan: '>',
            LessThan: '<',
            GreaterEqual: '>=',
            LessEqual: '<='
        };
        this.lookupOptions = {
            primaryTextField: 'Name',
            onLookupChange: (record) => {
                this._value = _.get(record, 'Name');
            }
        };
        this.val = null;
        // Set the _value field on reference type fields that are reference types with preset values.
        if (_.get(_.find(this.fieldLabels, { value: _.get(this.condition, 'field') }), 'referenceType')) {
            _.get(_.find(this.fieldLabels, { value: _.get(this.condition, 'field') }), 'referenceType').get([_.get(this.condition, 'val')])
                .pipe(take(1)).subscribe(record => this._value = _.get(_.first(record), 'Name'));
        }
    }
    get label() {
        const displayField = _.find(this.fieldLabels, { value: _.get(this.condition, 'field') });
        return _.defaultTo(_.get(displayField, 'label'), _.get(this.condition, 'field'));
    }
    get value() {
        return _.get(this, '_value', _.get(this.condition, 'val'));
    }
    get operator() {
        return _.get(this.operatorMap, _.get(this.condition, 'filterOperator'), _.get(this.condition, 'filterOperator'));
    }
}

/**
 * @ignore
 */
class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, declarations: [SplitPascalCasePipe], exports: [SplitPascalCasePipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [
                        SplitPascalCasePipe
                    ],
                    exports: [
                        SplitPascalCasePipe
                    ]
                }]
        }] });

/**
 * @ignore
 */
class DataFilterModule {
}
DataFilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataFilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterModule, declarations: [DataFilterComponent], imports: [CommonModule,
        InputFieldModule,
        FormsModule,
        ReactiveFormsModule, i2$1.TranslateModule, i2$2.BsDropdownModule, OutputFieldModule,
        PipesModule], exports: [DataFilterComponent] });
DataFilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterModule, imports: [[
            CommonModule,
            InputFieldModule,
            FormsModule,
            ReactiveFormsModule,
            TranslateModule.forChild(),
            BsDropdownModule.forRoot(),
            OutputFieldModule,
            PipesModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DataFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DataFilterComponent],
                    imports: [
                        CommonModule,
                        InputFieldModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TranslateModule.forChild(),
                        BsDropdownModule.forRoot(),
                        OutputFieldModule,
                        PipesModule
                    ],
                    exports: [DataFilterComponent]
                }]
        }] });

/**
 * Login Form component is used to display login page where user can register or log into the application.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/login.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
```typescript
import { LoginFormModule } from '@congacommerce/elements';
@NgModule({
  imports: [LoginFormModule, ...]
})
export class AppModule {}
```
* @example
* // Basic usage.
 ```typescript
* <apt-login-form
*             [type]="'OAuth'"
*             (onRegister)="handleOnRegisterChange()"
*             (onLogin)="handleOnLoginChange()"></apt-login-form>
 ```
*/
class LoginFormComponent {
    constructor(userService, ngZone, translateService, activatedRoute) {
        this.userService = userService;
        this.ngZone = ngZone;
        this.translateService = translateService;
        this.activatedRoute = activatedRoute;
        /**
         * Event emitter for when user registers.
         */
        this.onRegister = new EventEmitter();
        /**
         * Event emitter for when user logs in.
         */
        this.onLogin = new EventEmitter();
        /**
         * Type field to determine type of handler,
         * 'SOAP' or 'OAuth'.
         */
        this.type = 'SOAP';
        /**
         *  Holds the state of the authentication.
         * Default value is set as 'LOGIN'
         */
        this.loginState = 'LOGIN';
        /**@ignore */
        this.user = new User();
        /** @ignore */
        this.loading = false;
    }
    ngOnInit() {
        this.sessionExpiryErrorMessage = JSON.parse(localStorage.getItem(PlatformConstants.TOKEN_EXPIRED)) ? this.translateService.instant('ERROR.SESSION_EXPIRATION') : null;
    }
    /**
     * @ignore
     */
    samlLogin() {
        this.userService.loginOauth();
    }
    /**
     * Allows user to register to the site using user email.
     */
    doRegister() {
        this.loading = true;
        this.user.Username = this.user.Email;
        this.userService.register(this.user).subscribe(res => {
            this.onRegister.emit(res);
            this.loading = false;
        }, err => {
            this.loading = false;
            this.registerMessage = `Could not complete registration. Please contact your administrator.`;
        });
    }
    /**
     * Allows user to login to the site using user credentials like username and password for the registered user otherwise it shows the error message.
     */
    doLogin() {
        this.loading = true;
        combineLatest([this.userService.login(this.username, this.password), this.activatedRoute.queryParams])
            .pipe(take(1))
            .subscribe(res => {
            localStorage.removeItem(PlatformConstants.TOKEN_EXPIRED);
            if (get(last(res), 'redirectUrl')) {
                window.location.href = get(last(res), 'redirectUrl');
                if ((!!window.location.hash))
                    window.location.reload();
            }
            else
                window.location.reload();
        }, error => this.ngZone.run(() => {
            this.translateService.stream('MINI_PROFILE').subscribe((val) => {
                if (includes(lowerCase(get(error, 'error.data.message')), 'license required'))
                    this.loginMessage = val['LICENSE_REQUIRED'];
                else
                    this.loginMessage = val['INVALID_PASSWORD'];
            });
            this.loading = false;
        }));
    }
    /**
     * Allows user to logout form the site
     *
    */
    doLogout() {
        this.userService.logout().subscribe(res => window.location.reload(), err => window.location.reload());
    }
    /**
     * Allows user to reset the password for the exisiting user.
     *
     */
    doResetPassword() {
        this.loading = true;
        this.userService.sendPasswordResetEmail(this.resetUsername)
            .subscribe(res => this.ngZone.run(() => {
            this.loginState = 'RESET-CONFIRM';
            this.loading = false;
        }), err => this.ngZone.run(() => {
            console.log(err);
            this.resetMessage = 'An error occurred resseting your password. Please contact your administrator.';
            this.loading = false;
        }));
    }
}
LoginFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormComponent, deps: [{ token: i1.UserService }, { token: i0.NgZone }, { token: i2$1.TranslateService }, { token: i4$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
LoginFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LoginFormComponent, selector: "apt-login-form", inputs: { type: "type" }, outputs: { onRegister: "onRegister", onLogin: "onLogin" }, ngImport: i0, template: "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"tabbable-panel p-3\">\r\n                <div class=\"tabbable-line\">\r\n                    <ul class=\"nav nav-tabs justify-content-center\">\r\n                        <li class=\"nav-item\">\r\n                            <a class=\"nav-link\"\r\n                                [class.active]=\"loginState === 'LOGIN' || loginState === 'RESET-PASSWORD'\" href=\"#login\"\r\n                                data-toggle=\"tab\" (click)=\"loginState='LOGIN'\">\r\n                                LOGIN </a>\r\n                        </li>\r\n                        <li class=\"nav-item\">\r\n                            <a class=\"nav-link\" [class.active]=\"loginState === 'REGISTER'\" href=\"#register\"\r\n                                data-toggle=\"tab\" (click)=\"loginState='REGISTER'\">\r\n                                REGISTER </a>\r\n                        </li>\r\n                    </ul>\r\n                    <div class=\"tab-content pt-3\">\r\n                        <div class=\"tab-pane\"\r\n                            [class.active]=\"loginState === 'LOGIN' || loginState === 'RESET-PASSWORD' || loginState === 'RESET-CONFIRM'\"\r\n                            id=\"login\">\r\n                            <!-- LOGIN FORM -->\r\n                            <form class=\"center_form\" *ngIf=\"loginState === 'LOGIN'\" (ngSubmit)=\"doLogin()\">\r\n                                <ng-container>\r\n                                    <div class=\"form-group\">\r\n                                        <label for=\"email\">{{'COMMON.USERNAME' | translate}}</label>\r\n                                        <input autofocus type=\"email\" class=\"form-control\" id=\"username\" name=\"username\"\r\n                                            placeholder=\"{{'MINI_PROFILE.ENTER_USERNAME' | translate}}\"\r\n                                            [(ngModel)]=\"username\" required />\r\n                                    </div>\r\n                                    <div class=\"form-group\">\r\n                                        <label for=\"password\">{{'MINI_PROFILE.PASSWORD' | translate}}</label>\r\n                                        <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\"\r\n                                            placeholder=\"{{'MINI_PROFILE.PASSWORD' | translate}}\" [(ngModel)]=\"password\"\r\n                                            required>\r\n                                    </div>\r\n                                    <div class=\"mt-5\">\r\n                                        <small class=\"text-danger\"\r\n                                            *ngIf=\"loginMessage; else sessionMessage\">{{loginMessage}}</small>\r\n                                        <ng-template #sessionMessage>\r\n                                            <small class=\"text-danger\">{{sessionExpiryErrorMessage}}</small>\r\n                                        </ng-template>\r\n                                        <button class=\"btn btn-primary btn-block btn-raised\" type=\"submit\"\r\n                                            [ladda]=\"loading\">\r\n                                            {{'COMMON.SUBMIT' | translate}}\r\n                                        </button>\r\n                                    </div>\r\n                                    <br />\r\n                                    <div class=\"text-center\">\r\n                                        <a href=\"#reset_password\" data-toggle=\"tab\"\r\n                                            (click)=\"loginState='RESET-PASSWORD'\">\r\n                                            {{'MINI_PROFILE.FORGOT_PASSWORD' | translate}}? </a>\r\n                                    </div>\r\n                                </ng-container>\r\n                                <!-- For GA release we dont need this -->\r\n                                <!-- <ng-container>\r\n                                    <hr class=\"my-4 hr-text\" data-content=\"OR\" />\r\n                                    <button class=\"btn btn-outline-primary btn-raised btn-icon btn-block\"\r\n                                        type=\"button\" (click)=\"samlLogin()\">\r\n                                        <i class=\"fab fa-windows mr-3\"></i>\r\n                                        Login With Microsoft\r\n                                    </button>\r\n                                </ng-container> -->\r\n                            </form>\r\n                            <!-- RESET-PASSWORD FORM -->\r\n                            <form *ngIf=\"loginState === 'RESET-PASSWORD'\" id=\"reset_password\" class=\"center_form\"\r\n                                (ngSubmit)=\"resetForm.valid && doResetPassword()\" #resetForm=\"ngForm\">\r\n                                <div class=\"card-body\">\r\n                                    <p>{{'MINI_PROFILE.TROUBLE_LOGGINGIN' | translate}}</p>\r\n                                    <ul>\r\n                                        <li>{{'MINI_PROFILE.USERNAME_ARE_IN_EMAIL' | translate}}</li>\r\n                                        <li>{{'MINI_PROFILE.PASSWORDS_ARE_CASESENSITIVE' | translate}}</li>\r\n                                    </ul>\r\n                                    <p>{{'MINI_PROFILE.TO_RESET_PASSWORD_ENTER_USERNAME' | translate}}</p>\r\n                                    <div class=\"form-group\">\r\n                                        <label for=\"resetUsername\">{{'COMMON.USERNAME' | translate}}</label>\r\n                                        <input type=\"email\" [(ngModel)]=\"resetUsername\" class=\"form-control\"\r\n                                            name=\"resetUsername\" placeholder=\"{{'COMMON.USERNAME' | translate}}\"\r\n                                            required>\r\n                                    </div>\r\n                                    <small class=\"text-danger \" *ngIf=\"resetMessage\">{{resetMessage}}</small>\r\n                                    <small class=\"text-danger\"\r\n                                        *ngIf=\"(resetForm.dirty && resetForm.invalid) || (resetForm.submitted && resetForm.invalid)\">{{'MINI_PROFILE.PLEASE_ENTER_USERNAME'\r\n                                        | translate}}</small>\r\n                                </div>\r\n                                <div class=\"card-footer\">\r\n                                    <button type=\"button\" class=\"btn btn-secondary col-sm-6 text-center\"\r\n                                        (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button>\r\n                                    <button type=\"submit\" class=\"btn btn-raised btn-primary col-sm-6 text-center\"\r\n                                        type=\"submit\" [ladda]=\"loading\">{{'COMMON.SUBMIT' | translate}}</button>\r\n                                </div>\r\n                            </form>\r\n                            <div *ngIf=\"loginState === 'RESET-CONFIRM'\">\r\n                                <!-- <div class=\"card-header\">\r\n                                    <h5>{{'MINI_PROFILE.PASSWORD_RESET' | translate}}</h5>\r\n                                </div> -->\r\n                                <div class=\"card-body\">\r\n                                    <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM1' | translate}}</p>\r\n                                    <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM2' | translate}}</p>\r\n                                    <p>{{'MINI_PROFILE.PASSWORD_RESET_CONFIRM3' | translate}}</p>\r\n                                </div>\r\n                                <div class=\"card-footer\">\r\n                                    <button type=\"button\" class=\"btn btn-secondary btn-block\"\r\n                                        (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"tab-pane\" [class.active]=\"loginState === 'REGISTER'\" id=\"register\">\r\n                            <!-- REGISTER FORM -->\r\n                            <form *ngIf=\"loginState === 'REGISTER'\" class=\"center_form\" (ngSubmit)=\"doRegister()\">\r\n                                <div class=\"form-group\">\r\n                                    <label for=\"exampleInputEmail1\">{{'COMMON.EMAIL_ADDRESS' | translate}}&nbsp;\r\n                                        <a><i class=\"fa fa-info-circle\"\r\n                                                title=\"{{'MINI_PROFILE.NEVER_SHARE_YOUR_EMAIL' | translate}}\"></i></a></label>\r\n                                    <input type=\"email\" [(ngModel)]=\"user.Email\" class=\"form-control\" name=\"email\"\r\n                                        placeholder=\"{{'MINI_PROFILE.ENTER_EMAIL' | translate}}\" required>\r\n                                </div>\r\n                                <div class=\"form-group\">\r\n                                    <label for=\"firstName\">{{'COMMON.FIRST_NAME' | translate}}</label>\r\n                                    <input type=\"text\" class=\"form-control\" id=\"firstName\" [(ngModel)]=\"user.FirstName\"\r\n                                        name=\"firstName\" placeholder=\"{{'COMMON.FIRST_NAME' | translate}}\">\r\n                                </div>\r\n                                <div class=\"form-group\">\r\n                                    <label for=\"lastName\">{{'COMMON.LAST_NAME' | translate}}</label>\r\n                                    <input type=\"text\" class=\"form-control\"\r\n                                        placeholder=\"{{'COMMON.LAST_NAME' | translate}}\" [(ngModel)]=\"user.LastName\"\r\n                                        name=\"lastName\" id=\"lastName\">\r\n                                </div>\r\n                                <small class=\"text-danger \" *ngIf=\"registerMessage\">{{registerMessage}}</small>\r\n                                <div class=\"card-footer\">\r\n                                    <!-- <button type=\"button\" class=\"btn btn-secondary col-sm-6 text-center\"\r\n                                        (click)=\"loginState = 'LOGIN'\">{{'MINI_PROFILE.GO_BACK' | translate}}</button> -->\r\n                                    <button type=\"submit\" class=\"btn btn-raised btn-primary btn-block text-center\"\r\n                                        [ladda]=\"loading\">{{'COMMON.SUBMIT' | translate}}</button>\r\n                                </div>\r\n                            </form>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".hr-text{line-height:1em;position:relative;outline:0;border:0;color:#000;text-align:center;height:1.5em;opacity:.5}.hr-text:before{content:\"\";background:linear-gradient(to right,transparent,gray,transparent);position:absolute;left:0;top:50%;width:100%;height:1px}.hr-text:after{content:attr(data-content);position:relative;display:inline-block;color:#000;padding:0 .5em;line-height:1.5em;color:gray;background-color:#fff}.center_form{min-height:350px;margin:0 auto;width:80%}.tabbable-panel{border:1px solid lightgrey}.tabbable-line>.tab-content{background-color:#fff;border-top:1px solid lightgrey}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-login-form',
                    templateUrl: './login.component.html',
                    styleUrls: ['./login.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.UserService }, { type: i0.NgZone }, { type: i2$1.TranslateService }, { type: i4$1.ActivatedRoute }]; }, propDecorators: { onRegister: [{
                type: Output
            }], onLogin: [{
                type: Output
            }], type: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class LoginFormModule {
}
LoginFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LoginFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormModule, declarations: [LoginFormComponent], imports: [CommonModule, i2$1.TranslateModule, FormsModule,
        LaddaModule,
        IconModule,
        HttpClientModule], exports: [LoginFormComponent] });
LoginFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormModule, imports: [[
            CommonModule,
            TranslateModule.forChild(),
            FormsModule,
            LaddaModule,
            IconModule,
            HttpClientModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoginFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoginFormComponent],
                    exports: [LoginFormComponent],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FormsModule,
                        LaddaModule,
                        IconModule,
                        HttpClientModule
                    ]
                }]
        }] });

/**
 * Auto Focus directive for focusing on elements after the view has been loaded.
 * @example
 ```typescript
 * <input type="text" aptAutoFocus/>
 ```
 */
class AutoFocusDirective {
    constructor(element) {
        this.element = element;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.element.nativeElement.focus();
        });
    }
}
AutoFocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AutoFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AutoFocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: AutoFocusDirective, selector: "[aptAutoFocus]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AutoFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aptAutoFocus]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

/**
 * @ignore
 */
class DirectivesModule {
}
DirectivesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DirectivesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DirectivesModule, declarations: [AutoFocusDirective], exports: [AutoFocusDirective] });
DirectivesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DirectivesModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [
                        AutoFocusDirective
                    ],
                    exports: [
                        AutoFocusDirective
                    ]
                }]
        }] });

/**
 * Product Search Component can be used to render typeahead search implementation, while searching for
 * a list of products matching a given input string.
 * This component can search for products matching a product name, product code or product description.
 * The minimum number of characters in the search string must be 3.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/productSearch.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { ProductSearchModule } from '@congacommerce/elements';

@NgModule({
  imports: [ProductSearchModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-product-search></apt-product-search>
```
*/
class ProductSearchComponent {
    constructor(modalService, productService, router, config) {
        this.modalService = modalService;
        this.productService = productService;
        this.router = router;
        this.config = config;
        /**
         * typeAheadLimit specifies the maximum number of search results to be shown (defaults to 5).
         */
        this.typeAheadLimit = 5;
        /**
         * Observable instance of type Product to show result based on search.
         */
        this.typeahead$ = new Observable();
        /**
         * Flag to show loader.
         */
        this.typeaheadLoading = false;
        this.typeahead$ = Observable.create((observer) => {
            observer.next(this.searchQuery);
        }).pipe(switchMap((query) => {
            return this.productService.searchProducts(query, 5);
        }));
    }
    /** @ignore */
    ngOnInit() {
    }
    /** @ignore */
    onSubmit() {
        this.router.navigate(['/search', this.searchQuery]);
    }
    /** @ignore */
    typeaheadOnSelect(evt) {
        if (this.searchString !== this.searchQuery) {
            this.searchQuery = this.searchString;
            this.doSearch();
        }
        else {
            this.modalRef.hide();
            this.typeaheadLoading = false;
            this.router.navigate(['/products', evt.item[this.config.get('productIdentifier')]]);
        }
    }
    /** @ignore */
    onInputChange(evt) {
        if (evt.key.toLowerCase() === 'enter' && !isEmpty(this.searchQuery) && this.searchQuery.length > 2) {
            this.searchString = this.searchQuery;
            this.doSearch();
        }
    }
    /** @ignore */
    onTemplateMatch(match) {
        this.searchString = match.value;
    }
    /** @ignore */
    openModal(template) {
        this.searchQuery = '';
        this.modalRef = this.modalService.show(template);
    }
    /** @ignore */
    doSearch() {
        this.modalRef.hide();
        this.typeaheadLoading = false;
        if (this.searchQuery)
            this.router.navigate(['/search', this.searchQuery]);
    }
}
ProductSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchComponent, deps: [{ token: i1$2.BsModalService }, { token: i1.ProductService }, { token: i4$1.Router }, { token: i1$1.ConfigurationService }], target: i0.ɵɵFactoryTarget.Component });
ProductSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductSearchComponent, selector: "apt-product-search", inputs: { typeAheadLimit: "typeAheadLimit" }, viewQueries: [{ propertyName: "searchBox", first: true, predicate: ["searchBox"], descendants: true }, { propertyName: "searchModal", first: true, predicate: ["searchModal"], descendants: true }, { propertyName: "typeAheadItem", first: true, predicate: ["typeAheadItem"], descendants: true }], ngImport: i0, template: "<button class=\"btn btn-link\" (click)=\"openModal(searchModal)\">\r\n  <i class=\"fa fa-search fa-lg\"></i>\r\n</button>\r\n\r\n<ng-template #searchModal>\r\n  <form role=\"document\" (ngSubmit)=\"doSearch()\" class=\"search-container\">\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\" id=\"searchModalLabel\">{{'HEADER.PRODUCT_SERACH' | translate}}</h5>\r\n      <button type=\"button\" class=\"close\" (click)=\"modalRef.hide()\" aria-label=\"Close\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <apt-spinner [large]=\"false\" *ngIf=\"typeaheadLoading\"></apt-spinner>\r\n      <input type=\"search\" class=\"form-control\" placeholder=\"{{'HEADER.ENTER_YOUR_SEARCH_TERM' | translate}}\"\r\n        (typeaheadLoading)=\"typeaheadLoading = $event\" (keyup)=\"onInputChange($event)\"\r\n        (typeaheadOnSelect)=\"typeaheadOnSelect($event)\" [typeaheadIsFirstItemActive]=\"false\"\r\n        [typeaheadItemTemplate]=\"typeAheadItem\" [typeahead]=\"typeahead$\" [typeaheadOptionsLimit]=\"5\" minlength=\"2\"\r\n        typeaheadWaitMs=\"1000\" typeaheadOptionField=\"Name\" [(ngModel)]=\"searchQuery\" name=\"searchQuery\" #searchBox\r\n        aptAutoFocus autocomplete=\"off\" />\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\"\r\n        (click)=\"modalRef.hide()\">{{'COMMON.CANCEL' | translate}}</button>\r\n      <button type=\"button\" class=\"btn btn-primary btn-raised\" type=\"submit\"\r\n        [disabled]=\"searchQuery?.length < 3\">{{'HEADER.SUBMIT' | translate}}</button>\r\n    </div>\r\n  </form>\r\n</ng-template>\r\n\r\n<ng-template #typeAheadItem let-model=\"item\" let-index=\"index\" let-last=\"last\" let-match=\"match\">\r\n  <div class=\"media w-100 p-2\" (click)=\"onTemplateMatch(match)\">\r\n    <img class=\"mr-3 align-self-center thumbnail\" [src]=\"model.IconId | image: true: true: model.Id\"\r\n      [alt]=\"model.IconId\">\r\n    <div class=\"media-body truncate\">\r\n      <h6 class=\"m-0\">{{model.Name}}</h6>\r\n      <small class=\"d-block\">{{model.ProductCode}}</small>\r\n    </div>\r\n  </div>\r\n</ng-template>", styles: [".search-container apt-spinner{position:absolute;right:3rem;top:1.5rem}.search-container typeahead-container{left:-24px!important;right:24px!important}\n"], components: [{ type: SpinnerComponent, selector: "apt-spinner", inputs: ["large", "color"] }], directives: [{ type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: AutoFocusDirective, selector: "[aptAutoFocus]" }, { type: i9$1.TypeaheadDirective, selector: "[typeahead]", inputs: ["isAnimated", "typeaheadLatinize", "typeaheadSingleWords", "typeaheadWordDelimiters", "typeaheadMultipleSearchDelimiters", "typeaheadPhraseDelimiters", "typeaheadScrollable", "typeaheadOptionsInScrollableView", "typeaheadSelectFirstItem", "typeaheadIsFirstItemActive", "dropup", "typeaheadOptionsLimit", "typeaheadMinLength", "typeaheadWaitMs", "typeaheadAsync", "typeahead", "adaptivePosition", "typeaheadOptionField", "typeaheadGroupField", "typeaheadOrderBy", "typeaheadMultipleSearch", "typeaheadItemTemplate", "optionsListTemplate", "typeaheadHideResultsOnBlur", "container"], outputs: ["typeaheadLoading", "typeaheadNoResults", "typeaheadOnSelect", "typeaheadOnBlur"], exportAs: ["bs-typeahead"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i2$1.TranslatePipe, "image": i1$1.ImagePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-search',
                    templateUrl: './product-search.component.html',
                    styleUrls: ['./product-search.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i1$2.BsModalService }, { type: i1.ProductService }, { type: i4$1.Router }, { type: i1$1.ConfigurationService }]; }, propDecorators: { searchBox: [{
                type: ViewChild,
                args: ['searchBox', { static: false }]
            }], searchModal: [{
                type: ViewChild,
                args: ['searchModal', { static: false }]
            }], typeAheadItem: [{
                type: ViewChild,
                args: ['typeAheadItem', { static: false }]
            }], typeAheadLimit: [{
                type: Input
            }] } });

/**
 * @ignore
 */
class ProductSearchModule {
}
ProductSearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ProductSearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchModule, declarations: [ProductSearchComponent], imports: [CommonModule,
        FormsModule,
        DirectivesModule, i1$2.ModalModule, i2$2.BsDropdownModule, i9$1.TypeaheadModule, i2$1.TranslateModule, IconModule,
        ApttusModule], exports: [ProductSearchComponent] });
ProductSearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchModule, imports: [[
            CommonModule,
            FormsModule,
            DirectivesModule,
            ModalModule.forRoot(),
            BsDropdownModule.forRoot(),
            TypeaheadModule.forRoot(),
            TranslateModule.forChild(),
            IconModule,
            ApttusModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ProductSearchComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        DirectivesModule,
                        ModalModule.forRoot(),
                        BsDropdownModule.forRoot(),
                        TypeaheadModule.forRoot(),
                        TranslateModule.forChild(),
                        IconModule,
                        ApttusModule
                    ],
                    exports: [ProductSearchComponent]
                }]
        }] });

/** @ignore */
/**
 * Price Modal component can be used when pricing on cart fails for any reason.
 * User can choose to clear the cart or reprice it, from the modal.
 * <h3>Usage</h3>
 *
```typescript
import { PriceModalModule } from '@congacommerce/elements';
@NgModule({
  imports: [PriceModalModule, ...]
})
export class AppModule {}
```
* @example
```typescript
* <apt-price-modal></apt-price-modal>
```
*/
class PriceModalComponent {
    constructor(cartService, modalService) {
        this.cartService = cartService;
        this.modalService = modalService;
        /**
         * Flag to show loader
         * @ignore
         */
        this.btnLoader = false;
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this.cartService.getCartPriceStatus().pipe().subscribe((cartRes) => {
            if (cartRes)
                this.showPriceErrorModal();
            else
                this.closeModal();
        });
    }
    /**
     * Open price modal popup.
     */
    showPriceErrorModal() {
        this.modalRef = this.modalService.show(this.priceModalTemplate);
    }
    /**
     * Call price cart API of cart.service.
     */
    retryPrice() {
        this.cartService.priceCart();
        this.closeModal();
    }
    /**
     * Create new cart and set it active. After that close price error modal.
     */
    clearCart() {
        this.btnLoader = true;
        this.cartService.createNewCart().pipe(take(1))
            .subscribe(() => {
            this.btnLoader = false;
            this.closeModal();
        });
    }
    /**
     * Close price modal.
     */
    closeModal() {
        if (this.modalRef)
            this.modalRef.hide();
    }
}
PriceModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalComponent, deps: [{ token: i1.CartService }, { token: i1$2.BsModalService }], target: i0.ɵɵFactoryTarget.Component });
PriceModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PriceModalComponent, selector: "apt-price-modal", viewQueries: [{ propertyName: "priceModalTemplate", first: true, predicate: ["priceModal"], descendants: true }], ngImport: i0, template: "<ng-template #priceModal>\r\n    <div>\r\n        <div class=\"modal-header\">\r\n        <h4 class=\"modal-title d-flex align-items-center m-0 text-truncate\">\r\n            {{'COMMON.PRICING_FAILED' | translate}}\r\n        </h4>\r\n        <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"closeModal()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        </div>\r\n        <div\u00A0class=\"modal-body\">\r\n        <div\u00A0class=\"row\">\r\n            <div\u00A0class=\"col-md-10\">\r\n            <div>\r\n                {{'COMMON.PRICE_ERROR' | translate}}\r\n            </div>\r\n            </div>\r\n        </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-outline-danger mr-2\" [ladda]=\"btnLoader\" [attr.data-style]=\"'zoom-in'\"\r\n                    (click)=\"clearCart()\">{{'COMMON.CLEAR_CART' | translate}}</button>\r\n            <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"retryPrice()\"\r\n                    data-style=\"zoom-in\">{{'COMMON.REPRICE_CART' | translate}}</button>\r\n        </div>\r\n    </div>\r\n</ng-template>", styles: [""], directives: [{ type: i8.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }], pipes: { "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-price-modal',
                    templateUrl: './price-modal.component.html',
                    styleUrls: ['./price-modal.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: i1.CartService }, { type: i1$2.BsModalService }]; }, propDecorators: { priceModalTemplate: [{
                type: ViewChild,
                args: ['priceModal']
            }] } });

/**
 * @ignore
 */
class PriceModalModule {
}
PriceModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PriceModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalModule, declarations: [PriceModalComponent], imports: [CommonModule,
        ApttusModule, i2$1.TranslateModule, LaddaModule], exports: [PriceModalComponent] });
PriceModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalModule, imports: [[
            CommonModule,
            ApttusModule,
            TranslateModule.forChild(),
            LaddaModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PriceModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        TranslateModule.forChild(),
                        LaddaModule
                    ],
                    declarations: [PriceModalComponent],
                    exports: [PriceModalComponent]
                }]
        }] });

/**
 * @ignore
 */
class RevalidateCartModalModule {
}
RevalidateCartModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RevalidateCartModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalModule, declarations: [RevalidateCartModalComponent], imports: [CommonModule,
        ApttusModule, i2$1.TranslateModule, LaddaModule] });
RevalidateCartModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalModule, imports: [[
            CommonModule,
            ApttusModule,
            TranslateModule.forChild(),
            LaddaModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RevalidateCartModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        TranslateModule.forChild(),
                        LaddaModule
                    ],
                    declarations: [
                        RevalidateCartModalComponent
                    ],
                    entryComponents: [RevalidateCartModalComponent]
                }]
        }] });

/**
 * @ignore
 */
class FavoriteModalModule {
}
FavoriteModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FavoriteModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalModule, declarations: [FavoriteModalComponent], imports: [CommonModule,
        InputFieldModule,
        NgSelectModule,
        LaddaModule,
        IconModule, i2$1.TranslateModule], exports: [FavoriteModalComponent] });
FavoriteModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalModule, imports: [[
            CommonModule,
            InputFieldModule,
            NgSelectModule,
            LaddaModule,
            IconModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FavoriteModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FavoriteModalComponent
                    ],
                    imports: [
                        CommonModule,
                        InputFieldModule,
                        NgSelectModule,
                        LaddaModule,
                        IconModule,
                        TranslateModule.forChild()
                    ],
                    exports: [FavoriteModalComponent]
                }]
        }] });

/**
 * The select all component is used for selecting all the products/cart items and adding them to the drawer.
 *
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/selectAll.png" style="max-width: 100%">
 *
 * <h3>Usage</h3>
 *
 ```typescript
import { SelectAllModule } from '@congacommerce/elements';

@NgModule({
  imports: [SelectAllModule, ...]
})
export class AppModule {}
 ```
*
* @example
```typescript
* <apt-select-all
*                 [items]="items"
* ></apt-select-all>
```
*
*/
class SelectAllComponent {
    constructor(batchSelectionService) {
        this.batchSelectionService = batchSelectionService;
        /** The array of selected products of type Product or Cart Item */
        this.items = [];
        /** @ignore  */
        this.type = null;
        /** Use to determine the state of checkbox  */
        this.SelectionState = SelectionState.UNCHECKED;
        /** @ignore */
        this.subscriptions = [];
    }
    ngOnChanges() {
        if (this.items[0] instanceof Product) {
            this.type = 'product';
            this.subscriptions.push(this.batchSelectionService._products.subscribe(res => {
                this.setStatus(res, this.items);
            }));
        }
        else if (this.items[0] instanceof CartItem) {
            this.type = 'lineitem';
            this.subscriptions.push(this.batchSelectionService._lineItems.subscribe(res => {
                this.setStatus(res, this.items);
            }));
        }
    }
    /** @ignore */
    setStatus(selectedItem, allItems) {
        const selectedItems = filter$1(allItems, (item) => some(selectedItem, { 'Id': item.Id }));
        if (selectedItems.length === this.items.length)
            this.SelectionState = SelectionState.CHECKED;
        else if (selectedItems.length === 0)
            this.SelectionState = SelectionState.UNCHECKED;
        else
            this.SelectionState = SelectionState.INDETERMINATE;
    }
    /** @ignore */
    toggleAllItems(items) {
        if (items[0] instanceof Product) {
            (this.SelectionState === SelectionState.UNCHECKED || this.SelectionState === SelectionState.INDETERMINATE)
                ? this.batchSelectionService.addAllProductstoSelection(items)
                : this.batchSelectionService.removeAllProductsFromSelection(items);
        }
        else if (items[0] instanceof CartItem) {
            (this.SelectionState === SelectionState.UNCHECKED || this.SelectionState === SelectionState.INDETERMINATE)
                ? this.batchSelectionService.addAllLineItemstoSelection(items)
                : this.batchSelectionService.removeAllLineItemsFromSelection(items);
        }
    }
    /** @ignore */
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
SelectAllComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllComponent, deps: [{ token: BatchSelectionService }], target: i0.ɵɵFactoryTarget.Component });
SelectAllComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SelectAllComponent, selector: "apt-select-all", inputs: { items: "items" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"custom-control custom-checkbox pl-5\" *ngIf=\"items.length > 1\">\r\n    <input type=\"checkbox\" class=\"custom-control-input\" [id]=\"'select-all-' + type\"\r\n        [indeterminate]=\"SelectionState === 'indeterminate'\"\r\n        [checked]=\"SelectionState === 'checked'\" (click)=\"toggleAllItems(items)\">\r\n    <label class=\"custom-control-label\" [for]=\"'select-all-' + type\">Select All</label>\r\n</div>", styles: [""], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-select-all',
                    templateUrl: './select-all.component.html',
                    styleUrls: ['./select-all.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: BatchSelectionService }]; }, propDecorators: { items: [{
                type: Input
            }] } });
/** @ignore */
var SelectionState;
(function (SelectionState) {
    SelectionState["CHECKED"] = "checked";
    SelectionState["INDETERMINATE"] = "indeterminate";
    SelectionState["UNCHECKED"] = "unchecked";
})(SelectionState || (SelectionState = {}));

/**
 * @ignore
 */
class SelectAllModule {
}
SelectAllModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SelectAllModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllModule, declarations: [SelectAllComponent], imports: [CommonModule], exports: [SelectAllComponent] });
SelectAllModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SelectAllModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SelectAllComponent],
                    exports: [SelectAllComponent]
                }]
        }] });

/**
 *  The files component is used for showing a list of attachments associated with an order in a table view.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/files.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { FilesModule } from '@congacommerce/elements';

@NgModule({
  imports: [FilesModule, ...]
})
export class AppModule {}
 ```
*
* @example
 ```typescript
* <apt-files
*           [recordId]='recordId'
* ></apt-files>
 ```
*
*/
class FilesComponent {
    constructor(storefrontService, attachmentService, fileService, productInformationService) {
        this.storefrontService = storefrontService;
        this.attachmentService = attachmentService;
        this.fileService = fileService;
        this.productInformationService = productInformationService;
    }
    ngOnChanges(changes) {
        this.fileList$ = this.storefrontService.getSetting('EnableFiles')
            .pipe(switchMap((filesEnabled) => {
            if (filesEnabled)
                return this.fileService.getFiles(this.recordId)
                    .pipe(map((fileList) => fileList.map(this.mapFile)));
            else
                return this.attachmentService.getAttachments(this.recordId)
                    .pipe(map((attachmentList) => attachmentList.map(this.mapAttachment)));
        }));
    }
    /**
     * This function used to download attachments.
     * @param file is an instance of IFile.
     */
    download(file) {
        if (file.is_file) {
            this.fileService.downloadFile(file.record);
        }
        else {
            window.open(this.productInformationService.getAttachmentUrl(file.record.Id, this.recordId), '_blank');
        }
    }
    mapFile(file, index) {
        return {
            record: file,
            id: file.Id,
            index: index + 1,
            title: file.Title,
            type: file.FileExtension,
            size: (file.ContentSize / 1024).toFixed(2) + ' KB',
            created_date: file.CreatedDate,
            is_file: true
        };
    }
    mapAttachment(attachment, index) {
        return {
            record: attachment,
            id: attachment.Id,
            index: index + 1,
            title: attachment.Name,
            type: attachment.ContentType,
            size: (attachment.BodyLength / 1024).toFixed(2) + ' KB',
            created_date: attachment.CreatedDate,
            is_file: false
        };
    }
}
FilesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesComponent, deps: [{ token: i1.StorefrontService }, { token: i1.AttachmentService }, { token: i1.FileService }, { token: i1.ProductInformationService }], target: i0.ɵɵFactoryTarget.Component });
FilesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: FilesComponent, selector: "apt-files", inputs: { recordId: "recordId", orderGenerated: "orderGenerated" }, usesOnChanges: true, ngImport: i0, template: "<h5 class=\"py-2 text-uppercase\">\r\n    {{'DETAILS.ATTACHMENTS' | translate}}\r\n    <span *ngIf=\"fileList$ | async as fileList\">({{fileList.length}})</span>\r\n</h5>\r\n<div class=\"row\">\r\n    <div class=\"col\">\r\n        <table class=\"table table-sm\">\r\n            <thead>\r\n                <tr>\r\n                    <th scope=\"col\">#</th>\r\n                    <th scope=\"col\">Name</th>\r\n                    <th scope=\"col\">Type</th>\r\n                    <th scope=\"col\">File Size</th>\r\n                    <th scope=\"col\">Created Date</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr *ngFor=\"let file of fileList$ | async\">\r\n                    <th scope=\"row\">{{file.index}}</th>\r\n                    <td><a class=\"text-underline\" (click)=\"download(file)\" target=\"_blank\">{{file.title}}</a></td>\r\n                    <td class=\"text-truncate\">{{file.type}}</td>\r\n                    <td>{{file.size}}</td>\r\n                    <td>{{file.created_date | date:'short'}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>", styles: [""], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i2$1.TranslatePipe, "async": i5.AsyncPipe, "date": i5.DatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-files',
                    templateUrl: './files.component.html',
                    styleUrls: ['./files.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.StorefrontService }, { type: i1.AttachmentService }, { type: i1.FileService }, { type: i1.ProductInformationService }]; }, propDecorators: { recordId: [{
                type: Input,
                args: ['recordId']
            }], orderGenerated: [{
                type: Input,
                args: ['orderGenerated']
            }] } });

/**
 * @ignore
 */
class FilesModule {
}
FilesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FilesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesModule, declarations: [FilesComponent], imports: [CommonModule,
        ApttusModule, i2$1.TranslateModule], exports: [FilesComponent] });
FilesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesModule, imports: [[
            CommonModule,
            ApttusModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ApttusModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [FilesComponent],
                    exports: [FilesComponent]
                }]
        }] });

/**
 * Product Type Filter Component is a way to filter the product list based on product type.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/product-type-filter.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { FilterModule } from '@congacommerce/elements';

@NgModule({
  imports: [FilterModule, ...]
})
export class AppModule {}
 ```
* @example
 ```typescript
* <apt-product-type-filter
*              (onFilterAdd)="handleFilterAdd($event)"
*              (onFilterRemove)="handleFilterRemove($event)"
* ></apt-product-type-filter>
 ```
*/
class ProductTypeFilterComponent {
    constructor(productService, storefrontService, assetService, accountService, userService) {
        this.productService = productService;
        this.storefrontService = storefrontService;
        this.assetService = assetService;
        this.accountService = accountService;
        this.userService = userService;
        /**
         * Event emitter for when a new filter is added.
         */
        this.onFilterAdd = new EventEmitter();
        /**
         * Event emitter for when a filter is removed.
         */
        this.onFilterRemove = new EventEmitter();
        /**
         * Current selected value.
         * @ignore
         */
        this.value = 'All';
    }
    ngOnInit() {
        this.storefront$ = this.storefrontService.getStorefront();
        this.isLoggedIn$ = this.userService.isLoggedIn();
    }
    /** @ignore */
    onCheckChange(event) {
        if (event.target.value === 'Assets') {
            this.ngOnDestroy();
            this.subscription = this.accountService.getCurrentAccount()
                .pipe(filter(account => !_.isNil(account)), switchMap(account => this.assetService.query({
                conditions: [
                    new ACondition(this.assetService.type, 'LineType', 'NotEqual', 'Option'),
                    new ACondition(this.assetService.type, 'IsPrimaryLine', 'Equal', true),
                    new ACondition(this.assetService.type, 'Product.ConfigurationType', 'NotEqual', 'Option')
                ],
                groupBy: ['ProductId']
            }))).subscribe(assetList => {
                this.filter = new ACondition(this.productService.type, 'Id', 'In', _.map(assetList, a => a.ProductId));
                this.onFilterAdd.emit(this.filter);
            });
        }
        else {
            this.onFilterRemove.emit(this.filter);
        }
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}
ProductTypeFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductTypeFilterComponent, deps: [{ token: i1.ProductService }, { token: i1.StorefrontService }, { token: i1.AssetService }, { token: i1.AccountService }, { token: i1.UserService }], target: i0.ɵɵFactoryTarget.Component });
ProductTypeFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: ProductTypeFilterComponent, selector: "apt-product-type-filter", outputs: { onFilterAdd: "onFilterAdd", onFilterRemove: "onFilterRemove" }, ngImport: i0, template: "<div class=\"card mb-2\" *ngIf=\"(isLoggedIn$ | async) === true && (storefront$ | async)?.EnableABO\">\r\n  <div class=\"card-body\">\r\n    <h5 class=\"card-title\">{{'FILTER.PRODUCT_TYPES' | translate}}</h5>\r\n    <form>\r\n      <ul class=\"list-unstyled pl-2\">\r\n        <li>\r\n          <div class=\"custom-control custom-radio\">\r\n            <input type=\"radio\" id=\"allTypes\" class=\"custom-control-input\" name=\"productTypes\"\r\n              (change)=\"onCheckChange($event)\" value=\"All\" [(ngModel)]=\"value\">\r\n            <label class=\"custom-control-label\" for=\"allTypes\">\r\n              {{'FILTER.ALL' | translate}}\r\n            </label>\r\n          </div>\r\n        </li>\r\n        <li>\r\n          <div class=\"custom-control custom-radio\">\r\n            <input type=\"radio\" id=\"assetType\" class=\"custom-control-input\" name=\"productTypes\"\r\n              (change)=\"onCheckChange($event)\" value=\"Assets\" [(ngModel)]=\"value\">\r\n            <label class=\"custom-control-label\" for=\"assetType\">\r\n              {{'FILTER.ASSETS' | translate}}\r\n            </label>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n    </form>\r\n  </div>\r\n</div>", styles: ["li{font-size:smaller;line-height:24px}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i6.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "async": i5.AsyncPipe, "translate": i2$1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ProductTypeFilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-product-type-filter',
                    templateUrl: './product-type-filter.component.html',
                    styleUrls: ['./product-type-filter.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.ProductService }, { type: i1.StorefrontService }, { type: i1.AssetService }, { type: i1.AccountService }, { type: i1.UserService }]; }, propDecorators: { onFilterAdd: [{
                type: Output
            }], onFilterRemove: [{
                type: Output
            }] } });

/**
 * Category filter component is a way to show the related categories and subcategories for a given product category.
 * <h3>Preview</h3>
 * <img src="https://raw.githubusercontent.com/Apttus-Ecom/Summer19/master/res/category_filter.png" style="max-width: 100%">
 * <h3>Usage</h3>
 *
 ```typescript
import { FilterModule } from '@congacommerce/elements';

@NgModule({
  imports: [FilterModule, ...]
})
export class AppModule {}
 ```
* @example
* // Basic Usage
 ```typescript
* <apt-category-filter
*             [category]="category"
*             (onChange)="handleCategoryChange($event)"
* ></apt-category-filter>
 ```
*
* // Setting multiselection on peer categories with a custom limit and title.
 ```typescript
* <apt-category-filter
*             [category]="category"
*             selection="multi"
*             relationship="peers"
*             limit="15"
*             title="Similar Categories"
*             (onChange)="handleCategoryChange($event)"
* ></apt-category-filter>
 ```
*/
class CategoryFilterComponent {
    constructor(categoryService, translateService) {
        this.categoryService = categoryService;
        this.translateService = translateService;
        /**
         * Input selection type.
         */
        this.selection = 'single';
        /**
         * The relationship the displayed categories should have to the main category.
         */
        this.relationship = 'children';
        /**
         * Maximum number of categories to display.
         */
        this.limit = 10;
        /**
         * Title to display on the card for this component.
         */
        this.title = (this.relationship === 'children') ? String(this.getTranslatedTitle('COMMON.SUB_CATEGORIES')) : String(this.getTranslatedTitle('FILTER.CATEGORIES'));
        /**
         * Event emitter for when the value of this component changes.
         */
        this.onChange = new EventEmitter();
        /** @ignore */
        this.filterGroup = new FormGroup({});
    }
    ngOnChanges() {
        // to reset category selection
        this.filterGroup = new FormGroup({});
        if (this.category) {
            if (SalesforceUtils.isValid(this.category)) {
                this.categoryId = this.category;
            }
            else if (this.category instanceof Category) {
                this.categoryId = get(this.category, 'Id');
            }
            else {
                this.translateService.get('FILTER.WRONG_INPUT').subscribe((val) => {
                    throw val;
                });
            }
            if (this.relationship === 'children')
                this.categoryList$ = this.categoryService.getSubcategories(this.categoryId, this.limit);
            else
                this.categoryList$ = this.categoryService.getRelatedCategories(this.categoryId, this.limit);
        }
        else if (this.relationship === 'peers') {
            this.categoryList$ = this.categoryService.getRootCategories();
        }
        if (this.categoryList$) {
            this.categoryList$.pipe(take(1)).subscribe(categoryList => {
                categoryList.forEach(category => {
                    this.filterGroup.addControl(category.Id, new FormControl());
                });
            });
        }
    }
    /**
     * @ignore
     */
    onCheckChange(event) {
        let categoryIdList = [];
        if (this.timeout)
            clearTimeout(this.timeout);
        this.categoryList$.pipe(take(1)).subscribe(categoryList => {
            categoryList.forEach(category => {
                if (this.filterGroup.controls[category.Id].value === true)
                    categoryIdList.push(category.Id);
            });
            this.categoryService.getCategoryBranchChildren(categoryIdList).pipe(take(1)).subscribe(categories => {
                this.timeout = setTimeout(() => this.onChange.emit(categories), 1000);
            });
        });
    }
    /** @ignore */
    getTranslatedTitle(key) {
        this.translateService.stream(key).subscribe((val) => {
            return val;
        });
    }
}
CategoryFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CategoryFilterComponent, deps: [{ token: i1.CategoryService }, { token: i2$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
CategoryFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: CategoryFilterComponent, selector: "apt-category-filter", inputs: { category: "category", selection: "selection", relationship: "relationship", limit: "limit", title: "title" }, outputs: { onChange: "onChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"card \" *ngIf=\"categoryList$ | async as categoryList\">\r\n  <div class=\"card-body\">\r\n    <h5 class=\"card-title\">{{title}}</h5>\r\n\r\n    <form *ngIf=\"selection === 'multi'\" [formGroup]=\"filterGroup\">\r\n      <ul class=\"list-unstyled pl-2\">\r\n        <li *ngFor=\"let category of categoryList\" class=\"custom-control custom-checkbox py-1\">\r\n          <input type=\"checkbox\" class=\"custom-control-input\" [id]=\"category.Id\" [formControlName]=\"category.Id\"\r\n            (change)=\"onCheckChange($event)\" [name]=\"category.Id\">\r\n          <label class=\"custom-control-label\" [for]=\"category.Id\">{{category.Label}}</label>\r\n        </li>\r\n      </ul>\r\n    </form>\r\n\r\n    <ul class=\"list-unstyled\" *ngIf=\"selection === 'single'\">\r\n      <li *ngFor=\"let category of categoryList\" [class.active]=\"category.Id == categoryId\">\r\n        <a href=\"javascript:void(0)\" class=\"btn btn-link btn-sm py-1 text-left\"\r\n          [class.disabled]=\"category.Id === categoryId\" (click)=\"onChange.emit([category])\">{{category.Label}}</a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div>", styles: [":host{display:block}li{font-size:smaller;line-height:24px}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CategoryFilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-category-filter',
                    templateUrl: './category-filter.component.html',
                    styleUrls: ['./category-filter.component.css'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.CategoryService }, { type: i2$1.TranslateService }]; }, propDecorators: { category: [{
                type: Input
            }], selection: [{
                type: Input
            }], relationship: [{
                type: Input
            }], limit: [{
                type: Input
            }], title: [{
                type: Input
            }], onChange: [{
                type: Output
            }] } });

/**
 * @ignore
 */
class FieldFilterComponent {
    constructor(metadataService) {
        this.metadataService = metadataService;
        this.fieldValueChange = new EventEmitter();
    }
    ngOnChanges() {
        const service = this.metadataService.getAObjectServiceForType(this.type);
        this.field$ = service.describe(null, this.fieldName, null, true);
    }
    handleChange(evt, fieldType) {
        if (fieldType === 'boolean') {
            // tslint:disable-next-line:triple-equals
            this.data = this.data.toLowerCase() == 'true' ? true : false;
        }
        this.fieldValueChange.emit(new ACondition(this.type, this.fieldName, 'Equal', this.data));
    }
}
FieldFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FieldFilterComponent, deps: [{ token: i1$1.MetadataService }], target: i0.ɵɵFactoryTarget.Component });
FieldFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: FieldFilterComponent, selector: "apt-field-filter", inputs: { fieldName: "fieldName", title: "title", type: "type" }, outputs: { fieldValueChange: "fieldValueChange" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="card" *ngIf="field$ | async as field">
      <div class="card-body">
        <h5 class="card-title">{{(title) ? title : field?.label}}</h5>
        <apt-input-field [field]="fieldName" [entity]="type" (change)="handleChange($event, field.type)" [(ngModel)]="data" [showLabel]="false" [allowEmpty]="true"></apt-input-field>
      </div>
    </div>
  `, isInline: true, styles: ["\n    :host{\n      font-size: smaller;\n    }\n  "], components: [{ type: InputFieldComponent, selector: "apt-input-field", inputs: ["errorMsg", "field", "entity", "showLabel", "label", "readonly", "allowEmpty", "disabledValues", "hiddenValues", "inline", "small", "rows", "placeholder", "required", "labelClass", "filterValues", "hideOptions", "hide", "minVal", "defaultValue", "enableValues", "lookupOptions", "multiple", "asterisk", "fieldType", "displayFieldType"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FieldFilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'apt-field-filter',
                    template: `
    <div class="card" *ngIf="field$ | async as field">
      <div class="card-body">
        <h5 class="card-title">{{(title) ? title : field?.label}}</h5>
        <apt-input-field [field]="fieldName" [entity]="type" (change)="handleChange($event, field.type)" [(ngModel)]="data" [showLabel]="false" [allowEmpty]="true"></apt-input-field>
      </div>
    </div>
  `,
                    styles: [`
    :host{
      font-size: smaller;
    }
  `]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MetadataService }]; }, propDecorators: { fieldName: [{
                type: Input
            }], title: [{
                type: Input
            }], type: [{
                type: Input
            }], fieldValueChange: [{
                type: Output
            }] } });

/**
 * @ignore
 */
class FilterModule {
}
FilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilterModule, declarations: [FieldFilterComponent, ProductTypeFilterComponent, CategoryFilterComponent], imports: [CommonModule,
        InputFieldModule,
        FormsModule,
        ReactiveFormsModule,
        PricingModule, i2$1.TranslateModule], exports: [FieldFilterComponent, ProductTypeFilterComponent, CategoryFilterComponent] });
FilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilterModule, imports: [[
            CommonModule,
            InputFieldModule,
            FormsModule,
            ReactiveFormsModule,
            PricingModule,
            TranslateModule.forChild()
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FilterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        InputFieldModule,
                        FormsModule,
                        ReactiveFormsModule,
                        PricingModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [FieldFilterComponent, ProductTypeFilterComponent, CategoryFilterComponent],
                    exports: [FieldFilterComponent, ProductTypeFilterComponent, CategoryFilterComponent]
                }]
        }] });

/*
 * Public API Surface of elements
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddToCartComponent, AddressComponent, AddressModule, AlertComponent, AlertModule, ApttusModalModule, AssetAction, AssetDropdownButtonComponent, AssetListComponent, AssetListModule, AssetModalService, AssetSelectionService, AutoFocusDirective, BatchActionService, BatchSelectionService, BreadcrumbComponent, BreadcrumbModule, ButtonModule, BuyMoreModalComponent, CRIconComponent, CRPopoverComponent, CategoryFilterComponent, ChangeConfigurationModalComponent, ChartComponent, ChartModule, CheckState, CompareProductCardComponent, ConfigurationSummaryModule, ConstraintPopoverModule, ConstraintPopoverService, ConstraintRuleAlertComponent, ConstraintRuleModule, ConstraintRuleSidebarComponent, CreditCardExtractorPipe, DataFilterComponent, DataFilterModule, DependentPicklistComponent, DependentPicklistModule, DirectivesModule, DotsComponent, ExceptionService, FavoriteModalComponent, FavoriteModalModule, FavoriteModalService, FieldFilterComponent, FilesComponent, FilesModule, FilterModule, GenerateDocumentComponent, IconModule, InputDateComponent, InputDateModule, InputFieldComponent, InputFieldModule, InputQuantityComponent, InputQuantityModule, InputSelectComponent, InputSelectModule, InstalledProductsComponent, JumbotronComponent, JumbotronModule, LineItemMenuComponent, LineItemTableRowComponent, LineItemTableRowModule, LoginFormComponent, LoginFormModule, MiniCartComponent, MiniCartModule, MiniCartService, MiniProfileComponent, MiniProfileModule, OutputFieldComponent, OutputFieldModule, PaymentComponent, PaymentComponentModule, PaymentIFrameComponent, PaymentMethodComponent, PipesModule, PresentDocumentComponent, PriceComponent, PriceModalComponent, PriceModalModule, PriceModule, PriceSummaryComponent, PriceSummaryModule, PriceType, ProductAttributeComponent, ProductAttributeModule, ProductCardComponent, ProductCardModule, ProductCarouselComponent, ProductCarouselModule, ProductCompareComponent, ProductCompareModule, ProductConfigurationComponent, ProductConfigurationModule, ProductConfigurationService, ProductConfigurationSummaryComponent, ProductDrawerComponent, ProductDrawerModule, ProductDrawerService, ProductImagesComponent, ProductImagesModule, ProductSearchComponent, ProductSearchModule, ProductTypeFilterComponent, PromotionComponent, PromotionModalComponent, PromotionModalModule, PromotionModule, RenewModalComponent, RevalidateCartModalModule, RevalidateCartService, SelectAllComponent, SelectAllModule, SelectionState, SpinnerComponent, SplitPascalCasePipe, TableComponent, TableModule, TaxPopHoverComponent, TaxPopHoverModule, TerminateModalComponent, UserViewMappingService };
